// This file is auto-generated by @hey-api/openapi-ts

export type ClientOptions = {
    baseURL: `${string}://${string}` | (string & {});
};

/**
 * AccessValidationRequest
 *
 * Request to validate access to a form.
 */
export type AccessValidationRequest = {
    /**
     * Access Code
     */
    access_code?: string | null;
};

/**
 * AccessValidationResponse
 *
 * Response for access validation.
 */
export type AccessValidationResponse = {
    /**
     * Valid
     */
    valid: boolean;
    /**
     * Submission Id
     */
    submission_id?: string | null;
    /**
     * Message
     */
    message?: string | null;
};

/**
 * Account
 */
export type Account = {
    /**
     * Id
     */
    id: string;
    /**
     * Name
     */
    name: string;
    /**
     * Is Active
     */
    is_active?: boolean;
    /**
     * Is Deleted
     */
    is_deleted?: boolean;
    /**
     * Has Logo
     */
    has_logo?: boolean;
    /**
     * Logo Url
     */
    logo_url?: string | null;
};

/**
 * AccountBalance
 *
 * Balance rollup for a billing or service account.
 */
export type AccountBalance = {
    /**
     * Total Charged
     */
    total_charged: number | string;
    /**
     * Total Paid
     */
    total_paid: number | string;
    /**
     * Outstanding
     */
    outstanding: number | string;
};

/**
 * AccountUpdate
 */
export type AccountUpdate = {
    /**
     * Name
     */
    name?: string | null;
    /**
     * Is Active
     */
    is_active?: boolean | null;
    /**
     * Is Deleted
     */
    is_deleted?: boolean | null;
};

/**
 * Address
 */
export type Address = {
    /**
     * Address1
     */
    address1: string;
    /**
     * Address2
     */
    address2?: string | null;
    /**
     * City
     */
    city: string;
    /**
     * County
     */
    county?: string | null;
    state?: State | null;
    /**
     * State Other
     */
    state_other?: string | null;
    /**
     * Postal Code
     */
    postal_code: string;
    country: AddressCountry;
};

/**
 * AddressCountry
 *
 * :US: United States
 * :AD: Andorra
 * :AE: United Arab Emirates (the)
 * :AF: Afghanistan
 * :AG: Antigua and Barbuda
 * :AI: Anguilla
 * :AL: Albania
 * :AM: Armenia
 * :AO: Angola
 * :AQ: Antarctica
 * :AR: Argentina
 * :AT: Austria
 * :AU: Australia
 * :AW: Aruba
 * :AX: Åland Islands
 * :AZ: Azerbaijan
 * :BA: Bosnia and Herzegovina
 * :BB: Barbados
 * :BD: Bangladesh
 * :BE: Belgium
 * :BF: Burkina Faso
 * :BG: Bulgaria
 * :BH: Bahrain
 * :BI: Burundi
 * :BJ: Benin
 * :BL: Saint Barthélemy
 * :BM: Bermuda
 * :BN: Brunei Darussalam
 * :BO: Bolivia (Plurinational State of)
 * :BQ: Bonaire, Sint Eustatius and Saba
 * :BR: Brazil
 * :BS: Bahamas (the)
 * :BT: Bhutan
 * :BV: Bouvet Island
 * :BW: Botswana
 * :BY: Belarus
 * :BZ: Belize
 * :CA: Canada
 * :CC: Cocos (Keeling) Islands (the)
 * :CD: Congo (the Democratic Republic of the)
 * :CF: Central African Republic (the)
 * :CG: Congo (the)
 * :CH: Switzerland
 * :CI: Côte d'Ivoire
 * :CK: Cook Islands (the)
 * :CL: Chile
 * :CM: Cameroon
 * :CN: China
 * :CO: Colombia
 * :CR: Costa Rica
 * :CU: Cuba
 * :CV: Cabo Verde
 * :CW: Curaçao
 * :CX: Christmas Island
 * :CY: Cyprus
 * :CZ: Czech Republic (the)
 * :DE: Germany
 * :DJ: Djibouti
 * :DK: Denmark
 * :DM: Dominica
 * :DO: Dominican Republic (the)
 * :DZ: Algeria
 * :EC: Ecuador
 * :EE: Estonia
 * :EG: Egypt
 * :EH: Western Sahara*
 * :ER: Eritrea
 * :ES: Spain
 * :ET: Ethiopia
 * :FI: Finland
 * :FJ: Fiji
 * :FK: Falkland Islands (the) [Malvinas]
 * :FM: Micronesia (Federated States of)
 * :FO: Faroe Islands (the)
 * :FR: France
 * :GA: Gabon
 * :GB: United Kingdom of Great Britain and Northern Ireland (the)
 * :GD: Grenada
 * :GE: Georgia
 * :GF: French Guiana
 * :GG: Guernsey
 * :GH: Ghana
 * :GI: Gibraltar
 * :GL: Greenland
 * :GM: Gambia (the)
 * :GN: Guinea
 * :GP: Guadeloupe
 * :GQ: Equatorial Guinea
 * :GR: Greece
 * :GS: South Georgia and the South Sandwich Islands
 * :GT: Guatemala
 * :GW: Guinea-Bissau
 * :GY: Guyana
 * :HK: Hong Kong
 * :HM: Heard Island and McDonald Islands
 * :HN: Honduras
 * :HR: Croatia
 * :HT: Haiti
 * :HU: Hungary
 * :ID: Indonesia
 * :IE: Ireland
 * :IL: Israel
 * :IM: Isle of Man
 * :IN: India
 * :IO: British Indian Ocean Territory (the)
 * :IQ: Iraq
 * :IR: Iran (Islamic Republic of)
 * :IS: Iceland
 * :IT: Italy
 * :JE: Jersey
 * :JM: Jamaica
 * :JO: Jordan
 * :JP: Japan
 * :KE: Kenya
 * :KG: Kyrgyzstan
 * :KH: Cambodia
 * :KI: Kiribati
 * :KM: Comoros (the)
 * :KN: Saint Kitts and Nevis
 * :KP: Korea (the Democratic People's Republic of)
 * :KR: Korea (the Republic of)
 * :KW: Kuwait
 * :KY: Cayman Islands (the)
 * :KZ: Kazakhstan
 * :LA: Lao People's Democratic Republic (the)
 * :LB: Lebanon
 * :LC: Saint Lucia
 * :LI: Liechtenstein
 * :LK: Sri Lanka
 * :LR: Liberia
 * :LS: Lesotho
 * :LT: Lithuania
 * :LU: Luxembourg
 * :LV: Latvia
 * :LY: Libya
 * :MA: Morocco
 * :MC: Monaco
 * :MD: Moldova (the Republic of)
 * :ME: Montenegro
 * :MF: Saint Martin (French part)
 * :MG: Madagascar
 * :MK: Macedonia (the former Yugoslav Republic of)
 * :ML: Mali
 * :MM: Myanmar
 * :MN: Mongolia
 * :MO: Macao
 * :MQ: Martinique
 * :MR: Mauritania
 * :MS: Montserrat
 * :MT: Malta
 * :MU: Mauritius
 * :MV: Maldives
 * :MW: Malawi
 * :MX: Mexico
 * :MY: Malaysia
 * :MZ: Mozambique
 * :NA: Namibia
 * :NC: New Caledonia
 * :NE: Niger (the)
 * :NF: Norfolk Island
 * :NG: Nigeria
 * :NI: Nicaragua
 * :NL: Netherlands (the)
 * :NO: Norway
 * :NP: Nepal
 * :NR: Nauru
 * :NU: Niue
 * :NZ: New Zealand
 * :OM: Oman
 * :PA: Panama
 * :PE: Peru
 * :PF: French Polynesia
 * :PG: Papua New Guinea
 * :PH: Philippines (the)
 * :PK: Pakistan
 * :PL: Poland
 * :PM: Saint Pierre and Miquelon
 * :PN: Pitcairn
 * :PS: Palestine, State of
 * :PT: Portugal
 * :PW: Palau
 * :PY: Paraguay
 * :QA: Qatar
 * :RE: Réunion
 * :RO: Romania
 * :RS: Serbia
 * :RU: Russian Federation (the)
 * :RW: Rwanda
 * :SA: Saudi Arabia
 * :SB: Solomon Islands
 * :SC: Seychelles
 * :SD: Sudan (the)
 * :SE: Sweden
 * :SG: Singapore
 * :SH: Saint Helena, Ascension and Tristan da Cunha
 * :SI: Slovenia
 * :SJ: Svalbard and Jan Mayen
 * :SK: Slovakia
 * :SL: Sierra Leone
 * :SM: San Marino
 * :SN: Senegal
 * :SO: Somalia
 * :SR: Suriname
 * :SS: South Sudan
 * :ST: Sao Tome and Principe
 * :SV: El Salvador
 * :SX: Sint Maarten (Dutch part)
 * :SY: Syrian Arab Republic
 * :SZ: Swaziland
 * :TC: Turks and Caicos Islands (the)
 * :TD: Chad
 * :TF: French Southern Territories (the)
 * :TG: Togo
 * :TH: Thailand
 * :TJ: Tajikistan
 * :TK: Tokelau
 * :TL: Timor-Leste
 * :TM: Turkmenistan
 * :TN: Tunisia
 * :TO: Tonga
 * :TR: Turkey
 * :TT: Trinidad and Tobago
 * :TV: Tuvalu
 * :TW: Taiwan (Province of China)
 * :TZ: Tanzania, United Republic of
 * :UA: Ukraine
 * :UG: Uganda
 * :UY: Uruguay
 * :UZ: Uzbekistan
 * :VA: Holy See (the)
 * :VC: Saint Vincent and the Grenadines
 * :VE: Venezuela (Bolivarian Republic of)
 * :VG: Virgin Islands (British)
 * :VN: Viet Nam
 * :VU: Vanuatu
 * :WF: Wallis and Futuna
 * :WS: Samoa
 * :YE: Yemen
 * :YT: Mayotte
 * :ZA: South Africa
 * :ZM: Zambia
 * :ZW: Zimbabwe
 */
export const AddressCountry = {
    US: 'US',
    AD: 'AD',
    AE: 'AE',
    AF: 'AF',
    AG: 'AG',
    AI: 'AI',
    AL: 'AL',
    AM: 'AM',
    AO: 'AO',
    AQ: 'AQ',
    AR: 'AR',
    AT: 'AT',
    AU: 'AU',
    AW: 'AW',
    AX: 'AX',
    AZ: 'AZ',
    BA: 'BA',
    BB: 'BB',
    BD: 'BD',
    BE: 'BE',
    BF: 'BF',
    BG: 'BG',
    BH: 'BH',
    BI: 'BI',
    BJ: 'BJ',
    BL: 'BL',
    BM: 'BM',
    BN: 'BN',
    BO: 'BO',
    BQ: 'BQ',
    BR: 'BR',
    BS: 'BS',
    BT: 'BT',
    BV: 'BV',
    BW: 'BW',
    BY: 'BY',
    BZ: 'BZ',
    CA: 'CA',
    CC: 'CC',
    CD: 'CD',
    CF: 'CF',
    CG: 'CG',
    CH: 'CH',
    CI: 'CI',
    CK: 'CK',
    CL: 'CL',
    CM: 'CM',
    CN: 'CN',
    CO: 'CO',
    CR: 'CR',
    CU: 'CU',
    CV: 'CV',
    CW: 'CW',
    CX: 'CX',
    CY: 'CY',
    CZ: 'CZ',
    DE: 'DE',
    DJ: 'DJ',
    DK: 'DK',
    DM: 'DM',
    DO: 'DO',
    DZ: 'DZ',
    EC: 'EC',
    EE: 'EE',
    EG: 'EG',
    EH: 'EH',
    ER: 'ER',
    ES: 'ES',
    ET: 'ET',
    FI: 'FI',
    FJ: 'FJ',
    FK: 'FK',
    FM: 'FM',
    FO: 'FO',
    FR: 'FR',
    GA: 'GA',
    GB: 'GB',
    GD: 'GD',
    GE: 'GE',
    GF: 'GF',
    GG: 'GG',
    GH: 'GH',
    GI: 'GI',
    GL: 'GL',
    GM: 'GM',
    GN: 'GN',
    GP: 'GP',
    GQ: 'GQ',
    GR: 'GR',
    GS: 'GS',
    GT: 'GT',
    GW: 'GW',
    GY: 'GY',
    HK: 'HK',
    HM: 'HM',
    HN: 'HN',
    HR: 'HR',
    HT: 'HT',
    HU: 'HU',
    ID: 'ID',
    IE: 'IE',
    IL: 'IL',
    IM: 'IM',
    IN: 'IN',
    IO: 'IO',
    IQ: 'IQ',
    IR: 'IR',
    IS: 'IS',
    IT: 'IT',
    JE: 'JE',
    JM: 'JM',
    JO: 'JO',
    JP: 'JP',
    KE: 'KE',
    KG: 'KG',
    KH: 'KH',
    KI: 'KI',
    KM: 'KM',
    KN: 'KN',
    KP: 'KP',
    KR: 'KR',
    KW: 'KW',
    KY: 'KY',
    KZ: 'KZ',
    LA: 'LA',
    LB: 'LB',
    LC: 'LC',
    LI: 'LI',
    LK: 'LK',
    LR: 'LR',
    LS: 'LS',
    LT: 'LT',
    LU: 'LU',
    LV: 'LV',
    LY: 'LY',
    MA: 'MA',
    MC: 'MC',
    MD: 'MD',
    ME: 'ME',
    MF: 'MF',
    MG: 'MG',
    MK: 'MK',
    ML: 'ML',
    MM: 'MM',
    MN: 'MN',
    MO: 'MO',
    MQ: 'MQ',
    MR: 'MR',
    MS: 'MS',
    MT: 'MT',
    MU: 'MU',
    MV: 'MV',
    MW: 'MW',
    MX: 'MX',
    MY: 'MY',
    MZ: 'MZ',
    NA: 'NA',
    NC: 'NC',
    NE: 'NE',
    NF: 'NF',
    NG: 'NG',
    NI: 'NI',
    NL: 'NL',
    NO: 'NO',
    NP: 'NP',
    NR: 'NR',
    NU: 'NU',
    NZ: 'NZ',
    OM: 'OM',
    PA: 'PA',
    PE: 'PE',
    PF: 'PF',
    PG: 'PG',
    PH: 'PH',
    PK: 'PK',
    PL: 'PL',
    PM: 'PM',
    PN: 'PN',
    PS: 'PS',
    PT: 'PT',
    PW: 'PW',
    PY: 'PY',
    QA: 'QA',
    RE: 'RE',
    RO: 'RO',
    RS: 'RS',
    RU: 'RU',
    RW: 'RW',
    SA: 'SA',
    SB: 'SB',
    SC: 'SC',
    SD: 'SD',
    SE: 'SE',
    SG: 'SG',
    SH: 'SH',
    SI: 'SI',
    SJ: 'SJ',
    SK: 'SK',
    SL: 'SL',
    SM: 'SM',
    SN: 'SN',
    SO: 'SO',
    SR: 'SR',
    SS: 'SS',
    ST: 'ST',
    SV: 'SV',
    SX: 'SX',
    SY: 'SY',
    SZ: 'SZ',
    TC: 'TC',
    TD: 'TD',
    TF: 'TF',
    TG: 'TG',
    TH: 'TH',
    TJ: 'TJ',
    TK: 'TK',
    TL: 'TL',
    TM: 'TM',
    TN: 'TN',
    TO: 'TO',
    TR: 'TR',
    TT: 'TT',
    TV: 'TV',
    TW: 'TW',
    TZ: 'TZ',
    UA: 'UA',
    UG: 'UG',
    UY: 'UY',
    UZ: 'UZ',
    VA: 'VA',
    VC: 'VC',
    VE: 'VE',
    VG: 'VG',
    VN: 'VN',
    VU: 'VU',
    WF: 'WF',
    WS: 'WS',
    YE: 'YE',
    YT: 'YT',
    ZA: 'ZA',
    ZM: 'ZM',
    ZW: 'ZW'
} as const;

/**
 * AddressCountry
 *
 * :US: United States
 * :AD: Andorra
 * :AE: United Arab Emirates (the)
 * :AF: Afghanistan
 * :AG: Antigua and Barbuda
 * :AI: Anguilla
 * :AL: Albania
 * :AM: Armenia
 * :AO: Angola
 * :AQ: Antarctica
 * :AR: Argentina
 * :AT: Austria
 * :AU: Australia
 * :AW: Aruba
 * :AX: Åland Islands
 * :AZ: Azerbaijan
 * :BA: Bosnia and Herzegovina
 * :BB: Barbados
 * :BD: Bangladesh
 * :BE: Belgium
 * :BF: Burkina Faso
 * :BG: Bulgaria
 * :BH: Bahrain
 * :BI: Burundi
 * :BJ: Benin
 * :BL: Saint Barthélemy
 * :BM: Bermuda
 * :BN: Brunei Darussalam
 * :BO: Bolivia (Plurinational State of)
 * :BQ: Bonaire, Sint Eustatius and Saba
 * :BR: Brazil
 * :BS: Bahamas (the)
 * :BT: Bhutan
 * :BV: Bouvet Island
 * :BW: Botswana
 * :BY: Belarus
 * :BZ: Belize
 * :CA: Canada
 * :CC: Cocos (Keeling) Islands (the)
 * :CD: Congo (the Democratic Republic of the)
 * :CF: Central African Republic (the)
 * :CG: Congo (the)
 * :CH: Switzerland
 * :CI: Côte d'Ivoire
 * :CK: Cook Islands (the)
 * :CL: Chile
 * :CM: Cameroon
 * :CN: China
 * :CO: Colombia
 * :CR: Costa Rica
 * :CU: Cuba
 * :CV: Cabo Verde
 * :CW: Curaçao
 * :CX: Christmas Island
 * :CY: Cyprus
 * :CZ: Czech Republic (the)
 * :DE: Germany
 * :DJ: Djibouti
 * :DK: Denmark
 * :DM: Dominica
 * :DO: Dominican Republic (the)
 * :DZ: Algeria
 * :EC: Ecuador
 * :EE: Estonia
 * :EG: Egypt
 * :EH: Western Sahara*
 * :ER: Eritrea
 * :ES: Spain
 * :ET: Ethiopia
 * :FI: Finland
 * :FJ: Fiji
 * :FK: Falkland Islands (the) [Malvinas]
 * :FM: Micronesia (Federated States of)
 * :FO: Faroe Islands (the)
 * :FR: France
 * :GA: Gabon
 * :GB: United Kingdom of Great Britain and Northern Ireland (the)
 * :GD: Grenada
 * :GE: Georgia
 * :GF: French Guiana
 * :GG: Guernsey
 * :GH: Ghana
 * :GI: Gibraltar
 * :GL: Greenland
 * :GM: Gambia (the)
 * :GN: Guinea
 * :GP: Guadeloupe
 * :GQ: Equatorial Guinea
 * :GR: Greece
 * :GS: South Georgia and the South Sandwich Islands
 * :GT: Guatemala
 * :GW: Guinea-Bissau
 * :GY: Guyana
 * :HK: Hong Kong
 * :HM: Heard Island and McDonald Islands
 * :HN: Honduras
 * :HR: Croatia
 * :HT: Haiti
 * :HU: Hungary
 * :ID: Indonesia
 * :IE: Ireland
 * :IL: Israel
 * :IM: Isle of Man
 * :IN: India
 * :IO: British Indian Ocean Territory (the)
 * :IQ: Iraq
 * :IR: Iran (Islamic Republic of)
 * :IS: Iceland
 * :IT: Italy
 * :JE: Jersey
 * :JM: Jamaica
 * :JO: Jordan
 * :JP: Japan
 * :KE: Kenya
 * :KG: Kyrgyzstan
 * :KH: Cambodia
 * :KI: Kiribati
 * :KM: Comoros (the)
 * :KN: Saint Kitts and Nevis
 * :KP: Korea (the Democratic People's Republic of)
 * :KR: Korea (the Republic of)
 * :KW: Kuwait
 * :KY: Cayman Islands (the)
 * :KZ: Kazakhstan
 * :LA: Lao People's Democratic Republic (the)
 * :LB: Lebanon
 * :LC: Saint Lucia
 * :LI: Liechtenstein
 * :LK: Sri Lanka
 * :LR: Liberia
 * :LS: Lesotho
 * :LT: Lithuania
 * :LU: Luxembourg
 * :LV: Latvia
 * :LY: Libya
 * :MA: Morocco
 * :MC: Monaco
 * :MD: Moldova (the Republic of)
 * :ME: Montenegro
 * :MF: Saint Martin (French part)
 * :MG: Madagascar
 * :MK: Macedonia (the former Yugoslav Republic of)
 * :ML: Mali
 * :MM: Myanmar
 * :MN: Mongolia
 * :MO: Macao
 * :MQ: Martinique
 * :MR: Mauritania
 * :MS: Montserrat
 * :MT: Malta
 * :MU: Mauritius
 * :MV: Maldives
 * :MW: Malawi
 * :MX: Mexico
 * :MY: Malaysia
 * :MZ: Mozambique
 * :NA: Namibia
 * :NC: New Caledonia
 * :NE: Niger (the)
 * :NF: Norfolk Island
 * :NG: Nigeria
 * :NI: Nicaragua
 * :NL: Netherlands (the)
 * :NO: Norway
 * :NP: Nepal
 * :NR: Nauru
 * :NU: Niue
 * :NZ: New Zealand
 * :OM: Oman
 * :PA: Panama
 * :PE: Peru
 * :PF: French Polynesia
 * :PG: Papua New Guinea
 * :PH: Philippines (the)
 * :PK: Pakistan
 * :PL: Poland
 * :PM: Saint Pierre and Miquelon
 * :PN: Pitcairn
 * :PS: Palestine, State of
 * :PT: Portugal
 * :PW: Palau
 * :PY: Paraguay
 * :QA: Qatar
 * :RE: Réunion
 * :RO: Romania
 * :RS: Serbia
 * :RU: Russian Federation (the)
 * :RW: Rwanda
 * :SA: Saudi Arabia
 * :SB: Solomon Islands
 * :SC: Seychelles
 * :SD: Sudan (the)
 * :SE: Sweden
 * :SG: Singapore
 * :SH: Saint Helena, Ascension and Tristan da Cunha
 * :SI: Slovenia
 * :SJ: Svalbard and Jan Mayen
 * :SK: Slovakia
 * :SL: Sierra Leone
 * :SM: San Marino
 * :SN: Senegal
 * :SO: Somalia
 * :SR: Suriname
 * :SS: South Sudan
 * :ST: Sao Tome and Principe
 * :SV: El Salvador
 * :SX: Sint Maarten (Dutch part)
 * :SY: Syrian Arab Republic
 * :SZ: Swaziland
 * :TC: Turks and Caicos Islands (the)
 * :TD: Chad
 * :TF: French Southern Territories (the)
 * :TG: Togo
 * :TH: Thailand
 * :TJ: Tajikistan
 * :TK: Tokelau
 * :TL: Timor-Leste
 * :TM: Turkmenistan
 * :TN: Tunisia
 * :TO: Tonga
 * :TR: Turkey
 * :TT: Trinidad and Tobago
 * :TV: Tuvalu
 * :TW: Taiwan (Province of China)
 * :TZ: Tanzania, United Republic of
 * :UA: Ukraine
 * :UG: Uganda
 * :UY: Uruguay
 * :UZ: Uzbekistan
 * :VA: Holy See (the)
 * :VC: Saint Vincent and the Grenadines
 * :VE: Venezuela (Bolivarian Republic of)
 * :VG: Virgin Islands (British)
 * :VN: Viet Nam
 * :VU: Vanuatu
 * :WF: Wallis and Futuna
 * :WS: Samoa
 * :YE: Yemen
 * :YT: Mayotte
 * :ZA: South Africa
 * :ZM: Zambia
 * :ZW: Zimbabwe
 */
export type AddressCountry = typeof AddressCountry[keyof typeof AddressCountry];

/**
 * Agency
 */
export type Agency = {
    /**
     * Id
     */
    id: string;
    /**
     * Code
     */
    code: string;
    /**
     * Name
     */
    name: string;
    country: AgencyCountry;
};

/**
 * AgencyCountry
 */
export const AgencyCountry = {
    US: 'US',
    CA: 'CA',
    AD: 'AD',
    AE: 'AE',
    AF: 'AF',
    AG: 'AG',
    AL: 'AL',
    AM: 'AM',
    AN: 'AN',
    AO: 'AO',
    AQ: 'AQ',
    AR: 'AR',
    AS: 'AS',
    AT: 'AT',
    AU: 'AU',
    AW: 'AW',
    AZ: 'AZ',
    BA: 'BA',
    BB: 'BB',
    BD: 'BD',
    BE: 'BE',
    BF: 'BF',
    BG: 'BG',
    BH: 'BH',
    BI: 'BI',
    BJ: 'BJ',
    BM: 'BM',
    BN: 'BN',
    BO: 'BO',
    BR: 'BR',
    BS: 'BS',
    BT: 'BT',
    BV: 'BV',
    BW: 'BW',
    BY: 'BY',
    BZ: 'BZ',
    CC: 'CC',
    CD: 'CD',
    CF: 'CF',
    CG: 'CG',
    CH: 'CH',
    CI: 'CI',
    CK: 'CK',
    CL: 'CL',
    CM: 'CM',
    CN: 'CN',
    CO: 'CO',
    CR: 'CR',
    CS: 'CS',
    CU: 'CU',
    CV: 'CV',
    CX: 'CX',
    CY: 'CY',
    CZ: 'CZ',
    DE: 'DE',
    DJ: 'DJ',
    DK: 'DK',
    DM: 'DM',
    DO: 'DO',
    DZ: 'DZ',
    EC: 'EC',
    EE: 'EE',
    EG: 'EG',
    EH: 'EH',
    ER: 'ER',
    ES: 'ES',
    ET: 'ET',
    FI: 'FI',
    FJ: 'FJ',
    FK: 'FK',
    FM: 'FM',
    FO: 'FO',
    FR: 'FR',
    GA: 'GA',
    GB: 'GB',
    GD: 'GD',
    GE: 'GE',
    GF: 'GF',
    GH: 'GH',
    GI: 'GI',
    GL: 'GL',
    GM: 'GM',
    GN: 'GN',
    GP: 'GP',
    GQ: 'GQ',
    GR: 'GR',
    GS: 'GS',
    GT: 'GT',
    GU: 'GU',
    GW: 'GW',
    GY: 'GY',
    HK: 'HK',
    HM: 'HM',
    HN: 'HN',
    HR: 'HR',
    HT: 'HT',
    HU: 'HU',
    ID: 'ID',
    IE: 'IE',
    IL: 'IL',
    IN: 'IN',
    IO: 'IO',
    IQ: 'IQ',
    IR: 'IR',
    IS: 'IS',
    IT: 'IT',
    JM: 'JM',
    JO: 'JO',
    JP: 'JP',
    KE: 'KE',
    KG: 'KG',
    KH: 'KH',
    KI: 'KI',
    KM: 'KM',
    KN: 'KN',
    KP: 'KP',
    KR: 'KR',
    KW: 'KW',
    KY: 'KY',
    KZ: 'KZ',
    LA: 'LA',
    LB: 'LB',
    LC: 'LC',
    LI: 'LI',
    LK: 'LK',
    LR: 'LR',
    LS: 'LS',
    LT: 'LT',
    LU: 'LU',
    LV: 'LV',
    LY: 'LY',
    MA: 'MA',
    MC: 'MC',
    MD: 'MD',
    MG: 'MG',
    MH: 'MH',
    MK: 'MK',
    ML: 'ML',
    MM: 'MM',
    MN: 'MN',
    MO: 'MO',
    MP: 'MP',
    MQ: 'MQ',
    MR: 'MR',
    MS: 'MS',
    MT: 'MT',
    MU: 'MU',
    MV: 'MV',
    MW: 'MW',
    MX: 'MX',
    MY: 'MY',
    MZ: 'MZ',
    NA: 'NA',
    NC: 'NC',
    NE: 'NE',
    NF: 'NF',
    NG: 'NG',
    NI: 'NI',
    NL: 'NL',
    NO: 'NO',
    NP: 'NP',
    NR: 'NR',
    NU: 'NU',
    NZ: 'NZ',
    OM: 'OM',
    PA: 'PA',
    PE: 'PE',
    PF: 'PF',
    PG: 'PG',
    PH: 'PH',
    PK: 'PK',
    PL: 'PL',
    PM: 'PM',
    PN: 'PN',
    PR: 'PR',
    PS: 'PS',
    PW: 'PW',
    PY: 'PY',
    QA: 'QA',
    RE: 'RE',
    RO: 'RO',
    RU: 'RU',
    RW: 'RW',
    SA: 'SA',
    SB: 'SB',
    SC: 'SC',
    SD: 'SD',
    SE: 'SE',
    SG: 'SG',
    SH: 'SH',
    SI: 'SI',
    SJ: 'SJ',
    SK: 'SK',
    SL: 'SL',
    SM: 'SM',
    SN: 'SN',
    SO: 'SO',
    SR: 'SR',
    ST: 'ST',
    SV: 'SV',
    SY: 'SY',
    SZ: 'SZ',
    TC: 'TC',
    TD: 'TD',
    TF: 'TF',
    TG: 'TG',
    TH: 'TH',
    TJ: 'TJ',
    TK: 'TK',
    TL: 'TL',
    TM: 'TM',
    TN: 'TN',
    TO: 'TO',
    TR: 'TR',
    TT: 'TT',
    TV: 'TV',
    TW: 'TW',
    TZ: 'TZ',
    UA: 'UA',
    UG: 'UG',
    UM: 'UM',
    UY: 'UY',
    UZ: 'UZ',
    VC: 'VC',
    VE: 'VE',
    VG: 'VG',
    VI: 'VI',
    VN: 'VN',
    VU: 'VU',
    WF: 'WF',
    WS: 'WS',
    YE: 'YE',
    YT: 'YT',
    ZA: 'ZA',
    ZM: 'ZM',
    ZW: 'ZW'
} as const;

/**
 * AgencyCountry
 */
export type AgencyCountry = typeof AgencyCountry[keyof typeof AgencyCountry];

/**
 * AggregateExpression
 *
 * `func(column)` over the bucket. The standard metric kind.
 */
export type AggregateExpression = {
    /**
     * Kind
     */
    kind?: 'aggregate';
    /**
     * Column
     */
    column: string;
    /**
     * Func
     */
    func: 'sum' | 'avg' | 'min' | 'max' | 'count' | 'count_distinct' | 'array_agg' | 'array_agg_distinct' | 'string_agg';
    /**
     * Separator
     */
    separator?: string | null;
};

/**
 * Alert
 */
export type Alert = {
    /**
     * Id
     */
    id: string;
    /**
     * Org Id
     */
    org_id: string;
    severity: AlertSeverity;
    /**
     * Title
     */
    title: string;
    /**
     * Created At
     */
    created_at: string;
    /**
     * Cleared At
     */
    cleared_at: string | null;
    cleared_by: OrgUserRef | null;
    /**
     * Message
     */
    message: string | null;
    /**
     * Metadata
     */
    metadata: {
        [key: string]: unknown;
    } | null;
    /**
     * Timeout Seconds
     */
    timeout_seconds: number | null;
};

/**
 * AlertSeverity
 */
export const AlertSeverity = { HIGH: 'High', LOW: 'Low' } as const;

/**
 * AlertSeverity
 */
export type AlertSeverity = typeof AlertSeverity[keyof typeof AlertSeverity];

/**
 * AlertStats
 */
export type AlertStats = {
    /**
     * Total
     */
    total: number;
    /**
     * Uncleared
     */
    uncleared: number;
    /**
     * High Severity
     */
    high_severity: number;
    /**
     * Low Severity
     */
    low_severity: number;
};

/**
 * AlertSummary
 */
export type AlertSummary = {
    /**
     * Id
     */
    id: string;
    /**
     * Org Id
     */
    org_id: string;
    severity: AlertSeverity;
    /**
     * Title
     */
    title: string;
    /**
     * Created At
     */
    created_at: string;
    /**
     * Cleared At
     */
    cleared_at: string | null;
    cleared_by: OrgUserRef | null;
};

/**
 * AlertUpdate
 */
export type AlertUpdate = {
    /**
     * Cleared
     */
    cleared?: boolean | null;
};

/**
 * AlertsDigest
 */
export type AlertsDigest = {
    /**
     * Uncleared
     */
    uncleared: number;
    /**
     * High Severity
     */
    high_severity: number;
};

/**
 * AttestationKind
 *
 * Dated evidence about a property that program exemptions and requirements rely on.
 */
export const AttestationKind = {
    ENERGY_AUDIT: 'Energy audit',
    RETRO_COMMISSIONING: 'Retro-commissioning',
    TUNE_UP: 'Tune-up',
    ENERGY_STAR_CERTIFICATION: 'ENERGY STAR certification',
    GREEN_BUILDING_CERTIFICATION: 'Green building certification',
    PROFESSIONAL_ATTESTATION: 'Professional attestation',
    OTHER: 'Other'
} as const;

/**
 * AttestationKind
 *
 * Dated evidence about a property that program exemptions and requirements rely on.
 */
export type AttestationKind = typeof AttestationKind[keyof typeof AttestationKind];

/**
 * AttestationModel
 */
export type AttestationModel = {
    kind?: AttestationKind | null;
    /**
     * Name
     */
    name?: string | null;
    /**
     * Issuer
     */
    issuer?: string | null;
    /**
     * Issued On
     */
    issued_on?: string | null;
    /**
     * Expires On
     */
    expires_on?: string | null;
    /**
     * Evidence
     */
    evidence?: {
        [key: string]: unknown;
    } | null;
    /**
     * File Id
     */
    file_id?: string | null;
    /**
     * Notes
     */
    notes?: string | null;
};

/**
 * AttestationResponse
 */
export type AttestationResponse = {
    /**
     * Id
     */
    id: string;
    kind: AttestationKind;
    /**
     * Name
     */
    name: string;
    /**
     * Issuer
     */
    issuer: string | null;
    /**
     * Issued On
     */
    issued_on: string;
    /**
     * Expires On
     */
    expires_on: string | null;
    /**
     * Evidence
     */
    evidence: {
        [key: string]: unknown;
    } | null;
    /**
     * File Id
     */
    file_id: string | null;
    /**
     * Notes
     */
    notes: string | null;
    /**
     * Created At
     */
    created_at: string;
    /**
     * Is Valid Today
     */
    is_valid_today: boolean;
};

/**
 * AutoMatchCandidate
 */
export type AutoMatchCandidate = {
    /**
     * Em Property Id
     */
    em_property_id: string;
    /**
     * Org Id
     */
    org_id: string;
    /**
     * Is Same Org
     */
    is_same_org: boolean;
    /**
     * Name
     */
    name: string;
    /**
     * Address1
     */
    address1: string | null;
    /**
     * City
     */
    city: string | null;
    state: State | null;
    primary_function: PropertyFunction | null;
    /**
     * Gross Floor Area
     */
    gross_floor_area: number | string | null;
    /**
     * Year Built
     */
    year_built: number | null;
    share_status: ShareRequestStatus | null;
};

/**
 * BatchQueryRequest
 *
 * Multiple specs in one HTTP request. Used by dashboard pages.
 */
export type BatchQueryRequest = {
    /**
     * Queries
     */
    queries: {
        [key: string]: QuerySpec;
    };
};

/**
 * BatchQueryResponse
 */
export type BatchQueryResponse = {
    /**
     * Results
     */
    results: {
        [key: string]: QueryResult;
    };
};

/**
 * BillingAccountPatch
 */
export type BillingAccountPatch = {
    /**
     * Name
     */
    name?: string | null;
    /**
     * Vendor Account Number
     */
    vendor_account_number?: string | null;
    /**
     * Department Ids
     */
    department_ids?: Array<string> | null;
    /**
     * Identifiers
     */
    identifiers?: Array<Identifier> | null;
};

/**
 * Body_org-account-image-update_image
 */
export type BodyOrgAccountImageUpdateImage = {
    /**
     * Image
     */
    image: Blob | File;
};

/**
 * Body_org-file--upload_files
 */
export type BodyOrgFileUploadFiles = {
    /**
     * Files
     */
    files: Array<Blob | File>;
};

/**
 * Body_org-image-update_image
 */
export type BodyOrgImageUpdateImage = {
    /**
     * Image
     */
    image: Blob | File;
};

/**
 * Body_org-jurisdiction-upload-boundary-upload_boundary_file
 */
export type BodyOrgJurisdictionUploadBoundaryUploadBoundaryFile = {
    /**
     * File
     */
    file: Blob | File;
};

/**
 * Body_org-program-cycles-portals-submissions-upload_owner_portal_submission
 */
export type BodyOrgProgramCyclesPortalsSubmissionsUploadOwnerPortalSubmission = {
    /**
     * Property Id
     */
    property_id: string;
    /**
     * File
     */
    file: Blob | File;
};

/**
 * Body_org-user-image-update_image
 */
export type BodyOrgUserImageUpdateImage = {
    /**
     * Image
     */
    image: Blob | File;
};

/**
 * BucketGrain
 */
export const BucketGrain = {
    HOURLY: 'Hourly',
    DAILY: 'Daily',
    WEEKLY: 'Weekly',
    'WEEKLY_ALIGNED,_MONDAY_START': 'Weekly (Aligned, Monday-Start)',
    MONTHLY_CALENDAR: 'Monthly (Calendar)',
    QUARTERLY_CALENDAR: 'Quarterly (Calendar)',
    YEARLY_CALENDAR: 'Yearly (Calendar)',
    MONTHLY_FISCAL: 'Monthly (Fiscal)',
    QUARTERLY_FISCAL: 'Quarterly (Fiscal)',
    YEARLY_FISCAL: 'Yearly (Fiscal)'
} as const;

/**
 * BucketGrain
 */
export type BucketGrain = typeof BucketGrain[keyof typeof BucketGrain];

/**
 * BuildingPerformanceProgramsDigest
 */
export type BuildingPerformanceProgramsDigest = {
    /**
     * Total Programs
     */
    total_programs: number;
    /**
     * Active Cycles
     */
    active_cycles: number;
    /**
     * Enrolled Properties
     */
    enrolled_properties: number;
};

/**
 * BulkRequirementSatisfied
 */
export type BulkRequirementSatisfied = {
    /**
     * Cycle Id
     */
    cycle_id: string;
    /**
     * Requirement Key
     */
    requirement_key: string;
    /**
     * Property Ids
     */
    property_ids: Array<string>;
    /**
     * Note
     */
    note?: string | null;
};

/**
 * CitywideReport
 */
export type CitywideReport = {
    /**
     * Cycle Id
     */
    cycle_id: string;
    /**
     * Enrolled
     */
    enrolled: number;
    /**
     * Exempt
     */
    exempt: number;
    /**
     * In Compliance
     */
    in_compliance: number;
    /**
     * Non Compliant
     */
    non_compliant: number;
    /**
     * Pending
     */
    pending: number;
    /**
     * Other
     */
    other: number;
    /**
     * Compliance Rate
     */
    compliance_rate: number;
    /**
     * By Status
     */
    by_status: Array<StatusBreakdown>;
    /**
     * By Property Function
     */
    by_property_function: Array<CountByKey>;
    /**
     * By Gfa Bucket
     */
    by_gfa_bucket: Array<CountByKey>;
};

/**
 * CoefficientMethod
 */
export const CoefficientMethod = {
    STANDARD: 'Standard',
    TIME_OF_USE: 'Time of use',
    OFFSITE_SOLAR: 'Offsite solar',
    BENEFICIAL_ELECTRIFICATION: 'Beneficial electrification'
} as const;

/**
 * CoefficientMethod
 */
export type CoefficientMethod = typeof CoefficientMethod[keyof typeof CoefficientMethod];

/**
 * CoefficientResponse
 */
export type CoefficientResponse = {
    /**
     * Key
     */
    key: string;
    /**
     * Fuel Key
     */
    fuel_key: string;
    method: CoefficientMethod;
    /**
     * Unit
     */
    unit: string;
    /**
     * Start Year
     */
    start_year: number;
    /**
     * End Year
     */
    end_year: number | null;
    /**
     * Value
     */
    value: number | string;
    record_status: ProgramRecordStatus;
    /**
     * Provenance
     */
    provenance: {
        [key: string]: unknown;
    } | null;
};

/**
 * CommodityCategory
 */
export const CommodityCategory = {
    ENERGY: 'ENERGY',
    WATER: 'WATER',
    WASTE: 'WASTE'
} as const;

/**
 * CommodityCategory
 */
export type CommodityCategory = typeof CommodityCategory[keyof typeof CommodityCategory];

/**
 * CommodityRef
 *
 * Reference commodity from the global commodity catalog.
 */
export type CommodityRef = {
    /**
     * Id
     */
    id: string;
    /**
     * Name
     */
    name: string;
    /**
     * Color
     */
    color: string | null;
    /**
     * Icon
     */
    icon: string | null;
    icon_source: IconSource | null;
    /**
     * Unit Of Measure
     */
    unit_of_measure: string | null;
    category: CommodityCategory;
};

/**
 * CommunicationChannel
 *
 * Communication channel for program communications
 */
export const CommunicationChannel = {
    EMAIL: 'Email',
    IN_APP_NOTIFICATION: 'In-App Notification',
    PRINT_MAIL: 'Print/Mail',
    SMS: 'SMS'
} as const;

/**
 * CommunicationChannel
 *
 * Communication channel for program communications
 */
export type CommunicationChannel = typeof CommunicationChannel[keyof typeof CommunicationChannel];

/**
 * CommunicationTemplateCreate
 */
export type CommunicationTemplateCreate = {
    /**
     * Name
     */
    name: string;
    /**
     * Description
     */
    description?: string | null;
    /**
     * Channel
     */
    channel: string;
    /**
     * Subject
     */
    subject?: string | null;
    /**
     * Body
     */
    body: string;
    /**
     * Header Html
     */
    header_html?: string | null;
    /**
     * Footer Html
     */
    footer_html?: string | null;
    /**
     * Category
     */
    category?: string | null;
};

/**
 * CommunicationTemplateResponse
 */
export type CommunicationTemplateResponse = {
    /**
     * Id
     */
    id: string;
    /**
     * Program Id
     */
    program_id: string;
    /**
     * Name
     */
    name: string;
    /**
     * Description
     */
    description: string | null;
    channel: CommunicationChannel;
    /**
     * Subject
     */
    subject: string | null;
    /**
     * Body
     */
    body: string;
    /**
     * Header Html
     */
    header_html: string | null;
    /**
     * Footer Html
     */
    footer_html: string | null;
    /**
     * Category
     */
    category: string | null;
    /**
     * Is Active
     */
    is_active: boolean;
    /**
     * Available Merge Fields
     */
    available_merge_fields: Array<string> | null;
};

/**
 * CommunicationTemplateUpdate
 */
export type CommunicationTemplateUpdate = {
    /**
     * Name
     */
    name?: string | null;
    /**
     * Description
     */
    description?: string | null;
    /**
     * Channel
     */
    channel?: string | null;
    /**
     * Subject
     */
    subject?: string | null;
    /**
     * Body
     */
    body?: string | null;
    /**
     * Header Html
     */
    header_html?: string | null;
    /**
     * Footer Html
     */
    footer_html?: string | null;
    /**
     * Category
     */
    category?: string | null;
    /**
     * Is Active
     */
    is_active?: boolean | null;
};

/**
 * ComplianceRecordCreatePublic
 */
export type ComplianceRecordCreatePublic = {
    /**
     * Property Id
     */
    property_id: string;
    compliance_status?: ComplianceStatus;
    /**
     * Compliance Score
     */
    compliance_score?: number | string | null;
    /**
     * Compliance Notes
     */
    compliance_notes?: string | null;
};

/**
 * ComplianceRecordResponse
 */
export type ComplianceRecordResponse = {
    /**
     * Id
     */
    id: string;
    /**
     * Property Id
     */
    property_id: string;
    /**
     * Cycle Id
     */
    cycle_id: string;
    compliance_status: ComplianceStatus;
    /**
     * Compliance Score
     */
    compliance_score: number | string | null;
    /**
     * Compliance Notes
     */
    compliance_notes: string | null;
    /**
     * Extension Granted
     */
    extension_granted: boolean;
    /**
     * Extension Deadline
     */
    extension_deadline: string | null;
    /**
     * Has Violations
     */
    has_violations: boolean;
    /**
     * Violation Details
     */
    violation_details: {
        [key: string]: unknown;
    } | null;
};

/**
 * ComplianceRecordUpdate
 */
export type ComplianceRecordUpdate = {
    compliance_status?: ComplianceStatus | null;
    /**
     * Compliance Score
     */
    compliance_score?: number | string | null;
    /**
     * Compliance Notes
     */
    compliance_notes?: string | null;
    /**
     * Extension Granted
     */
    extension_granted?: boolean | null;
    /**
     * Extension Deadline
     */
    extension_deadline?: string | null;
    /**
     * Extension Reason
     */
    extension_reason?: string | null;
    /**
     * Has Violations
     */
    has_violations?: boolean | null;
    /**
     * Violation Details
     */
    violation_details?: {
        [key: string]: unknown;
    } | null;
};

/**
 * ComplianceStatus
 *
 * Compliance status for a property within a program
 */
export const ComplianceStatus = {
    NOT_APPLICABLE: 'Not Applicable',
    PENDING: 'Pending',
    IN_COMPLIANCE: 'In Compliance',
    NON_COMPLIANT: 'Non-Compliant',
    EXEMPT: 'Exempt',
    EXTENSION_GRANTED: 'Extension Granted',
    UNDER_REVIEW: 'Under Review'
} as const;

/**
 * ComplianceStatus
 *
 * Compliance status for a property within a program
 */
export type ComplianceStatus = typeof ComplianceStatus[keyof typeof ComplianceStatus];

/**
 * ComplianceTaskCreate
 *
 * Data for creating a compliance task.
 */
export type ComplianceTaskCreate = {
    /**
     * Tracking Id
     */
    tracking_id: string;
    /**
     * Requirement Id
     */
    requirement_id?: string | null;
    /**
     * Parent Task Id
     */
    parent_task_id?: string | null;
    /**
     * Name
     */
    name: string;
    /**
     * Description
     */
    description?: string | null;
    /**
     * Instructions
     */
    instructions?: string | null;
    /**
     * Due Date
     */
    due_date?: string | null;
    /**
     * Priority
     */
    priority?: number;
    /**
     * Assignee Ids
     */
    assignee_ids?: Array<string> | null;
};

/**
 * ComplianceTaskStatus
 *
 * Status of a compliance task
 */
export const ComplianceTaskStatus = {
    NOT_STARTED: 'Not Started',
    IN_PROGRESS: 'In Progress',
    COMPLETED: 'Completed',
    OVERDUE: 'Overdue',
    BLOCKED: 'Blocked',
    SKIPPED: 'Skipped',
    CANCELLED: 'Cancelled'
} as const;

/**
 * ComplianceTaskStatus
 *
 * Status of a compliance task
 */
export type ComplianceTaskStatus = typeof ComplianceTaskStatus[keyof typeof ComplianceTaskStatus];

/**
 * ComplianceTaskUpdate
 *
 * Data for updating a compliance task.
 */
export type ComplianceTaskUpdate = {
    /**
     * Name
     */
    name?: string | null;
    /**
     * Description
     */
    description?: string | null;
    /**
     * Instructions
     */
    instructions?: string | null;
    status?: ComplianceTaskStatus | null;
    /**
     * Due Date
     */
    due_date?: string | null;
    /**
     * Priority
     */
    priority?: number | null;
    /**
     * Assignee Ids
     */
    assignee_ids?: Array<string> | null;
    /**
     * Display Order
     */
    display_order?: number | null;
};

/**
 * CompoundAggExpression
 *
 * Arithmetic between two aggregates, evaluated post-GROUP BY.
 *
 * Example: `SUM(charge) + SUM(other_charge)`.
 *
 * Operands may themselves be `CompoundAggExpression`, which is what allows
 * three-term expressions. Load factor is the motivating case:
 *
 * SUM(energy_kwh) / (MAX(peak_kw) * SUM(interval_hours))
 *
 * That cannot be a `RatioExpression`, whose denominator is a single aggregate
 * or a sum of like components. Nesting keeps the "no pre-divided ratios are
 * ever stored" contract intact -- the components stay additive on the fact and
 * the division still happens after GROUP BY, so the number stays correct when
 * a daily result is rolled up to a month.
 */
export type CompoundAggExpression = {
    /**
     * Kind
     */
    kind?: 'compound_agg';
    /**
     * Lhs
     */
    lhs: AggregateExpression | CompoundAggExpression;
    /**
     * Rhs
     */
    rhs: AggregateExpression | CompoundAggExpression;
    /**
     * Op
     */
    op: 'add' | 'subtract' | 'multiply' | 'divide';
};

/**
 * CompoundRowExpression
 *
 * Row-wise arithmetic between two columns, evaluated pre-GROUP BY, then
 * wrapped in a final aggregate — e.g. two columns multiplied at the line-item
 * level and the result summed.
 */
export type CompoundRowExpression = {
    /**
     * Kind
     */
    kind?: 'compound_row';
    /**
     * Lhs Column
     */
    lhs_column: string;
    /**
     * Rhs Column
     */
    rhs_column: string;
    /**
     * Op
     */
    op: 'add' | 'subtract' | 'multiply' | 'divide';
    /**
     * Outer Func
     */
    outer_func?: 'sum' | 'avg' | 'min' | 'max' | 'count' | 'count_distinct' | 'array_agg' | 'array_agg_distinct' | 'string_agg';
};

/**
 * ConstructionStatus
 */
export const ConstructionStatus = {
    EXISTING: 'Existing',
    PROJECT: 'Project',
    TEST: 'Test'
} as const;

/**
 * ConstructionStatus
 */
export type ConstructionStatus = typeof ConstructionStatus[keyof typeof ConstructionStatus];

/**
 * CountByKey
 */
export type CountByKey = {
    /**
     * Key
     */
    key: string;
    /**
     * Count
     */
    count: number;
};

/**
 * CoverageListKind
 *
 * COVERED_BUILDINGS lists name the buildings an agency treats as covered (with per-program flags);
 * AGENCY_STATUS lists report the agency's view of each building's compliance for a year.
 */
export const CoverageListKind = { COVERED_BUILDINGS: 'Covered buildings', AGENCY_STATUS: 'Agency status' } as const;

/**
 * CoverageListKind
 *
 * COVERED_BUILDINGS lists name the buildings an agency treats as covered (with per-program flags);
 * AGENCY_STATUS lists report the agency's view of each building's compliance for a year.
 */
export type CoverageListKind = typeof CoverageListKind[keyof typeof CoverageListKind];

/**
 * CoverageListResponse
 */
export type CoverageListResponse = {
    /**
     * Id
     */
    id: string;
    /**
     * Org Id
     */
    org_id: string | null;
    /**
     * Key
     */
    key: string;
    /**
     * Version
     */
    version: string;
    list_kind: CoverageListKind;
    /**
     * Title
     */
    title: string;
    /**
     * Publisher
     */
    publisher: string | null;
    /**
     * Source Url
     */
    source_url: string | null;
    /**
     * As Of Date
     */
    as_of_date: string | null;
    /**
     * Row Count
     */
    row_count: number;
    /**
     * Is Current
     */
    is_current: boolean;
    /**
     * Imported At
     */
    imported_at: string;
    /**
     * Is Platform List
     */
    is_platform_list: boolean;
};

/**
 * CoverageMatchOutcome
 */
export const CoverageMatchOutcome = { MATCHED: 'Matched', AMBIGUOUS: 'Ambiguous' } as const;

/**
 * CoverageMatchOutcome
 */
export type CoverageMatchOutcome = typeof CoverageMatchOutcome[keyof typeof CoverageMatchOutcome];

/**
 * CoverageMatchResponse
 */
export type CoverageMatchResponse = {
    /**
     * Id
     */
    id: string;
    /**
     * Property Id
     */
    property_id: string;
    outcome: CoverageMatchOutcome;
    /**
     * Method
     */
    method: string | null;
    /**
     * Confidence
     */
    confidence: string | null;
    /**
     * Reason
     */
    reason: string | null;
    /**
     * Size Mismatch
     */
    size_mismatch: boolean;
    /**
     * Entry Id
     */
    entry_id: string | null;
    /**
     * Entry Fields
     */
    entry_fields: {
        [key: string]: unknown;
    } | null;
    /**
     * Candidate Entry Ids
     */
    candidate_entry_ids: Array<string> | null;
    /**
     * Agency Status
     */
    agency_status: string | null;
    /**
     * Data Year
     */
    data_year: number | null;
};

/**
 * CriteriaKind
 *
 * Role of a criteria row in the coverage decision.
 *
 * INCLUDE rows are OR'd; an EXCLUDE row that matches removes the property; a REVIEW row that matches a
 * covered property leaves the decision to a person; ROUTE rows (lowest priority first) assign a track.
 */
export const CriteriaKind = {
    INCLUDE: 'Include',
    EXCLUDE: 'Exclude',
    REVIEW: 'Review',
    ROUTE: 'Route'
} as const;

/**
 * CriteriaKind
 *
 * Role of a criteria row in the coverage decision.
 *
 * INCLUDE rows are OR'd; an EXCLUDE row that matches removes the property; a REVIEW row that matches a
 * covered property leaves the decision to a person; ROUTE rows (lowest priority first) assign a track.
 */
export type CriteriaKind = typeof CriteriaKind[keyof typeof CriteriaKind];

/**
 * CriteriaResponse
 */
export type CriteriaResponse = {
    /**
     * Id
     */
    id: string;
    /**
     * Program Id
     */
    program_id: string | null;
    /**
     * Cycle Id
     */
    cycle_id: string | null;
    /**
     * Name
     */
    name: string;
    /**
     * Description
     */
    description: string | null;
    /**
     * Min Gross Floor Area
     */
    min_gross_floor_area: number | null;
    /**
     * Max Gross Floor Area
     */
    max_gross_floor_area: number | null;
    floor_area_uom: FloorAreaUnitOfMeasure;
    /**
     * Included Property Types
     */
    included_property_types: Array<PropertyFunction> | null;
    /**
     * Excluded Property Types
     */
    excluded_property_types: Array<PropertyFunction> | null;
    /**
     * Min Buildings
     */
    min_buildings: number | null;
    /**
     * Min Year Built
     */
    min_year_built: number | null;
    /**
     * Max Year Built
     */
    max_year_built: number | null;
    /**
     * Min Occupancy Percentage
     */
    min_occupancy_percentage: number | null;
    /**
     * Applies To Federal Properties
     */
    applies_to_federal_properties: boolean;
    /**
     * Applies To Institutional Properties
     */
    applies_to_institutional_properties: boolean;
    /**
     * Evaluation Order
     */
    evaluation_order: number;
    /**
     * Is Active
     */
    is_active: boolean;
    /**
     * Key
     */
    key: string | null;
    criteria_kind: CriteriaKind;
    /**
     * Track Key
     */
    track_key: string | null;
    /**
     * Priority
     */
    priority: number;
    /**
     * Custom Criteria
     */
    custom_criteria: {
        [key: string]: unknown;
    } | null;
    /**
     * First Year
     */
    first_year: number | null;
    /**
     * Last Year
     */
    last_year: number | null;
    /**
     * Effective To
     */
    effective_to: string | null;
    record_status: ProgramRecordStatus;
    /**
     * Provenance
     */
    provenance: {
        [key: string]: unknown;
    } | null;
};

/**
 * CycleComplianceStats
 */
export type CycleComplianceStats = {
    /**
     * Cycle Id
     */
    cycle_id: string;
    /**
     * Total Properties
     */
    total_properties?: number;
    /**
     * Enrolled Properties
     */
    enrolled_properties?: number;
    /**
     * Compliant Properties
     */
    compliant_properties?: number;
    /**
     * Non Compliant Properties
     */
    non_compliant_properties?: number;
    /**
     * Pending Properties
     */
    pending_properties?: number;
    /**
     * Exempt Properties
     */
    exempt_properties?: number;
    /**
     * Compliance Rate
     */
    compliance_rate?: number;
};

/**
 * CycleResponse
 */
export type CycleResponse = {
    /**
     * Id
     */
    id: string;
    /**
     * Program Id
     */
    program_id: string;
    /**
     * Name
     */
    name: string;
    /**
     * Start Date
     */
    start_date: string;
    /**
     * End Date
     */
    end_date: string;
    /**
     * Reporting Year
     */
    reporting_year: number | null;
    status: ProgramStatus;
    /**
     * Created At
     */
    created_at: string;
    /**
     * Updated At
     */
    updated_at: string;
    /**
     * Key
     */
    key: string | null;
    record_status: ProgramRecordStatus;
    /**
     * Provenance
     */
    provenance: {
        [key: string]: unknown;
    } | null;
};

/**
 * DashboardBlockTemplate
 *
 * One cell in a dashboard template.
 *
 * `view_template_id` references a `ViewTemplate` by id. Each block becomes
 * one `DBView` + one entry in `DBDashboard.contents.blocks` when the
 * dashboard template is instantiated.
 *
 * A `view_template_id` of `None` denotes a static text/markdown block,
 * rendered by the dashboard renderer from `props` without any data fetch.
 */
export type DashboardBlockTemplate = {
    /**
     * View Template Id
     */
    view_template_id?: string | null;
    /**
     * Width
     */
    width?: number;
    /**
     * Height
     */
    height?: number | null;
    /**
     * Title
     */
    title?: string | null;
    /**
     * Subtitle
     */
    subtitle?: string | null;
    /**
     * Presentation
     */
    presentation?: string | null;
    /**
     * Presentation Props
     */
    presentation_props?: {
        [key: string]: unknown;
    };
};

/**
 * DashboardCreateFromTemplateRequest
 */
export type DashboardCreateFromTemplateRequest = {
    /**
     * Template Id
     */
    template_id: string;
    /**
     * Name
     */
    name?: string | null;
};

/**
 * DashboardCreateRequest
 */
export type DashboardCreateRequest = {
    /**
     * Name
     */
    name: string;
    /**
     * Contents
     */
    contents?: {
        [key: string]: unknown;
    } | null;
    /**
     * Saved Filter Id
     */
    saved_filter_id?: string | null;
};

/**
 * DashboardDataRequest
 *
 * Request body for `POST /dashboard/{id}/data`.
 *
 * `dynamic_filters` and `dynamic_saved_filter_id` are the runtime filter
 * panel's selection. They merge additively into every block's spec; dims
 * that aren't keyable on a given block's fact are silently dropped.
 */
export type DashboardDataRequest = {
    dynamic_filters?: PublicFilterParams | null;
    /**
     * Dynamic Saved Filter Id
     */
    dynamic_saved_filter_id?: string | null;
};

/**
 * DashboardDetail
 */
export type DashboardDetail = {
    /**
     * Id
     */
    id: string;
    /**
     * Name
     */
    name: string;
    /**
     * Is Published
     */
    is_published: boolean;
    /**
     * Is Editable
     */
    is_editable: boolean;
    /**
     * Is Deletable
     */
    is_deletable: boolean;
    /**
     * Contents
     */
    contents: {
        [key: string]: unknown;
    };
    /**
     * Saved Filter Id
     */
    saved_filter_id?: string | null;
};

/**
 * DashboardReport
 */
export type DashboardReport = {
    /**
     * Cycle Id
     */
    cycle_id: string;
    /**
     * Total Properties
     */
    total_properties: number;
    /**
     * Enrolled
     */
    enrolled: number;
    /**
     * Submissions Pending Review
     */
    submissions_pending_review: number;
    /**
     * Deadlines Upcoming
     */
    deadlines_upcoming: number;
    /**
     * Compliance Rate
     */
    compliance_rate: number;
};

/**
 * DashboardSummary
 */
export type DashboardSummary = {
    /**
     * Id
     */
    id: string;
    /**
     * Name
     */
    name: string;
    /**
     * Is Published
     */
    is_published: boolean;
    /**
     * Is Editable
     */
    is_editable: boolean;
    /**
     * Is Deletable
     */
    is_deletable: boolean;
};

/**
 * DashboardSummaryResponse
 */
export type DashboardSummaryResponse = {
    /**
     * Id
     */
    id: string;
    /**
     * Name
     */
    name: string;
};

/**
 * DashboardTemplateLibraryResponse
 */
export type DashboardTemplateLibraryResponse = {
    /**
     * Categories
     */
    categories: Array<TemplateCategory>;
    /**
     * Templates
     */
    templates: Array<DashboardTemplateV2>;
};

/**
 * DashboardTemplateV2
 *
 * A layout of view-template references.
 */
export type DashboardTemplateV2 = {
    /**
     * Id
     */
    id: string;
    /**
     * Name
     */
    name: string;
    /**
     * Description
     */
    description?: string;
    /**
     * Category Ids
     */
    category_ids?: Array<string>;
    /**
     * Blocks
     */
    blocks: Array<DashboardBlockTemplate>;
    /**
     * Is Default
     */
    is_default?: boolean;
    /**
     * Default Order
     */
    default_order?: number | null;
};

/**
 * DashboardUpdateRequest
 */
export type DashboardUpdateRequest = {
    /**
     * Name
     */
    name?: string | null;
    /**
     * Contents
     */
    contents?: {
        [key: string]: unknown;
    } | null;
    /**
     * Publish
     */
    publish?: boolean | null;
    /**
     * Saved Filter Id
     */
    saved_filter_id?: string | null;
};

/**
 * DeadlineResponse
 */
export type DeadlineResponse = {
    /**
     * Id
     */
    id: string;
    /**
     * Program Id
     */
    program_id: string | null;
    /**
     * Cycle Id
     */
    cycle_id: string | null;
    /**
     * Requirement Id
     */
    requirement_id: string | null;
    /**
     * Name
     */
    name: string;
    /**
     * Description
     */
    description: string | null;
    /**
     * Deadline Date
     */
    deadline_date: string | null;
    /**
     * Template Offset Days
     */
    template_offset_days: number | null;
    /**
     * Template Month
     */
    template_month: number | null;
    /**
     * Template Day Of Month
     */
    template_day_of_month: number | null;
    /**
     * Applies To Reporting Year
     */
    applies_to_reporting_year: boolean;
    /**
     * Reminder Days Before
     */
    reminder_days_before: Array<number> | null;
    /**
     * Is Active
     */
    is_active: boolean;
    /**
     * Key
     */
    key: string | null;
    /**
     * Track Keys
     */
    track_keys: Array<string> | null;
    /**
     * Grace End Date
     */
    grace_end_date: string | null;
    /**
     * Extended Due Date
     */
    extended_due_date: string | null;
    /**
     * Extension Request Opens
     */
    extension_request_opens: string | null;
    /**
     * Extension Request Closes
     */
    extension_request_closes: string | null;
    /**
     * Window Opens
     */
    window_opens: string | null;
    /**
     * Window Closes
     */
    window_closes: string | null;
    /**
     * Weekend Roll
     */
    weekend_roll: string | null;
    /**
     * First Year
     */
    first_year: number | null;
    /**
     * Last Year
     */
    last_year: number | null;
    /**
     * Effective To
     */
    effective_to: string | null;
    record_status: ProgramRecordStatus;
    /**
     * Provenance
     */
    provenance: {
        [key: string]: unknown;
    } | null;
};

/**
 * DeclineRequest
 */
export type DeclineRequest = {
    /**
     * Note
     */
    note?: string | null;
};

/**
 * DefinitionRecordResponse
 */
export type DefinitionRecordResponse = {
    /**
     * Kind
     */
    kind: string;
    /**
     * Key
     */
    key: string;
    /**
     * Fields
     */
    fields: {
        [key: string]: unknown;
    };
    /**
     * Effective From
     */
    effective_from: string | null;
    /**
     * Effective To
     */
    effective_to: string | null;
    /**
     * Definition Version
     */
    definition_version: string;
    /**
     * Created At
     */
    created_at: string;
};

/**
 * Department
 */
export type Department = {
    /**
     * Id
     */
    id: string;
    /**
     * Org Id
     */
    org_id: string;
    /**
     * Name
     */
    name: string;
    /**
     * Short Name
     */
    short_name: string | null;
    /**
     * Properties
     */
    properties: Array<PropertySummary>;
    /**
     * Identifiers
     */
    identifiers: Array<IdentifierRef>;
};

/**
 * DepartmentCreate
 */
export type DepartmentCreate = {
    /**
     * Name
     */
    name: string;
    /**
     * Short Name
     */
    short_name?: string | null;
    /**
     * Property Ids
     */
    property_ids?: Array<string> | null;
    /**
     * Identifiers
     */
    identifiers?: Array<Identifier> | null;
};

/**
 * DepartmentSummary
 */
export type DepartmentSummary = {
    /**
     * Id
     */
    id: string;
    /**
     * Org Id
     */
    org_id: string;
    /**
     * Name
     */
    name: string;
    /**
     * Short Name
     */
    short_name: string | null;
    /**
     * Property Count
     */
    property_count: number;
};

/**
 * DepartmentUpdate
 */
export type DepartmentUpdate = {
    /**
     * Name
     */
    name?: string | null;
    /**
     * Short Name
     */
    short_name?: string | null;
    /**
     * Property Ids
     */
    property_ids?: Array<string> | null;
    /**
     * Identifiers
     */
    identifiers?: Array<Identifier> | null;
};

/**
 * DeterminationCreate
 */
export type DeterminationCreate = {
    kind: DeterminationKind;
    status?: DeterminationStatus;
    /**
     * Relief Key
     */
    relief_key?: string | null;
    /**
     * Requirement Key
     */
    requirement_key?: string | null;
    /**
     * Program Basis
     */
    program_basis?: string | null;
    /**
     * Requested On
     */
    requested_on?: string | null;
    /**
     * Evidence
     */
    evidence?: {
        [key: string]: unknown;
    } | null;
    /**
     * Notes
     */
    notes?: string | null;
};

/**
 * DeterminationDecision
 */
export type DeterminationDecision = {
    status: DeterminationStatus;
    /**
     * Decided On
     */
    decided_on?: string | null;
    /**
     * Valid From
     */
    valid_from?: string | null;
    /**
     * Valid To
     */
    valid_to?: string | null;
    /**
     * Due Date Override
     */
    due_date_override?: string | null;
    /**
     * Amount Fee
     */
    amount_fee?: number | string | null;
    /**
     * Amount Penalty
     */
    amount_penalty?: number | string | null;
    /**
     * Notes
     */
    notes?: string | null;
};

/**
 * DeterminationKind
 *
 * Kinds of program relief (reference data on the program) and of agency determinations requested
 * for a tracked property.
 */
export const DeterminationKind = {
    EXEMPTION: 'Exemption',
    NEW_BUILDING: 'New building',
    OWNERSHIP_CHANGE: 'Ownership change',
    DEMOLITION: 'Demolition',
    ADJUSTMENT: 'Adjustment',
    EXTENSION: 'Extension',
    MITIGATION: 'Mitigation',
    MEDIATED_RESOLUTION: 'Mediated resolution',
    ALTERNATIVE_COMPLIANCE: 'Alternative compliance',
    FEE_EXEMPTION: 'Fee exemption',
    APPEAL: 'Appeal',
    PATHWAY_SELECTION: 'Pathway selection',
    PATHWAY_CHANGE: 'Pathway change',
    ALTERNATIVE_SCHEDULE: 'Alternative schedule'
} as const;

/**
 * DeterminationKind
 *
 * Kinds of program relief (reference data on the program) and of agency determinations requested
 * for a tracked property.
 */
export type DeterminationKind = typeof DeterminationKind[keyof typeof DeterminationKind];

/**
 * DeterminationResponse
 */
export type DeterminationResponse = {
    /**
     * Id
     */
    id: string;
    /**
     * Tracking Id
     */
    tracking_id: string;
    kind: DeterminationKind;
    status: DeterminationStatus;
    /**
     * Relief Key
     */
    relief_key: string | null;
    /**
     * Requirement Key
     */
    requirement_key: string | null;
    /**
     * Program Basis
     */
    program_basis: string | null;
    /**
     * Requested On
     */
    requested_on: string | null;
    /**
     * Decided On
     */
    decided_on: string | null;
    /**
     * Valid From
     */
    valid_from: string | null;
    /**
     * Valid To
     */
    valid_to: string | null;
    /**
     * Decision Due On
     */
    decision_due_on: string | null;
    /**
     * Appeal Due On
     */
    appeal_due_on: string | null;
    /**
     * Due Date Override
     */
    due_date_override: string | null;
    /**
     * Amount Fee
     */
    amount_fee: number | string | null;
    /**
     * Amount Penalty
     */
    amount_penalty: number | string | null;
    /**
     * Evidence
     */
    evidence: {
        [key: string]: unknown;
    } | null;
    /**
     * Notes
     */
    notes: string | null;
    /**
     * Created At
     */
    created_at: string;
};

/**
 * DeterminationStatus
 */
export const DeterminationStatus = {
    DRAFT: 'Draft',
    REQUESTED: 'Requested',
    GRANTED: 'Granted',
    DENIED: 'Denied',
    EXPIRED: 'Expired',
    WITHDRAWN: 'Withdrawn'
} as const;

/**
 * DeterminationStatus
 */
export type DeterminationStatus = typeof DeterminationStatus[keyof typeof DeterminationStatus];

/**
 * Dimension
 */
export type Dimension = {
    /**
     * Name
     */
    name: string;
    /**
     * Label
     */
    label: string;
    /**
     * Fact Keys
     */
    fact_keys: {
        [key: string]: string;
    };
    /**
     * Dim View
     */
    dim_view?: string | null;
    /**
     * Id Column
     */
    id_column?: string;
    /**
     * Label Column
     */
    label_column?: string;
    /**
     * Filterable Attributes
     */
    filterable_attributes?: Array<string>;
    /**
     * Search Columns
     */
    search_columns?: Array<string>;
    /**
     * Private
     */
    private?: boolean;
};

/**
 * DimensionMeta
 */
export type DimensionMeta = {
    /**
     * Name
     */
    name: string;
    /**
     * Label
     */
    label: string;
    /**
     * Private
     */
    private?: boolean;
};

/**
 * DuplicateDataIssue
 *
 * Issue indicating duplicate statements, accounts, or properties.
 */
export type DuplicateDataIssue = {
    issue_type: IssueType;
    severity: IssueSeverity;
    /**
     * Description
     */
    description: string | null;
    /**
     * Detected At
     */
    detected_at: string;
    original_statement: VendorStatementRef | null;
    unexpected_or_duplicate_statement: VendorStatementRef | null;
};

/**
 * EmissionsComputeRequest
 */
export type EmissionsComputeRequest = {
    /**
     * Year
     */
    year: number;
};

/**
 * EnergyManagementDigest
 */
export type EnergyManagementDigest = {
    /**
     * Properties
     */
    properties: number;
    /**
     * Total Sqft
     */
    total_sqft?: number | string | null;
    /**
     * Total Consumption Kwh
     */
    total_consumption_kwh?: number | string | null;
    /**
     * Total Cost Usd
     */
    total_cost_usd?: number | string | null;
    /**
     * Eui Kwh Per Sqft
     */
    eui_kwh_per_sqft?: number | string | null;
    /**
     * Period Months
     */
    period_months?: number | null;
    /**
     * Outstanding Balance Usd
     */
    outstanding_balance_usd?: number | string;
};

/**
 * EnrollmentCreate
 */
export type EnrollmentCreate = {
    /**
     * Property Id
     */
    property_id: string;
    enrollment_status?: EnrollmentStatus;
    /**
     * Exemption Reason
     */
    exemption_reason?: string | null;
    /**
     * Notes
     */
    notes?: string | null;
};

/**
 * EnrollmentResponse
 */
export type EnrollmentResponse = {
    /**
     * Id
     */
    id: string;
    /**
     * Property Id
     */
    property_id: string;
    /**
     * Cycle Id
     */
    cycle_id: string;
    enrollment_status: EnrollmentStatus;
    /**
     * Enrolled Date
     */
    enrolled_date: string | null;
    /**
     * Exemption Reason
     */
    exemption_reason: string | null;
    /**
     * Auto Enrolled
     */
    auto_enrolled: boolean;
    /**
     * Notes
     */
    notes: string | null;
};

/**
 * EnrollmentStatus
 *
 * Enrollment status for a property in a program
 */
export const EnrollmentStatus = {
    NOT_ENROLLED: 'Not Enrolled',
    ENROLLED: 'Enrolled',
    EXEMPT: 'Exempt',
    PENDING_VERIFICATION: 'Pending Verification'
} as const;

/**
 * EnrollmentStatus
 *
 * Enrollment status for a property in a program
 */
export type EnrollmentStatus = typeof EnrollmentStatus[keyof typeof EnrollmentStatus];

/**
 * Entitlement
 */
export type Entitlement = {
    /**
     * Id
     */
    id: string;
    feature_key: FeatureKey;
    /**
     * Is Enabled
     */
    is_enabled: boolean;
    /**
     * Valid Time Remaining Seconds
     */
    valid_time_remaining_seconds: number | null;
};

/**
 * EntitlementPackage
 */
export type EntitlementPackage = {
    /**
     * Id
     */
    id: string;
    /**
     * Name
     */
    name: string;
    /**
     * Is Enabled
     */
    is_enabled: boolean;
    /**
     * Valid Time Remaining Seconds
     */
    valid_time_remaining_seconds: number | null;
    /**
     * Entitlements
     */
    entitlements: Array<EntitlementTemplate>;
};

/**
 * EntitlementTemplate
 */
export type EntitlementTemplate = {
    /**
     * Id
     */
    id: string;
    feature_key: FeatureKey;
    /**
     * Is Enabled
     */
    is_enabled: boolean;
    /**
     * Valid Time Remaining Seconds
     */
    valid_time_remaining_seconds: number | null;
    /**
     * Valid Duration Days
     */
    valid_duration_days: number | null;
};

/**
 * EvaluationKind
 *
 * ENTRY: does the building meet the standard at the start of a period; FINAL: end-of-cycle
 * evaluation; ANNUAL: a reporting year's computed result; MONITORING: a proxy from bills that never
 * drives a task or status.
 */
export const EvaluationKind = {
    ENTRY: 'Entry',
    FINAL: 'Final',
    ANNUAL: 'Annual',
    MONITORING: 'Monitoring'
} as const;

/**
 * EvaluationKind
 *
 * ENTRY: does the building meet the standard at the start of a period; FINAL: end-of-cycle
 * evaluation; ANNUAL: a reporting year's computed result; MONITORING: a proxy from bills that never
 * drives a task or status.
 */
export type EvaluationKind = typeof EvaluationKind[keyof typeof EvaluationKind];

/**
 * EventCreate
 */
export type EventCreate = {
    /**
     * Event Key
     */
    event_key: string;
    /**
     * Occurred On
     */
    occurred_on: string;
    /**
     * Evidence
     */
    evidence?: {
        [key: string]: unknown;
    } | null;
    /**
     * Notes
     */
    notes?: string | null;
};

/**
 * EventRecordedResponse
 */
export type EventRecordedResponse = {
    event: EventResponse;
    /**
     * Created Tasks
     */
    created_tasks: Array<TaskResponse>;
};

/**
 * EventResponse
 */
export type EventResponse = {
    /**
     * Id
     */
    id: string;
    /**
     * Tracking Id
     */
    tracking_id: string;
    /**
     * Event Key
     */
    event_key: string;
    /**
     * Occurred On
     */
    occurred_on: string;
    /**
     * Evidence
     */
    evidence: {
        [key: string]: unknown;
    } | null;
    /**
     * Notes
     */
    notes: string | null;
    /**
     * Created At
     */
    created_at: string;
};

/**
 * ExportJobStatus
 */
export const ExportJobStatus = {
    PENDING: 'Pending',
    RUNNING: 'Running',
    SUCCEEDED: 'Succeeded',
    FAILED: 'Failed',
    UNKNOWN: 'Unknown'
} as const;

/**
 * ExportJobStatus
 */
export type ExportJobStatus = typeof ExportJobStatus[keyof typeof ExportJobStatus];

/**
 * ExportJobSummary
 */
export type ExportJobSummary = {
    /**
     * Job Id
     */
    job_id: string;
    status: ExportJobStatus;
    /**
     * Row Count
     */
    row_count?: number | null;
    /**
     * File Id
     */
    file_id?: string | null;
    /**
     * Error
     */
    error?: string | null;
    /**
     * Requested At
     */
    requested_at: string;
    /**
     * Completed At
     */
    completed_at?: string | null;
};

/**
 * ExportRequest
 *
 * Async export of a query result. The Celery export task writes the
 * file to `file_store` and updates `DBExportJob`.
 */
export type ExportRequest = {
    spec: QuerySpec;
    /**
     * Format
     */
    format: 'csv' | 'xlsx';
    /**
     * Filename
     */
    filename?: string | null;
};

/**
 * FeatureKey
 */
export const FeatureKey = {
    MODULE_ENERGY_MANAGEMENT: 'module:energy_management',
    MODULE_PERFORMANCE_COMPLIANCE: 'module:performance_compliance',
    MODULE_BUILDING_PERFORMANCE_PROGRAMS: 'module:building_performance_programs'
} as const;

/**
 * FeatureKey
 */
export type FeatureKey = typeof FeatureKey[keyof typeof FeatureKey];

/**
 * FeeResponse
 */
export type FeeResponse = {
    /**
     * Key
     */
    key: string;
    /**
     * Name
     */
    name: string;
    /**
     * Amount
     */
    amount: number | string;
    /**
     * Unit
     */
    unit: string;
    record_status: ProgramRecordStatus;
    /**
     * Provenance
     */
    provenance: {
        [key: string]: unknown;
    } | null;
};

/**
 * File
 */
export type File = {
    /**
     * Id
     */
    id: string;
    details: FileDetails;
};

/**
 * FileDetails
 */
export type FileDetails = {
    /**
     * Id
     */
    id: string;
    org: OrgRef;
    /**
     * Original Filename
     */
    original_filename: string | null;
    /**
     * Size Bytes
     */
    size_bytes: number | null;
    /**
     * Content Type
     */
    content_type: string | null;
    file_use: FileUse | null;
};

/**
 * FileSet
 */
export type FileSet = {
    /**
     * Id
     */
    id: string;
    owner: UserRef;
    org: OrgRef;
    /**
     * Created Date
     */
    created_date: string;
    /**
     * Files
     */
    files: Array<File>;
};

/**
 * FileUse
 */
export const FileUse = {
    BILL: 'Bill',
    BULK_UPLOAD: 'Bulk Upload',
    DOCUMENT: 'Document',
    IMAGE: 'Image',
    AVATAR: 'Avatar',
    LOGO: 'Logo'
} as const;

/**
 * FileUse
 */
export type FileUse = typeof FileUse[keyof typeof FileUse];

/**
 * FloorArea
 */
export type FloorArea = {
    /**
     * Value
     */
    value: number | string;
    unit_of_measure: FloorAreaUnitOfMeasure;
};

/**
 * FloorAreaUnitOfMeasure
 */
export const FloorAreaUnitOfMeasure = { SQUARE_FEET: 'Square Feet', SQUARE_METERS: 'Square Meters' } as const;

/**
 * FloorAreaUnitOfMeasure
 */
export type FloorAreaUnitOfMeasure = typeof FloorAreaUnitOfMeasure[keyof typeof FloorAreaUnitOfMeasure];

/**
 * FormResponse
 */
export type FormResponse = {
    /**
     * Id
     */
    id: string;
    /**
     * Cycle Id
     */
    cycle_id: string;
    /**
     * Name
     */
    name: string;
    /**
     * Description
     */
    description: string | null;
    /**
     * Instructions
     */
    instructions: string | null;
    /**
     * Form Schema
     */
    form_schema: {
        [key: string]: unknown;
    };
    access_type: PortalAccessType;
    /**
     * Requirement Id
     */
    requirement_id: string | null;
    /**
     * Available From
     */
    available_from: string | null;
    /**
     * Available Until
     */
    available_until: string | null;
    /**
     * Is Active
     */
    is_active: boolean;
    /**
     * Version
     */
    version: number;
};

/**
 * FormSubmissionCreate
 *
 * Request to create/update a form submission.
 */
export type FormSubmissionCreate = {
    /**
     * Responses
     */
    responses: {
        [key: string]: unknown;
    };
    /**
     * Submitter Email
     */
    submitter_email?: string | null;
    /**
     * Submitter Name
     */
    submitter_name?: string | null;
    /**
     * Submit
     */
    submit?: boolean;
};

/**
 * GeoJsonObject
 */
export type GeoJsonObject = {
    /**
     * Type
     */
    type: 'FeatureCollection' | 'Feature' | 'Point' | 'MultiPoint' | 'LineString' | 'MultiLineString' | 'Polygon' | 'MultiPolygon' | 'GeometryCollection';
    [key: string]: unknown;
};

/**
 * GeoLocation
 */
export type GeoLocation = {
    /**
     * Latitude
     */
    latitude: number | string;
    /**
     * Longitude
     */
    longitude: number | string;
    /**
     * Crs
     */
    crs: string;
};

/**
 * HTTPValidationError
 */
export type HttpValidationError = {
    /**
     * Detail
     */
    detail?: Array<ValidationError>;
};

/**
 * IconSource
 */
export const IconSource = { MATERIAL: 'material', TEXT: 'text' } as const;

/**
 * IconSource
 */
export type IconSource = typeof IconSource[keyof typeof IconSource];

/**
 * Identifier
 */
export type Identifier = {
    /**
     * System
     */
    system: string;
    /**
     * Name
     */
    name: string;
    /**
     * Value
     */
    value: string;
    /**
     * Is Unique
     */
    is_unique: boolean;
};

/**
 * IdentifierRef
 */
export type IdentifierRef = {
    /**
     * Id
     */
    id: string;
    /**
     * System
     */
    system: string;
    /**
     * Name
     */
    name: string;
    /**
     * Value
     */
    value: string;
    /**
     * Is Unique
     */
    is_unique: boolean;
};

/**
 * ImpactEstimation
 */
export const ImpactEstimation = { ESTIMATED: 'Estimated', ACTUAL: 'Actual' } as const;

/**
 * ImpactEstimation
 */
export type ImpactEstimation = typeof ImpactEstimation[keyof typeof ImpactEstimation];

/**
 * ImpactMetricType
 */
export const ImpactMetricType = {
    ENERGY_CONSUMPTION: 'Energy Consumption',
    COST: 'Cost',
    DEMAND: 'Demand',
    WATER: 'Water',
    GHG_EMISSIONS: 'GHG Emissions',
    WASTE: 'Waste',
    OTHER: 'Other'
} as const;

/**
 * ImpactMetricType
 */
export type ImpactMetricType = typeof ImpactMetricType[keyof typeof ImpactMetricType];

/**
 * ImpactType
 */
export const ImpactType = { ABSOLUTE: 'Absolute', RELATIVE: 'Relative' } as const;

/**
 * ImpactType
 */
export type ImpactType = typeof ImpactType[keyof typeof ImpactType];

/**
 * ImportRunResponse
 */
export type ImportRunResponse = {
    /**
     * Id
     */
    id: string;
    /**
     * Definition Version
     */
    definition_version: string;
    /**
     * Actor
     */
    actor: string;
    /**
     * Effective On
     */
    effective_on: string;
    /**
     * Counts
     */
    counts: {
        [key: string]: unknown;
    };
    /**
     * Changes
     */
    changes: Array<{
        [key: string]: unknown;
    }>;
    /**
     * Created At
     */
    created_at: string;
};

/**
 * IncorrectDataIssue
 *
 * Issue indicating incorrect or abnormal data.
 */
export type IncorrectDataIssue = {
    issue_type: IssueType;
    severity: IssueSeverity;
    /**
     * Description
     */
    description: string | null;
    /**
     * Detected At
     */
    detected_at: string;
    statement: VendorStatementRef | null;
    /**
     * Actual Value
     */
    actual_value: number | string | null;
};

/**
 * IngestJob
 */
export type IngestJob = {
    /**
     * Id
     */
    id: string;
    status: JobStatus;
    file_set: FileSet;
    owner: OrgUserRef;
    /**
     * Created Date
     */
    created_date: string;
    results: IngestJobResults;
};

/**
 * IngestJobError
 */
export type IngestJobError = {
    /**
     * Id
     */
    id: string;
    /**
     * Message
     */
    message: string;
    /**
     * Additional Details
     */
    additional_details: {
        [key: string]: unknown;
    } | null;
    file: File | null;
};

/**
 * IngestJobMessage
 */
export type IngestJobMessage = {
    /**
     * Id
     */
    id: string;
    /**
     * Message
     */
    message: string;
    /**
     * Additional Details
     */
    additional_details: {
        [key: string]: unknown;
    } | null;
    file: File | null;
};

/**
 * IngestJobPatch
 */
export type IngestJobPatch = {
    /**
     * Status
     */
    status?: 'Cancelled' | 'Restarted' | null;
};

/**
 * IngestJobResourceResult[DepartmentSummary]
 */
export type IngestJobResourceResultDepartmentSummary = {
    resource: DepartmentSummary;
    action: JobResultResourceAction | null;
};

/**
 * IngestJobResourceResult[Meter]
 */
export type IngestJobResourceResultMeter = {
    resource: Meter;
    action: JobResultResourceAction | null;
};

/**
 * IngestJobResourceResult[PropertySummary]
 */
export type IngestJobResourceResultPropertySummary = {
    resource: PropertySummary;
    action: JobResultResourceAction | null;
};

/**
 * IngestJobResourceResult[VendorStatementRef]
 */
export type IngestJobResourceResultVendorStatementRef = {
    resource: VendorStatementRef;
    action: JobResultResourceAction | null;
};

/**
 * IngestJobResourceResult[Vendor]
 */
export type IngestJobResourceResultVendor = {
    resource: Vendor;
    action: JobResultResourceAction | null;
};

/**
 * IngestJobResourceResults[DepartmentSummary]
 */
export type IngestJobResourceResultsDepartmentSummary = {
    /**
     * Created Count
     */
    created_count: number;
    /**
     * Updated Count
     */
    updated_count: number;
    /**
     * Total Count
     */
    total_count: number;
    /**
     * Resources
     */
    resources: Array<IngestJobResourceResultDepartmentSummary>;
};

/**
 * IngestJobResourceResults[Meter]
 */
export type IngestJobResourceResultsMeter = {
    /**
     * Created Count
     */
    created_count: number;
    /**
     * Updated Count
     */
    updated_count: number;
    /**
     * Total Count
     */
    total_count: number;
    /**
     * Resources
     */
    resources: Array<IngestJobResourceResultMeter>;
};

/**
 * IngestJobResourceResults[PropertySummary]
 */
export type IngestJobResourceResultsPropertySummary = {
    /**
     * Created Count
     */
    created_count: number;
    /**
     * Updated Count
     */
    updated_count: number;
    /**
     * Total Count
     */
    total_count: number;
    /**
     * Resources
     */
    resources: Array<IngestJobResourceResultPropertySummary>;
};

/**
 * IngestJobResourceResults[VendorStatementRef]
 */
export type IngestJobResourceResultsVendorStatementRef = {
    /**
     * Created Count
     */
    created_count: number;
    /**
     * Updated Count
     */
    updated_count: number;
    /**
     * Total Count
     */
    total_count: number;
    /**
     * Resources
     */
    resources: Array<IngestJobResourceResultVendorStatementRef>;
};

/**
 * IngestJobResourceResults[Vendor]
 */
export type IngestJobResourceResultsVendor = {
    /**
     * Created Count
     */
    created_count: number;
    /**
     * Updated Count
     */
    updated_count: number;
    /**
     * Total Count
     */
    total_count: number;
    /**
     * Resources
     */
    resources: Array<IngestJobResourceResultVendor>;
};

/**
 * IngestJobResults
 */
export type IngestJobResults = {
    /**
     * Success Count
     */
    success_count: number;
    /**
     * Failure Count
     */
    failure_count: number;
    /**
     * Errors
     */
    errors: Array<IngestJobError>;
    /**
     * Messages
     */
    messages: Array<IngestJobMessage>;
    vendors: IngestJobResourceResultsVendor;
    departments: IngestJobResourceResultsDepartmentSummary;
    properties: IngestJobResourceResultsPropertySummary;
    meters: IngestJobResourceResultsMeter;
    statements: IngestJobResourceResultsVendorStatementRef;
};

/**
 * IngestJobSummary
 */
export type IngestJobSummary = {
    /**
     * Id
     */
    id: string;
    status: JobStatus;
    owner: OrgUserRef;
    /**
     * Created Date
     */
    created_date: string;
};

/**
 * Initiative
 */
export type Initiative = {
    /**
     * Name
     */
    name: string;
    /**
     * Description
     */
    description?: string | null;
    /**
     * Start Date
     */
    start_date?: string | null;
    /**
     * Estimated Completion Date
     */
    estimated_completion_date?: string | null;
    /**
     * Owner Id
     */
    owner_id?: string | null;
    /**
     * Id
     */
    id: string;
    /**
     * Org Id
     */
    org_id: string;
    status: InitiativeStatus;
    /**
     * Actual Completion Date
     */
    actual_completion_date?: string | null;
    owner?: OrgUserRef | null;
    /**
     * Tasks
     */
    tasks?: Array<InitiativeTask>;
    /**
     * Milestones
     */
    milestones?: Array<InitiativeMilestone>;
    /**
     * Impacts
     */
    impacts?: Array<InitiativeImpact>;
};

/**
 * InitiativeCreate
 */
export type InitiativeCreate = {
    /**
     * Name
     */
    name: string;
    /**
     * Description
     */
    description?: string | null;
    /**
     * Start Date
     */
    start_date?: string | null;
    /**
     * Estimated Completion Date
     */
    estimated_completion_date?: string | null;
    /**
     * Owner Id
     */
    owner_id?: string | null;
    /**
     * Tasks
     */
    tasks?: Array<InitiativeTaskCreate>;
    /**
     * Milestones
     */
    milestones?: Array<InitiativeMilestoneCreate>;
    /**
     * Impacts
     */
    impacts?: Array<InitiativeImpactCreate>;
};

/**
 * InitiativeImpact
 */
export type InitiativeImpact = {
    metric_type: ImpactMetricType;
    impact_type: ImpactType;
    /**
     * Absolute Value
     */
    absolute_value?: number | string | null;
    /**
     * Absolute Unit
     */
    absolute_unit?: string | null;
    /**
     * Relative Value Percent
     */
    relative_value_percent?: number | string | null;
    estimated_vs_actual?: ImpactEstimation;
    /**
     * Id
     */
    id: string;
    /**
     * Initiative Id
     */
    initiative_id: string;
    /**
     * Task Id
     */
    task_id?: string | null;
    /**
     * Milestone Id
     */
    milestone_id?: string | null;
    /**
     * Commodity Id
     */
    commodity_id?: string | null;
    /**
     * Commodity Name
     */
    commodity_name?: string | null;
};

/**
 * InitiativeImpactCreate
 */
export type InitiativeImpactCreate = {
    metric_type: ImpactMetricType;
    impact_type: ImpactType;
    /**
     * Absolute Value
     */
    absolute_value?: number | string | null;
    /**
     * Absolute Unit
     */
    absolute_unit?: string | null;
    /**
     * Relative Value Percent
     */
    relative_value_percent?: number | string | null;
    estimated_vs_actual?: ImpactEstimation;
    /**
     * Task Id
     */
    task_id?: string | null;
    /**
     * Milestone Id
     */
    milestone_id?: string | null;
    /**
     * Commodity Id
     */
    commodity_id?: string | null;
};

/**
 * InitiativeMilestone
 */
export type InitiativeMilestone = {
    /**
     * Name
     */
    name: string;
    /**
     * Description
     */
    description?: string | null;
    /**
     * Estimated Completion Date
     */
    estimated_completion_date?: string | null;
    /**
     * Id
     */
    id: string;
    /**
     * Initiative Id
     */
    initiative_id: string;
    /**
     * Is Completed
     */
    is_completed: boolean;
    /**
     * Actual Completion Date
     */
    actual_completion_date?: string | null;
    /**
     * Impacts
     */
    impacts?: Array<InitiativeImpact>;
};

/**
 * InitiativeMilestoneCreate
 */
export type InitiativeMilestoneCreate = {
    /**
     * Name
     */
    name: string;
    /**
     * Description
     */
    description?: string | null;
    /**
     * Estimated Completion Date
     */
    estimated_completion_date?: string | null;
};

/**
 * InitiativeMilestoneUpdate
 */
export type InitiativeMilestoneUpdate = {
    /**
     * Name
     */
    name?: string | null;
    /**
     * Description
     */
    description?: string | null;
    /**
     * Estimated Completion Date
     */
    estimated_completion_date?: string | null;
};

/**
 * InitiativeProgress
 */
export type InitiativeProgress = {
    /**
     * Initiative Id
     */
    initiative_id: string;
    /**
     * Total Tasks
     */
    total_tasks: number;
    /**
     * Completed Tasks
     */
    completed_tasks: number;
    /**
     * Task Completion Percentage
     */
    task_completion_percentage: number;
    /**
     * Total Milestones
     */
    total_milestones: number;
    /**
     * Completed Milestones
     */
    completed_milestones: number;
    /**
     * Milestone Completion Percentage
     */
    milestone_completion_percentage: number;
    /**
     * Overall Progress Percentage
     */
    overall_progress_percentage: number;
    /**
     * Estimated Impacts
     */
    estimated_impacts?: Array<InitiativeImpact>;
    /**
     * Actual Impacts
     */
    actual_impacts?: Array<InitiativeImpact>;
};

/**
 * InitiativeStatus
 */
export const InitiativeStatus = {
    PLANNED: 'Planned',
    IN_PROGRESS: 'In Progress',
    COMPLETE: 'Complete',
    INACTIVE: 'Inactive',
    DELETED: 'Deleted'
} as const;

/**
 * InitiativeStatus
 */
export type InitiativeStatus = typeof InitiativeStatus[keyof typeof InitiativeStatus];

/**
 * InitiativeSummary
 */
export type InitiativeSummary = {
    /**
     * Id
     */
    id: string;
    /**
     * Name
     */
    name: string;
    status: InitiativeStatus;
    /**
     * Estimated Completion Date
     */
    estimated_completion_date?: string | null;
    /**
     * Owner Name
     */
    owner_name?: string | null;
    /**
     * Task Count
     */
    task_count: number;
    /**
     * Completed Task Count
     */
    completed_task_count: number;
    /**
     * Milestone Count
     */
    milestone_count: number;
    /**
     * Completed Milestone Count
     */
    completed_milestone_count: number;
};

/**
 * InitiativeTask
 */
export type InitiativeTask = {
    /**
     * Name
     */
    name: string;
    /**
     * Description
     */
    description?: string | null;
    /**
     * Start Date
     */
    start_date?: string | null;
    /**
     * Estimated Completion Date
     */
    estimated_completion_date?: string | null;
    /**
     * Is Optional
     */
    is_optional?: boolean;
    /**
     * Parent Task Id
     */
    parent_task_id?: string | null;
    /**
     * Id
     */
    id: string;
    /**
     * Initiative Id
     */
    initiative_id: string;
    /**
     * Is Completed
     */
    is_completed: boolean;
    status: InitiativeStatus;
    /**
     * Actual Completion Date
     */
    actual_completion_date?: string | null;
    /**
     * Assignees
     */
    assignees?: Array<OrgUserRef>;
    /**
     * Impacts
     */
    impacts?: Array<InitiativeImpact>;
};

/**
 * InitiativeTaskCreate
 */
export type InitiativeTaskCreate = {
    /**
     * Name
     */
    name: string;
    /**
     * Description
     */
    description?: string | null;
    /**
     * Start Date
     */
    start_date?: string | null;
    /**
     * Estimated Completion Date
     */
    estimated_completion_date?: string | null;
    /**
     * Is Optional
     */
    is_optional?: boolean;
    /**
     * Parent Task Id
     */
    parent_task_id?: string | null;
    /**
     * Assignee Ids
     */
    assignee_ids?: Array<string>;
};

/**
 * InitiativeTaskUpdate
 */
export type InitiativeTaskUpdate = {
    /**
     * Name
     */
    name?: string | null;
    /**
     * Description
     */
    description?: string | null;
    /**
     * Start Date
     */
    start_date?: string | null;
    /**
     * Estimated Completion Date
     */
    estimated_completion_date?: string | null;
    /**
     * Is Optional
     */
    is_optional?: boolean | null;
    /**
     * Parent Task Id
     */
    parent_task_id?: string | null;
    /**
     * Assignee Ids
     */
    assignee_ids?: Array<string> | null;
};

/**
 * InitiativeUpdate
 */
export type InitiativeUpdate = {
    /**
     * Name
     */
    name?: string | null;
    /**
     * Description
     */
    description?: string | null;
    /**
     * Start Date
     */
    start_date?: string | null;
    /**
     * Estimated Completion Date
     */
    estimated_completion_date?: string | null;
    /**
     * Owner Id
     */
    owner_id?: string | null;
    status?: InitiativeStatus | null;
};

/**
 * InsightsSummary
 *
 * Aggregated insights summary for an organization.
 */
export type InsightsSummary = {
    /**
     * Total Missing Issues
     */
    total_missing_issues: number;
    /**
     * Total Incorrect Issues
     */
    total_incorrect_issues: number;
    /**
     * Total Duplicate Issues
     */
    total_duplicate_issues: number;
    /**
     * Critical Issues
     */
    critical_issues: number;
    /**
     * High Issues
     */
    high_issues: number;
    /**
     * Medium Issues
     */
    medium_issues: number;
    /**
     * Low Issues
     */
    low_issues: number;
    /**
     * Missing Issues By Type
     */
    missing_issues_by_type: {
        [key in IssueType]?: number;
    };
    /**
     * Incorrect Issues By Type
     */
    incorrect_issues_by_type: {
        [key in IssueType]?: number;
    };
    /**
     * Duplicate Issues By Type
     */
    duplicate_issues_by_type: {
        [key in IssueType]?: number;
    };
};

/**
 * Integration
 */
export type Integration = {
    /**
     * Id
     */
    id: string;
    /**
     * Name
     */
    name: string;
    /**
     * Has Logo
     */
    has_logo?: boolean;
    /**
     * Logo Url
     */
    logo_url?: string | null;
    /**
     * Aliases
     */
    aliases?: Array<string> | null;
    /**
     * Website
     */
    website?: string | null;
    /**
     * Regions
     */
    regions?: Array<string> | null;
    /**
     * Is Active
     */
    is_active?: boolean;
    /**
     * Commodities
     */
    commodities?: Array<CommodityRef> | null;
};

/**
 * IntegrationSchema
 */
export type IntegrationSchema = {
    /**
     * Id
     */
    id: string;
    integration: Integration;
    /**
     * Type
     */
    type: string;
    /**
     * Version
     */
    version: string;
    /**
     * Details
     */
    details: {
        [key: string]: unknown;
    };
    /**
     * Schema Def
     */
    schema_def: {
        [key: string]: unknown;
    };
};

/**
 * IntervalBatchIn
 *
 * A batch of readings for one channel, pushed by a gateway or ETL job.
 *
 * `interval_seconds` and `accumulation` are required rather than inferred:
 * a pushing client knows its own meter, and guessing here would silently
 * misinterpret a register total as per-interval consumption.
 */
export type IntervalBatchIn = {
    /**
     * Capability Id
     */
    capability_id: string;
    /**
     * Interval Seconds
     */
    interval_seconds: number;
    /**
     * Accumulation
     */
    accumulation?: string;
    /**
     * Unit Of Measure
     */
    unit_of_measure?: string | null;
    /**
     * Source
     */
    source?: string;
    /**
     * Timestamps Are Interval End
     */
    timestamps_are_interval_end?: boolean;
    /**
     * Readings
     */
    readings: Array<IntervalReadingIn>;
};

/**
 * IntervalBatchResult
 */
export type IntervalBatchResult = {
    /**
     * Capability Id
     */
    capability_id: string;
    /**
     * Received
     */
    received: number;
    /**
     * Inserted
     */
    inserted: number;
    /**
     * Updated
     */
    updated: number;
    /**
     * Unchanged
     */
    unchanged: number;
    /**
     * Skipped
     */
    skipped: number;
    /**
     * Deduplicated
     */
    deduplicated: number;
    /**
     * First Interval
     */
    first_interval?: string | null;
    /**
     * Last Interval
     */
    last_interval?: string | null;
};

/**
 * IntervalBucket
 *
 * One point on a chart.
 *
 * Carries the spread, not just the mean. A downsampled load profile that
 * shows only averages hides the peaks the data was acquired to find, so the
 * client can draw a min-max band behind the line and stay honest about what
 * was averaged away.
 */
export type IntervalBucket = {
    /**
     * T
     */
    t: string;
    /**
     * Avg
     */
    avg?: number | string | null;
    /**
     * Min
     */
    min?: number | string | null;
    /**
     * Max
     */
    max?: number | string | null;
    /**
     * Total
     */
    total?: number | string | null;
    /**
     * N
     */
    n?: number;
};

/**
 * IntervalChannel
 *
 * A meter channel that carries interval data.
 */
export type IntervalChannel = {
    /**
     * Capability Id
     */
    capability_id: string;
    /**
     * Measure Type
     */
    measure_type?: string | null;
    /**
     * Measure Type Name
     */
    measure_type_name?: string | null;
    /**
     * Unit Of Measure
     */
    unit_of_measure?: string | null;
    /**
     * Interval Seconds
     */
    interval_seconds?: number | null;
    /**
     * First Day
     */
    first_day?: string | null;
    /**
     * Last Day
     */
    last_day?: string | null;
    /**
     * Coverage Pct
     */
    coverage_pct?: number | null;
};

/**
 * IntervalReadingIn
 *
 * One reading in a pushed batch.
 */
export type IntervalReadingIn = {
    /**
     * T
     */
    t: string;
    /**
     * V
     */
    v: number | string;
    /**
     * Q
     */
    q?: number;
};

/**
 * IntervalSeries
 */
export type IntervalSeries = {
    /**
     * Capability Id
     */
    capability_id: string;
    /**
     * Grain Used
     */
    grain_used: string;
    /**
     * Unit Of Measure
     */
    unit_of_measure?: string | null;
    /**
     * Interval Seconds
     */
    interval_seconds?: number | null;
    /**
     * Coverage Pct
     */
    coverage_pct?: number | null;
    /**
     * Time Zone
     */
    time_zone?: string | null;
    /**
     * Points
     */
    points?: Array<IntervalBucket>;
};

/**
 * IntervalSummary
 */
export type IntervalSummary = {
    /**
     * Capability Id
     */
    capability_id: string;
    /**
     * Unit Of Measure
     */
    unit_of_measure?: string | null;
    /**
     * Interval Seconds
     */
    interval_seconds?: number | null;
    /**
     * First Interval
     */
    first_interval?: string | null;
    /**
     * Last Interval
     */
    last_interval?: string | null;
    /**
     * Total Energy
     */
    total_energy?: number | string | null;
    /**
     * Peak Value
     */
    peak_value?: number | string | null;
    /**
     * Peak At
     */
    peak_at?: string | null;
    /**
     * Peak Kw
     */
    peak_kw?: number | string | null;
    /**
     * Baseload Kw
     */
    baseload_kw?: number | string | null;
    /**
     * Load Factor
     */
    load_factor?: number | null;
    /**
     * Coverage Pct
     */
    coverage_pct?: number | null;
    /**
     * Days With Gaps
     */
    days_with_gaps?: number;
    /**
     * Estimated Readings
     */
    estimated_readings?: number;
};

/**
 * Invitation
 */
export type Invitation = {
    /**
     * Id
     */
    id: string;
    org: OrgRef;
    /**
     * Email
     */
    email: string;
    status: InvitationStatus;
    target_org_user: OrgUserRef | null;
    /**
     * Roles
     */
    roles: Array<string>;
    created_by: OrgUserRef | null;
    /**
     * Created At
     */
    created_at: string;
    /**
     * Resolved At
     */
    resolved_at: string | null;
    /**
     * Valid Until
     */
    valid_until: string | null;
};

/**
 * InvitationCreate
 */
export type InvitationCreate = {
    /**
     * Email
     */
    email: string;
    /**
     * Role Ids
     */
    role_ids: Array<string> | null;
};

/**
 * InvitationCreateResult
 */
export type InvitationCreateResult = {
    /**
     * Result
     */
    result: 'CREATED' | 'USER_EXISTS_IN_ORG' | 'USER_EXISTS_IN_ACCOUNT__ADDED' | 'USER_EXISTS_IN_ACCOUNT__NOT_ADDED';
    invitation: Invitation | null;
    target_org_user: OrgUserRef | null;
};

/**
 * InvitationStatus
 */
export const InvitationStatus = {
    PENDING: 'Pending',
    ACCEPTED: 'Accepted',
    DECLINED: 'Declined',
    REVOKED: 'Revoked',
    EXPIRED: 'Expired'
} as const;

/**
 * InvitationStatus
 */
export type InvitationStatus = typeof InvitationStatus[keyof typeof InvitationStatus];

/**
 * InvitationUpdate
 */
export type InvitationUpdate = {
    /**
     * Accepted
     */
    accepted?: boolean | null;
    /**
     * Revoked
     */
    revoked?: boolean | null;
};

/**
 * IssueSeverity
 */
export const IssueSeverity = {
    LOW: 'low',
    MEDIUM: 'medium',
    HIGH: 'high',
    CRITICAL: 'critical'
} as const;

/**
 * IssueSeverity
 */
export type IssueSeverity = typeof IssueSeverity[keyof typeof IssueSeverity];

/**
 * IssueType
 */
export const IssueType = {
    MISSING_STATEMENT: 'Missing Statement',
    MISSING_SERVICE_ACCOUNT: 'Missing Service Account',
    DUPLICATED_STATEMENT: 'Duplicated Statement',
    UNEXPECTED_STATEMENT: 'Unexpected Statement',
    ABNORMAL_STATEMENT_TOTAL_CHARGE: 'Abnormal Statement Total Charge',
    ABNORMAL_SERVICE_ACCOUNT_TOTAL_CHARGE: 'Abnormal Service Account Total Charge',
    ABNORMAL_SERVICE_ACCOUNT_CONSUMPTION: 'Abnormal Service Account Consumption',
    ABNORMAL_SERVICE_ACCOUNT_DEMAND: 'Abnormal Service Account Demand',
    ABNORMAL_LINE_ITEM_USAGE: 'Abnormal Line Item Usage',
    ABNORMAL_LINE_ITEM_CHARGE: 'Abnormal Line Item Charge',
    ABNORMAL_METER_READING: 'Abnormal Meter Reading',
    MISSING_LINE_ITEM: 'Missing Line Item',
    UNEXPECTED_LINE_ITEM: 'Unexpected Line Item',
    LINE_ITEM_RATE_CHANGE: 'Line Item Rate Change'
} as const;

/**
 * IssueType
 */
export type IssueType = typeof IssueType[keyof typeof IssueType];

/**
 * JobResultResourceAction
 */
export const JobResultResourceAction = { CREATED: 'Created', UPDATED: 'Updated' } as const;

/**
 * JobResultResourceAction
 */
export type JobResultResourceAction = typeof JobResultResourceAction[keyof typeof JobResultResourceAction];

/**
 * JobStatus
 */
export const JobStatus = {
    CREATED: 'Created',
    STARTED: 'Started',
    PROCESSING: 'Processing',
    COMPLETE: 'Complete',
    FAILED: 'Failed',
    WAITING: 'Waiting',
    CANCELLED: 'Cancelled',
    RESTARTED: 'Restarted'
} as const;

/**
 * JobStatus
 */
export type JobStatus = typeof JobStatus[keyof typeof JobStatus];

/**
 * Jurisdiction
 *
 * API response model for a jurisdiction.
 */
export type Jurisdiction = {
    /**
     * Id
     */
    id: string;
    /**
     * Org Id
     */
    org_id: string;
    /**
     * Name
     */
    name: string;
    jurisdiction_type: JurisdictionType;
    /**
     * Description
     */
    description: string | null;
    /**
     * Country
     */
    country: string;
    state: State | null;
    /**
     * County
     */
    county: string | null;
    /**
     * City
     */
    city: string | null;
    /**
     * Zip Codes
     */
    zip_codes: Array<string> | null;
    /**
     * Fips Codes
     */
    fips_codes: Array<string> | null;
    /**
     * Is Entire Us
     */
    is_entire_us: boolean;
    /**
     * Boundary Geojson
     */
    boundary_geojson: {
        [key: string]: unknown;
    } | null;
    /**
     * Is Active
     */
    is_active: boolean;
};

/**
 * JurisdictionCreate
 *
 * Data for creating a new jurisdiction.
 */
export type JurisdictionCreate = {
    /**
     * Name
     */
    name: string;
    jurisdiction_type: JurisdictionType;
    /**
     * Description
     */
    description?: string | null;
    country?: AddressCountry;
    state?: State | null;
    /**
     * County
     */
    county?: string | null;
    /**
     * City
     */
    city?: string | null;
    /**
     * Zip Codes
     */
    zip_codes?: Array<string> | null;
    /**
     * Fips Codes
     */
    fips_codes?: Array<string> | null;
    /**
     * Is Entire Us
     */
    is_entire_us?: boolean;
    /**
     * Geospatial Bounds
     */
    geospatial_bounds?: Array<GeoJsonObject> | null;
};

/**
 * JurisdictionType
 *
 * Type of jurisdiction for performance programs
 */
export const JurisdictionType = {
    CITY: 'City',
    COUNTY: 'County',
    STATE: 'State',
    FEDERAL: 'Federal',
    DISTRICT: 'District',
    TERRITORY: 'Territory',
    OTHER: 'Other'
} as const;

/**
 * JurisdictionType
 *
 * Type of jurisdiction for performance programs
 */
export type JurisdictionType = typeof JurisdictionType[keyof typeof JurisdictionType];

/**
 * JurisdictionUpdate
 *
 * Data for updating a jurisdiction.
 */
export type JurisdictionUpdate = {
    /**
     * Name
     */
    name?: string | null;
    jurisdiction_type?: JurisdictionType | null;
    /**
     * Description
     */
    description?: string | null;
    country?: AddressCountry | null;
    state?: State | null;
    /**
     * County
     */
    county?: string | null;
    /**
     * City
     */
    city?: string | null;
    /**
     * Is Active
     */
    is_active?: boolean | null;
    /**
     * Zip Codes
     */
    zip_codes?: Array<string> | null;
    /**
     * Fips Codes
     */
    fips_codes?: Array<string> | null;
    /**
     * Is Entire Us
     */
    is_entire_us?: boolean | null;
    /**
     * Geospatial Bounds
     */
    geospatial_bounds?: Array<GeoJsonObject> | null;
};

/**
 * KnowledgeBaseArticle
 *
 * Full knowledge base article model with content
 */
export type KnowledgeBaseArticle = {
    /**
     * Id
     */
    id: string;
    /**
     * Title
     */
    title: string;
    topic: KnowledgeBaseTopic;
    /**
     * Tags
     */
    tags: Array<string>;
    /**
     * Summary
     */
    summary: string;
    /**
     * Content
     */
    content: string;
    /**
     * Last Updated
     */
    last_updated: string;
    /**
     * Estimated Read Time
     */
    estimated_read_time: string;
};

/**
 * KnowledgeBaseArticleSummary
 *
 * Summary view of a knowledge base article for lists/overviews
 */
export type KnowledgeBaseArticleSummary = {
    /**
     * Id
     */
    id: string;
    /**
     * Title
     */
    title: string;
    topic: KnowledgeBaseTopic;
    /**
     * Tags
     */
    tags: Array<string>;
    /**
     * Summary
     */
    summary: string;
    /**
     * Last Updated
     */
    last_updated: string;
    /**
     * Estimated Read Time
     */
    estimated_read_time: string;
};

/**
 * KnowledgeBaseTopic
 *
 * Topic categories for knowledge base articles
 */
export const KnowledgeBaseTopic = {
    GETTING_STARTED: 'Getting Started',
    ENERGY_MANAGEMENT: 'Energy Management',
    DATA_MANAGEMENT: 'Data Management',
    PERFORMANCE_COMPLIANCE: 'Performance Compliance',
    BUILDING_PERFORMANCE_PROGRAMS: 'Building Performance Programs',
    'ACCOUNT &_SETTINGS': 'Account & Settings'
} as const;

/**
 * KnowledgeBaseTopic
 *
 * Topic categories for knowledge base articles
 */
export type KnowledgeBaseTopic = typeof KnowledgeBaseTopic[keyof typeof KnowledgeBaseTopic];

/**
 * LandArea
 */
export type LandArea = {
    /**
     * Value
     */
    value: number | string;
    unit_of_measure: LandAreaUnitOfMeasure;
};

/**
 * LandAreaUnitOfMeasure
 */
export const LandAreaUnitOfMeasure = {
    SQUARE_FEET: 'Square Feet',
    SQUARE_METERS: 'Square Meters',
    ACRES: 'Acres'
} as const;

/**
 * LandAreaUnitOfMeasure
 */
export type LandAreaUnitOfMeasure = typeof LandAreaUnitOfMeasure[keyof typeof LandAreaUnitOfMeasure];

/**
 * LimitDirection
 *
 * Direction in which a value meets a limit: scores from above, intensities from below.
 */
export const LimitDirection = { HIGHER: 'Higher', LOWER: 'Lower' } as const;

/**
 * LimitDirection
 *
 * Direction in which a value meets a limit: scores from above, intensities from below.
 */
export type LimitDirection = typeof LimitDirection[keyof typeof LimitDirection];

/**
 * LimitResponse
 */
export type LimitResponse = {
    /**
     * Key
     */
    key: string;
    /**
     * Table Key
     */
    table_key: string;
    /**
     * Track Keys
     */
    track_keys: Array<string> | null;
    subject_kind: LimitSubjectKind;
    /**
     * Subject Key
     */
    subject_key: string;
    /**
     * Property Function
     */
    property_function: string | null;
    /**
     * Metric
     */
    metric: string;
    /**
     * Unit
     */
    unit: string;
    better: LimitDirection | null;
    /**
     * Period Key
     */
    period_key: string;
    /**
     * Start Year
     */
    start_year: number;
    /**
     * End Year
     */
    end_year: number | null;
    /**
     * Value
     */
    value: number | string;
    record_status: ProgramRecordStatus;
    /**
     * Provenance
     */
    provenance: {
        [key: string]: unknown;
    } | null;
};

/**
 * LimitSubjectKind
 *
 * What a limit table's subjects are: ESPM property types, building-code occupancy groups, platform
 * property functions, or named campuses.
 */
export const LimitSubjectKind = {
    ESPM_PROPERTY_TYPE: 'ESPM property type',
    OCCUPANCY_GROUP: 'Occupancy group',
    PROPERTY_FUNCTION: 'Property function',
    CAMPUS: 'Campus'
} as const;

/**
 * LimitSubjectKind
 *
 * What a limit table's subjects are: ESPM property types, building-code occupancy groups, platform
 * property functions, or named campuses.
 */
export type LimitSubjectKind = typeof LimitSubjectKind[keyof typeof LimitSubjectKind];

/**
 * MatchRequest
 */
export type MatchRequest = {
    /**
     * List Key
     */
    list_key: string;
    /**
     * Platform List
     */
    platform_list?: boolean;
    /**
     * Accept Unverified
     */
    accept_unverified?: boolean;
    /**
     * Dry Run
     */
    dry_run?: boolean;
};

/**
 * MatchResult
 */
export type MatchResult = {
    /**
     * List Id
     */
    list_id: string;
    /**
     * List Version
     */
    list_version: string;
    /**
     * Counts
     */
    counts: {
        [key: string]: number;
    };
    /**
     * Tracking Changes
     */
    tracking_changes: Array<{
        [key: string]: unknown;
    }>;
    /**
     * Dry Run
     */
    dry_run: boolean;
};

/**
 * Meter
 */
export type Meter = {
    /**
     * Id
     */
    id: string;
    /**
     * Name
     */
    name: string;
    meter_type: MeterType;
    /**
     * Meter Type Other
     */
    meter_type_other?: string | null;
    /**
     * Active
     */
    active: boolean;
    /**
     * Inactive Date
     */
    inactive_date?: string | null;
    service_account: VendorServiceAccountRef;
    /**
     * Property Id
     */
    property_id?: string | null;
    property?: PropertySummary | null;
    vendor: Vendor;
    /**
     * External Identifiers
     */
    external_identifiers: Array<IdentifierRef>;
    /**
     * Capabilities
     */
    capabilities: Array<MeterCapability>;
};

/**
 * MeterCapability
 */
export type MeterCapability = {
    /**
     * Id
     */
    id: string;
    measure_type: MeterMeasureType;
    /**
     * Unit Of Measure
     */
    unit_of_measure: string;
    /**
     * Is Active
     */
    is_active: boolean;
    /**
     * Metadata
     */
    metadata: {
        [key: string]: unknown;
    };
};

/**
 * MeterCategory
 */
export const MeterCategory = {
    ENERGY: 'ENERGY',
    WATER: 'WATER',
    WASTE: 'WASTE',
    GENERAL: 'GENERAL'
} as const;

/**
 * MeterCategory
 */
export type MeterCategory = typeof MeterCategory[keyof typeof MeterCategory];

/**
 * MeterMeasureType
 */
export type MeterMeasureType = {
    /**
     * Id
     */
    id: string;
    /**
     * Plug
     */
    plug: string;
    /**
     * Name
     */
    name: string;
    /**
     * Description
     */
    description: string | null;
    category: MeterCategory;
    /**
     * Default Unit Of Measure
     */
    default_unit_of_measure: string;
};

/**
 * MeterReading
 */
export type MeterReading = {
    /**
     * Id
     */
    id: string;
    /**
     * Reading Date
     */
    reading_date: string;
    /**
     * Value
     */
    value: number | string;
    /**
     * Unit Of Measure
     */
    unit_of_measure: string | null;
    /**
     * Reading Method
     */
    reading_method: string;
    /**
     * Source
     */
    source: string;
    /**
     * Metadata
     */
    metadata: {
        [key: string]: unknown;
    };
    capability: MeterCapability;
};

/**
 * MeterReadingCreate
 */
export type MeterReadingCreate = {
    /**
     * Meter Id
     */
    meter_id: string;
    /**
     * Capability Id
     */
    capability_id: string;
    /**
     * Reading Date
     */
    reading_date: string;
    /**
     * Value
     */
    value: number | string;
    /**
     * Unit Of Measure
     */
    unit_of_measure: string | null;
    /**
     * Reading Method
     */
    reading_method: MeterReadingMethod | string;
    /**
     * Source
     */
    source: MeterReadingSource | string;
    /**
     * Metadata
     */
    metadata: {
        [key: string]: unknown;
    };
};

/**
 * MeterReadingMethod
 */
export const MeterReadingMethod = {
    ACTUAL: 'Actual',
    ESTIMATED: 'Estimated',
    CALCULATED: 'Calculated'
} as const;

/**
 * MeterReadingMethod
 */
export type MeterReadingMethod = typeof MeterReadingMethod[keyof typeof MeterReadingMethod];

/**
 * MeterReadingSource
 */
export const MeterReadingSource = {
    MANUAL: 'Manual',
    STATEMENT: 'Statement',
    AMR: 'AMR',
    AMI: 'AMI'
} as const;

/**
 * MeterReadingSource
 */
export type MeterReadingSource = typeof MeterReadingSource[keyof typeof MeterReadingSource];

/**
 * MeterReadingUpdate
 */
export type MeterReadingUpdate = {
    /**
     * Meter Id
     */
    meter_id?: string | null;
    /**
     * Capability Id
     */
    capability_id?: string | null;
    /**
     * Reading Date
     */
    reading_date?: string | null;
    /**
     * Value
     */
    value?: number | string | null;
    /**
     * Unit Of Measure
     */
    unit_of_measure?: string | null;
    /**
     * Reading Method
     */
    reading_method?: MeterReadingMethod | string | null;
    /**
     * Source
     */
    source?: MeterReadingSource | string | null;
    /**
     * Metadata
     */
    metadata?: {
        [key: string]: unknown;
    } | null;
};

/**
 * MeterType
 */
export type MeterType = {
    /**
     * Id
     */
    id: string;
    /**
     * Plug
     */
    plug: string;
    category: MeterCategory;
    /**
     * Name
     */
    name: string;
};

/**
 * Metric
 */
export type Metric = {
    /**
     * Name
     */
    name: string;
    /**
     * Label
     */
    label: string;
    /**
     * Category
     */
    category: 'energy' | 'cost' | 'demand' | 'performance' | 'compliance' | 'ops' | 'detail';
    /**
     * Unit
     */
    unit: string;
    /**
     * Format
     */
    format: 'number' | 'currency' | 'percent' | 'integer' | 'date' | 'string';
    /**
     * Fact
     */
    fact: string;
    /**
     * Expression
     */
    expression: ({
        kind: 'aggregate';
    } & AggregateExpression) | ({
        kind: 'ratio';
    } & RatioExpression) | ({
        kind: 'compound_agg';
    } & CompoundAggExpression) | ({
        kind: 'compound_row';
    } & CompoundRowExpression) | ({
        kind: 'passthrough';
    } & PassthroughExpression);
    /**
     * Additivity
     */
    additivity: 'additive' | 'semi_additive' | 'non_additive';
    /**
     * Period Compare Kinds
     */
    period_compare_kinds?: Array<'prior_period' | 'prior_year' | 'baseline'>;
    /**
     * Applicable Dimensions
     */
    applicable_dimensions: Array<string>;
    /**
     * Requires
     */
    requires?: Array<'weather'>;
    /**
     * Weather Normalizable
     */
    weather_normalizable?: boolean;
    /**
     * Private
     */
    private?: boolean;
    /**
     * Description
     */
    description?: string | null;
};

/**
 * MetricFilter
 *
 * A filter applied to a metric after aggregation (HAVING clause).
 */
export type MetricFilter = {
    /**
     * Metric
     */
    metric: string;
    /**
     * Op
     */
    op: 'eq' | 'gt' | 'gte' | 'lt' | 'lte' | 'between';
    /**
     * Value
     */
    value: unknown;
};

/**
 * MetricMeta
 *
 * Metadata about a metric as it appears in the result.
 *
 * `comparison_columns` lists which `_prior`/`_delta`/`_pct_change` companion
 * fields are present in each row for this metric (depends on `compare_to`).
 *
 * `weather_normalizable` lets a view/dashboard decide whether to offer the
 * weather-normalization toggle. `unit` already reflects normalization when
 * the result was produced with `weather_normalize` on (e.g. "kBTU/dd").
 */
export type MetricMeta = {
    /**
     * Name
     */
    name: string;
    /**
     * Label
     */
    label: string;
    /**
     * Unit
     */
    unit: string;
    /**
     * Format
     */
    format: string;
    /**
     * Comparison Columns
     */
    comparison_columns?: Array<string>;
    /**
     * Weather Normalizable
     */
    weather_normalizable?: boolean;
};

/**
 * MetricResponse
 */
export type MetricResponse = {
    /**
     * Metric Key
     */
    metric_key: string;
    /**
     * Year
     */
    year: number;
    /**
     * Value
     */
    value: number | string;
    source?: MetricSource;
    /**
     * Unit
     */
    unit?: string | null;
    /**
     * As Of
     */
    as_of?: string | null;
    /**
     * External Ref
     */
    external_ref?: string | null;
    /**
     * Verified
     */
    verified: boolean;
    /**
     * Note
     */
    note?: string | null;
    /**
     * Id
     */
    id: string;
};

/**
 * MetricSource
 *
 * Where an annual property metric came from. ESPM and DOEE values are written by imports; MANUAL
 * values by people; DERIVED values by Viaduct from bills.
 */
export const MetricSource = {
    PORTFOLIO_MANAGER: 'Portfolio Manager',
    DOEE: 'DOEE',
    MANUAL: 'Manual',
    DERIVED: 'Derived'
} as const;

/**
 * MetricSource
 *
 * Where an annual property metric came from. ESPM and DOEE values are written by imports; MANUAL
 * values by people; DERIVED values by Viaduct from bills.
 */
export type MetricSource = typeof MetricSource[keyof typeof MetricSource];

/**
 * MetricValue
 */
export type MetricValue = {
    /**
     * Metric Key
     */
    metric_key: string;
    /**
     * Year
     */
    year: number;
    /**
     * Value
     */
    value: number | string;
    source?: MetricSource;
    /**
     * Unit
     */
    unit?: string | null;
    /**
     * As Of
     */
    as_of?: string | null;
    /**
     * External Ref
     */
    external_ref?: string | null;
    /**
     * Verified
     */
    verified?: boolean | null;
    /**
     * Note
     */
    note?: string | null;
};

/**
 * MetricsImportRequest
 */
export type MetricsImportRequest = {
    /**
     * Csv
     */
    csv: string;
    source?: MetricSource;
    /**
     * Identifier Systems
     */
    identifier_systems?: Array<string>;
    /**
     * Dry Run
     */
    dry_run?: boolean;
};

/**
 * MetricsImportResponse
 */
export type MetricsImportResponse = {
    /**
     * Counts
     */
    counts: {
        [key: string]: number;
    };
    /**
     * Rows
     */
    rows: Array<MetricsImportRow>;
};

/**
 * MetricsImportRow
 */
export type MetricsImportRow = {
    /**
     * Line
     */
    line: number;
    /**
     * Property Identifier
     */
    property_identifier: string;
    /**
     * Metric Key
     */
    metric_key: string;
    /**
     * Year
     */
    year: number | null;
    /**
     * Value
     */
    value: number | string | null;
    /**
     * Property Id
     */
    property_id: string | null;
    /**
     * Action
     */
    action: string | null;
    /**
     * Error
     */
    error: string | null;
};

/**
 * MissingDataIssue
 *
 * Issue indicating missing statements or accounts.
 */
export type MissingDataIssue = {
    issue_type: IssueType;
    severity: IssueSeverity;
    /**
     * Description
     */
    description: string | null;
    /**
     * Detected At
     */
    detected_at: string;
    billing_account?: VendorBillingAccountRef | null;
    service_account?: VendorServiceAccountRef | null;
    /**
     * Expected Date
     */
    expected_date?: string | null;
    /**
     * Last Statement Date
     */
    last_statement_date?: string | null;
    /**
     * Days Since Last
     */
    days_since_last?: number | null;
};

/**
 * Notification
 */
export type Notification = {
    /**
     * Id
     */
    id: string;
    /**
     * Title
     */
    title: string;
    /**
     * Message
     */
    message: string | null;
    /**
     * Metadata
     */
    metadata: {
        [key: string]: unknown;
    } | null;
    /**
     * Created At
     */
    created_at: string;
    /**
     * Read At
     */
    read_at: string | null;
    /**
     * Cleared At
     */
    cleared_at: string | null;
    /**
     * Timeout Seconds
     */
    timeout_seconds: number | null;
    alert: Alert | null;
};

/**
 * NotificationStats
 */
export type NotificationStats = {
    /**
     * Total
     */
    total: number;
    /**
     * Unread
     */
    unread: number;
    /**
     * Uncleared
     */
    uncleared: number;
};

/**
 * NotificationSummary
 */
export type NotificationSummary = {
    /**
     * Id
     */
    id: string;
    /**
     * Title
     */
    title: string;
    /**
     * Created At
     */
    created_at: string;
    /**
     * Read At
     */
    read_at: string | null;
    /**
     * Cleared At
     */
    cleared_at: string | null;
    alert: AlertSummary | null;
};

/**
 * NotificationUpdate
 */
export type NotificationUpdate = {
    /**
     * Read
     */
    read?: boolean | null;
    /**
     * Cleared
     */
    cleared?: boolean | null;
};

/**
 * OrgBalance
 *
 * Org-wide balance rollup.
 */
export type OrgBalance = {
    /**
     * Org Id
     */
    org_id: string;
    /**
     * Total Charged
     */
    total_charged: number | string;
    /**
     * Total Paid
     */
    total_paid: number | string;
    /**
     * Outstanding
     */
    outstanding: number | string;
};

/**
 * OrgCommodity
 *
 * Organization-specific commodity configuration.
 */
export type OrgCommodity = {
    /**
     * Id
     */
    id: string;
    /**
     * Ref Id
     */
    ref_id?: string | null;
    /**
     * Name
     */
    name: string;
    /**
     * Color
     */
    color?: string | null;
    /**
     * Icon
     */
    icon?: string | null;
    icon_source?: IconSource | null;
    /**
     * Unit Of Measure
     */
    unit_of_measure?: string | null;
    /**
     * Is Enabled
     */
    is_enabled?: boolean;
    /**
     * Is Custom
     */
    is_custom?: boolean;
    category: CommodityCategory;
};

/**
 * OrgCommodityCreate
 *
 * Create a new organization commodity.
 */
export type OrgCommodityCreate = {
    /**
     * Ref Id
     */
    ref_id?: string | null;
    /**
     * Name
     */
    name: string;
    /**
     * Color
     */
    color?: string | null;
    /**
     * Icon
     */
    icon?: string | null;
    icon_source?: IconSource | null;
    /**
     * Unit Of Measure
     */
    unit_of_measure?: string | null;
    /**
     * Is Enabled
     */
    is_enabled?: boolean;
    category: CommodityCategory;
};

/**
 * OrgCommodityUpdate
 *
 * Update an existing organization commodity.
 */
export type OrgCommodityUpdate = {
    /**
     * Name
     */
    name?: string | null;
    /**
     * Color
     */
    color?: string | null;
    /**
     * Icon
     */
    icon?: string | null;
    icon_source?: IconSource | null;
    /**
     * Unit Of Measure
     */
    unit_of_measure?: string | null;
    /**
     * Is Enabled
     */
    is_enabled?: boolean | null;
    category?: CommodityCategory | null;
};

/**
 * OrgDetails
 */
export type OrgDetails = {
    /**
     * Id
     */
    id: string;
    account: Account;
    /**
     * Name
     */
    name: string;
    /**
     * Is Active
     */
    is_active?: boolean;
    /**
     * Is Deleted
     */
    is_deleted?: boolean;
    /**
     * Has Logo
     */
    has_logo?: boolean;
    /**
     * Logo Url
     */
    logo_url?: string | null;
    /**
     * Entitlements
     */
    entitlements: Array<Entitlement>;
};

/**
 * OrgDigest
 */
export type OrgDigest = {
    /**
     * Id
     */
    id: string;
    /**
     * Last Data Update
     */
    last_data_update?: string | null;
    alerts: AlertsDigest;
    energy_management?: EnergyManagementDigest | null;
    performance_compliance?: PerformanceComplianceDigest | null;
    building_performance_programs?: BuildingPerformanceProgramsDigest | null;
};

/**
 * OrgIntegration
 */
export type OrgIntegration = {
    /**
     * Id
     */
    id: string;
    /**
     * Is Active
     */
    is_active: boolean;
    integration: Integration;
};

/**
 * OrgRef
 */
export type OrgRef = {
    /**
     * Id
     */
    id: string;
    /**
     * Name
     */
    name: string;
    /**
     * Is Active
     */
    is_active?: boolean;
    /**
     * Is Deleted
     */
    is_deleted?: boolean;
    /**
     * Has Logo
     */
    has_logo?: boolean;
    /**
     * Logo Url
     */
    logo_url?: string | null;
};

/**
 * OrgUpdate
 */
export type OrgUpdate = {
    /**
     * Name
     */
    name?: string | null;
    /**
     * Logo Url
     */
    logo_url?: string | null;
    /**
     * Is Active
     */
    is_active?: boolean | null;
    /**
     * Is Deleted
     */
    is_deleted?: boolean | null;
    preferences?: PreferenceCollection | null;
    /**
     * Entitlement Package Id
     */
    entitlement_package_id?: string | null;
};

/**
 * OrgUserCreate
 */
export type OrgUserCreate = {
    /**
     * Name
     */
    name: string;
    /**
     * Email
     */
    email: string;
};

/**
 * OrgUserDetails
 */
export type OrgUserDetails = {
    /**
     * Id
     */
    id: string;
    org: OrgDetails;
    user: UserDetails;
    user_class: UserClass;
    /**
     * Roles
     */
    roles: Array<RoleRef>;
    /**
     * Permissions
     */
    permissions: Array<Permission>;
};

/**
 * OrgUserPrivate
 */
export type OrgUserPrivate = {
    /**
     * Id
     */
    id: string;
    org: OrgDetails;
    user: UserPrivate;
    user_class: UserClass;
    /**
     * Roles
     */
    roles: Array<RoleRef>;
    /**
     * Permissions
     */
    permissions: Array<Permission>;
};

/**
 * OrgUserRef
 */
export type OrgUserRef = {
    /**
     * Id
     */
    id: string;
    user: UserRef;
    org: OrgRef;
    user_class: UserClass;
};

/**
 * OrgUserUpdate
 */
export type OrgUserUpdate = {
    /**
     * Name
     */
    name?: string | null;
    /**
     * Role Ids
     */
    role_ids?: Array<string> | null;
    /**
     * Email
     */
    email?: string | null;
    /**
     * Avatar Url
     */
    avatar_url?: string | null;
    /**
     * Is Active
     */
    is_active?: boolean | null;
    /**
     * Is Deleted
     */
    is_deleted?: boolean | null;
    org_user_preferences?: PreferenceCollection | null;
    user_preferences?: PreferenceCollection | null;
};

/**
 * OrgVendor
 */
export type OrgVendor = {
    /**
     * Id
     */
    id: string;
    /**
     * Is Active
     */
    is_active: boolean;
    vendor: Vendor;
    /**
     * Outstanding
     */
    outstanding?: number | string | null;
    /**
     * Billing Account Count
     */
    billing_account_count?: number | null;
};

/**
 * OrgVendorCreateUpdate
 */
export type OrgVendorCreateUpdate = {
    /**
     * Is Active
     */
    is_active: boolean;
};

/**
 * OwnerFormDefinition
 */
export type OwnerFormDefinition = {
    /**
     * Id
     */
    id: string;
    /**
     * Cycle Id
     */
    cycle_id: string;
    /**
     * Name
     */
    name: string;
    /**
     * Description
     */
    description: string | null;
    /**
     * Instructions
     */
    instructions: string | null;
    /**
     * Form Schema
     */
    form_schema: {
        [key: string]: unknown;
    };
    access_type: PortalAccessType;
    /**
     * Requirement Id
     */
    requirement_id: string | null;
    /**
     * Available From
     */
    available_from: string | null;
    /**
     * Available Until
     */
    available_until: string | null;
};

/**
 * OwnerFormSubmissionResponse
 */
export type OwnerFormSubmissionResponse = {
    /**
     * Id
     */
    id: string;
    /**
     * Form Id
     */
    form_id: string;
    /**
     * Property Id
     */
    property_id: string | null;
    status: SubmissionStatus;
    /**
     * Responses
     */
    responses: {
        [key: string]: unknown;
    };
    /**
     * Submitted At
     */
    submitted_at: string | null;
    /**
     * Review Notes
     */
    review_notes: string | null;
    /**
     * Rejection Reason
     */
    rejection_reason: string | null;
};

/**
 * OwnerPortalSubmissionResponse
 */
export type OwnerPortalSubmissionResponse = {
    /**
     * Id
     */
    id: string;
    /**
     * Portal Id
     */
    portal_id: string;
    /**
     * Property Id
     */
    property_id: string | null;
    status: SubmissionStatus;
    /**
     * File Name
     */
    file_name: string;
    /**
     * Submitted At
     */
    submitted_at: string | null;
    /**
     * Review Notes
     */
    review_notes: string | null;
};

/**
 * OwnerSubmissionDraft
 */
export type OwnerSubmissionDraft = {
    /**
     * Property Id
     */
    property_id: string;
    /**
     * Responses
     */
    responses: {
        [key: string]: unknown;
    };
};

/**
 * OwnershipClass
 *
 * Who owns a property, for coverage rules that treat public owners differently.
 */
export const OwnershipClass = {
    PRIVATE: 'Private',
    FEDERAL: 'Federal',
    STATE: 'State',
    LOCAL_GOVERNMENT: 'Local government',
    DISTRICT_OF_COLUMBIA: 'District of Columbia',
    INSTITUTIONAL: 'Institutional',
    NONPROFIT: 'Nonprofit'
} as const;

/**
 * OwnershipClass
 *
 * Who owns a property, for coverage rules that treat public owners differently.
 */
export type OwnershipClass = typeof OwnershipClass[keyof typeof OwnershipClass];

/**
 * PageInfo
 */
export type PageInfo = {
    /**
     * Total Count
     */
    total_count: number;
    /**
     * Has More
     */
    has_more: boolean;
    /**
     * Next Offset
     */
    next_offset?: number | null;
};

/**
 * PaginatedResult[VendorStatementOverview]
 */
export type PaginatedResultVendorStatementOverview = {
    /**
     * Total
     */
    total: number;
    /**
     * Data
     */
    data: Array<VendorStatementOverview>;
};

/**
 * Pagination
 *
 * Offset-based pagination. UI uses this. Streaming export uses an
 * internal keyset cursor instead and does not surface this type.
 */
export type Pagination = {
    /**
     * Offset
     */
    offset?: number;
    /**
     * Limit
     */
    limit?: number;
};

/**
 * PassthroughExpression
 *
 * Raw column value, valid only when the query has no GROUP BY (no
 * dimensions and no time grain), or when the dimension key set uniquely
 * determines a row. Used by tabular reports that show one row per line item.
 */
export type PassthroughExpression = {
    /**
     * Kind
     */
    kind?: 'passthrough';
    /**
     * Column
     */
    column: string;
};

/**
 * PastDeadlinePolicy
 *
 * What task generation does with a requirement whose deadline has already passed: create the task
 * with its original date (it shows as overdue), or create no task (milestones that are history).
 */
export const PastDeadlinePolicy = { OVERDUE_TASK: 'Overdue task', NO_TASK: 'No task' } as const;

/**
 * PastDeadlinePolicy
 *
 * What task generation does with a requirement whose deadline has already passed: create the task
 * with its original date (it shows as overdue), or create no task (milestones that are history).
 */
export type PastDeadlinePolicy = typeof PastDeadlinePolicy[keyof typeof PastDeadlinePolicy];

/**
 * Payment
 */
export type Payment = {
    /**
     * Id
     */
    id: string;
    /**
     * Billing Account Id
     */
    billing_account_id: string;
    /**
     * Service Account Id
     */
    service_account_id: string | null;
    /**
     * Statement Id
     */
    statement_id: string | null;
    /**
     * Statement Service Details Id
     */
    statement_service_details_id: string | null;
    /**
     * Amount
     */
    amount: number | string;
    /**
     * Payment Date
     */
    payment_date: string;
    /**
     * Reference
     */
    reference: string | null;
    /**
     * Notes
     */
    notes: string | null;
    source: PaymentSource;
    /**
     * Created By User Id
     */
    created_by_user_id: string | null;
    /**
     * Created At
     */
    created_at: string;
    /**
     * Updated At
     */
    updated_at: string;
};

/**
 * PaymentCreate
 */
export type PaymentCreate = {
    /**
     * Billing Account Id
     */
    billing_account_id: string;
    /**
     * Service Account Id
     */
    service_account_id?: string | null;
    /**
     * Statement Id
     */
    statement_id?: string | null;
    /**
     * Statement Service Details Id
     */
    statement_service_details_id?: string | null;
    /**
     * Amount
     */
    amount: number | string;
    /**
     * Payment Date
     */
    payment_date: string;
    /**
     * Reference
     */
    reference?: string | null;
    /**
     * Notes
     */
    notes?: string | null;
};

/**
 * PaymentSource
 */
export const PaymentSource = {
    MANUAL: 'manual',
    PARSER: 'parser',
    IMPORT: 'import'
} as const;

/**
 * PaymentSource
 */
export type PaymentSource = typeof PaymentSource[keyof typeof PaymentSource];

/**
 * PaymentUpdate
 */
export type PaymentUpdate = {
    /**
     * Service Account Id
     */
    service_account_id?: string | null;
    /**
     * Statement Id
     */
    statement_id?: string | null;
    /**
     * Statement Service Details Id
     */
    statement_service_details_id?: string | null;
    /**
     * Amount
     */
    amount?: number | string | null;
    /**
     * Payment Date
     */
    payment_date?: string | null;
    /**
     * Reference
     */
    reference?: string | null;
    /**
     * Notes
     */
    notes?: string | null;
};

/**
 * PenaltyKind
 */
export const PenaltyKind = {
    PER_UNIT_OVER_LIMIT: 'Per unit over limit',
    PER_AREA_PER_MONTH: 'Per area per month',
    FLAT_PER_BUILDING: 'Flat per building',
    FLAT_PER_REPORT_YEAR: 'Flat per report year',
    PER_UNIT_PER_YEAR: 'Per unit per year',
    'PER_AREA,_SCALED_AND_CAPPED': 'Per area, scaled and capped',
    'FLAT,_THEN_PER_DAY': 'Flat, then per day'
} as const;

/**
 * PenaltyKind
 */
export type PenaltyKind = typeof PenaltyKind[keyof typeof PenaltyKind];

/**
 * PenaltyRuleResponse
 */
export type PenaltyRuleResponse = {
    /**
     * Key
     */
    key: string;
    kind: PenaltyKind;
    /**
     * Amount
     */
    amount: number | string;
    /**
     * Unit
     */
    unit: string;
    /**
     * Track Keys
     */
    track_keys: Array<string> | null;
    /**
     * Max Months
     */
    max_months: number | null;
    /**
     * Grace Days
     */
    grace_days: number | null;
    /**
     * Is Ceiling
     */
    is_ceiling: boolean;
    /**
     * Cap
     */
    cap: number | string | null;
    /**
     * Daily Amount
     */
    daily_amount: number | string | null;
    /**
     * Description
     */
    description: string | null;
    /**
     * Requirement Key
     */
    requirement_key: string | null;
    record_status: ProgramRecordStatus;
    /**
     * Provenance
     */
    provenance: {
        [key: string]: unknown;
    } | null;
};

/**
 * PerformanceComplianceDigest
 */
export type PerformanceComplianceDigest = {
    /**
     * Active Trackings
     */
    active_trackings: number;
    /**
     * Overdue Tasks
     */
    overdue_tasks: number;
    /**
     * Due Soon Tasks
     */
    due_soon_tasks: number;
    /**
     * Completed This Period
     */
    completed_this_period: number;
    /**
     * Next Deadline
     */
    next_deadline?: string | null;
};

/**
 * Permission
 */
export type Permission = {
    /**
     * Id
     */
    id: string;
    /**
     * Name
     */
    name: string;
    /**
     * Display Name
     */
    display_name: string;
    /**
     * Is Builtin
     */
    is_builtin: boolean;
};

/**
 * PermissionCreateUpdate
 */
export type PermissionCreateUpdate = {
    /**
     * Name
     */
    name: string;
};

/**
 * PortalAccessType
 *
 * Access type for upload portals and forms
 */
export const PortalAccessType = {
    PUBLIC: 'Public',
    MAGIC_LINK: 'Magic Link',
    ACCESS_CODE: 'Access Code',
    ACCOUNT_REQUIRED: 'Account Required'
} as const;

/**
 * PortalAccessType
 *
 * Access type for upload portals and forms
 */
export type PortalAccessType = typeof PortalAccessType[keyof typeof PortalAccessType];

/**
 * PortalResponse
 */
export type PortalResponse = {
    /**
     * Id
     */
    id: string;
    /**
     * Cycle Id
     */
    cycle_id: string;
    /**
     * Name
     */
    name: string;
    /**
     * Description
     */
    description: string | null;
    /**
     * Instructions
     */
    instructions: string | null;
    /**
     * Accepted File Types
     */
    accepted_file_types: Array<string> | null;
    /**
     * Max File Size Mb
     */
    max_file_size_mb: number | null;
    access_type: PortalAccessType;
    /**
     * Requirement Id
     */
    requirement_id: string | null;
    /**
     * Is Active
     */
    is_active: boolean;
};

/**
 * PortalSubmissionResponse
 */
export type PortalSubmissionResponse = {
    /**
     * Id
     */
    id: string;
    /**
     * Portal Id
     */
    portal_id: string;
    /**
     * Property Id
     */
    property_id: string | null;
    /**
     * Submitter Email
     */
    submitter_email: string | null;
    /**
     * Submitter Name
     */
    submitter_name: string | null;
    /**
     * File Name
     */
    file_name: string;
    status: SubmissionStatus;
    /**
     * Submitted At
     */
    submitted_at: string | null;
    /**
     * Reviewed At
     */
    reviewed_at: string | null;
    /**
     * Review Notes
     */
    review_notes: string | null;
};

/**
 * Preference
 */
export type Preference = {
    key: PreferenceKey;
    /**
     * Value
     */
    value: string | null;
    /**
     * Components
     */
    components: Array<PreferenceComponent>;
    definition: PreferenceDefinition;
};

/**
 * PreferenceCollection
 */
export type PreferenceCollection = {
    preference_type: PreferenceType;
    /**
     * Preferences
     */
    preferences: Array<PreferenceUpdate>;
};

/**
 * PreferenceComponent
 */
export type PreferenceComponent = {
    preference_type: PreferenceType;
    key: PreferenceKey;
    /**
     * Value
     */
    value: string | null;
};

/**
 * PreferenceDefinition
 */
export type PreferenceDefinition = {
    key: PreferenceKey;
    /**
     * Component Keys
     */
    component_keys: {
        [key in PreferenceType]?: PreferenceKey;
    };
    override_key: PreferenceKey | null;
};

/**
 * PreferenceKey
 */
export const PreferenceKey = {
    PREFERRED_UNITS: 'PREFERRED_UNITS',
    HOME_VIEW_TYPE: 'HOME_VIEW_TYPE',
    HOME_VIEW_PARAMS: 'HOME_VIEW_PARAMS',
    HOME_VIEW_ALLOW_OVERRIDE: 'HOME_VIEW_ALLOW_OVERRIDE',
    DATE_FORMAT: 'DATE_FORMAT',
    TIME_FORMAT: 'TIME_FORMAT',
    DATE_TIME_FORMAT_ALLOW_OVERRIDE: 'DATE_TIME_FORMAT_ALLOW_OVERRIDE',
    LOCATION: 'LOCATION',
    LOCATION_ALLOW_OVERRIDE: 'LOCATION_ALLOW_OVERRIDE',
    TIMEZONE: 'TIMEZONE',
    TIMEZONE_ALLOW_OVERRIDE: 'TIMEZONE_ALLOW_OVERRIDE',
    FISCAL_YEAR_START: 'FISCAL_YEAR_START',
    COLOR_PALETTE: 'COLOR_PALETTE',
    COLOR_PALETTE_ALLOW_OVERRIDE: 'COLOR_PALETTE_ALLOW_OVERRIDE',
    LOGIN_BEHAVIOR: 'LOGIN_BEHAVIOR',
    LAST_ORG: 'LAST_ORG',
    THEME: 'THEME'
} as const;

/**
 * PreferenceKey
 */
export type PreferenceKey = typeof PreferenceKey[keyof typeof PreferenceKey];

/**
 * PreferenceType
 */
export const PreferenceType = {
    ORG: 'Org',
    ORG_USER: 'Org User',
    USER: 'User'
} as const;

/**
 * PreferenceType
 */
export type PreferenceType = typeof PreferenceType[keyof typeof PreferenceType];

/**
 * PreferenceUpdate
 */
export type PreferenceUpdate = {
    key: PreferenceKey;
    /**
     * Value
     */
    value: string | null;
};

/**
 * ProgramCreatePublic
 */
export type ProgramCreatePublic = {
    /**
     * Name
     */
    name: string;
    /**
     * Short Name
     */
    short_name?: string | null;
    /**
     * Description
     */
    description?: string | null;
    program_type: ProgramType;
    /**
     * Jurisdiction Id
     */
    jurisdiction_id: string;
    /**
     * Website Url
     */
    website_url?: string | null;
    /**
     * Documentation Url
     */
    documentation_url?: string | null;
    visibility?: ProgramVisibility;
    /**
     * Match Disclosure
     */
    match_disclosure?: string | null;
};

/**
 * ProgramCriteriaCreate
 */
export type ProgramCriteriaCreate = {
    /**
     * Name
     */
    name: string;
    /**
     * Description
     */
    description?: string | null;
    /**
     * Min Gross Floor Area
     */
    min_gross_floor_area?: number | string | null;
    /**
     * Max Gross Floor Area
     */
    max_gross_floor_area?: number | string | null;
    floor_area_uom?: FloorAreaUnitOfMeasure;
    /**
     * Included Property Types
     */
    included_property_types?: Array<PropertyFunction> | null;
    /**
     * Excluded Property Types
     */
    excluded_property_types?: Array<PropertyFunction> | null;
    /**
     * Min Buildings
     */
    min_buildings?: number | null;
    /**
     * Min Year Built
     */
    min_year_built?: number | null;
    /**
     * Max Year Built
     */
    max_year_built?: number | null;
    /**
     * Min Occupancy Percentage
     */
    min_occupancy_percentage?: number | null;
    /**
     * Applies To Federal Properties
     */
    applies_to_federal_properties?: boolean;
    /**
     * Applies To Institutional Properties
     */
    applies_to_institutional_properties?: boolean;
    /**
     * Custom Criteria
     */
    custom_criteria?: {
        [key: string]: unknown;
    } | null;
    /**
     * Evaluation Order
     */
    evaluation_order?: number;
};

/**
 * ProgramCriteriaUpdate
 */
export type ProgramCriteriaUpdate = {
    /**
     * Name
     */
    name?: string | null;
    /**
     * Description
     */
    description?: string | null;
    /**
     * Min Gross Floor Area
     */
    min_gross_floor_area?: number | string | null;
    /**
     * Max Gross Floor Area
     */
    max_gross_floor_area?: number | string | null;
    floor_area_uom?: FloorAreaUnitOfMeasure | null;
    /**
     * Included Property Types
     */
    included_property_types?: Array<PropertyFunction> | null;
    /**
     * Excluded Property Types
     */
    excluded_property_types?: Array<PropertyFunction> | null;
    /**
     * Min Buildings
     */
    min_buildings?: number | null;
    /**
     * Min Year Built
     */
    min_year_built?: number | null;
    /**
     * Max Year Built
     */
    max_year_built?: number | null;
    /**
     * Min Occupancy Percentage
     */
    min_occupancy_percentage?: number | null;
    /**
     * Applies To Federal Properties
     */
    applies_to_federal_properties?: boolean | null;
    /**
     * Applies To Institutional Properties
     */
    applies_to_institutional_properties?: boolean | null;
    /**
     * Custom Criteria
     */
    custom_criteria?: {
        [key: string]: unknown;
    } | null;
    /**
     * Evaluation Order
     */
    evaluation_order?: number | null;
    /**
     * Is Active
     */
    is_active?: boolean | null;
};

/**
 * ProgramCycleCreatePublic
 *
 * Data for creating a new program cycle.
 */
export type ProgramCycleCreatePublic = {
    /**
     * Name
     */
    name?: string | null;
    /**
     * Start Date
     */
    start_date: string;
    /**
     * End Date
     */
    end_date: string;
    /**
     * Inherit From
     */
    inherit_from?: string | null;
};

/**
 * ProgramCycleUpdate
 */
export type ProgramCycleUpdate = {
    /**
     * Name
     */
    name?: string | null;
    /**
     * Start Date
     */
    start_date?: string | null;
    /**
     * End Date
     */
    end_date?: string | null;
    status?: ProgramStatus | null;
};

/**
 * ProgramDeadlineCreate
 */
export type ProgramDeadlineCreate = {
    /**
     * Name
     */
    name: string;
    /**
     * Description
     */
    description?: string | null;
    /**
     * Requirement Id
     */
    requirement_id?: string | null;
    /**
     * Deadline Date
     */
    deadline_date?: string | null;
    /**
     * Template Offset Days
     */
    template_offset_days?: number | null;
    /**
     * Template Month
     */
    template_month?: number | null;
    /**
     * Template Day Of Month
     */
    template_day_of_month?: number | null;
    /**
     * Applies To Reporting Year
     */
    applies_to_reporting_year?: boolean;
    /**
     * Reminder Days Before
     */
    reminder_days_before?: Array<number> | null;
};

/**
 * ProgramDeadlineUpdate
 */
export type ProgramDeadlineUpdate = {
    /**
     * Name
     */
    name?: string | null;
    /**
     * Description
     */
    description?: string | null;
    /**
     * Requirement Id
     */
    requirement_id?: string | null;
    /**
     * Deadline Date
     */
    deadline_date?: string | null;
    /**
     * Template Offset Days
     */
    template_offset_days?: number | null;
    /**
     * Template Month
     */
    template_month?: number | null;
    /**
     * Template Day Of Month
     */
    template_day_of_month?: number | null;
    /**
     * Applies To Reporting Year
     */
    applies_to_reporting_year?: boolean | null;
    /**
     * Reminder Days Before
     */
    reminder_days_before?: Array<number> | null;
    /**
     * Is Active
     */
    is_active?: boolean | null;
};

/**
 * ProgramDetailResponse
 *
 * A program with everything needed to read it: tracks, cycles and each cycle's rows, sources and the
 * program's reference tables.
 */
export type ProgramDetailResponse = {
    program: ProgramResponse;
    /**
     * Tracks
     */
    tracks: Array<TrackResponse>;
    /**
     * Sources
     */
    sources: Array<SourceResponse>;
    /**
     * Cycles
     */
    cycles: Array<CycleResponse>;
    /**
     * Criteria
     */
    criteria: Array<CriteriaResponse>;
    /**
     * Requirements
     */
    requirements: Array<RequirementResponse>;
    /**
     * Deadlines
     */
    deadlines: Array<DeadlineResponse>;
    reference: ProgramReferenceResponse;
};

/**
 * ProgramEnrollmentUpdate
 */
export type ProgramEnrollmentUpdate = {
    enrollment_status?: EnrollmentStatus | null;
    /**
     * Exemption Reason
     */
    exemption_reason?: string | null;
    /**
     * Exemption Start Date
     */
    exemption_start_date?: string | null;
    /**
     * Exemption End Date
     */
    exemption_end_date?: string | null;
    /**
     * Notes
     */
    notes?: string | null;
};

/**
 * ProgramFactsResponse
 */
export type ProgramFactsResponse = {
    /**
     * Supplied
     */
    supplied: {
        [key: string]: unknown;
    };
    /**
     * Effective
     */
    effective: {
        [key: string]: unknown;
    };
    /**
     * Registry
     */
    registry: {
        [key: string]: string;
    };
};

/**
 * ProgramFormCreate
 */
export type ProgramFormCreate = {
    /**
     * Name
     */
    name: string;
    /**
     * Description
     */
    description?: string | null;
    /**
     * Instructions
     */
    instructions?: string | null;
    /**
     * Form Schema
     */
    form_schema: {
        [key: string]: unknown;
    };
    access_type?: PortalAccessType;
    /**
     * Requirement Id
     */
    requirement_id?: string | null;
    /**
     * Available From
     */
    available_from?: string | null;
    /**
     * Available Until
     */
    available_until?: string | null;
};

/**
 * ProgramFormUpdate
 */
export type ProgramFormUpdate = {
    /**
     * Name
     */
    name?: string | null;
    /**
     * Description
     */
    description?: string | null;
    /**
     * Instructions
     */
    instructions?: string | null;
    /**
     * Form Schema
     */
    form_schema?: {
        [key: string]: unknown;
    } | null;
    access_type?: PortalAccessType | null;
    /**
     * Requirement Id
     */
    requirement_id?: string | null;
    /**
     * Available From
     */
    available_from?: string | null;
    /**
     * Available Until
     */
    available_until?: string | null;
    /**
     * Is Active
     */
    is_active?: boolean | null;
};

/**
 * ProgramMatchResponse
 */
export type ProgramMatchResponse = {
    /**
     * Id
     */
    id: string;
    /**
     * Property Id
     */
    property_id: string;
    /**
     * Property Name
     */
    property_name: string;
    /**
     * Program Id
     */
    program_id: string;
    /**
     * Program Key
     */
    program_key: string | null;
    /**
     * Program Name
     */
    program_name: string;
    /**
     * Agency
     */
    agency: string | null;
    /**
     * Program Org Id
     */
    program_org_id: string | null;
    /**
     * Program Owner Name
     */
    program_owner_name: string | null;
    status: ProgramMatchStatus;
    source: ProgramMatchSource;
    /**
     * Reasons
     */
    reasons: Array<string>;
    /**
     * Details
     */
    details: {
        [key: string]: unknown;
    } | null;
    /**
     * Proposed At
     */
    proposed_at: string;
    /**
     * Decided At
     */
    decided_at: string | null;
    /**
     * Decision Note
     */
    decision_note: string | null;
    /**
     * Disclosure
     */
    disclosure: string;
    /**
     * Tracking Ids
     */
    tracking_ids: Array<string>;
};

/**
 * ProgramMatchSource
 *
 * What matched the property to the program.
 */
export const ProgramMatchSource = {
    CRITERIA: 'Criteria',
    PROGRAM_LIST: 'Program list',
    COVERAGE_LIST: 'Coverage list',
    MANUAL: 'Manual'
} as const;

/**
 * ProgramMatchSource
 *
 * What matched the property to the program.
 */
export type ProgramMatchSource = typeof ProgramMatchSource[keyof typeof ProgramMatchSource];

/**
 * ProgramMatchStatus
 *
 * Where a property/program match stands with the property's org. PROPOSED and POSSIBLE ("might
 * match") matches wait for the org to confirm or decline; only CONFIRMED matches are tracked.
 */
export const ProgramMatchStatus = {
    PROPOSED: 'Proposed',
    POSSIBLE: 'Possible',
    CONFIRMED: 'Confirmed',
    DECLINED: 'Declined'
} as const;

/**
 * ProgramMatchStatus
 *
 * Where a property/program match stands with the property's org. PROPOSED and POSSIBLE ("might
 * match") matches wait for the org to confirm or decline; only CONFIRMED matches are tracked.
 */
export type ProgramMatchStatus = typeof ProgramMatchStatus[keyof typeof ProgramMatchStatus];

/**
 * ProgramPropertyCreate
 */
export type ProgramPropertyCreate = {
    /**
     * Name
     */
    name: string;
    /**
     * External Id
     */
    external_id?: string | null;
    /**
     * Address1
     */
    address1: string;
    /**
     * Address2
     */
    address2?: string | null;
    /**
     * City
     */
    city: string;
    /**
     * County
     */
    county?: string | null;
    /**
     * State
     */
    state?: string | null;
    /**
     * Postal Code
     */
    postal_code: string;
    /**
     * Country
     */
    country?: string;
    /**
     * Latitude
     */
    latitude?: number | string | null;
    /**
     * Longitude
     */
    longitude?: number | string | null;
    /**
     * Primary Function
     */
    primary_function?: string | null;
    /**
     * Gross Floor Area
     */
    gross_floor_area?: number | string | null;
    gross_floor_area_uom?: FloorAreaUnitOfMeasure;
    /**
     * Year Built
     */
    year_built?: number | null;
    /**
     * Number Of Buildings
     */
    number_of_buildings?: number | null;
    /**
     * Number Of Floors
     */
    number_of_floors?: number | null;
    /**
     * Occupancy Percentage
     */
    occupancy_percentage?: number | null;
    /**
     * Owner Name
     */
    owner_name?: string | null;
    /**
     * Owner Email
     */
    owner_email?: string | null;
    /**
     * Owner Phone
     */
    owner_phone?: string | null;
    /**
     * Owner Address
     */
    owner_address?: string | null;
    /**
     * Manager Name
     */
    manager_name?: string | null;
    /**
     * Manager Email
     */
    manager_email?: string | null;
    /**
     * Manager Phone
     */
    manager_phone?: string | null;
    /**
     * Notes
     */
    notes?: string | null;
};

/**
 * ProgramPropertyResponse
 */
export type ProgramPropertyResponse = {
    /**
     * Id
     */
    id: string;
    /**
     * Jurisdiction Id
     */
    jurisdiction_id: string;
    /**
     * Name
     */
    name: string;
    /**
     * External Id
     */
    external_id: string | null;
    /**
     * Address1
     */
    address1: string;
    /**
     * Address2
     */
    address2: string | null;
    /**
     * City
     */
    city: string;
    /**
     * County
     */
    county: string | null;
    state: State | null;
    /**
     * Postal Code
     */
    postal_code: string;
    /**
     * Country
     */
    country: string;
    primary_function: PropertyFunction | null;
    /**
     * Gross Floor Area
     */
    gross_floor_area: number | string | null;
    gross_floor_area_uom: FloorAreaUnitOfMeasure;
    /**
     * Year Built
     */
    year_built: number | null;
    /**
     * Number Of Buildings
     */
    number_of_buildings: number | null;
    /**
     * Occupancy Percentage
     */
    occupancy_percentage: number | null;
    /**
     * Owner Name
     */
    owner_name: string | null;
    /**
     * Owner Email
     */
    owner_email: string | null;
    /**
     * Manager Name
     */
    manager_name: string | null;
    /**
     * Manager Email
     */
    manager_email: string | null;
    /**
     * Notes
     */
    notes: string | null;
    /**
     * Latitude
     */
    latitude: number | string | null;
    /**
     * Longitude
     */
    longitude: number | string | null;
    /**
     * Linked Em Property Ids
     */
    linked_em_property_ids: Array<string>;
};

/**
 * ProgramPropertyUpdate
 */
export type ProgramPropertyUpdate = {
    /**
     * Name
     */
    name?: string | null;
    /**
     * External Id
     */
    external_id?: string | null;
    /**
     * Address1
     */
    address1?: string | null;
    /**
     * Address2
     */
    address2?: string | null;
    /**
     * City
     */
    city?: string | null;
    /**
     * County
     */
    county?: string | null;
    /**
     * State
     */
    state?: string | null;
    /**
     * Postal Code
     */
    postal_code?: string | null;
    /**
     * Country
     */
    country?: string | null;
    /**
     * Latitude
     */
    latitude?: number | string | null;
    /**
     * Longitude
     */
    longitude?: number | string | null;
    /**
     * Primary Function
     */
    primary_function?: string | null;
    /**
     * Gross Floor Area
     */
    gross_floor_area?: number | string | null;
    gross_floor_area_uom?: FloorAreaUnitOfMeasure | null;
    /**
     * Year Built
     */
    year_built?: number | null;
    /**
     * Number Of Buildings
     */
    number_of_buildings?: number | null;
    /**
     * Number Of Floors
     */
    number_of_floors?: number | null;
    /**
     * Occupancy Percentage
     */
    occupancy_percentage?: number | null;
    /**
     * Owner Name
     */
    owner_name?: string | null;
    /**
     * Owner Email
     */
    owner_email?: string | null;
    /**
     * Owner Phone
     */
    owner_phone?: string | null;
    /**
     * Owner Address
     */
    owner_address?: string | null;
    /**
     * Manager Name
     */
    manager_name?: string | null;
    /**
     * Manager Email
     */
    manager_email?: string | null;
    /**
     * Manager Phone
     */
    manager_phone?: string | null;
    /**
     * Notes
     */
    notes?: string | null;
};

/**
 * ProgramRecordStatus
 *
 * How far a program record (from a program definition) can be trusted.
 *
 * Only VERIFIED records generate tracking, tasks, dates or results; the others are shown with their note.
 */
export const ProgramRecordStatus = {
    VERIFIED: 'Verified',
    UNVERIFIED: 'Unverified',
    CONFLICT: 'Conflict'
} as const;

/**
 * ProgramRecordStatus
 *
 * How far a program record (from a program definition) can be trusted.
 *
 * Only VERIFIED records generate tracking, tasks, dates or results; the others are shown with their note.
 */
export type ProgramRecordStatus = typeof ProgramRecordStatus[keyof typeof ProgramRecordStatus];

/**
 * ProgramReferenceResponse
 */
export type ProgramReferenceResponse = {
    /**
     * Limits
     */
    limits: Array<LimitResponse>;
    /**
     * Coefficients
     */
    coefficients: Array<CoefficientResponse>;
    /**
     * Penalty Rules
     */
    penalty_rules: Array<PenaltyRuleResponse>;
    /**
     * Fees
     */
    fees: Array<FeeResponse>;
    /**
     * Reliefs
     */
    reliefs: Array<ReliefResponse>;
    /**
     * Relations
     */
    relations: Array<RelationResponse>;
};

/**
 * ProgramRelationKind
 *
 * How two programs relate: one's report is a prerequisite of the other's, or they share a fee, a
 * covered-building list, an extension, a filing or a deadline.
 */
export const ProgramRelationKind = {
    PREREQUISITE: 'Prerequisite',
    SHARES_FEE: 'Shares fee',
    SHARES_COVERAGE_LIST: 'Shares coverage list',
    EXTENSION_APPLIES_TO: 'Extension applies to',
    SHARES_FILING: 'Shares filing',
    SHARES_DEADLINE: 'Shares deadline'
} as const;

/**
 * ProgramRelationKind
 *
 * How two programs relate: one's report is a prerequisite of the other's, or they share a fee, a
 * covered-building list, an extension, a filing or a deadline.
 */
export type ProgramRelationKind = typeof ProgramRelationKind[keyof typeof ProgramRelationKind];

/**
 * ProgramRequirementCreate
 */
export type ProgramRequirementCreate = {
    /**
     * Name
     */
    name: string;
    /**
     * Description
     */
    description?: string | null;
    requirement_type: RequirementType;
    /**
     * Instructions
     */
    instructions?: string | null;
    /**
     * Documentation Url
     */
    documentation_url?: string | null;
    /**
     * Target Value
     */
    target_value?: number | string | null;
    /**
     * Target Unit
     */
    target_unit?: string | null;
    /**
     * Is Recurring
     */
    is_recurring?: boolean;
    /**
     * Recurrence Period Months
     */
    recurrence_period_months?: number | null;
    /**
     * Grace Period Days
     */
    grace_period_days?: number | null;
    /**
     * Display Order
     */
    display_order?: number;
    /**
     * Is Mandatory
     */
    is_mandatory?: boolean;
};

/**
 * ProgramRequirementUpdate
 */
export type ProgramRequirementUpdate = {
    /**
     * Name
     */
    name?: string | null;
    /**
     * Description
     */
    description?: string | null;
    requirement_type?: RequirementType | null;
    /**
     * Instructions
     */
    instructions?: string | null;
    /**
     * Documentation Url
     */
    documentation_url?: string | null;
    /**
     * Target Value
     */
    target_value?: number | string | null;
    /**
     * Target Unit
     */
    target_unit?: string | null;
    /**
     * Is Recurring
     */
    is_recurring?: boolean | null;
    /**
     * Recurrence Period Months
     */
    recurrence_period_months?: number | null;
    /**
     * Grace Period Days
     */
    grace_period_days?: number | null;
    /**
     * Display Order
     */
    display_order?: number | null;
    /**
     * Is Mandatory
     */
    is_mandatory?: boolean | null;
    /**
     * Is Active
     */
    is_active?: boolean | null;
};

/**
 * ProgramResponse
 */
export type ProgramResponse = {
    /**
     * Id
     */
    id: string;
    /**
     * Org Id
     */
    org_id: string | null;
    /**
     * Owner Name
     */
    owner_name: string | null;
    /**
     * Jurisdiction Id
     */
    jurisdiction_id: string;
    /**
     * Name
     */
    name: string;
    /**
     * Short Name
     */
    short_name: string | null;
    /**
     * Description
     */
    description: string | null;
    program_type: ProgramType;
    /**
     * Website Url
     */
    website_url: string | null;
    /**
     * Documentation Url
     */
    documentation_url: string | null;
    /**
     * Created At
     */
    created_at: string;
    /**
     * Updated At
     */
    updated_at: string;
    /**
     * Key
     */
    key: string | null;
    /**
     * Definition Version
     */
    definition_version: string | null;
    status: ProgramStatus;
    visibility: ProgramVisibility;
    /**
     * Match Disclosure
     */
    match_disclosure: string | null;
    /**
     * Agency
     */
    agency: string | null;
    /**
     * Citations
     */
    citations: Array<string> | null;
    /**
     * Effective From
     */
    effective_from: string | null;
    past_deadline_policy: PastDeadlinePolicy;
    /**
     * Parameters
     */
    parameters: {
        [key: string]: unknown;
    } | null;
    record_status: ProgramRecordStatus;
    /**
     * Provenance
     */
    provenance: {
        [key: string]: unknown;
    } | null;
};

/**
 * ProgramSourceKind
 */
export const ProgramSourceKind = { PRIMARY: 'Primary', SECONDARY: 'Secondary' } as const;

/**
 * ProgramSourceKind
 */
export type ProgramSourceKind = typeof ProgramSourceKind[keyof typeof ProgramSourceKind];

/**
 * ProgramStatus
 *
 * Status of a performance program
 */
export const ProgramStatus = {
    DRAFT: 'Draft',
    ACTIVE: 'Active',
    SUSPENDED: 'Suspended',
    ARCHIVED: 'Archived'
} as const;

/**
 * ProgramStatus
 *
 * Status of a performance program
 */
export type ProgramStatus = typeof ProgramStatus[keyof typeof ProgramStatus];

/**
 * ProgramStatusUpdate
 */
export type ProgramStatusUpdate = {
    status: ProgramStatus;
};

/**
 * ProgramType
 *
 * Type of building performance program
 */
export const ProgramType = {
    BENCHMARKING: 'Benchmarking',
    BUILDING_PERFORMANCE_STANDARD: 'Building Performance Standard',
    ENERGY_AUDIT: 'Energy Audit',
    RETRO_COMMISSIONING: 'Retro-commissioning',
    BUILDING_TUNE_UP: 'Building Tune-Up',
    ENERGY_DISCLOSURE: 'Energy Disclosure',
    OTHER: 'Other'
} as const;

/**
 * ProgramType
 *
 * Type of building performance program
 */
export type ProgramType = typeof ProgramType[keyof typeof ProgramType];

/**
 * ProgramUpdatePublic
 */
export type ProgramUpdatePublic = {
    /**
     * Name
     */
    name?: string | null;
    /**
     * Short Name
     */
    short_name?: string | null;
    /**
     * Description
     */
    description?: string | null;
    program_type?: ProgramType | null;
    /**
     * Jurisdiction Id
     */
    jurisdiction_id?: string | null;
    /**
     * Website Url
     */
    website_url?: string | null;
    /**
     * Documentation Url
     */
    documentation_url?: string | null;
    visibility?: ProgramVisibility | null;
    /**
     * Match Disclosure
     */
    match_disclosure?: string | null;
};

/**
 * ProgramVisibility
 *
 * How properties are matched to a program. Every property in a PUBLIC program's jurisdiction is
 * checked against its coverage rules; a PRIVATE program matches only the buildings on its own list
 * (program properties enrolled in a cycle, or a covered-building list it references).
 */
export const ProgramVisibility = { PRIVATE: 'Private', PUBLIC: 'Public' } as const;

/**
 * ProgramVisibility
 *
 * How properties are matched to a program. Every property in a PUBLIC program's jurisdiction is
 * checked against its coverage rules; a PRIVATE program matches only the buildings on its own list
 * (program properties enrolled in a cycle, or a covered-building list it references).
 */
export type ProgramVisibility = typeof ProgramVisibility[keyof typeof ProgramVisibility];

/**
 * Property
 */
export type Property = {
    /**
     * Id
     */
    id: string;
    /**
     * Org Id
     */
    org_id: string;
    /**
     * Name
     */
    name: string;
    /**
     * Departments
     */
    departments: Array<DepartmentSummary>;
    /**
     * Service Accounts
     */
    service_accounts: Array<VendorServiceAccountRef>;
    parent: PropertySummary | null;
    /**
     * Buildings
     */
    buildings: Array<Property>;
    /**
     * External Identifiers
     */
    external_identifiers: Array<IdentifierRef>;
    /**
     * Raw Address
     */
    raw_address: string | null;
    address: Address | null;
    geolocation: GeoLocation | null;
    construction_status: ConstructionStatus | null;
    primary_function: PropertyFunction | null;
    gross_floor_area: FloorArea | null;
    irrigated_area: LandArea | null;
    /**
     * Year Built
     */
    year_built: number | null;
    /**
     * Is Federal Property
     */
    is_federal_property: boolean | null;
    federal_owner: AddressCountry | null;
    agency: Agency | null;
    /**
     * Agency Department Region
     */
    agency_department_region: string | null;
    /**
     * Federal Campus
     */
    federal_campus: string | null;
    /**
     * Occupancy Percentage
     */
    occupancy_percentage: number | null;
    /**
     * Notes
     */
    notes: string | null;
    /**
     * Is Institutional Property
     */
    is_institutional_property: boolean | null;
    ownership_class: OwnershipClass | null;
};

/**
 * PropertyFunction
 */
export const PropertyFunction = {
    ADULT_EDUCATION: 'Adult Education',
    AMBULATORY_SURGICAL_CENTER: 'Ambulatory Surgical Center',
    AQUARIUM: 'Aquarium',
    BANK_BRANCH: 'Bank Branch',
    BAR_NIGHTCLUB: 'Bar/Nightclub',
    BARRACKS: 'Barracks',
    BOWLING_ALLEY: 'Bowling Alley',
    CASINO: 'Casino',
    COLLEGE_UNIVERSITY: 'College/University',
    CONVENIENCE_STORE_WITH_GAS_STATION: 'Convenience Store with Gas Station',
    CONVENIENCE_STORE_WITHOUT_GAS_STATION: 'Convenience Store without Gas Station',
    CONVENTION_CENTER: 'Convention Center',
    COURTHOUSE: 'Courthouse',
    DATA_CENTER: 'Data Center',
    DISTRIBUTION_CENTER: 'Distribution Center',
    'DRINKING_WATER_TREATMENT &_DISTRIBUTION': 'Drinking Water Treatment & Distribution',
    ELECTRIC_VEHICLE_CHARGING_STATION: 'Electric Vehicle Charging Station',
    ENCLOSED_MALL: 'Enclosed Mall',
    ENERGY_POWER_STATION: 'Energy/Power Station',
    FAST_FOOD_RESTAURANT: 'Fast Food Restaurant',
    FINANCIAL_OFFICE: 'Financial Office',
    FIRE_STATION: 'Fire Station',
    FITNESS_CENTER_HEALTH_CLUB_GYM: 'Fitness Center/Health Club/Gym',
    FOOD_SALES: 'Food Sales',
    FOOD_SERVICE: 'Food Service',
    'HOSPITAL_GENERAL_MEDICAL &_SURGICAL': 'Hospital (General Medical & Surgical)',
    HOTEL: 'Hotel',
    ICE_CURLING_RINK: 'Ice/Curling Rink',
    INDOOR_ARENA: 'Indoor Arena',
    K_12_SCHOOL: 'K-12 School',
    LABORATORY: 'Laboratory',
    LIBRARY: 'Library',
    LIFESTYLE_CENTER: 'Lifestyle Center',
    MAILING_CENTER_POST_OFFICE: 'Mailing Center/Post Office',
    MANUFACTURING_INDUSTRIAL_PLANT: 'Manufacturing/Industrial Plant',
    MEDICAL_OFFICE: 'Medical Office',
    MIXED_USE_PROPERTY: 'Mixed Use Property',
    MOVIE_THEATER: 'Movie Theater',
    MULTIFAMILY_HOUSING: 'Multifamily Housing',
    MUSEUM: 'Museum',
    NON_REFRIGERATED_WAREHOUSE: 'Non-Refrigerated Warehouse',
    OFFICE: 'Office',
    OTHER_EDUCATION: 'Other - Education',
    OTHER_ENTERTAINMENT_PUBLIC_ASSEMBLY: 'Other - Entertainment/Public Assembly',
    OTHER_LODGING_RESIDENTIAL: 'Other - Lodging/Residential',
    OTHER_MALL: 'Other - Mall',
    OTHER_PUBLIC_SERVICES: 'Other - Public Services',
    OTHER_RECREATION: 'Other - Recreation',
    OTHER_RESTAURANT_BAR: 'Other - Restaurant/Bar',
    OTHER_SERVICES: 'Other - Services',
    OTHER_STADIUM: 'Other - Stadium',
    OTHER_TECHNOLOGY_SCIENCE: 'Other - Technology/Science',
    OTHER_UTILITY: 'Other - Utility',
    OTHER: 'Other',
    OTHER_SPECIALTY_HOSPITAL: 'Other/Specialty Hospital',
    OUTPATIENT_REHABILITATION_PHYSICAL_THERAPY: 'Outpatient Rehabilitation/Physical Therapy',
    PARKING: 'Parking',
    PERFORMING_ARTS: 'Performing Arts',
    'PERSONAL_SERVICES_HEALTH_BEAUTY,_DRY_CLEANING,_ETC': 'Personal Services (Health/Beauty, Dry Cleaning, etc)',
    POLICE_STATION: 'Police Station',
    PRE_SCHOOL_DAYCARE: 'Pre-school/Daycare',
    PRISON_INCARCERATION: 'Prison/Incarceration',
    RACE_TRACK: 'Race Track',
    REFRIGERATED_WAREHOUSE: 'Refrigerated Warehouse',
    VEHICLE_REPAIR_SERVICES: 'Vehicle Repair Services',
    RESIDENCE_HALL_DORMITORY: 'Residence Hall/Dormitory',
    RESIDENTIAL_CARE_FACILITY: 'Residential Care Facility',
    RESTAURANT: 'Restaurant',
    RETAIL_STORE: 'Retail Store',
    ROLLER_RINK: 'Roller Rink',
    SELF_STORAGE_FACILITY: 'Self-Storage Facility',
    SENIOR_LIVING_COMMUNITY: 'Senior Living Community',
    SINGLE_FAMILY_HOME: 'Single Family Home',
    SOCIAL_MEETING_HALL: 'Social/Meeting Hall',
    STADIUM_CLOSED: 'Stadium (Closed)',
    STADIUM_OPEN: 'Stadium (Open)',
    STRIP_MALL: 'Strip Mall',
    SUPERMARKET_GROCERY_STORE: 'Supermarket/Grocery Store',
    SWIMMING_POOL: 'Swimming Pool',
    TRANSPORTATION_TERMINAL_STATION: 'Transportation Terminal/Station',
    URGENT_CARE_CLINIC_OTHER_OUTPATIENT: 'Urgent Care/Clinic/Other Outpatient',
    VEHICLE_DEALERSHIP: 'Vehicle Dealership',
    VETERINARY_OFFICE: 'Veterinary Office',
    VOCATIONAL_SCHOOL: 'Vocational School',
    WASTEWATER_TREATMENT_PLANT: 'Wastewater Treatment Plant',
    WHOLESALE_CLUB_SUPERCENTER: 'Wholesale Club/Supercenter',
    WORSHIP_FACILITY: 'Worship Facility',
    ZOO: 'Zoo'
} as const;

/**
 * PropertyFunction
 */
export type PropertyFunction = typeof PropertyFunction[keyof typeof PropertyFunction];

/**
 * PropertySummary
 */
export type PropertySummary = {
    /**
     * Id
     */
    id: string;
    /**
     * Org Id
     */
    org_id: string;
    /**
     * Name
     */
    name: string;
    address: Address | null;
};

/**
 * PropertyTrackingCreate
 *
 * Data for creating property program tracking.
 *
 * `cycle_id` is optional: when omitted, the service resolves the program's
 * currently-active cycle. Provide it explicitly to disambiguate or to target
 * a specific (non-active) cycle.
 */
export type PropertyTrackingCreate = {
    /**
     * Property Id
     */
    property_id: string;
    /**
     * Program Id
     */
    program_id: string;
    /**
     * Cycle Id
     */
    cycle_id?: string | null;
    /**
     * Is Auto Detected
     */
    is_auto_detected?: boolean;
    /**
     * Detection Details
     */
    detection_details?: {
        [key: string]: unknown;
    } | null;
    /**
     * Notes
     */
    notes?: string | null;
};

/**
 * PropertyTrackingUpdate
 *
 * Data for updating property program tracking.
 */
export type PropertyTrackingUpdate = {
    /**
     * Is Acknowledged
     */
    is_acknowledged?: boolean | null;
    /**
     * Is Opted Out
     */
    is_opted_out?: boolean | null;
    /**
     * Opt Out Reason
     */
    opt_out_reason?: string | null;
    /**
     * Exemption Requested
     */
    exemption_requested?: boolean | null;
    /**
     * Exemption Details
     */
    exemption_details?: string | null;
    /**
     * Notes
     */
    notes?: string | null;
    /**
     * Is Active
     */
    is_active?: boolean | null;
};

/**
 * PropertyUseModel
 */
export type PropertyUseModel = {
    property_function: PropertyFunction;
    /**
     * Gross Floor Area
     */
    gross_floor_area: number | string;
    uom?: FloorAreaUnitOfMeasure;
    /**
     * Effective From
     */
    effective_from?: string | null;
};

/**
 * PropertyUseResponse
 */
export type PropertyUseResponse = {
    property_function: PropertyFunction;
    /**
     * Gross Floor Area
     */
    gross_floor_area: number | string;
    uom?: FloorAreaUnitOfMeasure;
    /**
     * Effective From
     */
    effective_from?: string | null;
    /**
     * Id
     */
    id: string;
    /**
     * Effective To
     */
    effective_to: string | null;
};

/**
 * PublicAuthConfig
 */
export type PublicAuthConfig = {
    /**
     * Url
     */
    url: string;
    /**
     * Realm
     */
    realm: string;
    /**
     * Client Id
     */
    client_id: string;
};

/**
 * PublicConfig
 */
export type PublicConfig = {
    /**
     * Name
     */
    name: string;
    /**
     * Environment
     */
    environment: string;
    auth: PublicAuthConfig;
};

/**
 * PublicDashboardDataRequest
 *
 * Request body for `POST /public/dashboard/{id}/data`.
 *
 * Public viewers can apply a dynamic filter overlay just like an
 * authenticated user. The shape is constrained to `PublicFilterParams`
 * (entity/date/search) — public endpoints still never accept an ad-hoc
 * `QuerySpec` (that boundary is what prevents catalog leakage and
 * unconstrained queries from the public path).
 */
export type PublicDashboardDataRequest = {
    dynamic_filters?: PublicFilterParams | null;
    /**
     * Dynamic Saved Filter Id
     */
    dynamic_saved_filter_id?: string | null;
};

/**
 * PublicDashboardResponse
 */
export type PublicDashboardResponse = {
    /**
     * Id
     */
    id: string;
    /**
     * Name
     */
    name: string;
    /**
     * Contents
     */
    contents: {
        [key: string]: unknown;
    };
};

/**
 * PublicFilterParams
 */
export type PublicFilterParams = {
    /**
     * Search Text
     */
    search_text?: string | null;
    /**
     * Weather Normalize
     */
    weather_normalize?: boolean | null;
    bucket_grain?: BucketGrain | null;
    /**
     * Date Range Spec
     */
    date_range_spec?: 'Calendar Year To Date' | 'Last Calendar Year' | 'Fiscal Year To Date' | 'Last Fiscal Year' | 'Quarter To Date' | 'Last Quarter' | 'Month To Date' | 'Last Month' | 'Last Three Months' | 'Last Six Months' | 'Last Twelve Months' | 'Custom' | null;
    /**
     * Date Range Start
     */
    date_range_start?: string | null;
    /**
     * Date Range End
     */
    date_range_end?: string | null;
    /**
     * Funds
     */
    funds?: Array<string> | null;
    /**
     * Departments
     */
    departments?: Array<string> | null;
    /**
     * Properties
     */
    properties?: Array<string> | null;
    /**
     * Billing Accounts
     */
    billing_accounts?: Array<string> | null;
    /**
     * Commodities
     */
    commodities?: Array<string> | null;
    /**
     * Utility Tariffs
     */
    utility_tariffs?: Array<string> | null;
    /**
     * Utility Companies
     */
    utility_companies?: Array<string> | null;
    /**
     * Utility Suppliers
     */
    utility_suppliers?: Array<string> | null;
    /**
     * Meters
     */
    meters?: Array<string> | null;
};

/**
 * PublicFormResponse
 *
 * Public form information.
 */
export type PublicFormResponse = {
    /**
     * Id
     */
    id: string;
    /**
     * Name
     */
    name: string;
    /**
     * Description
     */
    description: string | null;
    /**
     * Instructions
     */
    instructions: string | null;
    /**
     * Form Schema
     */
    form_schema: {
        [key: string]: unknown;
    };
    /**
     * Access Type
     */
    access_type: string;
    /**
     * Program Name
     */
    program_name: string;
    /**
     * Cycle Id
     */
    cycle_id: string;
};

/**
 * PublicMeterCapabilityCreate
 */
export type PublicMeterCapabilityCreate = {
    /**
     * Measure Type Id
     */
    measure_type_id: string;
    /**
     * Unit Of Measure
     */
    unit_of_measure: string;
    /**
     * Is Active
     */
    is_active: boolean;
    /**
     * Metadata
     */
    metadata: {
        [key: string]: unknown;
    };
};

/**
 * PublicMeterCapabilityUpdate
 */
export type PublicMeterCapabilityUpdate = {
    /**
     * Id
     */
    id: string;
    /**
     * Measure Type Id
     */
    measure_type_id?: string | null;
    /**
     * Unit Of Measure
     */
    unit_of_measure?: string | null;
    /**
     * Is Active
     */
    is_active?: boolean | null;
    /**
     * Metadata
     */
    metadata?: {
        [key: string]: unknown;
    } | null;
};

/**
 * PublicMeterCreate
 */
export type PublicMeterCreate = {
    /**
     * Name
     */
    name: string;
    /**
     * Active
     */
    active: boolean;
    /**
     * Inactive Date
     */
    inactive_date: string | null;
    /**
     * Service Account Id
     */
    service_account_id: string;
    /**
     * Property Id
     */
    property_id?: string | null;
    /**
     * Meter Type Id
     */
    meter_type_id: string;
    /**
     * Meter Type Other
     */
    meter_type_other?: string | null;
    /**
     * Identifiers
     */
    identifiers?: Array<Identifier> | null;
    /**
     * Capabilities
     */
    capabilities?: Array<PublicMeterCapabilityCreate> | null;
};

/**
 * PublicMeterUpdate
 */
export type PublicMeterUpdate = {
    /**
     * Name
     */
    name?: string | null;
    /**
     * Active
     */
    active?: boolean | null;
    /**
     * Inactive Date
     */
    inactive_date?: string | null;
    /**
     * Service Account Id
     */
    service_account_id?: string | null;
    /**
     * Property Id
     */
    property_id?: string | null;
    /**
     * Meter Type Id
     */
    meter_type_id?: string | null;
    /**
     * Meter Type Other
     */
    meter_type_other?: string | null;
    /**
     * Identifiers
     */
    identifiers?: Array<Identifier> | null;
    /**
     * Capabilities
     */
    capabilities?: Array<PublicMeterCapabilityCreate | PublicMeterCapabilityUpdate> | null;
};

/**
 * PublicPortalResponse
 *
 * Public portal information.
 */
export type PublicPortalResponse = {
    /**
     * Id
     */
    id: string;
    /**
     * Name
     */
    name: string;
    /**
     * Description
     */
    description: string | null;
    /**
     * Instructions
     */
    instructions: string | null;
    /**
     * Accepted File Types
     */
    accepted_file_types: Array<string> | null;
    /**
     * Max File Size Mb
     */
    max_file_size_mb: number | null;
    /**
     * Max Files
     */
    max_files: number | null;
    /**
     * Access Type
     */
    access_type: string;
    /**
     * Program Name
     */
    program_name: string;
    /**
     * Cycle Id
     */
    cycle_id: string;
};

/**
 * PublicPropertyCreateUpdate
 */
export type PublicPropertyCreateUpdate = {
    /**
     * Name
     */
    name?: string | null;
    /**
     * Raw Address
     */
    raw_address?: string | null;
    address?: Address | null;
    geolocation?: GeoLocation | null;
    /**
     * Parent Id
     */
    parent_id?: string | null;
    /**
     * Building Ids
     */
    building_ids?: Array<string> | null;
    /**
     * Department Ids
     */
    department_ids?: Array<string> | null;
    /**
     * Identifiers
     */
    identifiers?: Array<Identifier> | null;
    construction_status?: ConstructionStatus | null;
    primary_function?: PropertyFunction | null;
    gross_floor_area?: FloorArea | null;
    irrigated_area?: LandArea | null;
    /**
     * Year Built
     */
    year_built?: number | null;
    /**
     * Is Federal Property
     */
    is_federal_property?: boolean | null;
    federal_owner?: AddressCountry | null;
    agency?: Agency | null;
    /**
     * Agency Department Region
     */
    agency_department_region?: string | null;
    /**
     * Federal Campus
     */
    federal_campus?: string | null;
    /**
     * Occupancy Percentage
     */
    occupancy_percentage?: number | null;
    /**
     * Notes
     */
    notes?: string | null;
    /**
     * Is Institutional Property
     */
    is_institutional_property?: boolean | null;
    ownership_class?: OwnershipClass | null;
};

/**
 * PublicViewDataRequest
 *
 * Request body for `POST /public/view/{id}/data`.
 *
 * Public viewers can toggle weather normalization and apply a dynamic
 * filter overlay. The shape is constrained to `PublicFilterParams` —
 * public endpoints never accept an ad-hoc `QuerySpec`.
 */
export type PublicViewDataRequest = {
    /**
     * Weather Normalize
     */
    weather_normalize?: boolean | null;
    dynamic_filters?: PublicFilterParams | null;
    /**
     * Dynamic Saved Filter Id
     */
    dynamic_saved_filter_id?: string | null;
};

/**
 * PublicViewResponse
 */
export type PublicViewResponse = {
    /**
     * Id
     */
    id: string;
    /**
     * Name
     */
    name: string;
    /**
     * Description
     */
    description: string;
    /**
     * Presentation
     */
    presentation: string;
    /**
     * Presentation Props
     */
    presentation_props: {
        [key: string]: unknown;
    };
};

/**
 * QueryFilter
 *
 * A filter applied to a dimension before aggregation (WHERE clause).
 *
 * `optional=True` marks a filter that should be silently dropped if the
 * routed fact has no key for its dimension (used by the dynamic filter
 * overlay, where a dashboard-wide property filter may not apply to every
 * block). Filters baked into a view definition default to `optional=False`
 * so a misconfigured definition errors loudly.
 */
export type QueryFilter = {
    /**
     * Dimension
     */
    dimension: string;
    /**
     * Op
     */
    op: 'eq' | 'in' | 'gt' | 'gte' | 'lt' | 'lte' | 'between' | 'is_null' | 'is_not_null';
    /**
     * Value
     */
    value?: unknown | null;
    /**
     * Optional
     */
    optional?: boolean;
};

/**
 * QueryPlanSummary
 *
 * Diagnostic info about how the engine executed the query.
 *
 * Returned on every `QueryResult` so dashboards/builders can show 'powered by
 * fact X' and engineers can debug performance. The full SQL is referenced
 * indirectly via `sql_hash` (rather than echoing potentially-large SQL text)
 * so log volume stays bounded.
 */
export type QueryPlanSummary = {
    /**
     * Facts Used
     */
    facts_used: Array<string>;
    /**
     * Cross Fact Join
     */
    cross_fact_join?: boolean;
    /**
     * Sql Hash
     */
    sql_hash: string;
    /**
     * Cache Hit
     */
    cache_hit?: boolean;
    /**
     * Execution Ms
     */
    execution_ms: number;
};

/**
 * QueryResult
 *
 * Engine output. A list of rows + the metadata needed to render them.
 */
export type QueryResult = {
    /**
     * Rows
     */
    rows: Array<{
        [key: string]: unknown;
    }>;
    /**
     * Metrics Meta
     */
    metrics_meta: Array<MetricMeta>;
    /**
     * Dimensions Meta
     */
    dimensions_meta: Array<DimensionMeta>;
    time_grain?: BucketGrain | null;
    /**
     * Bucket Label
     */
    bucket_label?: string | null;
    page_info: PageInfo;
    plan: QueryPlanSummary;
};

/**
 * QuerySort
 *
 * Sort directive. `target` may be a metric name, a dimension name, or
 * one of the engine-generated comparison columns (e.g., "<metric>_delta").
 */
export type QuerySort = {
    /**
     * Target
     */
    target: string;
    /**
     * Direction
     */
    direction?: 'asc' | 'desc';
    /**
     * Kind
     */
    kind?: 'auto' | 'id' | 'label';
};

/**
 * QuerySpec
 *
 * The full, persisted definition of a query.
 *
 * Stored as JSONB on `DBView.query_spec`. Validated on read. Older `version`
 * values are migrated up before execution (see `query/spec_migrate.py` when
 * that becomes necessary).
 */
export type QuerySpec = {
    /**
     * Version
     */
    version?: number;
    /**
     * Metrics
     */
    metrics: Array<string>;
    /**
     * Dimensions
     */
    dimensions?: Array<string>;
    time_grain?: BucketGrain | null;
    time_range?: TimeRange | null;
    /**
     * Filters
     */
    filters?: Array<QueryFilter>;
    /**
     * Having
     */
    having?: Array<MetricFilter>;
    /**
     * Sorts
     */
    sorts?: Array<QuerySort>;
    /**
     * Compare To
     */
    compare_to?: 'prior_period' | 'prior_year' | 'baseline' | null;
    baseline_range?: TimeRange | null;
    /**
     * Weather Normalize
     */
    weather_normalize?: boolean;
    pagination?: Pagination | null;
    /**
     * Facet
     */
    facet?: string | null;
    /**
     * Search Text
     */
    search_text?: string | null;
    /**
     * Saved Filter Id
     */
    saved_filter_id?: string | null;
};

/**
 * RatioExpression
 *
 * `SUM(numerator) / <denominator-aggregate>` evaluated post-GROUP BY.
 *
 * `denominator_func`:
 * - "sum"           → ΣD (use when D is additive).
 * - "avg_constant"  → ΣD / COUNT(DISTINCT distinct_field).
 * Use when D is time-invariant (e.g., floor area
 * repeated per month) so multi-period buckets don't
 * multiply D by the number of periods.
 * - "sum_components"→ Σ(component1) + Σ(component2). Used for weather:
 * denominator = Σhdd + Σcdd.
 */
export type RatioExpression = {
    /**
     * Kind
     */
    kind?: 'ratio';
    /**
     * Numerator Column
     */
    numerator_column: string;
    /**
     * Denominator Func
     */
    denominator_func: 'sum' | 'avg_constant' | 'sum_components';
    /**
     * Denominator Column
     */
    denominator_column?: string | null;
    /**
     * Denominator Components
     */
    denominator_components?: Array<string>;
    /**
     * Distinct Field
     */
    distinct_field?: string | null;
};

/**
 * RelationResponse
 */
export type RelationResponse = {
    /**
     * Key
     */
    key: string;
    /**
     * Program Id
     */
    program_id: string;
    kind: ProgramRelationKind;
    /**
     * Related Program Key
     */
    related_program_key: string;
    /**
     * Related Program Id
     */
    related_program_id: string | null;
    /**
     * Requirement Key
     */
    requirement_key: string | null;
    /**
     * Related Requirement Key
     */
    related_requirement_key: string | null;
    /**
     * Related Reporting Year
     */
    related_reporting_year: number | null;
    /**
     * Note
     */
    note: string | null;
    record_status: ProgramRecordStatus;
};

/**
 * ReliefResponse
 */
export type ReliefResponse = {
    /**
     * Key
     */
    key: string;
    /**
     * Name
     */
    name: string;
    kind: DeterminationKind;
    /**
     * Description
     */
    description: string;
    /**
     * Decided By
     */
    decided_by: string | null;
    /**
     * Application Window
     */
    application_window: string | null;
    /**
     * Evidence
     */
    evidence: Array<string> | null;
    /**
     * Fee Keys
     */
    fee_keys: Array<string> | null;
    /**
     * Valid Years
     */
    valid_years: number | null;
    /**
     * Decision Days
     */
    decision_days: number | null;
    /**
     * Appeal Days
     */
    appeal_days: number | null;
    record_status: ProgramRecordStatus;
    /**
     * Provenance
     */
    provenance: {
        [key: string]: unknown;
    } | null;
};

/**
 * RequirementGeneration
 *
 * AUTO requirements produce a task for every tracked property; MANUAL ones are created on demand.
 */
export const RequirementGeneration = { AUTO: 'Auto', MANUAL: 'Manual' } as const;

/**
 * RequirementGeneration
 *
 * AUTO requirements produce a task for every tracked property; MANUAL ones are created on demand.
 */
export type RequirementGeneration = typeof RequirementGeneration[keyof typeof RequirementGeneration];

/**
 * RequirementResponse
 */
export type RequirementResponse = {
    /**
     * Id
     */
    id: string;
    /**
     * Program Id
     */
    program_id: string | null;
    /**
     * Cycle Id
     */
    cycle_id: string | null;
    /**
     * Name
     */
    name: string;
    /**
     * Description
     */
    description: string | null;
    /**
     * Requirement Type
     */
    requirement_type: string;
    /**
     * Instructions
     */
    instructions: string | null;
    /**
     * Documentation Url
     */
    documentation_url: string | null;
    /**
     * Target Value
     */
    target_value: number | null;
    /**
     * Target Unit
     */
    target_unit: string | null;
    /**
     * Is Recurring
     */
    is_recurring: boolean;
    /**
     * Recurrence Period Months
     */
    recurrence_period_months: number | null;
    /**
     * Grace Period Days
     */
    grace_period_days: number | null;
    /**
     * Display Order
     */
    display_order: number;
    /**
     * Is Mandatory
     */
    is_mandatory: boolean;
    /**
     * Is Active
     */
    is_active: boolean;
    /**
     * Key
     */
    key: string | null;
    /**
     * Track Keys
     */
    track_keys: Array<string> | null;
    generation: RequirementGeneration;
    satisfaction: RequirementSatisfaction;
    trigger: RequirementTrigger;
    /**
     * Event Key
     */
    event_key: string | null;
    /**
     * Due Offset Days
     */
    due_offset_days: number | null;
    /**
     * Qualified Preparer
     */
    qualified_preparer: string | null;
    /**
     * External System
     */
    external_system: string | null;
    /**
     * Fee Keys
     */
    fee_keys: Array<string> | null;
    /**
     * Depends On Keys
     */
    depends_on_keys: Array<string> | null;
    /**
     * First Year
     */
    first_year: number | null;
    /**
     * Last Year
     */
    last_year: number | null;
    /**
     * Effective To
     */
    effective_to: string | null;
    record_status: ProgramRecordStatus;
    /**
     * Provenance
     */
    provenance: {
        [key: string]: unknown;
    } | null;
};

/**
 * RequirementSatisfaction
 *
 * PER_CYCLE requirements are due every cycle; ONCE_PER_PROPERTY ones are satisfied for good by a
 * completion in any earlier cycle of the same program.
 */
export const RequirementSatisfaction = { PER_CYCLE: 'Per cycle', ONCE_PER_PROPERTY: 'Once per property' } as const;

/**
 * RequirementSatisfaction
 *
 * PER_CYCLE requirements are due every cycle; ONCE_PER_PROPERTY ones are satisfied for good by a
 * completion in any earlier cycle of the same program.
 */
export type RequirementSatisfaction = typeof RequirementSatisfaction[keyof typeof RequirementSatisfaction];

/**
 * RequirementSatisfied
 */
export type RequirementSatisfied = {
    /**
     * Note
     */
    note?: string | null;
};

/**
 * RequirementTrigger
 *
 * DATE requirements are generated per cycle; EVENT requirements when the event is recorded for a
 * tracked property (due `due_offset_days` after it).
 */
export const RequirementTrigger = { DATE: 'Date', EVENT: 'Event' } as const;

/**
 * RequirementTrigger
 *
 * DATE requirements are generated per cycle; EVENT requirements when the event is recorded for a
 * tracked property (due `due_offset_days` after it).
 */
export type RequirementTrigger = typeof RequirementTrigger[keyof typeof RequirementTrigger];

/**
 * RequirementType
 *
 * Type of program requirement
 */
export const RequirementType = {
    REPORTING: 'Reporting',
    ACTION: 'Action',
    SUBMISSION: 'Submission',
    CERTIFICATION: 'Certification',
    AUDIT: 'Audit',
    OTHER: 'Other'
} as const;

/**
 * RequirementType
 *
 * Type of program requirement
 */
export type RequirementType = typeof RequirementType[keyof typeof RequirementType];

/**
 * ResultResponse
 */
export type ResultResponse = {
    /**
     * Id
     */
    id: string;
    /**
     * Tracking Id
     */
    tracking_id: string;
    /**
     * Reporting Year
     */
    reporting_year: number;
    /**
     * Data Year
     */
    data_year: number | null;
    /**
     * Metric
     */
    metric: string;
    evaluation_kind: EvaluationKind;
    /**
     * Value
     */
    value: number | string | null;
    /**
     * Limit Value
     */
    limit_value: number | string | null;
    /**
     * Delta
     */
    delta: number | string | null;
    /**
     * Penalty Amount
     */
    penalty_amount: number | string | null;
    status: TrackingResultStatus;
    /**
     * Is Estimate
     */
    is_estimate: boolean;
    /**
     * Inputs
     */
    inputs: {
        [key: string]: unknown;
    };
    /**
     * Computed At
     */
    computed_at: string;
};

/**
 * ReviewResolution
 */
export type ReviewResolution = {
    /**
     * Covered
     */
    covered: boolean;
    /**
     * Track Key
     */
    track_key?: string | null;
    /**
     * Note
     */
    note?: string | null;
};

/**
 * Role
 */
export type Role = {
    /**
     * Id
     */
    id: string;
    /**
     * Name
     */
    name: string;
    /**
     * Display Name
     */
    display_name: string;
    /**
     * Is Builtin
     */
    is_builtin: boolean;
    /**
     * Permissions
     */
    permissions: Array<Permission>;
};

/**
 * RoleCreateUpdate
 */
export type RoleCreateUpdate = {
    /**
     * Name
     */
    name: string;
    /**
     * Permissions
     */
    permissions: Array<Permission>;
};

/**
 * RoleRef
 */
export type RoleRef = {
    /**
     * Id
     */
    id: string;
    /**
     * Name
     */
    name: string;
    /**
     * Display Name
     */
    display_name: string;
    /**
     * Is Builtin
     */
    is_builtin: boolean;
};

/**
 * SavedFilter
 */
export type SavedFilter = {
    /**
     * Id
     */
    id: string;
    /**
     * Name
     */
    name: string;
    params: PublicFilterParams;
    /**
     * Is Shared
     */
    is_shared: boolean;
    /**
     * Is Owner
     */
    is_owner: boolean;
};

/**
 * SavedFilterBody
 */
export type SavedFilterBody = {
    /**
     * Name
     */
    name: string;
    params: PublicFilterParams;
    /**
     * Is Shared
     */
    is_shared?: boolean;
};

/**
 * SearchCategory
 *
 * Grouped search results by category
 */
export type SearchCategory = {
    /**
     * Category
     */
    category: string;
    /**
     * Results
     */
    results: Array<SearchResult>;
};

/**
 * SearchResponse
 *
 * Complete search response with all categories
 */
export type SearchResponse = {
    /**
     * Query
     */
    query: string;
    /**
     * Categories
     */
    categories: Array<SearchCategory>;
    /**
     * Total Results
     */
    total_results: number;
};

/**
 * SearchResult
 *
 * Individual search result item
 */
export type SearchResult = {
    type: SearchType;
    /**
     * Id
     */
    id: string;
    /**
     * Name
     */
    name: string;
    /**
     * Subtitle
     */
    subtitle?: string | null;
};

/**
 * SearchType
 */
export const SearchType = {
    PROPERTY: 'property',
    VENDOR: 'vendor',
    VENDOR_ACCOUNT: 'vendor_account',
    METER: 'meter',
    DASHBOARD: 'dashboard',
    REPORT: 'report',
    VIEW: 'view'
} as const;

/**
 * SearchType
 */
export type SearchType = typeof SearchType[keyof typeof SearchType];

/**
 * ServiceAccountPatch
 */
export type ServiceAccountPatch = {
    /**
     * Name
     */
    name?: string | null;
    /**
     * Vendor Account Number
     */
    vendor_account_number?: string | null;
    /**
     * Property Ids
     */
    property_ids?: Array<string> | null;
    /**
     * Is Active
     */
    is_active?: boolean | null;
    /**
     * Active Date
     */
    active_date?: string | null;
    /**
     * Inactive Date
     */
    inactive_date?: string | null;
    /**
     * Identifiers
     */
    identifiers?: Array<Identifier> | null;
};

/**
 * ServiceDetailSummary
 */
export type ServiceDetailSummary = {
    /**
     * Bill Periods
     */
    bill_periods: Array<string>;
    /**
     * Start Date
     */
    start_date: string | null;
    /**
     * End Date
     */
    end_date: string | null;
    /**
     * Commodities
     */
    commodities: Array<string>;
    /**
     * Total Charge
     */
    total_charge: number | string;
    /**
     * Total Consumption
     */
    total_consumption: number | string;
    /**
     * Consumption Uom
     */
    consumption_uom: string;
    /**
     * Total Demand
     */
    total_demand: number | string;
    /**
     * Demand Uom
     */
    demand_uom: string;
    /**
     * Service Periods
     */
    service_periods: Array<ServicePeriodSummary>;
};

/**
 * ServicePeriodSummary
 */
export type ServicePeriodSummary = {
    /**
     * Bill Period
     */
    bill_period: string | null;
    /**
     * Start Date
     */
    start_date: string;
    /**
     * End Date
     */
    end_date: string;
    commodity: CommodityRef | null;
    /**
     * Total Charge
     */
    total_charge: number | string;
    /**
     * Total Consumption
     */
    total_consumption: number | string;
    /**
     * Consumption Uom
     */
    consumption_uom: string;
    /**
     * Total Demand
     */
    total_demand: number | string;
    /**
     * Demand Uom
     */
    demand_uom: string;
};

/**
 * ShareRequestCreate
 */
export type ShareRequestCreate = {
    /**
     * Program Id
     */
    program_id: string;
    /**
     * Target Property Id
     */
    target_property_id: string;
    /**
     * Request Notes
     */
    request_notes?: string | null;
};

/**
 * ShareRequestDecision
 */
export type ShareRequestDecision = {
    /**
     * Decision Notes
     */
    decision_notes?: string | null;
};

/**
 * ShareRequestResponse
 */
export type ShareRequestResponse = {
    /**
     * Id
     */
    id: string;
    /**
     * Requesting Org Id
     */
    requesting_org_id: string;
    /**
     * Program Id
     */
    program_id: string;
    /**
     * Target Org Id
     */
    target_org_id: string;
    /**
     * Target Property Id
     */
    target_property_id: string;
    /**
     * Target Property Name
     */
    target_property_name: string | null;
    status: ShareRequestStatus;
    /**
     * Requested By User Id
     */
    requested_by_user_id: string;
    /**
     * Decided By User Id
     */
    decided_by_user_id: string | null;
    /**
     * Decided At
     */
    decided_at: string | null;
    /**
     * Request Notes
     */
    request_notes: string | null;
    /**
     * Decision Notes
     */
    decision_notes: string | null;
    /**
     * Created At
     */
    created_at: string;
    /**
     * Updated At
     */
    updated_at: string;
};

/**
 * ShareRequestStatus
 *
 * Status of a cross-org property share request.
 */
export const ShareRequestStatus = {
    PENDING: 'Pending',
    APPROVED: 'Approved',
    DENIED: 'Denied',
    REVOKED: 'Revoked'
} as const;

/**
 * ShareRequestStatus
 *
 * Status of a cross-org property share request.
 */
export type ShareRequestStatus = typeof ShareRequestStatus[keyof typeof ShareRequestStatus];

export const SortDirection = { ASC: 'asc', DESC: 'desc' } as const;

export type SortDirection = typeof SortDirection[keyof typeof SortDirection];

/**
 * SourceResponse
 */
export type SourceResponse = {
    /**
     * Key
     */
    key: string;
    /**
     * Url
     */
    url: string;
    /**
     * Title
     */
    title: string;
    /**
     * Publisher
     */
    publisher: string;
    kind: ProgramSourceKind;
    /**
     * Citation
     */
    citation: string | null;
    /**
     * Retrieved On
     */
    retrieved_on: string;
    /**
     * Verified On
     */
    verified_on: string | null;
    /**
     * Review Interval Days
     */
    review_interval_days: number;
    /**
     * Is Stale
     */
    is_stale: boolean;
};

/**
 * StandardEvaluationRequest
 */
export type StandardEvaluationRequest = {
    /**
     * Data Year
     */
    data_year?: number;
    /**
     * Period Start Year
     */
    period_start_year?: number;
    /**
     * Release If Met
     */
    release_if_met?: boolean;
};

/**
 * State
 *
 * :AK: Alaska in United States
 * :AL: Alabama in United States
 * :AR: Arkansas in United States
 * :AS: American Samoa in United States
 * :AZ: Arizona in United States
 * :CA: California in United States
 * :CO: Colorado in United States
 * :CT: Connecticut in United States
 * :DC: District of Columbia (D.C.) in United States
 * :DE: Delaware in United States
 * :FL: Florida in United States
 * :GA: Georgia in United States
 * :GU: Guam in United States
 * :HI: Hawaii in United States
 * :IA: Iowa in United States
 * :ID: Idaho in United States
 * :IL: Illinois in United States
 * :IN: Indiana in United States
 * :KS: Kansas in United States
 * :KY: Kentucky in United States
 * :LA: Louisiana in United States
 * :MA: Massachusetts in United States
 * :MD: Maryland in United States
 * :ME: Maine in United States
 * :MH: Marshall Islands in United States
 * :MI: Michigan in United States
 * :MN: Minnesota in United States
 * :MO: Missouri in United States
 * :MP: Northern Mariana Islands in United States
 * :MS: Mississippi in United States
 * :MT: Montana in United States
 * :NC: North Carolina in United States
 * :ND: North Dakota in United States
 * :NE: Nebraska in United States
 * :NH: New Hampshire in United States
 * :NJ: New Jersey in United States
 * :NM: New Mexico in United States
 * :NN: Navajo Nation in United States
 * :NV: Nevada in United States
 * :NY: New York in United States
 * :OH: Ohio in United States
 * :OK: Oklahoma in United States
 * :OR: Oregon in United States
 * :PA: Pennsylvania in United States
 * :PI: Pacific Islands in United States
 * :PR: Puerto Rico in United States
 * :RI: Rhode Island in United States
 * :SC: South Carolina in United States
 * :SD: South Dakota in United States
 * :TN: Tennessee in United States
 * :TT: Trust Territories in United States
 * :TX: Texas in United States
 * :UM: U.S. Minor Outlying Islands in United States
 * :UT: Utah in United States
 * :VA: Virginia in United States
 * :VI: Virgin Islands of the U.S. in United States
 * :VT: Vermont in United States
 * :WA: Washington in United States
 * :WI: Wisconsin in United States
 * :WQ: Wake Island in United States
 * :WV: West Virginia in United States
 * :WY: Wyoming in United States
 * :AB: Alberta province in Canada
 * :BC: British Columbia province in Canada
 * :MB: Manitoba province in Canada
 * :NB: New Brunswick province in Canada
 * :NL: Newfoundland and Labrador province in Canada
 * :NS: Nova Scotia province in Canada
 * :NT: Northwest Territories province in Canada
 * :NU: Nunavut province in Canada
 * :ON: Ontario province in Canada
 * :PE: Prince Edward Island province in Canada
 * :QC: Quebec province in Canada
 * :SK: Saskatchewan province in Canada
 * :YT: Yukon province in Canada
 */
export const State = {
    AK: 'AK',
    AL: 'AL',
    AR: 'AR',
    AS: 'AS',
    AZ: 'AZ',
    CA: 'CA',
    CO: 'CO',
    CT: 'CT',
    DC: 'DC',
    DE: 'DE',
    FL: 'FL',
    GA: 'GA',
    GU: 'GU',
    HI: 'HI',
    IA: 'IA',
    ID: 'ID',
    IL: 'IL',
    IN: 'IN',
    KS: 'KS',
    KY: 'KY',
    LA: 'LA',
    MA: 'MA',
    MD: 'MD',
    ME: 'ME',
    MH: 'MH',
    MI: 'MI',
    MN: 'MN',
    MO: 'MO',
    MP: 'MP',
    MS: 'MS',
    MT: 'MT',
    NC: 'NC',
    ND: 'ND',
    NE: 'NE',
    NH: 'NH',
    NJ: 'NJ',
    NM: 'NM',
    NN: 'NN',
    NV: 'NV',
    NY: 'NY',
    OH: 'OH',
    OK: 'OK',
    OR: 'OR',
    PA: 'PA',
    PI: 'PI',
    PR: 'PR',
    RI: 'RI',
    SC: 'SC',
    SD: 'SD',
    TN: 'TN',
    TT: 'TT',
    TX: 'TX',
    UM: 'UM',
    UT: 'UT',
    VA: 'VA',
    VI: 'VI',
    VT: 'VT',
    WA: 'WA',
    WI: 'WI',
    WQ: 'WQ',
    WV: 'WV',
    WY: 'WY',
    AB: 'AB',
    BC: 'BC',
    MB: 'MB',
    NB: 'NB',
    NL: 'NL',
    NS: 'NS',
    NT: 'NT',
    NU: 'NU',
    ON: 'ON',
    PE: 'PE',
    QC: 'QC',
    SK: 'SK',
    YT: 'YT'
} as const;

/**
 * State
 *
 * :AK: Alaska in United States
 * :AL: Alabama in United States
 * :AR: Arkansas in United States
 * :AS: American Samoa in United States
 * :AZ: Arizona in United States
 * :CA: California in United States
 * :CO: Colorado in United States
 * :CT: Connecticut in United States
 * :DC: District of Columbia (D.C.) in United States
 * :DE: Delaware in United States
 * :FL: Florida in United States
 * :GA: Georgia in United States
 * :GU: Guam in United States
 * :HI: Hawaii in United States
 * :IA: Iowa in United States
 * :ID: Idaho in United States
 * :IL: Illinois in United States
 * :IN: Indiana in United States
 * :KS: Kansas in United States
 * :KY: Kentucky in United States
 * :LA: Louisiana in United States
 * :MA: Massachusetts in United States
 * :MD: Maryland in United States
 * :ME: Maine in United States
 * :MH: Marshall Islands in United States
 * :MI: Michigan in United States
 * :MN: Minnesota in United States
 * :MO: Missouri in United States
 * :MP: Northern Mariana Islands in United States
 * :MS: Mississippi in United States
 * :MT: Montana in United States
 * :NC: North Carolina in United States
 * :ND: North Dakota in United States
 * :NE: Nebraska in United States
 * :NH: New Hampshire in United States
 * :NJ: New Jersey in United States
 * :NM: New Mexico in United States
 * :NN: Navajo Nation in United States
 * :NV: Nevada in United States
 * :NY: New York in United States
 * :OH: Ohio in United States
 * :OK: Oklahoma in United States
 * :OR: Oregon in United States
 * :PA: Pennsylvania in United States
 * :PI: Pacific Islands in United States
 * :PR: Puerto Rico in United States
 * :RI: Rhode Island in United States
 * :SC: South Carolina in United States
 * :SD: South Dakota in United States
 * :TN: Tennessee in United States
 * :TT: Trust Territories in United States
 * :TX: Texas in United States
 * :UM: U.S. Minor Outlying Islands in United States
 * :UT: Utah in United States
 * :VA: Virginia in United States
 * :VI: Virgin Islands of the U.S. in United States
 * :VT: Vermont in United States
 * :WA: Washington in United States
 * :WI: Wisconsin in United States
 * :WQ: Wake Island in United States
 * :WV: West Virginia in United States
 * :WY: Wyoming in United States
 * :AB: Alberta province in Canada
 * :BC: British Columbia province in Canada
 * :MB: Manitoba province in Canada
 * :NB: New Brunswick province in Canada
 * :NL: Newfoundland and Labrador province in Canada
 * :NS: Nova Scotia province in Canada
 * :NT: Northwest Territories province in Canada
 * :NU: Nunavut province in Canada
 * :ON: Ontario province in Canada
 * :PE: Prince Edward Island province in Canada
 * :QC: Quebec province in Canada
 * :SK: Saskatchewan province in Canada
 * :YT: Yukon province in Canada
 */
export type State = typeof State[keyof typeof State];

/**
 * StatementPaymentSummary
 *
 * Payment rollup for a single statement.
 */
export type StatementPaymentSummary = {
    /**
     * Total Due
     */
    total_due: number | string;
    /**
     * Total Paid
     */
    total_paid: number | string;
    /**
     * Remaining
     */
    remaining: number | string;
    /**
     * Payments
     */
    payments: Array<Payment>;
};

export const StatementSortFields = { STATEMENT_DATE: 'statement_date', VENDOR: 'vendor' } as const;

export type StatementSortFields = typeof StatementSortFields[keyof typeof StatementSortFields];

/**
 * StatementUpdate
 */
export type StatementUpdate = {
    /**
     * Identifiers
     */
    identifiers?: Array<Identifier> | null;
};

/**
 * StatusBreakdown
 */
export type StatusBreakdown = {
    status: ComplianceStatus;
    /**
     * Count
     */
    count: number;
};

/**
 * SubmeterStatus
 *
 * Electrical sub-metering of a tenant space: not required, required but missing, installed, or not
 * yet known.
 */
export const SubmeterStatus = {
    NOT_REQUIRED: 'Not required',
    'REQUIRED,_MISSING': 'Required, missing',
    INSTALLED: 'Installed',
    UNKNOWN: 'Unknown'
} as const;

/**
 * SubmeterStatus
 *
 * Electrical sub-metering of a tenant space: not required, required but missing, installed, or not
 * yet known.
 */
export type SubmeterStatus = typeof SubmeterStatus[keyof typeof SubmeterStatus];

/**
 * SubmissionReviewDecision
 */
export type SubmissionReviewDecision = {
    status: SubmissionStatus;
    /**
     * Review Notes
     */
    review_notes?: string | null;
    /**
     * Rejection Reason
     */
    rejection_reason?: string | null;
};

/**
 * SubmissionStatus
 *
 * Status of a form or portal submission
 */
export const SubmissionStatus = {
    DRAFT: 'Draft',
    SUBMITTED: 'Submitted',
    UNDER_REVIEW: 'Under Review',
    APPROVED: 'Approved',
    REJECTED: 'Rejected',
    REQUIRES_REVISION: 'Requires Revision'
} as const;

/**
 * SubmissionStatus
 *
 * Status of a form or portal submission
 */
export type SubmissionStatus = typeof SubmissionStatus[keyof typeof SubmissionStatus];

/**
 * SupportRequest
 *
 * Full support request model
 */
export type SupportRequest = {
    /**
     * Id
     */
    id: string;
    org_user: OrgUserRef;
    /**
     * Title
     */
    title: string;
    status: SupportRequestStatus;
    priority: SupportRequestPriority;
    /**
     * Source Page
     */
    source_page: string | null;
    /**
     * Metadata
     */
    metadata: {
        [key: string]: unknown;
    } | null;
    assigned_to: OrgUserRef | null;
    /**
     * Submission Date
     */
    submission_date: string;
    /**
     * Assignment Date
     */
    assignment_date: string | null;
    /**
     * Closure Date
     */
    closure_date: string | null;
    /**
     * Resolution Date
     */
    resolution_date: string | null;
    /**
     * Messages
     */
    messages: Array<SupportRequestMessage>;
};

/**
 * SupportRequestCreate
 *
 * Model for creating a new support request
 */
export type SupportRequestCreate = {
    /**
     * Title
     */
    title: string;
    /**
     * Message
     */
    message: string;
    /**
     * Source Page
     */
    source_page?: string | null;
    /**
     * Metadata
     */
    metadata?: {
        [key: string]: unknown;
    } | null;
    /**
     * File Set Id
     */
    file_set_id?: string | null;
};

/**
 * SupportRequestMessage
 *
 * Details of a single support request message
 */
export type SupportRequestMessage = {
    /**
     * Id
     */
    id: string;
    org_user: OrgUserRef;
    /**
     * Message
     */
    message: string;
    file_set: FileSet | null;
    /**
     * Send Date
     */
    send_date: string;
};

/**
 * SupportRequestMessageCreate
 *
 * Model for adding a message to a support request
 */
export type SupportRequestMessageCreate = {
    /**
     * Message
     */
    message: string;
    /**
     * File Set Id
     */
    file_set_id?: string | null;
};

/**
 * SupportRequestPriority
 */
export const SupportRequestPriority = {
    LOW: 'Low',
    MEDIUM: 'Medium',
    HIGH: 'High',
    URGENT: 'Urgent'
} as const;

/**
 * SupportRequestPriority
 */
export type SupportRequestPriority = typeof SupportRequestPriority[keyof typeof SupportRequestPriority];

/**
 * SupportRequestStatus
 */
export const SupportRequestStatus = {
    OPEN: 'Open',
    IN_PROGRESS: 'In Progress',
    RESOLVED: 'Resolved',
    CLOSED: 'Closed'
} as const;

/**
 * SupportRequestStatus
 */
export type SupportRequestStatus = typeof SupportRequestStatus[keyof typeof SupportRequestStatus];

/**
 * SupportRequestSummary
 *
 * Summary view of a support request for list displays
 */
export type SupportRequestSummary = {
    /**
     * Id
     */
    id: string;
    org_user: OrgUserRef;
    /**
     * Title
     */
    title: string;
    status: SupportRequestStatus;
    priority: SupportRequestPriority;
    /**
     * Submission Date
     */
    submission_date: string;
    /**
     * Assignment Date
     */
    assignment_date: string | null;
    /**
     * Closure Date
     */
    closure_date: string | null;
    /**
     * Resolution Date
     */
    resolution_date: string | null;
    assigned_to: OrgUserRef | null;
};

/**
 * SupportRequestUpdate
 *
 * Model for updating a support request
 */
export type SupportRequestUpdate = {
    status?: SupportRequestStatus | null;
    priority?: SupportRequestPriority | null;
    /**
     * Assigned To Id
     */
    assigned_to_id?: string | null;
};

/**
 * Target
 */
export type Target = {
    /**
     * Id
     */
    id: string;
    /**
     * Name
     */
    name: string;
    /**
     * Metric
     */
    metric: string;
    scope: TargetScope;
    /**
     * Scope Ref Id
     */
    scope_ref_id: string | null;
    /**
     * Baseline Year
     */
    baseline_year: number;
    /**
     * Baseline Value
     */
    baseline_value: number | string;
    /**
     * Target Year
     */
    target_year: number;
    /**
     * Target Value
     */
    target_value: number | string;
    interpolation: TargetInterpolation;
};

/**
 * TargetBody
 */
export type TargetBody = {
    /**
     * Name
     */
    name: string;
    /**
     * Metric
     */
    metric: string;
    scope: TargetScope;
    /**
     * Scope Ref Id
     */
    scope_ref_id?: string | null;
    /**
     * Baseline Year
     */
    baseline_year: number;
    /**
     * Baseline Value
     */
    baseline_value: number | string;
    /**
     * Target Year
     */
    target_year: number;
    /**
     * Target Value
     */
    target_value: number | string;
    interpolation?: TargetInterpolation;
};

/**
 * TargetInterpolation
 */
export const TargetInterpolation = { LINEAR: 'LINEAR', STEPWISE: 'STEPWISE' } as const;

/**
 * TargetInterpolation
 */
export type TargetInterpolation = typeof TargetInterpolation[keyof typeof TargetInterpolation];

/**
 * TargetProgressSummary
 */
export type TargetProgressSummary = {
    /**
     * Id
     */
    id: string;
    /**
     * Name
     */
    name: string;
    /**
     * Metric
     */
    metric: string;
    scope: TargetScope;
    /**
     * Baseline Year
     */
    baseline_year: number;
    /**
     * Baseline Value
     */
    baseline_value: number;
    /**
     * Target Year
     */
    target_year: number;
    /**
     * Target Value
     */
    target_value: number;
    /**
     * Latest Year
     */
    latest_year: string | null;
    /**
     * Latest Value
     */
    latest_value: number | null;
    /**
     * Fraction
     */
    fraction: number | null;
};

/**
 * TargetScope
 */
export const TargetScope = {
    PORTFOLIO: 'PORTFOLIO',
    DEPARTMENT: 'DEPARTMENT',
    PROPERTY: 'PROPERTY'
} as const;

/**
 * TargetScope
 */
export type TargetScope = typeof TargetScope[keyof typeof TargetScope];

/**
 * TaskResponse
 *
 * API response model for compliance task.
 */
export type TaskResponse = {
    /**
     * Id
     */
    id: string;
    /**
     * Tracking Id
     */
    tracking_id: string;
    /**
     * Org Id
     */
    org_id: string;
    /**
     * Requirement Id
     */
    requirement_id: string | null;
    /**
     * Parent Task Id
     */
    parent_task_id: string | null;
    /**
     * Name
     */
    name: string;
    /**
     * Description
     */
    description: string | null;
    /**
     * Instructions
     */
    instructions: string | null;
    /**
     * Status
     */
    status: string;
    /**
     * Due Date
     */
    due_date: string | null;
    /**
     * Completed At
     */
    completed_at: string | null;
    /**
     * Is Auto Generated
     */
    is_auto_generated: boolean;
    /**
     * Auto Generation Source
     */
    auto_generation_source: string | null;
    /**
     * Priority
     */
    priority: number;
    /**
     * Display Order
     */
    display_order: number;
    /**
     * Created At
     */
    created_at: string;
    /**
     * Assignee Ids
     */
    assignee_ids: Array<string>;
    /**
     * Submission Kind
     */
    submission_kind: string | null;
    /**
     * Submission Id
     */
    submission_id: string | null;
    /**
     * Satisfied By Task Id
     */
    satisfied_by_task_id: string | null;
    /**
     * Depends On Task Ids
     */
    depends_on_task_ids: Array<string>;
    /**
     * Reminder Days Before
     */
    reminder_days_before: Array<number> | null;
    /**
     * Metadata
     */
    metadata: {
        [key: string]: unknown;
    } | null;
};

/**
 * TemplateCategory
 */
export type TemplateCategory = {
    /**
     * Id
     */
    id: string;
    /**
     * Label
     */
    label: string;
};

/**
 * TemplateLibraryResponse
 */
export type TemplateLibraryResponse = {
    /**
     * Categories
     */
    categories: Array<TemplateCategory>;
    /**
     * Templates
     */
    templates: Array<ViewTemplate>;
};

/**
 * TenantSpaceModel
 */
export type TenantSpaceModel = {
    /**
     * Name
     */
    name?: string | null;
    /**
     * Tenant Name
     */
    tenant_name?: string | null;
    /**
     * Gross Floor Area
     */
    gross_floor_area?: number | string | null;
    uom?: FloorAreaUnitOfMeasure | null;
    /**
     * Floor
     */
    floor?: string | null;
    /**
     * Occupancy Group
     */
    occupancy_group?: string | null;
    /**
     * Is Dwelling Unit
     */
    is_dwelling_unit?: boolean | null;
    /**
     * Dedicated Utility Meter
     */
    dedicated_utility_meter?: boolean | null;
    submeter_status?: SubmeterStatus | null;
    /**
     * Effective From
     */
    effective_from?: string | null;
    /**
     * Effective To
     */
    effective_to?: string | null;
    /**
     * Notes
     */
    notes?: string | null;
};

/**
 * TenantSpaceResponse
 */
export type TenantSpaceResponse = {
    /**
     * Id
     */
    id: string;
    /**
     * Name
     */
    name: string;
    /**
     * Tenant Name
     */
    tenant_name: string | null;
    /**
     * Gross Floor Area
     */
    gross_floor_area: number | string;
    uom: FloorAreaUnitOfMeasure;
    /**
     * Floor
     */
    floor: string | null;
    /**
     * Occupancy Group
     */
    occupancy_group: string | null;
    /**
     * Is Dwelling Unit
     */
    is_dwelling_unit: boolean;
    /**
     * Dedicated Utility Meter
     */
    dedicated_utility_meter: boolean;
    submeter_status: SubmeterStatus;
    /**
     * Effective From
     */
    effective_from: string | null;
    /**
     * Effective To
     */
    effective_to: string | null;
    /**
     * Notes
     */
    notes: string | null;
    /**
     * Covered
     */
    covered?: boolean | null;
    /**
     * Coverage Reason
     */
    coverage_reason?: string | null;
    /**
     * Needs Submeter
     */
    needs_submeter?: boolean | null;
};

/**
 * TenantSpacesImportRequest
 */
export type TenantSpacesImportRequest = {
    /**
     * Csv
     */
    csv: string;
    /**
     * Apply
     */
    apply?: boolean;
};

/**
 * TenantSpacesImportResponse
 */
export type TenantSpacesImportResponse = {
    /**
     * Counts
     */
    counts: {
        [key: string]: number;
    };
    /**
     * Errors
     */
    errors: Array<string>;
    /**
     * Creates
     */
    creates: Array<string>;
    /**
     * Updates
     */
    updates: Array<string>;
    /**
     * Ends
     */
    ends: Array<string>;
};

/**
 * TenantSpacesResponse
 */
export type TenantSpacesResponse = {
    /**
     * Threshold Sf
     */
    threshold_sf: number | string;
    /**
     * Spaces
     */
    spaces: Array<TenantSpaceResponse>;
    /**
     * Exposure
     */
    exposure: {
        [key: string]: unknown;
    } | null;
};

/**
 * TimeRange
 *
 * Closed-open time window in UTC. `start` inclusive, `end` exclusive.
 */
export type TimeRange = {
    /**
     * Start
     */
    start: string;
    /**
     * End
     */
    end: string;
};

/**
 * TrackChangeRequest
 */
export type TrackChangeRequest = {
    /**
     * Track Key
     */
    track_key: string;
    status?: TrackStatus;
    /**
     * Effective On
     */
    effective_on?: string | null;
    /**
     * Note
     */
    note?: string | null;
};

/**
 * TrackChangeResponse
 */
export type TrackChangeResponse = {
    tracking: TrackingResponse;
    /**
     * Cancelled Tasks
     */
    cancelled_tasks: Array<TaskResponse>;
    /**
     * Created Tasks
     */
    created_tasks: Array<TaskResponse>;
};

/**
 * TrackHistoryResponse
 */
export type TrackHistoryResponse = {
    /**
     * Track Key
     */
    track_key: string | null;
    /**
     * Track Name
     */
    track_name: string | null;
    status: TrackStatus;
    source: TrackSource;
    /**
     * Effective From
     */
    effective_from: string;
    /**
     * Effective To
     */
    effective_to: string | null;
    /**
     * Determination Id
     */
    determination_id: string | null;
    /**
     * Note
     */
    note: string | null;
};

/**
 * TrackResponse
 */
export type TrackResponse = {
    /**
     * Id
     */
    id: string;
    /**
     * Program Id
     */
    program_id: string;
    /**
     * Key
     */
    key: string;
    /**
     * Name
     */
    name: string;
    /**
     * Description
     */
    description: string | null;
    /**
     * Sort
     */
    sort: number;
    /**
     * Portfolio Only
     */
    portfolio_only: boolean;
    /**
     * Effective From
     */
    effective_from: string | null;
    /**
     * Effective To
     */
    effective_to: string | null;
    record_status: ProgramRecordStatus;
    /**
     * Provenance
     */
    provenance: {
        [key: string]: unknown;
    } | null;
};

/**
 * TrackSource
 *
 * How a tracked property's compliance track was decided.
 */
export const TrackSource = {
    CRITERIA: 'Criteria',
    COVERAGE_LIST: 'Coverage list',
    MANUAL: 'Manual',
    OWNER: 'Owner'
} as const;

/**
 * TrackSource
 *
 * How a tracked property's compliance track was decided.
 */
export type TrackSource = typeof TrackSource[keyof typeof TrackSource];

/**
 * TrackStatus
 *
 * Standing of a tracked property's track: chosen by the owner, approved by the agency, or assigned
 * (by the agency, a covered-building list or the coverage rules).
 */
export const TrackStatus = {
    SELECTED: 'Selected',
    APPROVED: 'Approved',
    ASSIGNED: 'Assigned'
} as const;

/**
 * TrackStatus
 *
 * Standing of a tracked property's track: chosen by the owner, approved by the agency, or assigned
 * (by the agency, a covered-building list or the coverage rules).
 */
export type TrackStatus = typeof TrackStatus[keyof typeof TrackStatus];

/**
 * TrackingResponse
 *
 * API response model for property program tracking.
 */
export type TrackingResponse = {
    /**
     * Id
     */
    id: string;
    /**
     * Org Id
     */
    org_id: string;
    /**
     * Property Id
     */
    property_id: string;
    /**
     * Program Id
     */
    program_id: string;
    /**
     * Cycle Id
     */
    cycle_id: string;
    /**
     * Is Auto Detected
     */
    is_auto_detected: boolean;
    /**
     * Detection Details
     */
    detection_details: {
        [key: string]: unknown;
    } | null;
    /**
     * Program Property Link Id
     */
    program_property_link_id: string | null;
    /**
     * Is Acknowledged
     */
    is_acknowledged: boolean;
    /**
     * Acknowledged At
     */
    acknowledged_at: string | null;
    /**
     * Is Opted Out
     */
    is_opted_out: boolean;
    /**
     * Opt Out Reason
     */
    opt_out_reason: string | null;
    /**
     * Exemption Requested
     */
    exemption_requested: boolean;
    /**
     * Exemption Details
     */
    exemption_details: string | null;
    /**
     * Notes
     */
    notes: string | null;
    /**
     * Is Active
     */
    is_active: boolean;
    /**
     * Created At
     */
    created_at: string;
    /**
     * Track Id
     */
    track_id: string | null;
    /**
     * Track Key
     */
    track_key: string | null;
    /**
     * Track Name
     */
    track_name: string | null;
    track_status: TrackStatus | null;
    track_source: TrackSource | null;
    /**
     * Track Changed On
     */
    track_changed_on: string | null;
    /**
     * Needs Review
     */
    needs_review: boolean;
    /**
     * Coverage Entry Id
     */
    coverage_entry_id: string | null;
};

/**
 * TrackingResultStatus
 */
export const TrackingResultStatus = {
    IN_COMPLIANCE: 'In compliance',
    NOT_IN_COMPLIANCE: 'Not in compliance',
    INCOMPLETE_DATA: 'Incomplete data'
} as const;

/**
 * TrackingResultStatus
 */
export type TrackingResultStatus = typeof TrackingResultStatus[keyof typeof TrackingResultStatus];

/**
 * UpcomingPayment
 *
 * A statement with money still owed, ranked by due date.
 *
 * `due_date` is computed as ``statement_date + 30 days`` since the platform
 * does not store an explicit due date today. `days_until_due` is negative
 * when the statement is already past due.
 */
export type UpcomingPayment = {
    /**
     * Statement Id
     */
    statement_id: string;
    /**
     * Statement Date
     */
    statement_date: string;
    /**
     * Due Date
     */
    due_date: string;
    /**
     * Days Until Due
     */
    days_until_due: number;
    /**
     * Billing Account Id
     */
    billing_account_id: string;
    /**
     * Billing Account Name
     */
    billing_account_name: string | null;
    /**
     * Billing Account Number
     */
    billing_account_number: string;
    /**
     * Vendor Name
     */
    vendor_name: string;
    /**
     * Total Due
     */
    total_due: number | string;
    /**
     * Total Paid
     */
    total_paid: number | string;
    /**
     * Remaining
     */
    remaining: number | string;
};

/**
 * UploadPortalCreate
 */
export type UploadPortalCreate = {
    /**
     * Name
     */
    name: string;
    /**
     * Description
     */
    description?: string | null;
    /**
     * Instructions
     */
    instructions?: string | null;
    /**
     * Accepted File Types
     */
    accepted_file_types?: Array<string> | null;
    /**
     * Max File Size Mb
     */
    max_file_size_mb?: number | null;
    /**
     * Max Files
     */
    max_files?: number | null;
    access_type?: PortalAccessType;
    /**
     * Requirement Id
     */
    requirement_id?: string | null;
    /**
     * Available From
     */
    available_from?: string | null;
    /**
     * Available Until
     */
    available_until?: string | null;
};

/**
 * UploadPortalUpdate
 */
export type UploadPortalUpdate = {
    /**
     * Name
     */
    name?: string | null;
    /**
     * Description
     */
    description?: string | null;
    /**
     * Instructions
     */
    instructions?: string | null;
    /**
     * Accepted File Types
     */
    accepted_file_types?: Array<string> | null;
    /**
     * Max File Size Mb
     */
    max_file_size_mb?: number | null;
    /**
     * Max Files
     */
    max_files?: number | null;
    access_type?: PortalAccessType | null;
    /**
     * Requirement Id
     */
    requirement_id?: string | null;
    /**
     * Available From
     */
    available_from?: string | null;
    /**
     * Available Until
     */
    available_until?: string | null;
    /**
     * Is Active
     */
    is_active?: boolean | null;
};

/**
 * UserClass
 */
export const UserClass = { MEMBER: 'Member', EXTERNAL: 'External' } as const;

/**
 * UserClass
 */
export type UserClass = typeof UserClass[keyof typeof UserClass];

/**
 * UserDetails
 */
export type UserDetails = {
    /**
     * Id
     */
    id: string;
    /**
     * Email
     */
    email: string;
    /**
     * Name
     */
    name: string;
    /**
     * Is Active
     */
    is_active?: boolean;
    /**
     * Is Deleted
     */
    is_deleted?: boolean;
    /**
     * Has Avatar
     */
    has_avatar?: boolean;
    /**
     * Avatar Url
     */
    avatar_url?: string | null;
    /**
     * Roles
     */
    roles: Array<RoleRef>;
    /**
     * Permissions
     */
    permissions: Array<Permission>;
};

/**
 * UserPrivate
 */
export type UserPrivate = {
    /**
     * Id
     */
    id: string;
    account: Account;
    /**
     * Org Users
     */
    org_users: Array<OrgUserRef>;
    /**
     * Email
     */
    email: string;
    /**
     * Name
     */
    name: string;
    /**
     * Is Active
     */
    is_active?: boolean;
    /**
     * Is Deleted
     */
    is_deleted?: boolean;
    /**
     * Has Avatar
     */
    has_avatar?: boolean;
    /**
     * Avatar Url
     */
    avatar_url?: string | null;
    /**
     * Login Preferences
     */
    login_preferences: Array<Preference>;
    /**
     * Is Super
     */
    is_super: boolean;
    /**
     * Roles
     */
    roles: Array<RoleRef>;
    /**
     * Permissions
     */
    permissions: Array<Permission>;
};

/**
 * UserRef
 */
export type UserRef = {
    /**
     * Id
     */
    id: string;
    /**
     * Email
     */
    email: string;
    /**
     * Name
     */
    name: string;
    /**
     * Is Active
     */
    is_active?: boolean;
    /**
     * Is Deleted
     */
    is_deleted?: boolean;
    /**
     * Has Avatar
     */
    has_avatar?: boolean;
    /**
     * Avatar Url
     */
    avatar_url?: string | null;
};

/**
 * ValidationError
 */
export type ValidationError = {
    /**
     * Location
     */
    loc: Array<string | number>;
    /**
     * Message
     */
    msg: string;
    /**
     * Error Type
     */
    type: string;
    /**
     * Input
     */
    input?: unknown;
    /**
     * Context
     */
    ctx?: {
        [key: string]: unknown;
    };
};

/**
 * Vendor
 */
export type Vendor = {
    /**
     * Id
     */
    id: string;
    /**
     * Name
     */
    name: string;
    /**
     * Has Logo
     */
    has_logo?: boolean;
    /**
     * Logo Url
     */
    logo_url?: string | null;
    /**
     * Aliases
     */
    aliases?: Array<string> | null;
    /**
     * Website
     */
    website?: string | null;
    /**
     * Regions
     */
    regions?: Array<string> | null;
    /**
     * Is Active
     */
    is_active?: boolean;
    /**
     * Commodities
     */
    commodities?: Array<CommodityRef> | null;
};

/**
 * VendorBalance
 *
 * Balance rollup at the org-vendor level.
 */
export type VendorBalance = {
    /**
     * Org Vendor Id
     */
    org_vendor_id: string;
    /**
     * Total Charged
     */
    total_charged: number | string;
    /**
     * Total Paid
     */
    total_paid: number | string;
    /**
     * Outstanding
     */
    outstanding: number | string;
};

/**
 * VendorBillingAccount
 */
export type VendorBillingAccount = {
    /**
     * Id
     */
    id: string;
    vendor: VendorRef;
    /**
     * Vendor Account Number
     */
    vendor_account_number: string;
    /**
     * Name
     */
    name: string | null;
    /**
     * Departments
     */
    departments: Array<DepartmentSummary>;
    /**
     * Identifiers
     */
    identifiers: Array<IdentifierRef>;
    /**
     * Outstanding
     */
    outstanding?: number | string | null;
};

/**
 * VendorBillingAccountRef
 */
export type VendorBillingAccountRef = {
    /**
     * Id
     */
    id: string;
    vendor: VendorRef;
    /**
     * Vendor Account Number
     */
    vendor_account_number: string;
    /**
     * Name
     */
    name: string | null;
    /**
     * Outstanding
     */
    outstanding?: number | string | null;
    /**
     * Service Account Count
     */
    service_account_count?: number | null;
};

/**
 * VendorCreate
 */
export type VendorCreate = {
    /**
     * Name
     */
    name: string;
    /**
     * Aliases
     */
    aliases?: Array<string> | null;
    /**
     * Website
     */
    website?: string | null;
    /**
     * Regions
     */
    regions?: Array<string> | null;
    /**
     * Logo Url
     */
    logo_url?: string | null;
    /**
     * Commodity Ids
     */
    commodity_ids?: Array<string> | null;
};

/**
 * VendorRef
 */
export type VendorRef = {
    /**
     * Id
     */
    id: string;
    /**
     * Name
     */
    name: string;
};

/**
 * VendorServiceAccount
 */
export type VendorServiceAccount = {
    /**
     * Id
     */
    id: string;
    /**
     * Vendor Account Number
     */
    vendor_account_number: string;
    /**
     * Name
     */
    name: string | null;
    /**
     * Properties
     */
    properties: Array<PropertySummary>;
    /**
     * Identifiers
     */
    identifiers: Array<IdentifierRef>;
};

/**
 * VendorServiceAccountRef
 */
export type VendorServiceAccountRef = {
    /**
     * Id
     */
    id: string;
    billing_account: VendorBillingAccountRef;
    /**
     * Vendor Account Number
     */
    vendor_account_number: string;
    /**
     * Name
     */
    name: string | null;
    /**
     * Outstanding
     */
    outstanding?: number | string | null;
};

/**
 * VendorStatement
 */
export type VendorStatement = {
    /**
     * Id
     */
    id: string;
    org_vendor: OrgVendor;
    /**
     * Statement Date
     */
    statement_date: string;
    billing_account: VendorBillingAccount;
    statement_schema: VendorStatementSchema | null;
    integration_schema: IntegrationSchema | null;
    file: File | null;
    /**
     * Service Details
     */
    service_details: Array<VendorStatementServiceDetails>;
    statement_summary: VendorStatementSummary;
    payment_summary: StatementPaymentSummary;
    /**
     * Identifiers
     */
    identifiers: Array<IdentifierRef>;
};

/**
 * VendorStatementLineItem
 */
export type VendorStatementLineItem = {
    /**
     * Name
     */
    name: string;
    /**
     * Normalized Name
     */
    normalized_name: string;
    /**
     * Category
     */
    category: string | null;
    /**
     * Usage Amount
     */
    usage_amount: number | string | null;
    /**
     * Usage Amount Uom
     */
    usage_amount_uom: string | null;
    /**
     * Usage Rate
     */
    usage_rate: number | string | null;
    /**
     * Total Charge
     */
    total_charge: number | string;
};

/**
 * VendorStatementMeterDetails
 */
export type VendorStatementMeterDetails = {
    /**
     * Contents
     */
    contents: {
        [key: string]: unknown;
    };
};

/**
 * VendorStatementOverview
 */
export type VendorStatementOverview = {
    /**
     * Id
     */
    id: string;
    org_vendor: OrgVendor;
    /**
     * Statement Date
     */
    statement_date: string;
    billing_account: VendorBillingAccount;
    statement_summary: VendorStatementSummary;
    payment_summary: StatementPaymentSummary;
};

/**
 * VendorStatementRef
 */
export type VendorStatementRef = {
    /**
     * Id
     */
    id: string;
    org_vendor: OrgVendor;
    /**
     * Statement Date
     */
    statement_date: string;
    billing_account: VendorBillingAccountRef;
};

/**
 * VendorStatementSchema
 */
export type VendorStatementSchema = {
    /**
     * Id
     */
    id: string;
    vendor: Vendor;
    /**
     * Type
     */
    type: string;
    /**
     * Version
     */
    version: string;
    /**
     * Details
     */
    details: {
        [key: string]: unknown;
    };
    /**
     * Schema Def
     */
    schema_def: {
        [key: string]: unknown;
    };
};

/**
 * VendorStatementServiceDetails
 */
export type VendorStatementServiceDetails = {
    /**
     * Id
     */
    id: string;
    service_account: VendorServiceAccount;
    /**
     * Total Due
     */
    total_due: number | string;
    /**
     * Meter Details
     */
    meter_details: Array<VendorStatementMeterDetails>;
    /**
     * Service Periods
     */
    service_periods: Array<VendorStatementServicePeriod>;
};

/**
 * VendorStatementServicePeriod
 */
export type VendorStatementServicePeriod = {
    /**
     * Bill Period
     */
    bill_period: string | null;
    /**
     * Start Date
     */
    start_date: string;
    /**
     * End Date
     */
    end_date: string;
    /**
     * Line Items
     */
    line_items: Array<VendorStatementLineItem>;
};

/**
 * VendorStatementSummary
 */
export type VendorStatementSummary = {
    /**
     * Commodities
     */
    commodities: Array<CommodityRef>;
    /**
     * Total Charge
     */
    total_charge: number | string;
    /**
     * Total Consumption
     */
    total_consumption: number | string | null;
    /**
     * Total Consumption Uom
     */
    total_consumption_uom: string | null;
    /**
     * Total Demand
     */
    total_demand: number | string | null;
    /**
     * Total Demand Uom
     */
    total_demand_uom: string | null;
};

/**
 * VendorUpdate
 */
export type VendorUpdate = {
    /**
     * Name
     */
    name?: string | null;
    /**
     * Aliases
     */
    aliases?: Array<string> | null;
    /**
     * Website
     */
    website?: string | null;
    /**
     * Regions
     */
    regions?: Array<string> | null;
    /**
     * Logo Url
     */
    logo_url?: string | null;
    /**
     * Is Active
     */
    is_active?: boolean | null;
    /**
     * Commodity Ids
     */
    commodity_ids?: Array<string> | null;
};

/**
 * ViewCreateFromTemplateRequest
 */
export type ViewCreateFromTemplateRequest = {
    /**
     * Template Id
     */
    template_id: string;
    /**
     * Name
     */
    name?: string | null;
};

/**
 * ViewCreateRequest
 */
export type ViewCreateRequest = {
    /**
     * Name
     */
    name: string;
    /**
     * Description
     */
    description?: string;
    query_spec: QuerySpec;
    /**
     * Presentation
     */
    presentation?: string;
    /**
     * Presentation Props
     */
    presentation_props?: {
        [key: string]: unknown;
    };
    /**
     * Is Shared
     */
    is_shared?: boolean;
};

/**
 * ViewDataRequest
 *
 * Request body for `POST /view/{id}/data`.
 *
 * `weather_normalize` overrides the saved spec's value when supplied.
 * `dynamic_filters` and `dynamic_saved_filter_id` are the runtime filter
 * panel's selection; they merge additively into the spec, narrowing only
 * (time range intersects; dims not on the routed fact are silently
 * dropped).
 */
export type ViewDataRequest = {
    /**
     * Weather Normalize
     */
    weather_normalize?: boolean | null;
    dynamic_filters?: PublicFilterParams | null;
    /**
     * Dynamic Saved Filter Id
     */
    dynamic_saved_filter_id?: string | null;
};

/**
 * ViewDetail
 */
export type ViewDetail = {
    /**
     * Id
     */
    id: string;
    /**
     * Name
     */
    name: string;
    /**
     * Description
     */
    description: string;
    /**
     * Presentation
     */
    presentation: string;
    /**
     * Is Shared
     */
    is_shared: boolean;
    /**
     * Is Published
     */
    is_published: boolean;
    /**
     * Is Editable
     */
    is_editable: boolean;
    /**
     * Is Deletable
     */
    is_deletable: boolean;
    query_spec: QuerySpec;
    /**
     * Presentation Props
     */
    presentation_props: {
        [key: string]: unknown;
    };
};

/**
 * ViewSummary
 */
export type ViewSummary = {
    /**
     * Id
     */
    id: string;
    /**
     * Name
     */
    name: string;
    /**
     * Description
     */
    description: string;
    /**
     * Presentation
     */
    presentation: string;
    /**
     * Is Shared
     */
    is_shared: boolean;
    /**
     * Is Published
     */
    is_published: boolean;
    /**
     * Is Editable
     */
    is_editable: boolean;
    /**
     * Is Deletable
     */
    is_deletable: boolean;
};

/**
 * ViewTemplate
 *
 * A curated, instantiable view definition.
 *
 * `query_spec` is what gets copied into a new `DBView.query_spec`.
 * `presentation` is the default presentation when the template is
 * instantiated as a standalone view; embedded dashboard blocks can override.
 */
export type ViewTemplate = {
    /**
     * Id
     */
    id: string;
    /**
     * Name
     */
    name: string;
    /**
     * Description
     */
    description?: string;
    /**
     * Category Ids
     */
    category_ids?: Array<string>;
    query_spec: QuerySpec;
    /**
     * Presentation
     */
    presentation?: 'table' | 'line' | 'bar' | 'stacked_bar' | 'kpi' | 'gauge' | 'pie' | 'text';
    /**
     * Presentation Props
     */
    presentation_props?: {
        [key: string]: unknown;
    };
    /**
     * Is Default
     */
    is_default?: boolean;
    /**
     * Default Order
     */
    default_order?: number | null;
};

/**
 * ViewUpdateRequest
 */
export type ViewUpdateRequest = {
    /**
     * Name
     */
    name?: string | null;
    /**
     * Description
     */
    description?: string | null;
    query_spec?: QuerySpec | null;
    /**
     * Presentation
     */
    presentation?: string | null;
    /**
     * Presentation Props
     */
    presentation_props?: {
        [key: string]: unknown;
    } | null;
    /**
     * Is Shared
     */
    is_shared?: boolean | null;
    /**
     * Publish
     */
    publish?: boolean | null;
};

/**
 * FormSubmissionResponse
 */
export type ViaductApiRoutersProgramFormAdminFormSubmissionResponse = {
    /**
     * Id
     */
    id: string;
    /**
     * Form Id
     */
    form_id: string;
    /**
     * Property Id
     */
    property_id: string | null;
    /**
     * Submitter Email
     */
    submitter_email: string | null;
    /**
     * Submitter Name
     */
    submitter_name: string | null;
    status: SubmissionStatus;
    /**
     * Submitted At
     */
    submitted_at: string | null;
    /**
     * Reviewed At
     */
    reviewed_at: string | null;
    /**
     * Review Notes
     */
    review_notes: string | null;
    /**
     * Rejection Reason
     */
    rejection_reason: string | null;
    /**
     * Responses
     */
    responses: {
        [key: string]: unknown;
    };
};

/**
 * FormSubmissionResponse
 *
 * Form submission information for public access.
 */
export type ViaductApiRoutersPublicProgramPortalFormSubmissionResponse = {
    /**
     * Id
     */
    id: string;
    /**
     * Form Id
     */
    form_id: string;
    /**
     * Property Id
     */
    property_id: string | null;
    /**
     * Status
     */
    status: string;
    /**
     * Responses
     */
    responses: {
        [key: string]: unknown;
    };
    /**
     * Submitter Email
     */
    submitter_email: string | null;
    /**
     * Submitter Name
     */
    submitter_name: string | null;
};

export type AuthzRoleListRolesData = {
    body?: never;
    path?: never;
    query?: never;
    url: '/authz/role';
};

export type AuthzRoleListRolesErrors = {
    /**
     * Not found
     */
    404: unknown;
};

export type AuthzRoleListRolesResponses = {
    /**
     * Response Authz-Role-List Roles
     *
     * Successful Response
     */
    200: Array<Role>;
};

export type AuthzRoleListRolesResponse = AuthzRoleListRolesResponses[keyof AuthzRoleListRolesResponses];

export type ConfigGetData = {
    body?: never;
    path?: never;
    query?: never;
    url: '/config/';
};

export type ConfigGetErrors = {
    /**
     * Not found
     */
    404: unknown;
};

export type ConfigGetResponses = {
    /**
     * Successful Response
     */
    200: PublicConfig;
};

export type ConfigGetResponse = ConfigGetResponses[keyof ConfigGetResponses];

export type KnowledgeBaseListArticlesData = {
    body?: never;
    path?: never;
    query?: {
        /**
         * Topic
         *
         * Filter by topic
         */
        topic?: KnowledgeBaseTopic | null;
        /**
         * Search
         *
         * Search query
         */
        search?: string | null;
    };
    url: '/knowledge-base/';
};

export type KnowledgeBaseListArticlesErrors = {
    /**
     * Not found
     */
    404: unknown;
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type KnowledgeBaseListArticlesError = KnowledgeBaseListArticlesErrors[keyof KnowledgeBaseListArticlesErrors];

export type KnowledgeBaseListArticlesResponses = {
    /**
     * Response Knowledge-Base--List Articles
     *
     * Successful Response
     */
    200: Array<KnowledgeBaseArticleSummary>;
};

export type KnowledgeBaseListArticlesResponse = KnowledgeBaseListArticlesResponses[keyof KnowledgeBaseListArticlesResponses];

export type KnowledgeBaseGetArticleData = {
    body?: never;
    path: {
        /**
         * Article Id
         */
        article_id: string;
    };
    query?: never;
    url: '/knowledge-base/{article_id}';
};

export type KnowledgeBaseGetArticleErrors = {
    /**
     * Not found
     */
    404: unknown;
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type KnowledgeBaseGetArticleError = KnowledgeBaseGetArticleErrors[keyof KnowledgeBaseGetArticleErrors];

export type KnowledgeBaseGetArticleResponses = {
    /**
     * Successful Response
     */
    200: KnowledgeBaseArticle;
};

export type KnowledgeBaseGetArticleResponse = KnowledgeBaseGetArticleResponses[keyof KnowledgeBaseGetArticleResponses];

export type KnowledgeBaseTopicsListListTopicsData = {
    body?: never;
    path?: never;
    query?: never;
    url: '/knowledge-base/topics/list';
};

export type KnowledgeBaseTopicsListListTopicsErrors = {
    /**
     * Not found
     */
    404: unknown;
};

export type KnowledgeBaseTopicsListListTopicsResponses = {
    /**
     * Response Knowledge-Base-Topics-List-List Topics
     *
     * Successful Response
     */
    200: Array<string>;
};

export type KnowledgeBaseTopicsListListTopicsResponse = KnowledgeBaseTopicsListListTopicsResponses[keyof KnowledgeBaseTopicsListListTopicsResponses];

export type RestrictedAuthzRolesListRolesData = {
    body?: never;
    path?: never;
    query?: never;
    url: '/restricted/authz/roles';
};

export type RestrictedAuthzRolesListRolesErrors = {
    /**
     * Not found
     */
    404: unknown;
};

export type RestrictedAuthzRolesListRolesResponses = {
    /**
     * Response Restricted-Authz-Roles-List Roles
     *
     * Successful Response
     */
    200: Array<Role>;
};

export type RestrictedAuthzRolesListRolesResponse = RestrictedAuthzRolesListRolesResponses[keyof RestrictedAuthzRolesListRolesResponses];

export type RestrictedAuthzRolesCreateRoleData = {
    body: RoleCreateUpdate;
    path?: never;
    query?: never;
    url: '/restricted/authz/roles';
};

export type RestrictedAuthzRolesCreateRoleErrors = {
    /**
     * Not found
     */
    404: unknown;
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type RestrictedAuthzRolesCreateRoleError = RestrictedAuthzRolesCreateRoleErrors[keyof RestrictedAuthzRolesCreateRoleErrors];

export type RestrictedAuthzRolesCreateRoleResponses = {
    /**
     * Successful Response
     */
    200: Role;
};

export type RestrictedAuthzRolesCreateRoleResponse = RestrictedAuthzRolesCreateRoleResponses[keyof RestrictedAuthzRolesCreateRoleResponses];

export type RestrictedAuthzPermissionsListPermissionsData = {
    body?: never;
    path?: never;
    query?: never;
    url: '/restricted/authz/permissions';
};

export type RestrictedAuthzPermissionsListPermissionsErrors = {
    /**
     * Not found
     */
    404: unknown;
};

export type RestrictedAuthzPermissionsListPermissionsResponses = {
    /**
     * Response Restricted-Authz-Permissions-List Permissions
     *
     * Successful Response
     */
    200: Array<Permission>;
};

export type RestrictedAuthzPermissionsListPermissionsResponse = RestrictedAuthzPermissionsListPermissionsResponses[keyof RestrictedAuthzPermissionsListPermissionsResponses];

export type RestrictedAuthzPermissionsCreatePermissionData = {
    body: PermissionCreateUpdate;
    path?: never;
    query?: never;
    url: '/restricted/authz/permissions';
};

export type RestrictedAuthzPermissionsCreatePermissionErrors = {
    /**
     * Not found
     */
    404: unknown;
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type RestrictedAuthzPermissionsCreatePermissionError = RestrictedAuthzPermissionsCreatePermissionErrors[keyof RestrictedAuthzPermissionsCreatePermissionErrors];

export type RestrictedAuthzPermissionsCreatePermissionResponses = {
    /**
     * Successful Response
     */
    200: Permission;
};

export type RestrictedAuthzPermissionsCreatePermissionResponse = RestrictedAuthzPermissionsCreatePermissionResponses[keyof RestrictedAuthzPermissionsCreatePermissionResponses];

export type RestrictedAuthzRolesDeleteRoleData = {
    body?: never;
    path: {
        /**
         * Role Id
         */
        role_id: string;
    };
    query?: never;
    url: '/restricted/authz/roles/{role_id}';
};

export type RestrictedAuthzRolesDeleteRoleErrors = {
    /**
     * Not found
     */
    404: unknown;
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type RestrictedAuthzRolesDeleteRoleError = RestrictedAuthzRolesDeleteRoleErrors[keyof RestrictedAuthzRolesDeleteRoleErrors];

export type RestrictedAuthzRolesDeleteRoleResponses = {
    /**
     * Successful Response
     */
    200: unknown;
};

export type RestrictedAuthzRolesUpdateRoleData = {
    body: RoleCreateUpdate;
    path: {
        /**
         * Role Id
         */
        role_id: string;
    };
    query?: never;
    url: '/restricted/authz/roles/{role_id}';
};

export type RestrictedAuthzRolesUpdateRoleErrors = {
    /**
     * Not found
     */
    404: unknown;
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type RestrictedAuthzRolesUpdateRoleError = RestrictedAuthzRolesUpdateRoleErrors[keyof RestrictedAuthzRolesUpdateRoleErrors];

export type RestrictedAuthzRolesUpdateRoleResponses = {
    /**
     * Successful Response
     */
    200: Role;
};

export type RestrictedAuthzRolesUpdateRoleResponse = RestrictedAuthzRolesUpdateRoleResponses[keyof RestrictedAuthzRolesUpdateRoleResponses];

export type RestrictedAuthzPermissionsDeletePermissionData = {
    body?: never;
    path: {
        /**
         * Permission Id
         */
        permission_id: string;
    };
    query?: never;
    url: '/restricted/authz/permissions/{permission_id}';
};

export type RestrictedAuthzPermissionsDeletePermissionErrors = {
    /**
     * Not found
     */
    404: unknown;
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type RestrictedAuthzPermissionsDeletePermissionError = RestrictedAuthzPermissionsDeletePermissionErrors[keyof RestrictedAuthzPermissionsDeletePermissionErrors];

export type RestrictedAuthzPermissionsDeletePermissionResponses = {
    /**
     * Successful Response
     */
    200: unknown;
};

export type RestrictedAuthzPermissionsUpdatePermissionData = {
    body: PermissionCreateUpdate;
    path: {
        /**
         * Permission Id
         */
        permission_id: string;
    };
    query?: never;
    url: '/restricted/authz/permissions/{permission_id}';
};

export type RestrictedAuthzPermissionsUpdatePermissionErrors = {
    /**
     * Not found
     */
    404: unknown;
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type RestrictedAuthzPermissionsUpdatePermissionError = RestrictedAuthzPermissionsUpdatePermissionErrors[keyof RestrictedAuthzPermissionsUpdatePermissionErrors];

export type RestrictedAuthzPermissionsUpdatePermissionResponses = {
    /**
     * Successful Response
     */
    200: Permission;
};

export type RestrictedAuthzPermissionsUpdatePermissionResponse = RestrictedAuthzPermissionsUpdatePermissionResponses[keyof RestrictedAuthzPermissionsUpdatePermissionResponses];

export type RestrictedAccountsListAccountsData = {
    body?: never;
    path?: never;
    query?: never;
    url: '/restricted/accounts';
};

export type RestrictedAccountsListAccountsErrors = {
    /**
     * Not found
     */
    404: unknown;
};

export type RestrictedAccountsListAccountsResponses = {
    /**
     * Response Restricted-Accounts-List Accounts
     *
     * Successful Response
     */
    200: Array<Account>;
};

export type RestrictedAccountsListAccountsResponse = RestrictedAccountsListAccountsResponses[keyof RestrictedAccountsListAccountsResponses];

export type RestrictedAccountsOrgsListAccountOrgsData = {
    body?: never;
    path: {
        /**
         * Account Id
         */
        account_id: string;
    };
    query?: never;
    url: '/restricted/accounts/{account_id}/orgs';
};

export type RestrictedAccountsOrgsListAccountOrgsErrors = {
    /**
     * Not found
     */
    404: unknown;
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type RestrictedAccountsOrgsListAccountOrgsError = RestrictedAccountsOrgsListAccountOrgsErrors[keyof RestrictedAccountsOrgsListAccountOrgsErrors];

export type RestrictedAccountsOrgsListAccountOrgsResponses = {
    /**
     * Response Restricted-Accounts-Orgs-List Account Orgs
     *
     * Successful Response
     */
    200: Array<OrgRef>;
};

export type RestrictedAccountsOrgsListAccountOrgsResponse = RestrictedAccountsOrgsListAccountOrgsResponses[keyof RestrictedAccountsOrgsListAccountOrgsResponses];

export type RestrictedAccountsUsersListAccountUsersData = {
    body?: never;
    path: {
        /**
         * Account Id
         */
        account_id: string;
    };
    query?: never;
    url: '/restricted/accounts/{account_id}/users';
};

export type RestrictedAccountsUsersListAccountUsersErrors = {
    /**
     * Not found
     */
    404: unknown;
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type RestrictedAccountsUsersListAccountUsersError = RestrictedAccountsUsersListAccountUsersErrors[keyof RestrictedAccountsUsersListAccountUsersErrors];

export type RestrictedAccountsUsersListAccountUsersResponses = {
    /**
     * Response Restricted-Accounts-Users-List Account Users
     *
     * Successful Response
     */
    200: Array<UserRef>;
};

export type RestrictedAccountsUsersListAccountUsersResponse = RestrictedAccountsUsersListAccountUsersResponses[keyof RestrictedAccountsUsersListAccountUsersResponses];

export type RestrictedAccountsUpdateAccountData = {
    body: AccountUpdate;
    path: {
        /**
         * Account Id
         */
        account_id: string;
    };
    query?: never;
    url: '/restricted/accounts/{account_id}';
};

export type RestrictedAccountsUpdateAccountErrors = {
    /**
     * Not found
     */
    404: unknown;
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type RestrictedAccountsUpdateAccountError = RestrictedAccountsUpdateAccountErrors[keyof RestrictedAccountsUpdateAccountErrors];

export type RestrictedAccountsUpdateAccountResponses = {
    /**
     * Successful Response
     */
    200: Account;
};

export type RestrictedAccountsUpdateAccountResponse = RestrictedAccountsUpdateAccountResponses[keyof RestrictedAccountsUpdateAccountResponses];

export type RestrictedOrgsGetOrgData = {
    body?: never;
    path: {
        /**
         * Org Id
         */
        org_id: string;
    };
    query?: never;
    url: '/restricted/orgs/{org_id}';
};

export type RestrictedOrgsGetOrgErrors = {
    /**
     * Not found
     */
    404: unknown;
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type RestrictedOrgsGetOrgError = RestrictedOrgsGetOrgErrors[keyof RestrictedOrgsGetOrgErrors];

export type RestrictedOrgsGetOrgResponses = {
    /**
     * Successful Response
     */
    200: OrgDetails;
};

export type RestrictedOrgsGetOrgResponse = RestrictedOrgsGetOrgResponses[keyof RestrictedOrgsGetOrgResponses];

export type RestrictedOrgsUpdateOrgData = {
    body: OrgUpdate;
    path: {
        /**
         * Org Id
         */
        org_id: string;
    };
    query?: never;
    url: '/restricted/orgs/{org_id}';
};

export type RestrictedOrgsUpdateOrgErrors = {
    /**
     * Not found
     */
    404: unknown;
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type RestrictedOrgsUpdateOrgError = RestrictedOrgsUpdateOrgErrors[keyof RestrictedOrgsUpdateOrgErrors];

export type RestrictedOrgsUpdateOrgResponses = {
    /**
     * Successful Response
     */
    200: OrgDetails;
};

export type RestrictedOrgsUpdateOrgResponse = RestrictedOrgsUpdateOrgResponses[keyof RestrictedOrgsUpdateOrgResponses];

export type RestrictedVendorsCreateVendorData = {
    body: VendorCreate;
    path?: never;
    query?: never;
    url: '/restricted/vendors';
};

export type RestrictedVendorsCreateVendorErrors = {
    /**
     * Not found
     */
    404: unknown;
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type RestrictedVendorsCreateVendorError = RestrictedVendorsCreateVendorErrors[keyof RestrictedVendorsCreateVendorErrors];

export type RestrictedVendorsCreateVendorResponses = {
    /**
     * Successful Response
     */
    200: Vendor;
};

export type RestrictedVendorsCreateVendorResponse = RestrictedVendorsCreateVendorResponses[keyof RestrictedVendorsCreateVendorResponses];

export type RestrictedVendorsUpdateVendorData = {
    body: VendorUpdate;
    path: {
        /**
         * Vendor Id
         */
        vendor_id: string;
    };
    query?: never;
    url: '/restricted/vendors/{vendor_id}';
};

export type RestrictedVendorsUpdateVendorErrors = {
    /**
     * Not found
     */
    404: unknown;
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type RestrictedVendorsUpdateVendorError = RestrictedVendorsUpdateVendorErrors[keyof RestrictedVendorsUpdateVendorErrors];

export type RestrictedVendorsUpdateVendorResponses = {
    /**
     * Successful Response
     */
    200: Vendor;
};

export type RestrictedVendorsUpdateVendorResponse = RestrictedVendorsUpdateVendorResponses[keyof RestrictedVendorsUpdateVendorResponses];

export type RestrictedPackageListPackagesData = {
    body?: never;
    path?: never;
    query?: never;
    url: '/restricted/package';
};

export type RestrictedPackageListPackagesErrors = {
    /**
     * Not found
     */
    404: unknown;
};

export type RestrictedPackageListPackagesResponses = {
    /**
     * Response Restricted-Package-List Packages
     *
     * Successful Response
     */
    200: Array<EntitlementPackage>;
};

export type RestrictedPackageListPackagesResponse = RestrictedPackageListPackagesResponses[keyof RestrictedPackageListPackagesResponses];

export type UserMeGetData = {
    body?: never;
    path?: never;
    query?: never;
    url: '/user/me';
};

export type UserMeGetErrors = {
    /**
     * Not found
     */
    404: unknown;
};

export type UserMeGetResponses = {
    /**
     * Successful Response
     */
    200: UserPrivate;
};

export type UserMeGetResponse = UserMeGetResponses[keyof UserMeGetResponses];

export type UserImageGetUserImageData = {
    body?: never;
    path: {
        /**
         * User Id
         */
        user_id: string;
    };
    query?: never;
    url: '/user/{user_id}/image';
};

export type UserImageGetUserImageErrors = {
    /**
     * Not found
     */
    404: unknown;
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type UserImageGetUserImageError = UserImageGetUserImageErrors[keyof UserImageGetUserImageErrors];

export type UserImageGetUserImageResponses = {
    /**
     * Successful Response
     */
    200: unknown;
};

export type UserNotificationBulkDeleteUserNotificationsData = {
    body?: never;
    path?: never;
    query?: {
        /**
         * Read Only
         *
         * Only delete read notifications
         */
        read_only?: boolean;
    };
    url: '/user/notification/';
};

export type UserNotificationBulkDeleteUserNotificationsErrors = {
    /**
     * Not found
     */
    404: unknown;
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type UserNotificationBulkDeleteUserNotificationsError = UserNotificationBulkDeleteUserNotificationsErrors[keyof UserNotificationBulkDeleteUserNotificationsErrors];

export type UserNotificationBulkDeleteUserNotificationsResponses = {
    /**
     * Successful Response
     */
    200: unknown;
};

export type UserNotificationListUserNotificationsData = {
    body?: never;
    path?: never;
    query?: {
        /**
         * Include Cleared
         *
         * Include cleared notifications
         */
        include_cleared?: boolean;
        /**
         * Include Read
         *
         * Include read notifications
         */
        include_read?: boolean;
        /**
         * Limit
         *
         * Maximum number of results
         */
        limit?: number;
        /**
         * Offset
         *
         * Offset for pagination
         */
        offset?: number;
    };
    url: '/user/notification/';
};

export type UserNotificationListUserNotificationsErrors = {
    /**
     * Not found
     */
    404: unknown;
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type UserNotificationListUserNotificationsError = UserNotificationListUserNotificationsErrors[keyof UserNotificationListUserNotificationsErrors];

export type UserNotificationListUserNotificationsResponses = {
    /**
     * Response User-Notification--List User Notifications
     *
     * Successful Response
     */
    200: Array<NotificationSummary>;
};

export type UserNotificationListUserNotificationsResponse = UserNotificationListUserNotificationsResponses[keyof UserNotificationListUserNotificationsResponses];

export type UserNotificationStatsGetUserNotificationStatsData = {
    body?: never;
    path?: never;
    query?: never;
    url: '/user/notification/stats';
};

export type UserNotificationStatsGetUserNotificationStatsErrors = {
    /**
     * Not found
     */
    404: unknown;
};

export type UserNotificationStatsGetUserNotificationStatsResponses = {
    /**
     * Successful Response
     */
    200: NotificationStats;
};

export type UserNotificationStatsGetUserNotificationStatsResponse = UserNotificationStatsGetUserNotificationStatsResponses[keyof UserNotificationStatsGetUserNotificationStatsResponses];

export type UserNotificationDeleteUserNotificationData = {
    body?: never;
    path: {
        /**
         * Notification Id
         */
        notification_id: string;
    };
    query?: never;
    url: '/user/notification/{notification_id}';
};

export type UserNotificationDeleteUserNotificationErrors = {
    /**
     * Not found
     */
    404: unknown;
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type UserNotificationDeleteUserNotificationError = UserNotificationDeleteUserNotificationErrors[keyof UserNotificationDeleteUserNotificationErrors];

export type UserNotificationDeleteUserNotificationResponses = {
    /**
     * Successful Response
     */
    200: unknown;
};

export type UserNotificationGetUserNotificationData = {
    body?: never;
    path: {
        /**
         * Notification Id
         */
        notification_id: string;
    };
    query?: never;
    url: '/user/notification/{notification_id}';
};

export type UserNotificationGetUserNotificationErrors = {
    /**
     * Not found
     */
    404: unknown;
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type UserNotificationGetUserNotificationError = UserNotificationGetUserNotificationErrors[keyof UserNotificationGetUserNotificationErrors];

export type UserNotificationGetUserNotificationResponses = {
    /**
     * Successful Response
     */
    200: Notification;
};

export type UserNotificationGetUserNotificationResponse = UserNotificationGetUserNotificationResponses[keyof UserNotificationGetUserNotificationResponses];

export type UserNotificationUpdateUserNotificationData = {
    body: NotificationUpdate;
    path: {
        /**
         * Notification Id
         */
        notification_id: string;
    };
    query?: never;
    url: '/user/notification/{notification_id}';
};

export type UserNotificationUpdateUserNotificationErrors = {
    /**
     * Not found
     */
    404: unknown;
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type UserNotificationUpdateUserNotificationError = UserNotificationUpdateUserNotificationErrors[keyof UserNotificationUpdateUserNotificationErrors];

export type UserNotificationUpdateUserNotificationResponses = {
    /**
     * Successful Response
     */
    200: Notification;
};

export type UserNotificationUpdateUserNotificationResponse = UserNotificationUpdateUserNotificationResponses[keyof UserNotificationUpdateUserNotificationResponses];

export type VendorListData = {
    body?: never;
    path?: never;
    query?: never;
    url: '/vendor/';
};

export type VendorListErrors = {
    /**
     * Not found
     */
    404: unknown;
};

export type VendorListResponses = {
    /**
     * Response Vendor--List
     *
     * Successful Response
     */
    200: Array<Vendor>;
};

export type VendorListResponse = VendorListResponses[keyof VendorListResponses];

export type VendorImageGetImageData = {
    body?: never;
    path: {
        /**
         * Vendor Id
         */
        vendor_id: string;
    };
    query?: never;
    url: '/vendor/{vendor_id}/image';
};

export type VendorImageGetImageErrors = {
    /**
     * Not found
     */
    404: unknown;
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type VendorImageGetImageError = VendorImageGetImageErrors[keyof VendorImageGetImageErrors];

export type VendorImageGetImageResponses = {
    /**
     * Successful Response
     */
    200: unknown;
};

export type OrgAccountUserListUsersData = {
    body?: never;
    path: {
        /**
         * Account Id
         */
        account_id: string;
        /**
         * Org Id
         */
        org_id: string;
    };
    query?: {
        /**
         * Detailed
         */
        detailed?: boolean;
    };
    url: '/org/{org_id}/account/{account_id}/user';
};

export type OrgAccountUserListUsersErrors = {
    /**
     * Not found
     */
    404: unknown;
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type OrgAccountUserListUsersError = OrgAccountUserListUsersErrors[keyof OrgAccountUserListUsersErrors];

export type OrgAccountUserListUsersResponses = {
    /**
     * Response Org-Account-User-List Users
     *
     * Successful Response
     */
    200: Array<UserRef> | Array<UserDetails>;
};

export type OrgAccountUserListUsersResponse = OrgAccountUserListUsersResponses[keyof OrgAccountUserListUsersResponses];

export type OrgAccountDeleteData = {
    body?: never;
    path: {
        /**
         * Account Id
         */
        account_id: string;
        /**
         * Org Id
         */
        org_id: string;
    };
    query?: {
        /**
         * Hard
         */
        hard?: boolean;
    };
    url: '/org/{org_id}/account/{account_id}/';
};

export type OrgAccountDeleteErrors = {
    /**
     * Not found
     */
    404: unknown;
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type OrgAccountDeleteError = OrgAccountDeleteErrors[keyof OrgAccountDeleteErrors];

export type OrgAccountDeleteResponses = {
    /**
     * Successful Response
     */
    200: unknown;
};

export type OrgAccountUpdateData = {
    body: AccountUpdate;
    path: {
        /**
         * Account Id
         */
        account_id: string;
        /**
         * Org Id
         */
        org_id: string;
    };
    query?: never;
    url: '/org/{org_id}/account/{account_id}/';
};

export type OrgAccountUpdateErrors = {
    /**
     * Not found
     */
    404: unknown;
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type OrgAccountUpdateError = OrgAccountUpdateErrors[keyof OrgAccountUpdateErrors];

export type OrgAccountUpdateResponses = {
    /**
     * Successful Response
     */
    200: Account;
};

export type OrgAccountUpdateResponse = OrgAccountUpdateResponses[keyof OrgAccountUpdateResponses];

export type OrgAccountImageGetImageData = {
    body?: never;
    path: {
        /**
         * Account Id
         */
        account_id: string;
        /**
         * Org Id
         */
        org_id: string;
    };
    query?: never;
    url: '/org/{org_id}/account/{account_id}/image';
};

export type OrgAccountImageGetImageErrors = {
    /**
     * Not found
     */
    404: unknown;
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type OrgAccountImageGetImageError = OrgAccountImageGetImageErrors[keyof OrgAccountImageGetImageErrors];

export type OrgAccountImageGetImageResponses = {
    /**
     * Successful Response
     */
    200: unknown;
};

export type OrgAccountImageUpdateImageData = {
    body: BodyOrgAccountImageUpdateImage;
    path: {
        /**
         * Org Id
         */
        org_id: string;
    };
    query?: never;
    url: '/org/{org_id}/account/{account_id}/image';
};

export type OrgAccountImageUpdateImageErrors = {
    /**
     * Not found
     */
    404: unknown;
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type OrgAccountImageUpdateImageError = OrgAccountImageUpdateImageErrors[keyof OrgAccountImageUpdateImageErrors];

export type OrgAccountImageUpdateImageResponses = {
    /**
     * Successful Response
     */
    200: unknown;
};

export type OrgAlertBulkDeleteOrgAlertsData = {
    body?: never;
    path: {
        /**
         * Org Id
         */
        org_id: string;
    };
    query?: never;
    url: '/org/{org_id}/alert/';
};

export type OrgAlertBulkDeleteOrgAlertsErrors = {
    /**
     * Not found
     */
    404: unknown;
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type OrgAlertBulkDeleteOrgAlertsError = OrgAlertBulkDeleteOrgAlertsErrors[keyof OrgAlertBulkDeleteOrgAlertsErrors];

export type OrgAlertBulkDeleteOrgAlertsResponses = {
    /**
     * Successful Response
     */
    200: unknown;
};

export type OrgAlertListOrgAlertsData = {
    body?: never;
    path: {
        /**
         * Org Id
         */
        org_id: string;
    };
    query?: {
        /**
         * Include Cleared
         *
         * Include cleared alerts
         */
        include_cleared?: boolean;
        /**
         * Limit
         *
         * Maximum number of results
         */
        limit?: number;
        /**
         * Offset
         *
         * Offset for pagination
         */
        offset?: number;
    };
    url: '/org/{org_id}/alert/';
};

export type OrgAlertListOrgAlertsErrors = {
    /**
     * Not found
     */
    404: unknown;
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type OrgAlertListOrgAlertsError = OrgAlertListOrgAlertsErrors[keyof OrgAlertListOrgAlertsErrors];

export type OrgAlertListOrgAlertsResponses = {
    /**
     * Response Org-Alert--List Org Alerts
     *
     * Successful Response
     */
    200: Array<AlertSummary>;
};

export type OrgAlertListOrgAlertsResponse = OrgAlertListOrgAlertsResponses[keyof OrgAlertListOrgAlertsResponses];

export type OrgAlertStatsGetOrgAlertStatsData = {
    body?: never;
    path: {
        /**
         * Org Id
         */
        org_id: string;
    };
    query?: never;
    url: '/org/{org_id}/alert/stats';
};

export type OrgAlertStatsGetOrgAlertStatsErrors = {
    /**
     * Not found
     */
    404: unknown;
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type OrgAlertStatsGetOrgAlertStatsError = OrgAlertStatsGetOrgAlertStatsErrors[keyof OrgAlertStatsGetOrgAlertStatsErrors];

export type OrgAlertStatsGetOrgAlertStatsResponses = {
    /**
     * Successful Response
     */
    200: AlertStats;
};

export type OrgAlertStatsGetOrgAlertStatsResponse = OrgAlertStatsGetOrgAlertStatsResponses[keyof OrgAlertStatsGetOrgAlertStatsResponses];

export type OrgAlertDeleteOrgAlertData = {
    body?: never;
    path: {
        /**
         * Alert Id
         */
        alert_id: string;
        /**
         * Org Id
         */
        org_id: string;
    };
    query?: never;
    url: '/org/{org_id}/alert/{alert_id}';
};

export type OrgAlertDeleteOrgAlertErrors = {
    /**
     * Not found
     */
    404: unknown;
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type OrgAlertDeleteOrgAlertError = OrgAlertDeleteOrgAlertErrors[keyof OrgAlertDeleteOrgAlertErrors];

export type OrgAlertDeleteOrgAlertResponses = {
    /**
     * Successful Response
     */
    200: unknown;
};

export type OrgAlertGetOrgAlertData = {
    body?: never;
    path: {
        /**
         * Alert Id
         */
        alert_id: string;
        /**
         * Org Id
         */
        org_id: string;
    };
    query?: never;
    url: '/org/{org_id}/alert/{alert_id}';
};

export type OrgAlertGetOrgAlertErrors = {
    /**
     * Not found
     */
    404: unknown;
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type OrgAlertGetOrgAlertError = OrgAlertGetOrgAlertErrors[keyof OrgAlertGetOrgAlertErrors];

export type OrgAlertGetOrgAlertResponses = {
    /**
     * Successful Response
     */
    200: Alert;
};

export type OrgAlertGetOrgAlertResponse = OrgAlertGetOrgAlertResponses[keyof OrgAlertGetOrgAlertResponses];

export type OrgAlertUpdateOrgAlertData = {
    body: AlertUpdate;
    path: {
        /**
         * Alert Id
         */
        alert_id: string;
        /**
         * Org Id
         */
        org_id: string;
    };
    query?: never;
    url: '/org/{org_id}/alert/{alert_id}';
};

export type OrgAlertUpdateOrgAlertErrors = {
    /**
     * Not found
     */
    404: unknown;
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type OrgAlertUpdateOrgAlertError = OrgAlertUpdateOrgAlertErrors[keyof OrgAlertUpdateOrgAlertErrors];

export type OrgAlertUpdateOrgAlertResponses = {
    /**
     * Successful Response
     */
    200: Alert;
};

export type OrgAlertUpdateOrgAlertResponse = OrgAlertUpdateOrgAlertResponses[keyof OrgAlertUpdateOrgAlertResponses];

export type OrgBillingAccountBillingAccountListData = {
    body?: never;
    path: {
        /**
         * Org Id
         */
        org_id: string;
    };
    query?: never;
    url: '/org/{org_id}/billing_account/';
};

export type OrgBillingAccountBillingAccountListErrors = {
    /**
     * Not found
     */
    404: unknown;
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type OrgBillingAccountBillingAccountListError = OrgBillingAccountBillingAccountListErrors[keyof OrgBillingAccountBillingAccountListErrors];

export type OrgBillingAccountBillingAccountListResponses = {
    /**
     * Response Org-Billing Account--Billing Account List
     *
     * Successful Response
     */
    200: Array<VendorBillingAccountRef>;
};

export type OrgBillingAccountBillingAccountListResponse = OrgBillingAccountBillingAccountListResponses[keyof OrgBillingAccountBillingAccountListResponses];

export type OrgBillingAccountGetData = {
    body?: never;
    path: {
        /**
         * Billing Account Id
         */
        billing_account_id: string;
        /**
         * Org Id
         */
        org_id: string;
    };
    query?: never;
    url: '/org/{org_id}/billing_account/{billing_account_id}';
};

export type OrgBillingAccountGetErrors = {
    /**
     * Not found
     */
    404: unknown;
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type OrgBillingAccountGetError = OrgBillingAccountGetErrors[keyof OrgBillingAccountGetErrors];

export type OrgBillingAccountGetResponses = {
    /**
     * Successful Response
     */
    200: VendorBillingAccount;
};

export type OrgBillingAccountGetResponse = OrgBillingAccountGetResponses[keyof OrgBillingAccountGetResponses];

export type OrgBillingAccountBalanceGetBalanceData = {
    body?: never;
    path: {
        /**
         * Billing Account Id
         */
        billing_account_id: string;
        /**
         * Org Id
         */
        org_id: string;
    };
    query?: never;
    url: '/org/{org_id}/billing_account/{billing_account_id}/balance';
};

export type OrgBillingAccountBalanceGetBalanceErrors = {
    /**
     * Not found
     */
    404: unknown;
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type OrgBillingAccountBalanceGetBalanceError = OrgBillingAccountBalanceGetBalanceErrors[keyof OrgBillingAccountBalanceGetBalanceErrors];

export type OrgBillingAccountBalanceGetBalanceResponses = {
    /**
     * Successful Response
     */
    200: AccountBalance;
};

export type OrgBillingAccountBalanceGetBalanceResponse = OrgBillingAccountBalanceGetBalanceResponses[keyof OrgBillingAccountBalanceGetBalanceResponses];

export type OrgBillingAccountServiceAccountServiceAccountListData = {
    body?: never;
    path: {
        /**
         * Billing Account Id
         */
        billing_account_id: string;
        /**
         * Org Id
         */
        org_id: string;
    };
    query?: never;
    url: '/org/{org_id}/billing_account/{billing_account_id}/service_account';
};

export type OrgBillingAccountServiceAccountServiceAccountListErrors = {
    /**
     * Not found
     */
    404: unknown;
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type OrgBillingAccountServiceAccountServiceAccountListError = OrgBillingAccountServiceAccountServiceAccountListErrors[keyof OrgBillingAccountServiceAccountServiceAccountListErrors];

export type OrgBillingAccountServiceAccountServiceAccountListResponses = {
    /**
     * Response Org-Billing Account-Service Account-Service Account List
     *
     * Successful Response
     */
    200: Array<VendorServiceAccountRef>;
};

export type OrgBillingAccountServiceAccountServiceAccountListResponse = OrgBillingAccountServiceAccountServiceAccountListResponses[keyof OrgBillingAccountServiceAccountServiceAccountListResponses];

export type OrgCommodityReferenceListReferenceCommoditiesData = {
    body?: never;
    path: {
        /**
         * Org Id
         */
        org_id: string;
    };
    query?: never;
    url: '/org/{org_id}/commodity/reference';
};

export type OrgCommodityReferenceListReferenceCommoditiesErrors = {
    /**
     * Not found
     */
    404: unknown;
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type OrgCommodityReferenceListReferenceCommoditiesError = OrgCommodityReferenceListReferenceCommoditiesErrors[keyof OrgCommodityReferenceListReferenceCommoditiesErrors];

export type OrgCommodityReferenceListReferenceCommoditiesResponses = {
    /**
     * Response Org-Commodity-Reference-List Reference Commodities
     *
     * Successful Response
     */
    200: Array<CommodityRef>;
};

export type OrgCommodityReferenceListReferenceCommoditiesResponse = OrgCommodityReferenceListReferenceCommoditiesResponses[keyof OrgCommodityReferenceListReferenceCommoditiesResponses];

export type OrgCommodityListOrgCommoditiesData = {
    body?: never;
    path: {
        /**
         * Org Id
         */
        org_id: string;
    };
    query?: never;
    url: '/org/{org_id}/commodity/';
};

export type OrgCommodityListOrgCommoditiesErrors = {
    /**
     * Not found
     */
    404: unknown;
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type OrgCommodityListOrgCommoditiesError = OrgCommodityListOrgCommoditiesErrors[keyof OrgCommodityListOrgCommoditiesErrors];

export type OrgCommodityListOrgCommoditiesResponses = {
    /**
     * Response Org-Commodity--List Org Commodities
     *
     * Successful Response
     */
    200: Array<OrgCommodity>;
};

export type OrgCommodityListOrgCommoditiesResponse = OrgCommodityListOrgCommoditiesResponses[keyof OrgCommodityListOrgCommoditiesResponses];

export type OrgCommodityCreateOrgCommodityData = {
    body: OrgCommodityCreate;
    path: {
        /**
         * Org Id
         */
        org_id: string;
    };
    query?: never;
    url: '/org/{org_id}/commodity/';
};

export type OrgCommodityCreateOrgCommodityErrors = {
    /**
     * Not found
     */
    404: unknown;
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type OrgCommodityCreateOrgCommodityError = OrgCommodityCreateOrgCommodityErrors[keyof OrgCommodityCreateOrgCommodityErrors];

export type OrgCommodityCreateOrgCommodityResponses = {
    /**
     * Successful Response
     */
    200: OrgCommodity;
};

export type OrgCommodityCreateOrgCommodityResponse = OrgCommodityCreateOrgCommodityResponses[keyof OrgCommodityCreateOrgCommodityResponses];

export type OrgCommodityDeleteOrgCommodityData = {
    body?: never;
    path: {
        /**
         * Commodity Id
         */
        commodity_id: string;
        /**
         * Org Id
         */
        org_id: string;
    };
    query?: never;
    url: '/org/{org_id}/commodity/{commodity_id}';
};

export type OrgCommodityDeleteOrgCommodityErrors = {
    /**
     * Not found
     */
    404: unknown;
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type OrgCommodityDeleteOrgCommodityError = OrgCommodityDeleteOrgCommodityErrors[keyof OrgCommodityDeleteOrgCommodityErrors];

export type OrgCommodityDeleteOrgCommodityResponses = {
    /**
     * Response Org-Commodity-Delete Org Commodity
     *
     * Successful Response
     */
    200: {
        [key: string]: string;
    };
};

export type OrgCommodityDeleteOrgCommodityResponse = OrgCommodityDeleteOrgCommodityResponses[keyof OrgCommodityDeleteOrgCommodityResponses];

export type OrgCommodityUpdateOrgCommodityData = {
    body: OrgCommodityUpdate;
    path: {
        /**
         * Commodity Id
         */
        commodity_id: string;
        /**
         * Org Id
         */
        org_id: string;
    };
    query?: never;
    url: '/org/{org_id}/commodity/{commodity_id}';
};

export type OrgCommodityUpdateOrgCommodityErrors = {
    /**
     * Not found
     */
    404: unknown;
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type OrgCommodityUpdateOrgCommodityError = OrgCommodityUpdateOrgCommodityErrors[keyof OrgCommodityUpdateOrgCommodityErrors];

export type OrgCommodityUpdateOrgCommodityResponses = {
    /**
     * Successful Response
     */
    200: OrgCommodity;
};

export type OrgCommodityUpdateOrgCommodityResponse = OrgCommodityUpdateOrgCommodityResponses[keyof OrgCommodityUpdateOrgCommodityResponses];

export type OrgComplianceTrackingListOrgTrackingData = {
    body?: never;
    path: {
        /**
         * Org Id
         */
        org_id: string;
    };
    query?: {
        /**
         * Include Inactive
         */
        include_inactive?: boolean;
    };
    url: '/org/{org_id}/compliance/tracking';
};

export type OrgComplianceTrackingListOrgTrackingErrors = {
    /**
     * Not found
     */
    404: unknown;
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type OrgComplianceTrackingListOrgTrackingError = OrgComplianceTrackingListOrgTrackingErrors[keyof OrgComplianceTrackingListOrgTrackingErrors];

export type OrgComplianceTrackingListOrgTrackingResponses = {
    /**
     * Response Org-Compliance-Tracking-List Org Tracking
     *
     * Successful Response
     */
    200: Array<TrackingResponse>;
};

export type OrgComplianceTrackingListOrgTrackingResponse = OrgComplianceTrackingListOrgTrackingResponses[keyof OrgComplianceTrackingListOrgTrackingResponses];

export type OrgComplianceTrackingCreateNewTrackingData = {
    body: PropertyTrackingCreate;
    path: {
        /**
         * Org Id
         */
        org_id: string;
    };
    query?: never;
    url: '/org/{org_id}/compliance/tracking';
};

export type OrgComplianceTrackingCreateNewTrackingErrors = {
    /**
     * Not found
     */
    404: unknown;
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type OrgComplianceTrackingCreateNewTrackingError = OrgComplianceTrackingCreateNewTrackingErrors[keyof OrgComplianceTrackingCreateNewTrackingErrors];

export type OrgComplianceTrackingCreateNewTrackingResponses = {
    /**
     * Successful Response
     */
    200: TrackingResponse;
};

export type OrgComplianceTrackingCreateNewTrackingResponse = OrgComplianceTrackingCreateNewTrackingResponses[keyof OrgComplianceTrackingCreateNewTrackingResponses];

export type OrgComplianceTrackingPropertyListTrackingForPropertyData = {
    body?: never;
    path: {
        /**
         * Property Id
         */
        property_id: string;
        /**
         * Org Id
         */
        org_id: string;
    };
    query?: {
        /**
         * Include Inactive
         */
        include_inactive?: boolean;
    };
    url: '/org/{org_id}/compliance/tracking/property/{property_id}';
};

export type OrgComplianceTrackingPropertyListTrackingForPropertyErrors = {
    /**
     * Not found
     */
    404: unknown;
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type OrgComplianceTrackingPropertyListTrackingForPropertyError = OrgComplianceTrackingPropertyListTrackingForPropertyErrors[keyof OrgComplianceTrackingPropertyListTrackingForPropertyErrors];

export type OrgComplianceTrackingPropertyListTrackingForPropertyResponses = {
    /**
     * Response Org-Compliance-Tracking-Property-List Tracking For Property
     *
     * Successful Response
     */
    200: Array<TrackingResponse>;
};

export type OrgComplianceTrackingPropertyListTrackingForPropertyResponse = OrgComplianceTrackingPropertyListTrackingForPropertyResponses[keyof OrgComplianceTrackingPropertyListTrackingForPropertyResponses];

export type OrgComplianceTrackingGetTrackingDetailsData = {
    body?: never;
    path: {
        /**
         * Tracking Id
         */
        tracking_id: string;
        /**
         * Org Id
         */
        org_id: string;
    };
    query?: never;
    url: '/org/{org_id}/compliance/tracking/{tracking_id}';
};

export type OrgComplianceTrackingGetTrackingDetailsErrors = {
    /**
     * Not found
     */
    404: unknown;
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type OrgComplianceTrackingGetTrackingDetailsError = OrgComplianceTrackingGetTrackingDetailsErrors[keyof OrgComplianceTrackingGetTrackingDetailsErrors];

export type OrgComplianceTrackingGetTrackingDetailsResponses = {
    /**
     * Successful Response
     */
    200: TrackingResponse;
};

export type OrgComplianceTrackingGetTrackingDetailsResponse = OrgComplianceTrackingGetTrackingDetailsResponses[keyof OrgComplianceTrackingGetTrackingDetailsResponses];

export type OrgComplianceTrackingUpdateTrackingDetailsData = {
    body: PropertyTrackingUpdate;
    path: {
        /**
         * Tracking Id
         */
        tracking_id: string;
        /**
         * Org Id
         */
        org_id: string;
    };
    query?: never;
    url: '/org/{org_id}/compliance/tracking/{tracking_id}';
};

export type OrgComplianceTrackingUpdateTrackingDetailsErrors = {
    /**
     * Not found
     */
    404: unknown;
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type OrgComplianceTrackingUpdateTrackingDetailsError = OrgComplianceTrackingUpdateTrackingDetailsErrors[keyof OrgComplianceTrackingUpdateTrackingDetailsErrors];

export type OrgComplianceTrackingUpdateTrackingDetailsResponses = {
    /**
     * Successful Response
     */
    200: TrackingResponse;
};

export type OrgComplianceTrackingUpdateTrackingDetailsResponse = OrgComplianceTrackingUpdateTrackingDetailsResponses[keyof OrgComplianceTrackingUpdateTrackingDetailsResponses];

export type OrgComplianceTrackingAcknowledgeAcknowledgeTrackingData = {
    body?: never;
    path: {
        /**
         * Tracking Id
         */
        tracking_id: string;
        /**
         * Org Id
         */
        org_id: string;
    };
    query?: never;
    url: '/org/{org_id}/compliance/tracking/{tracking_id}/acknowledge';
};

export type OrgComplianceTrackingAcknowledgeAcknowledgeTrackingErrors = {
    /**
     * Not found
     */
    404: unknown;
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type OrgComplianceTrackingAcknowledgeAcknowledgeTrackingError = OrgComplianceTrackingAcknowledgeAcknowledgeTrackingErrors[keyof OrgComplianceTrackingAcknowledgeAcknowledgeTrackingErrors];

export type OrgComplianceTrackingAcknowledgeAcknowledgeTrackingResponses = {
    /**
     * Successful Response
     */
    200: TrackingResponse;
};

export type OrgComplianceTrackingAcknowledgeAcknowledgeTrackingResponse = OrgComplianceTrackingAcknowledgeAcknowledgeTrackingResponses[keyof OrgComplianceTrackingAcknowledgeAcknowledgeTrackingResponses];

export type OrgComplianceTrackingGenerateTasksGenerateTasksData = {
    body?: never;
    path: {
        /**
         * Tracking Id
         */
        tracking_id: string;
        /**
         * Org Id
         */
        org_id: string;
    };
    query?: never;
    url: '/org/{org_id}/compliance/tracking/{tracking_id}/generate-tasks';
};

export type OrgComplianceTrackingGenerateTasksGenerateTasksErrors = {
    /**
     * Not found
     */
    404: unknown;
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type OrgComplianceTrackingGenerateTasksGenerateTasksError = OrgComplianceTrackingGenerateTasksGenerateTasksErrors[keyof OrgComplianceTrackingGenerateTasksGenerateTasksErrors];

export type OrgComplianceTrackingGenerateTasksGenerateTasksResponses = {
    /**
     * Response Org-Compliance-Tracking-Generate-Tasks-Generate Tasks
     *
     * Successful Response
     */
    200: Array<TaskResponse>;
};

export type OrgComplianceTrackingGenerateTasksGenerateTasksResponse = OrgComplianceTrackingGenerateTasksGenerateTasksResponses[keyof OrgComplianceTrackingGenerateTasksGenerateTasksResponses];

export type OrgComplianceTasksListOrgTasksData = {
    body?: never;
    path: {
        /**
         * Org Id
         */
        org_id: string;
    };
    query?: {
        /**
         * Include Deleted
         */
        include_deleted?: boolean;
    };
    url: '/org/{org_id}/compliance/tasks';
};

export type OrgComplianceTasksListOrgTasksErrors = {
    /**
     * Not found
     */
    404: unknown;
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type OrgComplianceTasksListOrgTasksError = OrgComplianceTasksListOrgTasksErrors[keyof OrgComplianceTasksListOrgTasksErrors];

export type OrgComplianceTasksListOrgTasksResponses = {
    /**
     * Response Org-Compliance-Tasks-List Org Tasks
     *
     * Successful Response
     */
    200: Array<TaskResponse>;
};

export type OrgComplianceTasksListOrgTasksResponse = OrgComplianceTasksListOrgTasksResponses[keyof OrgComplianceTasksListOrgTasksResponses];

export type OrgComplianceTasksCreateNewTaskData = {
    body: ComplianceTaskCreate;
    path: {
        /**
         * Org Id
         */
        org_id: string;
    };
    query?: never;
    url: '/org/{org_id}/compliance/tasks';
};

export type OrgComplianceTasksCreateNewTaskErrors = {
    /**
     * Not found
     */
    404: unknown;
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type OrgComplianceTasksCreateNewTaskError = OrgComplianceTasksCreateNewTaskErrors[keyof OrgComplianceTasksCreateNewTaskErrors];

export type OrgComplianceTasksCreateNewTaskResponses = {
    /**
     * Successful Response
     */
    200: TaskResponse;
};

export type OrgComplianceTasksCreateNewTaskResponse = OrgComplianceTasksCreateNewTaskResponses[keyof OrgComplianceTasksCreateNewTaskResponses];

export type OrgComplianceTasksOverdueListOverdueTasksData = {
    body?: never;
    path: {
        /**
         * Org Id
         */
        org_id: string;
    };
    query?: never;
    url: '/org/{org_id}/compliance/tasks/overdue';
};

export type OrgComplianceTasksOverdueListOverdueTasksErrors = {
    /**
     * Not found
     */
    404: unknown;
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type OrgComplianceTasksOverdueListOverdueTasksError = OrgComplianceTasksOverdueListOverdueTasksErrors[keyof OrgComplianceTasksOverdueListOverdueTasksErrors];

export type OrgComplianceTasksOverdueListOverdueTasksResponses = {
    /**
     * Response Org-Compliance-Tasks-Overdue-List Overdue Tasks
     *
     * Successful Response
     */
    200: Array<TaskResponse>;
};

export type OrgComplianceTasksOverdueListOverdueTasksResponse = OrgComplianceTasksOverdueListOverdueTasksResponses[keyof OrgComplianceTasksOverdueListOverdueTasksResponses];

export type OrgComplianceTasksMyTasksListMyTasksData = {
    body?: never;
    path: {
        /**
         * Org Id
         */
        org_id: string;
    };
    query?: {
        /**
         * Include Completed
         */
        include_completed?: boolean;
    };
    url: '/org/{org_id}/compliance/tasks/my-tasks';
};

export type OrgComplianceTasksMyTasksListMyTasksErrors = {
    /**
     * Not found
     */
    404: unknown;
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type OrgComplianceTasksMyTasksListMyTasksError = OrgComplianceTasksMyTasksListMyTasksErrors[keyof OrgComplianceTasksMyTasksListMyTasksErrors];

export type OrgComplianceTasksMyTasksListMyTasksResponses = {
    /**
     * Response Org-Compliance-Tasks-My-Tasks-List My Tasks
     *
     * Successful Response
     */
    200: Array<TaskResponse>;
};

export type OrgComplianceTasksMyTasksListMyTasksResponse = OrgComplianceTasksMyTasksListMyTasksResponses[keyof OrgComplianceTasksMyTasksListMyTasksResponses];

export type OrgComplianceTrackingTasksListTrackingTasksData = {
    body?: never;
    path: {
        /**
         * Tracking Id
         */
        tracking_id: string;
        /**
         * Org Id
         */
        org_id: string;
    };
    query?: {
        /**
         * Include Deleted
         */
        include_deleted?: boolean;
    };
    url: '/org/{org_id}/compliance/tracking/{tracking_id}/tasks';
};

export type OrgComplianceTrackingTasksListTrackingTasksErrors = {
    /**
     * Not found
     */
    404: unknown;
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type OrgComplianceTrackingTasksListTrackingTasksError = OrgComplianceTrackingTasksListTrackingTasksErrors[keyof OrgComplianceTrackingTasksListTrackingTasksErrors];

export type OrgComplianceTrackingTasksListTrackingTasksResponses = {
    /**
     * Response Org-Compliance-Tracking-Tasks-List Tracking Tasks
     *
     * Successful Response
     */
    200: Array<TaskResponse>;
};

export type OrgComplianceTrackingTasksListTrackingTasksResponse = OrgComplianceTrackingTasksListTrackingTasksResponses[keyof OrgComplianceTrackingTasksListTrackingTasksResponses];

export type OrgComplianceTasksDeleteTaskData = {
    body?: never;
    path: {
        /**
         * Task Id
         */
        task_id: string;
        /**
         * Org Id
         */
        org_id: string;
    };
    query?: never;
    url: '/org/{org_id}/compliance/tasks/{task_id}';
};

export type OrgComplianceTasksDeleteTaskErrors = {
    /**
     * Not found
     */
    404: unknown;
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type OrgComplianceTasksDeleteTaskError = OrgComplianceTasksDeleteTaskErrors[keyof OrgComplianceTasksDeleteTaskErrors];

export type OrgComplianceTasksDeleteTaskResponses = {
    /**
     * Response Org-Compliance-Tasks-Delete Task
     *
     * Successful Response
     */
    200: {
        [key: string]: string;
    };
};

export type OrgComplianceTasksDeleteTaskResponse = OrgComplianceTasksDeleteTaskResponses[keyof OrgComplianceTasksDeleteTaskResponses];

export type OrgComplianceTasksGetTaskDetailsData = {
    body?: never;
    path: {
        /**
         * Task Id
         */
        task_id: string;
        /**
         * Org Id
         */
        org_id: string;
    };
    query?: never;
    url: '/org/{org_id}/compliance/tasks/{task_id}';
};

export type OrgComplianceTasksGetTaskDetailsErrors = {
    /**
     * Not found
     */
    404: unknown;
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type OrgComplianceTasksGetTaskDetailsError = OrgComplianceTasksGetTaskDetailsErrors[keyof OrgComplianceTasksGetTaskDetailsErrors];

export type OrgComplianceTasksGetTaskDetailsResponses = {
    /**
     * Successful Response
     */
    200: TaskResponse;
};

export type OrgComplianceTasksGetTaskDetailsResponse = OrgComplianceTasksGetTaskDetailsResponses[keyof OrgComplianceTasksGetTaskDetailsResponses];

export type OrgComplianceTasksUpdateTaskDetailsData = {
    body: ComplianceTaskUpdate;
    path: {
        /**
         * Task Id
         */
        task_id: string;
        /**
         * Org Id
         */
        org_id: string;
    };
    query?: never;
    url: '/org/{org_id}/compliance/tasks/{task_id}';
};

export type OrgComplianceTasksUpdateTaskDetailsErrors = {
    /**
     * Not found
     */
    404: unknown;
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type OrgComplianceTasksUpdateTaskDetailsError = OrgComplianceTasksUpdateTaskDetailsErrors[keyof OrgComplianceTasksUpdateTaskDetailsErrors];

export type OrgComplianceTasksUpdateTaskDetailsResponses = {
    /**
     * Successful Response
     */
    200: TaskResponse;
};

export type OrgComplianceTasksUpdateTaskDetailsResponse = OrgComplianceTasksUpdateTaskDetailsResponses[keyof OrgComplianceTasksUpdateTaskDetailsResponses];

export type OrgComplianceTasksCompleteCompleteTaskData = {
    body?: never;
    path: {
        /**
         * Task Id
         */
        task_id: string;
        /**
         * Org Id
         */
        org_id: string;
    };
    query?: never;
    url: '/org/{org_id}/compliance/tasks/{task_id}/complete';
};

export type OrgComplianceTasksCompleteCompleteTaskErrors = {
    /**
     * Not found
     */
    404: unknown;
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type OrgComplianceTasksCompleteCompleteTaskError = OrgComplianceTasksCompleteCompleteTaskErrors[keyof OrgComplianceTasksCompleteCompleteTaskErrors];

export type OrgComplianceTasksCompleteCompleteTaskResponses = {
    /**
     * Successful Response
     */
    200: TaskResponse;
};

export type OrgComplianceTasksCompleteCompleteTaskResponse = OrgComplianceTasksCompleteCompleteTaskResponses[keyof OrgComplianceTasksCompleteCompleteTaskResponses];

export type OrgComplianceTrackingTrackHistoryListTrackingTrackHistoryData = {
    body?: never;
    path: {
        /**
         * Tracking Id
         */
        tracking_id: string;
        /**
         * Org Id
         */
        org_id: string;
    };
    query?: never;
    url: '/org/{org_id}/compliance/tracking/{tracking_id}/track-history';
};

export type OrgComplianceTrackingTrackHistoryListTrackingTrackHistoryErrors = {
    /**
     * Not found
     */
    404: unknown;
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type OrgComplianceTrackingTrackHistoryListTrackingTrackHistoryError = OrgComplianceTrackingTrackHistoryListTrackingTrackHistoryErrors[keyof OrgComplianceTrackingTrackHistoryListTrackingTrackHistoryErrors];

export type OrgComplianceTrackingTrackHistoryListTrackingTrackHistoryResponses = {
    /**
     * Response Org-Compliance-Tracking-Track-History-List Tracking Track History
     *
     * Successful Response
     */
    200: Array<TrackHistoryResponse>;
};

export type OrgComplianceTrackingTrackHistoryListTrackingTrackHistoryResponse = OrgComplianceTrackingTrackHistoryListTrackingTrackHistoryResponses[keyof OrgComplianceTrackingTrackHistoryListTrackingTrackHistoryResponses];

export type OrgComplianceTrackingTrackChangeTrackingTrackData = {
    body: TrackChangeRequest;
    path: {
        /**
         * Tracking Id
         */
        tracking_id: string;
        /**
         * Org Id
         */
        org_id: string;
    };
    query?: never;
    url: '/org/{org_id}/compliance/tracking/{tracking_id}/track';
};

export type OrgComplianceTrackingTrackChangeTrackingTrackErrors = {
    /**
     * Not found
     */
    404: unknown;
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type OrgComplianceTrackingTrackChangeTrackingTrackError = OrgComplianceTrackingTrackChangeTrackingTrackErrors[keyof OrgComplianceTrackingTrackChangeTrackingTrackErrors];

export type OrgComplianceTrackingTrackChangeTrackingTrackResponses = {
    /**
     * Successful Response
     */
    200: TrackChangeResponse;
};

export type OrgComplianceTrackingTrackChangeTrackingTrackResponse = OrgComplianceTrackingTrackChangeTrackingTrackResponses[keyof OrgComplianceTrackingTrackChangeTrackingTrackResponses];

export type OrgComplianceTrackingReviewResolveTrackingReviewData = {
    body: ReviewResolution;
    path: {
        /**
         * Tracking Id
         */
        tracking_id: string;
        /**
         * Org Id
         */
        org_id: string;
    };
    query?: never;
    url: '/org/{org_id}/compliance/tracking/{tracking_id}/review';
};

export type OrgComplianceTrackingReviewResolveTrackingReviewErrors = {
    /**
     * Not found
     */
    404: unknown;
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type OrgComplianceTrackingReviewResolveTrackingReviewError = OrgComplianceTrackingReviewResolveTrackingReviewErrors[keyof OrgComplianceTrackingReviewResolveTrackingReviewErrors];

export type OrgComplianceTrackingReviewResolveTrackingReviewResponses = {
    /**
     * Successful Response
     */
    200: TrackingResponse;
};

export type OrgComplianceTrackingReviewResolveTrackingReviewResponse = OrgComplianceTrackingReviewResolveTrackingReviewResponses[keyof OrgComplianceTrackingReviewResolveTrackingReviewResponses];

export type OrgComplianceTrackingEventsListTrackingEventsData = {
    body?: never;
    path: {
        /**
         * Tracking Id
         */
        tracking_id: string;
        /**
         * Org Id
         */
        org_id: string;
    };
    query?: never;
    url: '/org/{org_id}/compliance/tracking/{tracking_id}/events';
};

export type OrgComplianceTrackingEventsListTrackingEventsErrors = {
    /**
     * Not found
     */
    404: unknown;
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type OrgComplianceTrackingEventsListTrackingEventsError = OrgComplianceTrackingEventsListTrackingEventsErrors[keyof OrgComplianceTrackingEventsListTrackingEventsErrors];

export type OrgComplianceTrackingEventsListTrackingEventsResponses = {
    /**
     * Response Org-Compliance-Tracking-Events-List Tracking Events
     *
     * Successful Response
     */
    200: Array<EventResponse>;
};

export type OrgComplianceTrackingEventsListTrackingEventsResponse = OrgComplianceTrackingEventsListTrackingEventsResponses[keyof OrgComplianceTrackingEventsListTrackingEventsResponses];

export type OrgComplianceTrackingEventsRecordTrackingEventData = {
    body: EventCreate;
    path: {
        /**
         * Tracking Id
         */
        tracking_id: string;
        /**
         * Org Id
         */
        org_id: string;
    };
    query?: never;
    url: '/org/{org_id}/compliance/tracking/{tracking_id}/events';
};

export type OrgComplianceTrackingEventsRecordTrackingEventErrors = {
    /**
     * Not found
     */
    404: unknown;
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type OrgComplianceTrackingEventsRecordTrackingEventError = OrgComplianceTrackingEventsRecordTrackingEventErrors[keyof OrgComplianceTrackingEventsRecordTrackingEventErrors];

export type OrgComplianceTrackingEventsRecordTrackingEventResponses = {
    /**
     * Successful Response
     */
    200: EventRecordedResponse;
};

export type OrgComplianceTrackingEventsRecordTrackingEventResponse = OrgComplianceTrackingEventsRecordTrackingEventResponses[keyof OrgComplianceTrackingEventsRecordTrackingEventResponses];

export type OrgComplianceTrackingDeterminationsListTrackingDeterminationsData = {
    body?: never;
    path: {
        /**
         * Tracking Id
         */
        tracking_id: string;
        /**
         * Org Id
         */
        org_id: string;
    };
    query?: never;
    url: '/org/{org_id}/compliance/tracking/{tracking_id}/determinations';
};

export type OrgComplianceTrackingDeterminationsListTrackingDeterminationsErrors = {
    /**
     * Not found
     */
    404: unknown;
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type OrgComplianceTrackingDeterminationsListTrackingDeterminationsError = OrgComplianceTrackingDeterminationsListTrackingDeterminationsErrors[keyof OrgComplianceTrackingDeterminationsListTrackingDeterminationsErrors];

export type OrgComplianceTrackingDeterminationsListTrackingDeterminationsResponses = {
    /**
     * Response Org-Compliance-Tracking-Determinations-List Tracking Determinations
     *
     * Successful Response
     */
    200: Array<DeterminationResponse>;
};

export type OrgComplianceTrackingDeterminationsListTrackingDeterminationsResponse = OrgComplianceTrackingDeterminationsListTrackingDeterminationsResponses[keyof OrgComplianceTrackingDeterminationsListTrackingDeterminationsResponses];

export type OrgComplianceTrackingDeterminationsCreateTrackingDeterminationData = {
    body: DeterminationCreate;
    path: {
        /**
         * Tracking Id
         */
        tracking_id: string;
        /**
         * Org Id
         */
        org_id: string;
    };
    query?: never;
    url: '/org/{org_id}/compliance/tracking/{tracking_id}/determinations';
};

export type OrgComplianceTrackingDeterminationsCreateTrackingDeterminationErrors = {
    /**
     * Not found
     */
    404: unknown;
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type OrgComplianceTrackingDeterminationsCreateTrackingDeterminationError = OrgComplianceTrackingDeterminationsCreateTrackingDeterminationErrors[keyof OrgComplianceTrackingDeterminationsCreateTrackingDeterminationErrors];

export type OrgComplianceTrackingDeterminationsCreateTrackingDeterminationResponses = {
    /**
     * Successful Response
     */
    200: DeterminationResponse;
};

export type OrgComplianceTrackingDeterminationsCreateTrackingDeterminationResponse = OrgComplianceTrackingDeterminationsCreateTrackingDeterminationResponses[keyof OrgComplianceTrackingDeterminationsCreateTrackingDeterminationResponses];

export type OrgComplianceDeterminationsDecisionDecideTrackingDeterminationData = {
    body: DeterminationDecision;
    path: {
        /**
         * Determination Id
         */
        determination_id: string;
        /**
         * Org Id
         */
        org_id: string;
    };
    query?: never;
    url: '/org/{org_id}/compliance/determinations/{determination_id}/decision';
};

export type OrgComplianceDeterminationsDecisionDecideTrackingDeterminationErrors = {
    /**
     * Not found
     */
    404: unknown;
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type OrgComplianceDeterminationsDecisionDecideTrackingDeterminationError = OrgComplianceDeterminationsDecisionDecideTrackingDeterminationErrors[keyof OrgComplianceDeterminationsDecisionDecideTrackingDeterminationErrors];

export type OrgComplianceDeterminationsDecisionDecideTrackingDeterminationResponses = {
    /**
     * Successful Response
     */
    200: DeterminationResponse;
};

export type OrgComplianceDeterminationsDecisionDecideTrackingDeterminationResponse = OrgComplianceDeterminationsDecisionDecideTrackingDeterminationResponses[keyof OrgComplianceDeterminationsDecisionDecideTrackingDeterminationResponses];

export type OrgComplianceTrackingResultsListTrackingResultsData = {
    body?: never;
    path: {
        /**
         * Tracking Id
         */
        tracking_id: string;
        /**
         * Org Id
         */
        org_id: string;
    };
    query?: {
        /**
         * Kind
         */
        kind?: EvaluationKind | null;
    };
    url: '/org/{org_id}/compliance/tracking/{tracking_id}/results';
};

export type OrgComplianceTrackingResultsListTrackingResultsErrors = {
    /**
     * Not found
     */
    404: unknown;
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type OrgComplianceTrackingResultsListTrackingResultsError = OrgComplianceTrackingResultsListTrackingResultsErrors[keyof OrgComplianceTrackingResultsListTrackingResultsErrors];

export type OrgComplianceTrackingResultsListTrackingResultsResponses = {
    /**
     * Response Org-Compliance-Tracking-Results-List Tracking Results
     *
     * Successful Response
     */
    200: Array<ResultResponse>;
};

export type OrgComplianceTrackingResultsListTrackingResultsResponse = OrgComplianceTrackingResultsListTrackingResultsResponses[keyof OrgComplianceTrackingResultsListTrackingResultsResponses];

export type OrgComplianceTrackingResultsEmissionsComputeTrackingEmissionsData = {
    body: EmissionsComputeRequest;
    path: {
        /**
         * Tracking Id
         */
        tracking_id: string;
        /**
         * Org Id
         */
        org_id: string;
    };
    query?: never;
    url: '/org/{org_id}/compliance/tracking/{tracking_id}/results/emissions';
};

export type OrgComplianceTrackingResultsEmissionsComputeTrackingEmissionsErrors = {
    /**
     * Not found
     */
    404: unknown;
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type OrgComplianceTrackingResultsEmissionsComputeTrackingEmissionsError = OrgComplianceTrackingResultsEmissionsComputeTrackingEmissionsErrors[keyof OrgComplianceTrackingResultsEmissionsComputeTrackingEmissionsErrors];

export type OrgComplianceTrackingResultsEmissionsComputeTrackingEmissionsResponses = {
    /**
     * Successful Response
     */
    200: ResultResponse;
};

export type OrgComplianceTrackingResultsEmissionsComputeTrackingEmissionsResponse = OrgComplianceTrackingResultsEmissionsComputeTrackingEmissionsResponses[keyof OrgComplianceTrackingResultsEmissionsComputeTrackingEmissionsResponses];

export type OrgComplianceTrackingResultsStandardEvaluateTrackingStandardData = {
    body: StandardEvaluationRequest;
    path: {
        /**
         * Tracking Id
         */
        tracking_id: string;
        /**
         * Org Id
         */
        org_id: string;
    };
    query?: never;
    url: '/org/{org_id}/compliance/tracking/{tracking_id}/results/standard';
};

export type OrgComplianceTrackingResultsStandardEvaluateTrackingStandardErrors = {
    /**
     * Not found
     */
    404: unknown;
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type OrgComplianceTrackingResultsStandardEvaluateTrackingStandardError = OrgComplianceTrackingResultsStandardEvaluateTrackingStandardErrors[keyof OrgComplianceTrackingResultsStandardEvaluateTrackingStandardErrors];

export type OrgComplianceTrackingResultsStandardEvaluateTrackingStandardResponses = {
    /**
     * Successful Response
     */
    200: ResultResponse;
};

export type OrgComplianceTrackingResultsStandardEvaluateTrackingStandardResponse = OrgComplianceTrackingResultsStandardEvaluateTrackingStandardResponses[keyof OrgComplianceTrackingResultsStandardEvaluateTrackingStandardResponses];

export type OrgComplianceTrackingAcpExposureGetTrackingAcpExposureData = {
    body?: never;
    path: {
        /**
         * Tracking Id
         */
        tracking_id: string;
        /**
         * Org Id
         */
        org_id: string;
    };
    query?: {
        /**
         * Reduction
         *
         * Performance: site EUI reduction achieved (0-1)
         */
        reduction?: number | string | null;
        /**
         * Distance
         *
         * Standard target: distance from the standard
         */
        distance?: number | string | null;
        /**
         * Distance At Twenty Percent
         */
        distance_at_twenty_percent?: number | string | null;
        /**
         * Points Earned
         *
         * Prescriptive: points earned
         */
        points_earned?: number | string | null;
        /**
         * Points Needed
         */
        points_needed?: number | string | null;
        /**
         * Information Missing
         */
        information_missing?: boolean;
    };
    url: '/org/{org_id}/compliance/tracking/{tracking_id}/acp-exposure';
};

export type OrgComplianceTrackingAcpExposureGetTrackingAcpExposureErrors = {
    /**
     * Not found
     */
    404: unknown;
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type OrgComplianceTrackingAcpExposureGetTrackingAcpExposureError = OrgComplianceTrackingAcpExposureGetTrackingAcpExposureErrors[keyof OrgComplianceTrackingAcpExposureGetTrackingAcpExposureErrors];

export type OrgComplianceTrackingAcpExposureGetTrackingAcpExposureResponses = {
    /**
     * Response Org-Compliance-Tracking-Acp-Exposure-Get Tracking Acp Exposure
     *
     * Successful Response
     */
    200: {
        [key: string]: unknown;
    };
};

export type OrgComplianceTrackingAcpExposureGetTrackingAcpExposureResponse = OrgComplianceTrackingAcpExposureGetTrackingAcpExposureResponses[keyof OrgComplianceTrackingAcpExposureGetTrackingAcpExposureResponses];

export type OrgComplianceTrackingRequirementsSatisfiedMarkTrackingRequirementSatisfiedData = {
    body: RequirementSatisfied;
    path: {
        /**
         * Tracking Id
         */
        tracking_id: string;
        /**
         * Requirement Id
         */
        requirement_id: string;
        /**
         * Org Id
         */
        org_id: string;
    };
    query?: never;
    url: '/org/{org_id}/compliance/tracking/{tracking_id}/requirements/{requirement_id}/satisfied';
};

export type OrgComplianceTrackingRequirementsSatisfiedMarkTrackingRequirementSatisfiedErrors = {
    /**
     * Not found
     */
    404: unknown;
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type OrgComplianceTrackingRequirementsSatisfiedMarkTrackingRequirementSatisfiedError = OrgComplianceTrackingRequirementsSatisfiedMarkTrackingRequirementSatisfiedErrors[keyof OrgComplianceTrackingRequirementsSatisfiedMarkTrackingRequirementSatisfiedErrors];

export type OrgComplianceTrackingRequirementsSatisfiedMarkTrackingRequirementSatisfiedResponses = {
    /**
     * Successful Response
     */
    200: TaskResponse;
};

export type OrgComplianceTrackingRequirementsSatisfiedMarkTrackingRequirementSatisfiedResponse = OrgComplianceTrackingRequirementsSatisfiedMarkTrackingRequirementSatisfiedResponses[keyof OrgComplianceTrackingRequirementsSatisfiedMarkTrackingRequirementSatisfiedResponses];

export type OrgComplianceRequirementsSatisfiedMarkRequirementSatisfiedForPropertiesData = {
    body: BulkRequirementSatisfied;
    path: {
        /**
         * Org Id
         */
        org_id: string;
    };
    query?: never;
    url: '/org/{org_id}/compliance/requirements/satisfied';
};

export type OrgComplianceRequirementsSatisfiedMarkRequirementSatisfiedForPropertiesErrors = {
    /**
     * Not found
     */
    404: unknown;
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type OrgComplianceRequirementsSatisfiedMarkRequirementSatisfiedForPropertiesError = OrgComplianceRequirementsSatisfiedMarkRequirementSatisfiedForPropertiesErrors[keyof OrgComplianceRequirementsSatisfiedMarkRequirementSatisfiedForPropertiesErrors];

export type OrgComplianceRequirementsSatisfiedMarkRequirementSatisfiedForPropertiesResponses = {
    /**
     * Response Org-Compliance-Requirements-Satisfied-Mark Requirement Satisfied For Properties
     *
     * Successful Response
     */
    200: Array<TaskResponse>;
};

export type OrgComplianceRequirementsSatisfiedMarkRequirementSatisfiedForPropertiesResponse = OrgComplianceRequirementsSatisfiedMarkRequirementSatisfiedForPropertiesResponses[keyof OrgComplianceRequirementsSatisfiedMarkRequirementSatisfiedForPropertiesResponses];

export type OrgCompliancePropertyAgencyStatusGetPropertyAgencyStatusData = {
    body?: never;
    path: {
        /**
         * Property Id
         */
        property_id: string;
        /**
         * Org Id
         */
        org_id: string;
    };
    query?: never;
    url: '/org/{org_id}/compliance/property/{property_id}/agency-status';
};

export type OrgCompliancePropertyAgencyStatusGetPropertyAgencyStatusErrors = {
    /**
     * Not found
     */
    404: unknown;
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type OrgCompliancePropertyAgencyStatusGetPropertyAgencyStatusError = OrgCompliancePropertyAgencyStatusGetPropertyAgencyStatusErrors[keyof OrgCompliancePropertyAgencyStatusGetPropertyAgencyStatusErrors];

export type OrgCompliancePropertyAgencyStatusGetPropertyAgencyStatusResponses = {
    /**
     * Response Org-Compliance-Property-Agency-Status-Get Property Agency Status
     *
     * Successful Response
     */
    200: Array<{
        [key: string]: unknown;
    }>;
};

export type OrgCompliancePropertyAgencyStatusGetPropertyAgencyStatusResponse = OrgCompliancePropertyAgencyStatusGetPropertyAgencyStatusResponses[keyof OrgCompliancePropertyAgencyStatusGetPropertyAgencyStatusResponses];

export type OrgCoverageListListCoverageListsData = {
    body?: never;
    path: {
        /**
         * Org Id
         */
        org_id: string;
    };
    query?: {
        /**
         * Include Old Versions
         */
        include_old_versions?: boolean;
    };
    url: '/org/{org_id}/coverage-list';
};

export type OrgCoverageListListCoverageListsErrors = {
    /**
     * Not found
     */
    404: unknown;
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type OrgCoverageListListCoverageListsError = OrgCoverageListListCoverageListsErrors[keyof OrgCoverageListListCoverageListsErrors];

export type OrgCoverageListListCoverageListsResponses = {
    /**
     * Response Org-Coverage-List-List Coverage Lists
     *
     * Successful Response
     */
    200: Array<CoverageListResponse>;
};

export type OrgCoverageListListCoverageListsResponse = OrgCoverageListListCoverageListsResponses[keyof OrgCoverageListListCoverageListsResponses];

export type OrgCoverageListAnomaliesListCoverageListAnomaliesData = {
    body?: never;
    path: {
        /**
         * List Id
         */
        list_id: string;
        /**
         * Org Id
         */
        org_id: string;
    };
    query?: {
        /**
         * Flag
         *
         * Only rows whose column FLAG is "Y", e.g. "On LL88 CBL (Y/N)".
         */
        flag?: string | null;
        /**
         * Max Lot Gsf
         */
        max_lot_gsf?: number | string | null;
    };
    url: '/org/{org_id}/coverage-list/{list_id}/anomalies';
};

export type OrgCoverageListAnomaliesListCoverageListAnomaliesErrors = {
    /**
     * Not found
     */
    404: unknown;
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type OrgCoverageListAnomaliesListCoverageListAnomaliesError = OrgCoverageListAnomaliesListCoverageListAnomaliesErrors[keyof OrgCoverageListAnomaliesListCoverageListAnomaliesErrors];

export type OrgCoverageListAnomaliesListCoverageListAnomaliesResponses = {
    /**
     * Response Org-Coverage-List-Anomalies-List Coverage List Anomalies
     *
     * Successful Response
     */
    200: Array<{
        [key: string]: unknown;
    }>;
};

export type OrgCoverageListAnomaliesListCoverageListAnomaliesResponse = OrgCoverageListAnomaliesListCoverageListAnomaliesResponses[keyof OrgCoverageListAnomaliesListCoverageListAnomaliesResponses];

export type OrgCoverageListMatchesListCoverageListMatchesData = {
    body?: never;
    path: {
        /**
         * List Id
         */
        list_id: string;
        /**
         * Org Id
         */
        org_id: string;
    };
    query?: {
        /**
         * Outcome
         */
        outcome?: CoverageMatchOutcome | null;
    };
    url: '/org/{org_id}/coverage-list/{list_id}/matches';
};

export type OrgCoverageListMatchesListCoverageListMatchesErrors = {
    /**
     * Not found
     */
    404: unknown;
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type OrgCoverageListMatchesListCoverageListMatchesError = OrgCoverageListMatchesListCoverageListMatchesErrors[keyof OrgCoverageListMatchesListCoverageListMatchesErrors];

export type OrgCoverageListMatchesListCoverageListMatchesResponses = {
    /**
     * Response Org-Coverage-List-Matches-List Coverage List Matches
     *
     * Successful Response
     */
    200: Array<CoverageMatchResponse>;
};

export type OrgCoverageListMatchesListCoverageListMatchesResponse = OrgCoverageListMatchesListCoverageListMatchesResponses[keyof OrgCoverageListMatchesListCoverageListMatchesResponses];

export type OrgCoverageListMatchMatchCoverageListData = {
    body: MatchRequest;
    path: {
        /**
         * Org Id
         */
        org_id: string;
    };
    query?: never;
    url: '/org/{org_id}/coverage-list/match';
};

export type OrgCoverageListMatchMatchCoverageListErrors = {
    /**
     * Not found
     */
    404: unknown;
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type OrgCoverageListMatchMatchCoverageListError = OrgCoverageListMatchMatchCoverageListErrors[keyof OrgCoverageListMatchMatchCoverageListErrors];

export type OrgCoverageListMatchMatchCoverageListResponses = {
    /**
     * Successful Response
     */
    200: MatchResult;
};

export type OrgCoverageListMatchMatchCoverageListResponse = OrgCoverageListMatchMatchCoverageListResponses[keyof OrgCoverageListMatchMatchCoverageListResponses];

export type OrgDashboardListDashboardsData = {
    body?: never;
    path: {
        /**
         * Org Id
         */
        org_id: string;
    };
    query?: never;
    url: '/org/{org_id}/dashboard/';
};

export type OrgDashboardListDashboardsErrors = {
    /**
     * Not found
     */
    404: unknown;
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type OrgDashboardListDashboardsError = OrgDashboardListDashboardsErrors[keyof OrgDashboardListDashboardsErrors];

export type OrgDashboardListDashboardsResponses = {
    /**
     * Response Org-Dashboard--List Dashboards
     *
     * Successful Response
     */
    200: Array<DashboardSummary>;
};

export type OrgDashboardListDashboardsResponse = OrgDashboardListDashboardsResponses[keyof OrgDashboardListDashboardsResponses];

export type OrgDashboardCreateDashboardData = {
    body: DashboardCreateRequest;
    path: {
        /**
         * Org Id
         */
        org_id: string;
    };
    query?: never;
    url: '/org/{org_id}/dashboard/';
};

export type OrgDashboardCreateDashboardErrors = {
    /**
     * Not found
     */
    404: unknown;
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type OrgDashboardCreateDashboardError = OrgDashboardCreateDashboardErrors[keyof OrgDashboardCreateDashboardErrors];

export type OrgDashboardCreateDashboardResponses = {
    /**
     * Successful Response
     */
    200: DashboardDetail;
};

export type OrgDashboardCreateDashboardResponse = OrgDashboardCreateDashboardResponses[keyof OrgDashboardCreateDashboardResponses];

export type OrgDashboardDeleteDashboardData = {
    body?: never;
    path: {
        /**
         * Dashboard Id
         */
        dashboard_id: string;
        /**
         * Org Id
         */
        org_id: string;
    };
    query?: never;
    url: '/org/{org_id}/dashboard/{dashboard_id}';
};

export type OrgDashboardDeleteDashboardErrors = {
    /**
     * Not found
     */
    404: unknown;
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type OrgDashboardDeleteDashboardError = OrgDashboardDeleteDashboardErrors[keyof OrgDashboardDeleteDashboardErrors];

export type OrgDashboardDeleteDashboardResponses = {
    /**
     * Response Org-Dashboard-Delete Dashboard
     *
     * Successful Response
     */
    200: {
        [key: string]: string;
    };
};

export type OrgDashboardDeleteDashboardResponse = OrgDashboardDeleteDashboardResponses[keyof OrgDashboardDeleteDashboardResponses];

export type OrgDashboardGetDashboardData = {
    body?: never;
    path: {
        /**
         * Dashboard Id
         */
        dashboard_id: string;
        /**
         * Org Id
         */
        org_id: string;
    };
    query?: never;
    url: '/org/{org_id}/dashboard/{dashboard_id}';
};

export type OrgDashboardGetDashboardErrors = {
    /**
     * Not found
     */
    404: unknown;
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type OrgDashboardGetDashboardError = OrgDashboardGetDashboardErrors[keyof OrgDashboardGetDashboardErrors];

export type OrgDashboardGetDashboardResponses = {
    /**
     * Successful Response
     */
    200: DashboardDetail;
};

export type OrgDashboardGetDashboardResponse = OrgDashboardGetDashboardResponses[keyof OrgDashboardGetDashboardResponses];

export type OrgDashboardUpdateDashboardData = {
    body: DashboardUpdateRequest;
    path: {
        /**
         * Dashboard Id
         */
        dashboard_id: string;
        /**
         * Org Id
         */
        org_id: string;
    };
    query?: never;
    url: '/org/{org_id}/dashboard/{dashboard_id}';
};

export type OrgDashboardUpdateDashboardErrors = {
    /**
     * Not found
     */
    404: unknown;
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type OrgDashboardUpdateDashboardError = OrgDashboardUpdateDashboardErrors[keyof OrgDashboardUpdateDashboardErrors];

export type OrgDashboardUpdateDashboardResponses = {
    /**
     * Successful Response
     */
    200: DashboardDetail;
};

export type OrgDashboardUpdateDashboardResponse = OrgDashboardUpdateDashboardResponses[keyof OrgDashboardUpdateDashboardResponses];

export type OrgDashboardDataGetDashboardDataData = {
    /**
     * Body
     */
    body?: DashboardDataRequest | null;
    path: {
        /**
         * Dashboard Id
         */
        dashboard_id: string;
        /**
         * Org Id
         */
        org_id: string;
    };
    query?: never;
    url: '/org/{org_id}/dashboard/{dashboard_id}/data';
};

export type OrgDashboardDataGetDashboardDataErrors = {
    /**
     * Not found
     */
    404: unknown;
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type OrgDashboardDataGetDashboardDataError = OrgDashboardDataGetDashboardDataErrors[keyof OrgDashboardDataGetDashboardDataErrors];

export type OrgDashboardDataGetDashboardDataResponses = {
    /**
     * Response Org-Dashboard-Data-Get Dashboard Data
     *
     * Successful Response
     */
    200: {
        [key: string]: QueryResult;
    };
};

export type OrgDashboardDataGetDashboardDataResponse = OrgDashboardDataGetDashboardDataResponses[keyof OrgDashboardDataGetDashboardDataResponses];

export type OrgDashboardDuplicateDuplicateDashboardData = {
    body?: never;
    path: {
        /**
         * Dashboard Id
         */
        dashboard_id: string;
        /**
         * Org Id
         */
        org_id: string;
    };
    query?: never;
    url: '/org/{org_id}/dashboard/{dashboard_id}/duplicate';
};

export type OrgDashboardDuplicateDuplicateDashboardErrors = {
    /**
     * Not found
     */
    404: unknown;
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type OrgDashboardDuplicateDuplicateDashboardError = OrgDashboardDuplicateDuplicateDashboardErrors[keyof OrgDashboardDuplicateDuplicateDashboardErrors];

export type OrgDashboardDuplicateDuplicateDashboardResponses = {
    /**
     * Successful Response
     */
    200: DashboardDetail;
};

export type OrgDashboardDuplicateDuplicateDashboardResponse = OrgDashboardDuplicateDuplicateDashboardResponses[keyof OrgDashboardDuplicateDuplicateDashboardResponses];

export type OrgDepartmentListData = {
    body?: never;
    path: {
        /**
         * Org Id
         */
        org_id: string;
    };
    query?: never;
    url: '/org/{org_id}/department/';
};

export type OrgDepartmentListErrors = {
    /**
     * Not found
     */
    404: unknown;
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type OrgDepartmentListError = OrgDepartmentListErrors[keyof OrgDepartmentListErrors];

export type OrgDepartmentListResponses = {
    /**
     * Response Org-Department--List
     *
     * Successful Response
     */
    200: Array<DepartmentSummary>;
};

export type OrgDepartmentListResponse = OrgDepartmentListResponses[keyof OrgDepartmentListResponses];

export type OrgDepartmentCreateData = {
    body: DepartmentCreate;
    path: {
        /**
         * Org Id
         */
        org_id: string;
    };
    query?: never;
    url: '/org/{org_id}/department/';
};

export type OrgDepartmentCreateErrors = {
    /**
     * Not found
     */
    404: unknown;
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type OrgDepartmentCreateError = OrgDepartmentCreateErrors[keyof OrgDepartmentCreateErrors];

export type OrgDepartmentCreateResponses = {
    /**
     * Successful Response
     */
    200: Department;
};

export type OrgDepartmentCreateResponse = OrgDepartmentCreateResponses[keyof OrgDepartmentCreateResponses];

export type OrgDepartmentGetData = {
    body?: never;
    path: {
        /**
         * Department Id
         */
        department_id: string;
        /**
         * Org Id
         */
        org_id: string;
    };
    query?: never;
    url: '/org/{org_id}/department/{department_id}';
};

export type OrgDepartmentGetErrors = {
    /**
     * Not found
     */
    404: unknown;
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type OrgDepartmentGetError = OrgDepartmentGetErrors[keyof OrgDepartmentGetErrors];

export type OrgDepartmentGetResponses = {
    /**
     * Response Org-Department-Get
     *
     * Successful Response
     */
    200: Department | null;
};

export type OrgDepartmentGetResponse = OrgDepartmentGetResponses[keyof OrgDepartmentGetResponses];

export type OrgDepartmentUpdateData = {
    body: DepartmentUpdate;
    path: {
        /**
         * Department Id
         */
        department_id: string;
        /**
         * Org Id
         */
        org_id: string;
    };
    query?: never;
    url: '/org/{org_id}/department/{department_id}';
};

export type OrgDepartmentUpdateErrors = {
    /**
     * Not found
     */
    404: unknown;
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type OrgDepartmentUpdateError = OrgDepartmentUpdateErrors[keyof OrgDepartmentUpdateErrors];

export type OrgDepartmentUpdateResponses = {
    /**
     * Successful Response
     */
    200: Department;
};

export type OrgDepartmentUpdateResponse = OrgDepartmentUpdateResponses[keyof OrgDepartmentUpdateResponses];

export type OrgFileGetFilesData = {
    body?: never;
    path: {
        /**
         * Org Id
         */
        org_id: string;
    };
    query?: never;
    url: '/org/{org_id}/file/';
};

export type OrgFileGetFilesErrors = {
    /**
     * Not found
     */
    404: unknown;
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type OrgFileGetFilesError = OrgFileGetFilesErrors[keyof OrgFileGetFilesErrors];

export type OrgFileGetFilesResponses = {
    /**
     * Response Org-File--Get Files
     *
     * Successful Response
     */
    200: Array<FileSet>;
};

export type OrgFileGetFilesResponse = OrgFileGetFilesResponses[keyof OrgFileGetFilesResponses];

export type OrgFileUploadFilesData = {
    body: BodyOrgFileUploadFiles;
    path: {
        /**
         * Org Id
         */
        org_id: string;
    };
    query?: never;
    url: '/org/{org_id}/file/';
};

export type OrgFileUploadFilesErrors = {
    /**
     * Not found
     */
    404: unknown;
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type OrgFileUploadFilesError = OrgFileUploadFilesErrors[keyof OrgFileUploadFilesErrors];

export type OrgFileUploadFilesResponses = {
    /**
     * Successful Response
     */
    200: IngestJobSummary;
};

export type OrgFileUploadFilesResponse = OrgFileUploadFilesResponses[keyof OrgFileUploadFilesResponses];

export type OrgFileGetFileSetData = {
    body?: never;
    path: {
        /**
         * File Set Id
         */
        file_set_id: string;
        /**
         * Org Id
         */
        org_id: string;
    };
    query?: never;
    url: '/org/{org_id}/file/{file_set_id}';
};

export type OrgFileGetFileSetErrors = {
    /**
     * Not found
     */
    404: unknown;
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type OrgFileGetFileSetError = OrgFileGetFileSetErrors[keyof OrgFileGetFileSetErrors];

export type OrgFileGetFileSetResponses = {
    /**
     * Successful Response
     */
    200: FileSet;
};

export type OrgFileGetFileSetResponse = OrgFileGetFileSetResponses[keyof OrgFileGetFileSetResponses];

export type OrgFileContentsGetFileContentsData = {
    body?: never;
    path: {
        /**
         * File Id
         */
        file_id: string;
        /**
         * Org Id
         */
        org_id: string;
    };
    query?: never;
    url: '/org/{org_id}/file/contents/{file_id}';
};

export type OrgFileContentsGetFileContentsErrors = {
    /**
     * Not found
     */
    404: unknown;
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type OrgFileContentsGetFileContentsError = OrgFileContentsGetFileContentsErrors[keyof OrgFileContentsGetFileContentsErrors];

export type OrgFileContentsGetFileContentsResponses = {
    /**
     * Successful Response
     */
    200: unknown;
};

export type OrgIngestJobListData = {
    body?: never;
    path: {
        /**
         * Org Id
         */
        org_id: string;
    };
    query?: never;
    url: '/org/{org_id}/ingest_job/';
};

export type OrgIngestJobListErrors = {
    /**
     * Not found
     */
    404: unknown;
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type OrgIngestJobListError = OrgIngestJobListErrors[keyof OrgIngestJobListErrors];

export type OrgIngestJobListResponses = {
    /**
     * Response Org-Ingest Job--List
     *
     * Successful Response
     */
    200: Array<IngestJobSummary>;
};

export type OrgIngestJobListResponse = OrgIngestJobListResponses[keyof OrgIngestJobListResponses];

export type OrgIngestJobCreateData = {
    body?: never;
    path: {
        /**
         * Org Id
         */
        org_id: string;
    };
    query?: never;
    url: '/org/{org_id}/ingest_job/';
};

export type OrgIngestJobCreateErrors = {
    /**
     * Not found
     */
    404: unknown;
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type OrgIngestJobCreateError = OrgIngestJobCreateErrors[keyof OrgIngestJobCreateErrors];

export type OrgIngestJobCreateResponses = {
    /**
     * Successful Response
     */
    200: IngestJobSummary;
};

export type OrgIngestJobCreateResponse = OrgIngestJobCreateResponses[keyof OrgIngestJobCreateResponses];

export type OrgIngestJobGetData = {
    body?: never;
    path: {
        /**
         * Ingest Job Id
         */
        ingest_job_id: string;
        /**
         * Org Id
         */
        org_id: string;
    };
    query?: never;
    url: '/org/{org_id}/ingest_job/{ingest_job_id}';
};

export type OrgIngestJobGetErrors = {
    /**
     * Not found
     */
    404: unknown;
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type OrgIngestJobGetError = OrgIngestJobGetErrors[keyof OrgIngestJobGetErrors];

export type OrgIngestJobGetResponses = {
    /**
     * Successful Response
     */
    200: IngestJob;
};

export type OrgIngestJobGetResponse = OrgIngestJobGetResponses[keyof OrgIngestJobGetResponses];

export type OrgIngestJobUpdateData = {
    body: IngestJobPatch;
    path: {
        /**
         * Ingest Job Id
         */
        ingest_job_id: string;
        /**
         * Org Id
         */
        org_id: string;
    };
    query?: never;
    url: '/org/{org_id}/ingest_job/{ingest_job_id}';
};

export type OrgIngestJobUpdateErrors = {
    /**
     * Not found
     */
    404: unknown;
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type OrgIngestJobUpdateError = OrgIngestJobUpdateErrors[keyof OrgIngestJobUpdateErrors];

export type OrgIngestJobUpdateResponses = {
    /**
     * Successful Response
     */
    200: IngestJobSummary;
};

export type OrgIngestJobUpdateResponse = OrgIngestJobUpdateResponses[keyof OrgIngestJobUpdateResponses];

export type OrgInitiativesListInitiativesData = {
    body?: never;
    path: {
        /**
         * Org Id
         */
        org_id: string;
    };
    query?: {
        /**
         * Include Deleted
         *
         * Include soft-deleted initiatives
         */
        include_deleted?: boolean;
    };
    url: '/org/{org_id}/initiatives/';
};

export type OrgInitiativesListInitiativesErrors = {
    /**
     * Not found
     */
    404: unknown;
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type OrgInitiativesListInitiativesError = OrgInitiativesListInitiativesErrors[keyof OrgInitiativesListInitiativesErrors];

export type OrgInitiativesListInitiativesResponses = {
    /**
     * Response Org-Initiatives--List Initiatives
     *
     * Successful Response
     */
    200: Array<InitiativeSummary>;
};

export type OrgInitiativesListInitiativesResponse = OrgInitiativesListInitiativesResponses[keyof OrgInitiativesListInitiativesResponses];

export type OrgInitiativesCreateNewInitiativeData = {
    body: InitiativeCreate;
    path: {
        /**
         * Org Id
         */
        org_id: string;
    };
    query?: never;
    url: '/org/{org_id}/initiatives/';
};

export type OrgInitiativesCreateNewInitiativeErrors = {
    /**
     * Not found
     */
    404: unknown;
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type OrgInitiativesCreateNewInitiativeError = OrgInitiativesCreateNewInitiativeErrors[keyof OrgInitiativesCreateNewInitiativeErrors];

export type OrgInitiativesCreateNewInitiativeResponses = {
    /**
     * Successful Response
     */
    200: Initiative;
};

export type OrgInitiativesCreateNewInitiativeResponse = OrgInitiativesCreateNewInitiativeResponses[keyof OrgInitiativesCreateNewInitiativeResponses];

export type OrgInitiativesDeleteInitiativeEndpointData = {
    body?: never;
    path: {
        /**
         * Initiative Id
         */
        initiative_id: string;
        /**
         * Org Id
         */
        org_id: string;
    };
    query?: never;
    url: '/org/{org_id}/initiatives/{initiative_id}';
};

export type OrgInitiativesDeleteInitiativeEndpointErrors = {
    /**
     * Not found
     */
    404: unknown;
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type OrgInitiativesDeleteInitiativeEndpointError = OrgInitiativesDeleteInitiativeEndpointErrors[keyof OrgInitiativesDeleteInitiativeEndpointErrors];

export type OrgInitiativesDeleteInitiativeEndpointResponses = {
    /**
     * Response Org-Initiatives-Delete Initiative Endpoint
     *
     * Successful Response
     */
    200: {
        [key: string]: string;
    };
};

export type OrgInitiativesDeleteInitiativeEndpointResponse = OrgInitiativesDeleteInitiativeEndpointResponses[keyof OrgInitiativesDeleteInitiativeEndpointResponses];

export type OrgInitiativesGetInitiativeDetailsData = {
    body?: never;
    path: {
        /**
         * Initiative Id
         */
        initiative_id: string;
        /**
         * Org Id
         */
        org_id: string;
    };
    query?: never;
    url: '/org/{org_id}/initiatives/{initiative_id}';
};

export type OrgInitiativesGetInitiativeDetailsErrors = {
    /**
     * Not found
     */
    404: unknown;
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type OrgInitiativesGetInitiativeDetailsError = OrgInitiativesGetInitiativeDetailsErrors[keyof OrgInitiativesGetInitiativeDetailsErrors];

export type OrgInitiativesGetInitiativeDetailsResponses = {
    /**
     * Successful Response
     */
    200: Initiative;
};

export type OrgInitiativesGetInitiativeDetailsResponse = OrgInitiativesGetInitiativeDetailsResponses[keyof OrgInitiativesGetInitiativeDetailsResponses];

export type OrgInitiativesUpdateInitiativeDetailsData = {
    body: InitiativeUpdate;
    path: {
        /**
         * Initiative Id
         */
        initiative_id: string;
        /**
         * Org Id
         */
        org_id: string;
    };
    query?: never;
    url: '/org/{org_id}/initiatives/{initiative_id}';
};

export type OrgInitiativesUpdateInitiativeDetailsErrors = {
    /**
     * Not found
     */
    404: unknown;
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type OrgInitiativesUpdateInitiativeDetailsError = OrgInitiativesUpdateInitiativeDetailsErrors[keyof OrgInitiativesUpdateInitiativeDetailsErrors];

export type OrgInitiativesUpdateInitiativeDetailsResponses = {
    /**
     * Response Org-Initiatives-Update Initiative Details
     *
     * Successful Response
     */
    200: InitiativeSummary | null;
};

export type OrgInitiativesUpdateInitiativeDetailsResponse = OrgInitiativesUpdateInitiativeDetailsResponses[keyof OrgInitiativesUpdateInitiativeDetailsResponses];

export type OrgInitiativesTasksCreateInitiativeTaskData = {
    body: InitiativeTaskCreate;
    path: {
        /**
         * Initiative Id
         */
        initiative_id: string;
        /**
         * Org Id
         */
        org_id: string;
    };
    query?: never;
    url: '/org/{org_id}/initiatives/{initiative_id}/tasks';
};

export type OrgInitiativesTasksCreateInitiativeTaskErrors = {
    /**
     * Not found
     */
    404: unknown;
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type OrgInitiativesTasksCreateInitiativeTaskError = OrgInitiativesTasksCreateInitiativeTaskErrors[keyof OrgInitiativesTasksCreateInitiativeTaskErrors];

export type OrgInitiativesTasksCreateInitiativeTaskResponses = {
    /**
     * Successful Response
     */
    200: InitiativeTask;
};

export type OrgInitiativesTasksCreateInitiativeTaskResponse = OrgInitiativesTasksCreateInitiativeTaskResponses[keyof OrgInitiativesTasksCreateInitiativeTaskResponses];

export type OrgInitiativesTasksDeleteInitiativeTaskData = {
    body?: never;
    path: {
        /**
         * Initiative Id
         */
        initiative_id: string;
        /**
         * Task Id
         */
        task_id: string;
        /**
         * Org Id
         */
        org_id: string;
    };
    query?: never;
    url: '/org/{org_id}/initiatives/{initiative_id}/tasks/{task_id}';
};

export type OrgInitiativesTasksDeleteInitiativeTaskErrors = {
    /**
     * Not found
     */
    404: unknown;
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type OrgInitiativesTasksDeleteInitiativeTaskError = OrgInitiativesTasksDeleteInitiativeTaskErrors[keyof OrgInitiativesTasksDeleteInitiativeTaskErrors];

export type OrgInitiativesTasksDeleteInitiativeTaskResponses = {
    /**
     * Response Org-Initiatives-Tasks-Delete Initiative Task
     *
     * Successful Response
     */
    200: {
        [key: string]: string;
    };
};

export type OrgInitiativesTasksDeleteInitiativeTaskResponse = OrgInitiativesTasksDeleteInitiativeTaskResponses[keyof OrgInitiativesTasksDeleteInitiativeTaskResponses];

export type OrgInitiativesTasksUpdateInitiativeTaskData = {
    body: InitiativeTaskUpdate;
    path: {
        /**
         * Initiative Id
         */
        initiative_id: string;
        /**
         * Task Id
         */
        task_id: string;
        /**
         * Org Id
         */
        org_id: string;
    };
    query?: never;
    url: '/org/{org_id}/initiatives/{initiative_id}/tasks/{task_id}';
};

export type OrgInitiativesTasksUpdateInitiativeTaskErrors = {
    /**
     * Not found
     */
    404: unknown;
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type OrgInitiativesTasksUpdateInitiativeTaskError = OrgInitiativesTasksUpdateInitiativeTaskErrors[keyof OrgInitiativesTasksUpdateInitiativeTaskErrors];

export type OrgInitiativesTasksUpdateInitiativeTaskResponses = {
    /**
     * Response Org-Initiatives-Tasks-Update Initiative Task
     *
     * Successful Response
     */
    200: InitiativeTask | null;
};

export type OrgInitiativesTasksUpdateInitiativeTaskResponse = OrgInitiativesTasksUpdateInitiativeTaskResponses[keyof OrgInitiativesTasksUpdateInitiativeTaskResponses];

export type OrgInitiativesTasksCompleteCompleteInitiativeTaskData = {
    body?: never;
    path: {
        /**
         * Initiative Id
         */
        initiative_id: string;
        /**
         * Task Id
         */
        task_id: string;
        /**
         * Org Id
         */
        org_id: string;
    };
    query?: never;
    url: '/org/{org_id}/initiatives/{initiative_id}/tasks/{task_id}/complete';
};

export type OrgInitiativesTasksCompleteCompleteInitiativeTaskErrors = {
    /**
     * Not found
     */
    404: unknown;
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type OrgInitiativesTasksCompleteCompleteInitiativeTaskError = OrgInitiativesTasksCompleteCompleteInitiativeTaskErrors[keyof OrgInitiativesTasksCompleteCompleteInitiativeTaskErrors];

export type OrgInitiativesTasksCompleteCompleteInitiativeTaskResponses = {
    /**
     * Response Org-Initiatives-Tasks-Complete-Complete Initiative Task
     *
     * Successful Response
     */
    200: {
        [key: string]: string;
    };
};

export type OrgInitiativesTasksCompleteCompleteInitiativeTaskResponse = OrgInitiativesTasksCompleteCompleteInitiativeTaskResponses[keyof OrgInitiativesTasksCompleteCompleteInitiativeTaskResponses];

export type OrgInitiativesMilestonesCreateInitiativeMilestoneData = {
    body: InitiativeMilestoneCreate;
    path: {
        /**
         * Initiative Id
         */
        initiative_id: string;
        /**
         * Org Id
         */
        org_id: string;
    };
    query?: never;
    url: '/org/{org_id}/initiatives/{initiative_id}/milestones';
};

export type OrgInitiativesMilestonesCreateInitiativeMilestoneErrors = {
    /**
     * Not found
     */
    404: unknown;
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type OrgInitiativesMilestonesCreateInitiativeMilestoneError = OrgInitiativesMilestonesCreateInitiativeMilestoneErrors[keyof OrgInitiativesMilestonesCreateInitiativeMilestoneErrors];

export type OrgInitiativesMilestonesCreateInitiativeMilestoneResponses = {
    /**
     * Successful Response
     */
    200: InitiativeMilestone;
};

export type OrgInitiativesMilestonesCreateInitiativeMilestoneResponse = OrgInitiativesMilestonesCreateInitiativeMilestoneResponses[keyof OrgInitiativesMilestonesCreateInitiativeMilestoneResponses];

export type OrgInitiativesMilestonesUpdateInitiativeMilestoneData = {
    body: InitiativeMilestoneUpdate;
    path: {
        /**
         * Initiative Id
         */
        initiative_id: string;
        /**
         * Milestone Id
         */
        milestone_id: string;
        /**
         * Org Id
         */
        org_id: string;
    };
    query?: never;
    url: '/org/{org_id}/initiatives/{initiative_id}/milestones/{milestone_id}';
};

export type OrgInitiativesMilestonesUpdateInitiativeMilestoneErrors = {
    /**
     * Not found
     */
    404: unknown;
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type OrgInitiativesMilestonesUpdateInitiativeMilestoneError = OrgInitiativesMilestonesUpdateInitiativeMilestoneErrors[keyof OrgInitiativesMilestonesUpdateInitiativeMilestoneErrors];

export type OrgInitiativesMilestonesUpdateInitiativeMilestoneResponses = {
    /**
     * Response Org-Initiatives-Milestones-Update Initiative Milestone
     *
     * Successful Response
     */
    200: InitiativeMilestone | null;
};

export type OrgInitiativesMilestonesUpdateInitiativeMilestoneResponse = OrgInitiativesMilestonesUpdateInitiativeMilestoneResponses[keyof OrgInitiativesMilestonesUpdateInitiativeMilestoneResponses];

export type OrgInitiativesMilestonesCompleteCompleteInitiativeMilestoneData = {
    body?: never;
    path: {
        /**
         * Initiative Id
         */
        initiative_id: string;
        /**
         * Milestone Id
         */
        milestone_id: string;
        /**
         * Org Id
         */
        org_id: string;
    };
    query?: never;
    url: '/org/{org_id}/initiatives/{initiative_id}/milestones/{milestone_id}/complete';
};

export type OrgInitiativesMilestonesCompleteCompleteInitiativeMilestoneErrors = {
    /**
     * Not found
     */
    404: unknown;
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type OrgInitiativesMilestonesCompleteCompleteInitiativeMilestoneError = OrgInitiativesMilestonesCompleteCompleteInitiativeMilestoneErrors[keyof OrgInitiativesMilestonesCompleteCompleteInitiativeMilestoneErrors];

export type OrgInitiativesMilestonesCompleteCompleteInitiativeMilestoneResponses = {
    /**
     * Response Org-Initiatives-Milestones-Complete-Complete Initiative Milestone
     *
     * Successful Response
     */
    200: {
        [key: string]: string;
    };
};

export type OrgInitiativesMilestonesCompleteCompleteInitiativeMilestoneResponse = OrgInitiativesMilestonesCompleteCompleteInitiativeMilestoneResponses[keyof OrgInitiativesMilestonesCompleteCompleteInitiativeMilestoneResponses];

export type OrgInitiativesImpactsAddInitiativeImpactData = {
    body: InitiativeImpactCreate;
    path: {
        /**
         * Initiative Id
         */
        initiative_id: string;
        /**
         * Org Id
         */
        org_id: string;
    };
    query?: never;
    url: '/org/{org_id}/initiatives/{initiative_id}/impacts';
};

export type OrgInitiativesImpactsAddInitiativeImpactErrors = {
    /**
     * Not found
     */
    404: unknown;
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type OrgInitiativesImpactsAddInitiativeImpactError = OrgInitiativesImpactsAddInitiativeImpactErrors[keyof OrgInitiativesImpactsAddInitiativeImpactErrors];

export type OrgInitiativesImpactsAddInitiativeImpactResponses = {
    /**
     * Response Org-Initiatives-Impacts-Add Initiative Impact
     *
     * Successful Response
     */
    200: {
        [key: string]: string;
    };
};

export type OrgInitiativesImpactsAddInitiativeImpactResponse = OrgInitiativesImpactsAddInitiativeImpactResponses[keyof OrgInitiativesImpactsAddInitiativeImpactResponses];

export type OrgInitiativesProgressGetInitiativeProgressData = {
    body?: never;
    path: {
        /**
         * Initiative Id
         */
        initiative_id: string;
        /**
         * Org Id
         */
        org_id: string;
    };
    query?: never;
    url: '/org/{org_id}/initiatives/{initiative_id}/progress';
};

export type OrgInitiativesProgressGetInitiativeProgressErrors = {
    /**
     * Not found
     */
    404: unknown;
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type OrgInitiativesProgressGetInitiativeProgressError = OrgInitiativesProgressGetInitiativeProgressErrors[keyof OrgInitiativesProgressGetInitiativeProgressErrors];

export type OrgInitiativesProgressGetInitiativeProgressResponses = {
    /**
     * Successful Response
     */
    200: InitiativeProgress;
};

export type OrgInitiativesProgressGetInitiativeProgressResponse = OrgInitiativesProgressGetInitiativeProgressResponses[keyof OrgInitiativesProgressGetInitiativeProgressResponses];

export type OrgInsightsGetSummaryData = {
    body?: never;
    path: {
        /**
         * Org Id
         */
        org_id: string;
    };
    query?: never;
    url: '/org/{org_id}/insights/';
};

export type OrgInsightsGetSummaryErrors = {
    /**
     * Not found
     */
    404: unknown;
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type OrgInsightsGetSummaryError = OrgInsightsGetSummaryErrors[keyof OrgInsightsGetSummaryErrors];

export type OrgInsightsGetSummaryResponses = {
    /**
     * Successful Response
     */
    200: InsightsSummary;
};

export type OrgInsightsGetSummaryResponse = OrgInsightsGetSummaryResponses[keyof OrgInsightsGetSummaryResponses];

export type OrgInsightsMissingGetMissingIssuesData = {
    body?: never;
    path: {
        /**
         * Org Id
         */
        org_id: string;
    };
    query?: never;
    url: '/org/{org_id}/insights/missing';
};

export type OrgInsightsMissingGetMissingIssuesErrors = {
    /**
     * Not found
     */
    404: unknown;
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type OrgInsightsMissingGetMissingIssuesError = OrgInsightsMissingGetMissingIssuesErrors[keyof OrgInsightsMissingGetMissingIssuesErrors];

export type OrgInsightsMissingGetMissingIssuesResponses = {
    /**
     * Response Org-Insights-Missing-Get Missing Issues
     *
     * Successful Response
     */
    200: Array<MissingDataIssue>;
};

export type OrgInsightsMissingGetMissingIssuesResponse = OrgInsightsMissingGetMissingIssuesResponses[keyof OrgInsightsMissingGetMissingIssuesResponses];

export type OrgInsightsIncorrectGetIncorrectIssuesData = {
    body?: never;
    path: {
        /**
         * Org Id
         */
        org_id: string;
    };
    query?: never;
    url: '/org/{org_id}/insights/incorrect';
};

export type OrgInsightsIncorrectGetIncorrectIssuesErrors = {
    /**
     * Not found
     */
    404: unknown;
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type OrgInsightsIncorrectGetIncorrectIssuesError = OrgInsightsIncorrectGetIncorrectIssuesErrors[keyof OrgInsightsIncorrectGetIncorrectIssuesErrors];

export type OrgInsightsIncorrectGetIncorrectIssuesResponses = {
    /**
     * Response Org-Insights-Incorrect-Get Incorrect Issues
     *
     * Successful Response
     */
    200: Array<IncorrectDataIssue>;
};

export type OrgInsightsIncorrectGetIncorrectIssuesResponse = OrgInsightsIncorrectGetIncorrectIssuesResponses[keyof OrgInsightsIncorrectGetIncorrectIssuesResponses];

export type OrgInsightsDuplicatesGetDuplicateIssuesData = {
    body?: never;
    path: {
        /**
         * Org Id
         */
        org_id: string;
    };
    query?: never;
    url: '/org/{org_id}/insights/duplicates';
};

export type OrgInsightsDuplicatesGetDuplicateIssuesErrors = {
    /**
     * Not found
     */
    404: unknown;
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type OrgInsightsDuplicatesGetDuplicateIssuesError = OrgInsightsDuplicatesGetDuplicateIssuesErrors[keyof OrgInsightsDuplicatesGetDuplicateIssuesErrors];

export type OrgInsightsDuplicatesGetDuplicateIssuesResponses = {
    /**
     * Response Org-Insights-Duplicates-Get Duplicate Issues
     *
     * Successful Response
     */
    200: Array<DuplicateDataIssue>;
};

export type OrgInsightsDuplicatesGetDuplicateIssuesResponse = OrgInsightsDuplicatesGetDuplicateIssuesResponses[keyof OrgInsightsDuplicatesGetDuplicateIssuesResponses];

export type OrgIntegrationListOrgIntegrationsData = {
    body?: never;
    path: {
        /**
         * Org Id
         */
        org_id: string;
    };
    query?: never;
    url: '/org/{org_id}/integration/';
};

export type OrgIntegrationListOrgIntegrationsErrors = {
    /**
     * Not found
     */
    404: unknown;
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type OrgIntegrationListOrgIntegrationsError = OrgIntegrationListOrgIntegrationsErrors[keyof OrgIntegrationListOrgIntegrationsErrors];

export type OrgIntegrationListOrgIntegrationsResponses = {
    /**
     * Response Org-Integration--List Org Integrations
     *
     * Successful Response
     */
    200: Array<OrgIntegration>;
};

export type OrgIntegrationListOrgIntegrationsResponse = OrgIntegrationListOrgIntegrationsResponses[keyof OrgIntegrationListOrgIntegrationsResponses];

export type OrgIntegrationImageGetImageData = {
    body?: never;
    path: {
        /**
         * Integration Id
         */
        integration_id: string;
    };
    query?: never;
    url: '/org/{org_id}/integration/{integration_id}/image';
};

export type OrgIntegrationImageGetImageErrors = {
    /**
     * Not found
     */
    404: unknown;
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type OrgIntegrationImageGetImageError = OrgIntegrationImageGetImageErrors[keyof OrgIntegrationImageGetImageErrors];

export type OrgIntegrationImageGetImageResponses = {
    /**
     * Successful Response
     */
    200: unknown;
};

export type OrgInvitationListInvitationsData = {
    body?: never;
    path: {
        /**
         * Org Id
         */
        org_id: string;
    };
    query?: never;
    url: '/org/{org_id}/invitation/';
};

export type OrgInvitationListInvitationsErrors = {
    /**
     * Not found
     */
    404: unknown;
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type OrgInvitationListInvitationsError = OrgInvitationListInvitationsErrors[keyof OrgInvitationListInvitationsErrors];

export type OrgInvitationListInvitationsResponses = {
    /**
     * Response Org-Invitation--List Invitations
     *
     * Successful Response
     */
    200: Array<Invitation>;
};

export type OrgInvitationListInvitationsResponse = OrgInvitationListInvitationsResponses[keyof OrgInvitationListInvitationsResponses];

export type OrgInvitationCreateData = {
    body: InvitationCreate;
    path: {
        /**
         * Org Id
         */
        org_id: string;
    };
    query?: never;
    url: '/org/{org_id}/invitation/';
};

export type OrgInvitationCreateErrors = {
    /**
     * Not found
     */
    404: unknown;
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type OrgInvitationCreateError = OrgInvitationCreateErrors[keyof OrgInvitationCreateErrors];

export type OrgInvitationCreateResponses = {
    /**
     * Successful Response
     */
    200: InvitationCreateResult;
};

export type OrgInvitationCreateResponse = OrgInvitationCreateResponses[keyof OrgInvitationCreateResponses];

export type OrgInvitationReadData = {
    body?: never;
    path: {
        /**
         * Invitation Id
         */
        invitation_id: string;
        /**
         * Org Id
         */
        org_id: string;
    };
    query?: never;
    url: '/org/{org_id}/invitation/{invitation_id}';
};

export type OrgInvitationReadErrors = {
    /**
     * Not found
     */
    404: unknown;
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type OrgInvitationReadError = OrgInvitationReadErrors[keyof OrgInvitationReadErrors];

export type OrgInvitationReadResponses = {
    /**
     * Successful Response
     */
    200: Invitation;
};

export type OrgInvitationReadResponse = OrgInvitationReadResponses[keyof OrgInvitationReadResponses];

export type OrgInvitationUpdateData = {
    body: InvitationUpdate;
    path: {
        /**
         * Invitation Id
         */
        invitation_id: string;
        /**
         * Org Id
         */
        org_id: string;
    };
    query?: never;
    url: '/org/{org_id}/invitation/{invitation_id}';
};

export type OrgInvitationUpdateErrors = {
    /**
     * Not found
     */
    404: unknown;
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type OrgInvitationUpdateError = OrgInvitationUpdateErrors[keyof OrgInvitationUpdateErrors];

export type OrgInvitationUpdateResponses = {
    /**
     * Successful Response
     */
    200: Invitation;
};

export type OrgInvitationUpdateResponse = OrgInvitationUpdateResponses[keyof OrgInvitationUpdateResponses];

export type OrgJurisdictionBoundsLookupBoundsData = {
    body?: never;
    path: {
        /**
         * Org Id
         */
        org_id: string;
    };
    query?: {
        /**
         * Zip
         */
        zip?: Array<string> | null;
        /**
         * City
         */
        city?: string | null;
        /**
         * County
         */
        county?: string | null;
        /**
         * State
         */
        state?: string | null;
    };
    url: '/org/{org_id}/jurisdiction/bounds';
};

export type OrgJurisdictionBoundsLookupBoundsErrors = {
    /**
     * Not found
     */
    404: unknown;
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type OrgJurisdictionBoundsLookupBoundsError = OrgJurisdictionBoundsLookupBoundsErrors[keyof OrgJurisdictionBoundsLookupBoundsErrors];

export type OrgJurisdictionBoundsLookupBoundsResponses = {
    /**
     * Response Org-Jurisdiction-Bounds-Lookup Bounds
     *
     * Successful Response
     */
    200: Array<GeoJsonObject>;
};

export type OrgJurisdictionBoundsLookupBoundsResponse = OrgJurisdictionBoundsLookupBoundsResponses[keyof OrgJurisdictionBoundsLookupBoundsResponses];

export type OrgJurisdictionListJurisdictionsData = {
    body?: never;
    path: {
        /**
         * Org Id
         */
        org_id: string;
    };
    query?: never;
    url: '/org/{org_id}/jurisdiction/';
};

export type OrgJurisdictionListJurisdictionsErrors = {
    /**
     * Not found
     */
    404: unknown;
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type OrgJurisdictionListJurisdictionsError = OrgJurisdictionListJurisdictionsErrors[keyof OrgJurisdictionListJurisdictionsErrors];

export type OrgJurisdictionListJurisdictionsResponses = {
    /**
     * Response Org-Jurisdiction--List Jurisdictions
     *
     * Successful Response
     */
    200: Array<Jurisdiction>;
};

export type OrgJurisdictionListJurisdictionsResponse = OrgJurisdictionListJurisdictionsResponses[keyof OrgJurisdictionListJurisdictionsResponses];

export type OrgJurisdictionCreateOrgJurisdictionData = {
    body: JurisdictionCreate;
    path: {
        /**
         * Org Id
         */
        org_id: string;
    };
    query?: never;
    url: '/org/{org_id}/jurisdiction/';
};

export type OrgJurisdictionCreateOrgJurisdictionErrors = {
    /**
     * Not found
     */
    404: unknown;
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type OrgJurisdictionCreateOrgJurisdictionError = OrgJurisdictionCreateOrgJurisdictionErrors[keyof OrgJurisdictionCreateOrgJurisdictionErrors];

export type OrgJurisdictionCreateOrgJurisdictionResponses = {
    /**
     * Successful Response
     */
    200: Jurisdiction;
};

export type OrgJurisdictionCreateOrgJurisdictionResponse = OrgJurisdictionCreateOrgJurisdictionResponses[keyof OrgJurisdictionCreateOrgJurisdictionResponses];

export type OrgJurisdictionDeactivateJurisdictionEndpointData = {
    body?: never;
    path: {
        /**
         * Jurisdiction Id
         */
        jurisdiction_id: string;
        /**
         * Org Id
         */
        org_id: string;
    };
    query?: never;
    url: '/org/{org_id}/jurisdiction/{jurisdiction_id}';
};

export type OrgJurisdictionDeactivateJurisdictionEndpointErrors = {
    /**
     * Not found
     */
    404: unknown;
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type OrgJurisdictionDeactivateJurisdictionEndpointError = OrgJurisdictionDeactivateJurisdictionEndpointErrors[keyof OrgJurisdictionDeactivateJurisdictionEndpointErrors];

export type OrgJurisdictionDeactivateJurisdictionEndpointResponses = {
    /**
     * Response Org-Jurisdiction-Deactivate Jurisdiction Endpoint
     *
     * Successful Response
     */
    200: {
        [key: string]: string;
    };
};

export type OrgJurisdictionDeactivateJurisdictionEndpointResponse = OrgJurisdictionDeactivateJurisdictionEndpointResponses[keyof OrgJurisdictionDeactivateJurisdictionEndpointResponses];

export type OrgJurisdictionGetJurisdictionDetailsData = {
    body?: never;
    path: {
        /**
         * Jurisdiction Id
         */
        jurisdiction_id: string;
        /**
         * Org Id
         */
        org_id: string;
    };
    query?: never;
    url: '/org/{org_id}/jurisdiction/{jurisdiction_id}';
};

export type OrgJurisdictionGetJurisdictionDetailsErrors = {
    /**
     * Not found
     */
    404: unknown;
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type OrgJurisdictionGetJurisdictionDetailsError = OrgJurisdictionGetJurisdictionDetailsErrors[keyof OrgJurisdictionGetJurisdictionDetailsErrors];

export type OrgJurisdictionGetJurisdictionDetailsResponses = {
    /**
     * Successful Response
     */
    200: Jurisdiction;
};

export type OrgJurisdictionGetJurisdictionDetailsResponse = OrgJurisdictionGetJurisdictionDetailsResponses[keyof OrgJurisdictionGetJurisdictionDetailsResponses];

export type OrgJurisdictionUpdateJurisdictionDetailsData = {
    body: JurisdictionUpdate;
    path: {
        /**
         * Jurisdiction Id
         */
        jurisdiction_id: string;
        /**
         * Org Id
         */
        org_id: string;
    };
    query?: never;
    url: '/org/{org_id}/jurisdiction/{jurisdiction_id}';
};

export type OrgJurisdictionUpdateJurisdictionDetailsErrors = {
    /**
     * Not found
     */
    404: unknown;
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type OrgJurisdictionUpdateJurisdictionDetailsError = OrgJurisdictionUpdateJurisdictionDetailsErrors[keyof OrgJurisdictionUpdateJurisdictionDetailsErrors];

export type OrgJurisdictionUpdateJurisdictionDetailsResponses = {
    /**
     * Successful Response
     */
    200: Jurisdiction;
};

export type OrgJurisdictionUpdateJurisdictionDetailsResponse = OrgJurisdictionUpdateJurisdictionDetailsResponses[keyof OrgJurisdictionUpdateJurisdictionDetailsResponses];

export type OrgJurisdictionUploadBoundaryUploadBoundaryFileData = {
    body: BodyOrgJurisdictionUploadBoundaryUploadBoundaryFile;
    path: {
        /**
         * Org Id
         */
        org_id: string;
    };
    query?: never;
    url: '/org/{org_id}/jurisdiction/upload-boundary';
};

export type OrgJurisdictionUploadBoundaryUploadBoundaryFileErrors = {
    /**
     * Not found
     */
    404: unknown;
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type OrgJurisdictionUploadBoundaryUploadBoundaryFileError = OrgJurisdictionUploadBoundaryUploadBoundaryFileErrors[keyof OrgJurisdictionUploadBoundaryUploadBoundaryFileErrors];

export type OrgJurisdictionUploadBoundaryUploadBoundaryFileResponses = {
    /**
     * Successful Response
     */
    200: FileSet;
};

export type OrgJurisdictionUploadBoundaryUploadBoundaryFileResponse = OrgJurisdictionUploadBoundaryUploadBoundaryFileResponses[keyof OrgJurisdictionUploadBoundaryUploadBoundaryFileResponses];

export type OrgMeterListMetersData = {
    body?: never;
    path: {
        /**
         * Org Id
         */
        org_id: string;
    };
    query?: {
        /**
         * Search Text
         */
        search_text?: string | null;
        /**
         * Weather Normalize
         */
        weather_normalize?: boolean | null;
        /**
         * Bucket Grain
         */
        bucket_grain?: BucketGrain | null;
        /**
         * Date Range Spec
         */
        date_range_spec?: 'Calendar Year To Date' | 'Last Calendar Year' | 'Fiscal Year To Date' | 'Last Fiscal Year' | 'Quarter To Date' | 'Last Quarter' | 'Month To Date' | 'Last Month' | 'Last Three Months' | 'Last Six Months' | 'Last Twelve Months' | 'Custom' | null;
        /**
         * Date Range Start
         */
        date_range_start?: string | null;
        /**
         * Date Range End
         */
        date_range_end?: string | null;
        /**
         * Funds
         */
        funds?: Array<string> | null;
        /**
         * Departments
         */
        departments?: Array<string> | null;
        /**
         * Properties
         */
        properties?: Array<string> | null;
        /**
         * Billing Accounts
         */
        billing_accounts?: Array<string> | null;
        /**
         * Commodities
         */
        commodities?: Array<string> | null;
        /**
         * Utility Tariffs
         */
        utility_tariffs?: Array<string> | null;
        /**
         * Utility Companies
         */
        utility_companies?: Array<string> | null;
        /**
         * Utility Suppliers
         */
        utility_suppliers?: Array<string> | null;
        /**
         * Meters
         */
        meters?: Array<string> | null;
    };
    url: '/org/{org_id}/meter/';
};

export type OrgMeterListMetersErrors = {
    /**
     * Not found
     */
    404: unknown;
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type OrgMeterListMetersError = OrgMeterListMetersErrors[keyof OrgMeterListMetersErrors];

export type OrgMeterListMetersResponses = {
    /**
     * Response Org-Meter--List Meters
     *
     * Successful Response
     */
    200: Array<Meter>;
};

export type OrgMeterListMetersResponse = OrgMeterListMetersResponses[keyof OrgMeterListMetersResponses];

export type OrgMeterCreateMeterData = {
    body: PublicMeterCreate;
    path: {
        /**
         * Org Id
         */
        org_id: string;
    };
    query?: never;
    url: '/org/{org_id}/meter/';
};

export type OrgMeterCreateMeterErrors = {
    /**
     * Not found
     */
    404: unknown;
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type OrgMeterCreateMeterError = OrgMeterCreateMeterErrors[keyof OrgMeterCreateMeterErrors];

export type OrgMeterCreateMeterResponses = {
    /**
     * Successful Response
     */
    200: Meter;
};

export type OrgMeterCreateMeterResponse = OrgMeterCreateMeterResponses[keyof OrgMeterCreateMeterResponses];

export type OrgMeterDeleteMeterData = {
    body?: never;
    path: {
        /**
         * Meter Id
         */
        meter_id: string;
        /**
         * Org Id
         */
        org_id: string;
    };
    query?: never;
    url: '/org/{org_id}/meter/{meter_id}';
};

export type OrgMeterDeleteMeterErrors = {
    /**
     * Not found
     */
    404: unknown;
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type OrgMeterDeleteMeterError = OrgMeterDeleteMeterErrors[keyof OrgMeterDeleteMeterErrors];

export type OrgMeterDeleteMeterResponses = {
    /**
     * Successful Response
     */
    200: unknown;
};

export type OrgMeterGetMeterData = {
    body?: never;
    path: {
        /**
         * Meter Id
         */
        meter_id: string;
        /**
         * Org Id
         */
        org_id: string;
    };
    query?: never;
    url: '/org/{org_id}/meter/{meter_id}';
};

export type OrgMeterGetMeterErrors = {
    /**
     * Not found
     */
    404: unknown;
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type OrgMeterGetMeterError = OrgMeterGetMeterErrors[keyof OrgMeterGetMeterErrors];

export type OrgMeterGetMeterResponses = {
    /**
     * Successful Response
     */
    200: Meter;
};

export type OrgMeterGetMeterResponse = OrgMeterGetMeterResponses[keyof OrgMeterGetMeterResponses];

export type OrgMeterUpdateMeterData = {
    body: PublicMeterUpdate;
    path: {
        /**
         * Meter Id
         */
        meter_id: string;
        /**
         * Org Id
         */
        org_id: string;
    };
    query?: never;
    url: '/org/{org_id}/meter/{meter_id}';
};

export type OrgMeterUpdateMeterErrors = {
    /**
     * Not found
     */
    404: unknown;
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type OrgMeterUpdateMeterError = OrgMeterUpdateMeterErrors[keyof OrgMeterUpdateMeterErrors];

export type OrgMeterUpdateMeterResponses = {
    /**
     * Successful Response
     */
    200: Meter;
};

export type OrgMeterUpdateMeterResponse = OrgMeterUpdateMeterResponses[keyof OrgMeterUpdateMeterResponses];

export type OrgMeterCapabilityListCapabilitiesData = {
    body?: never;
    path: {
        /**
         * Meter Id
         */
        meter_id: string;
        /**
         * Org Id
         */
        org_id: string;
    };
    query?: never;
    url: '/org/{org_id}/meter/{meter_id}/capability/';
};

export type OrgMeterCapabilityListCapabilitiesErrors = {
    /**
     * Not found
     */
    404: unknown;
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type OrgMeterCapabilityListCapabilitiesError = OrgMeterCapabilityListCapabilitiesErrors[keyof OrgMeterCapabilityListCapabilitiesErrors];

export type OrgMeterCapabilityListCapabilitiesResponses = {
    /**
     * Response Org-Meter-Capability--List Capabilities
     *
     * Successful Response
     */
    200: Array<MeterCapability>;
};

export type OrgMeterCapabilityListCapabilitiesResponse = OrgMeterCapabilityListCapabilitiesResponses[keyof OrgMeterCapabilityListCapabilitiesResponses];

export type OrgMeterCapabilityAddCapabilityData = {
    body: PublicMeterCapabilityCreate;
    path: {
        /**
         * Meter Id
         */
        meter_id: string;
        /**
         * Org Id
         */
        org_id: string;
    };
    query?: never;
    url: '/org/{org_id}/meter/{meter_id}/capability/';
};

export type OrgMeterCapabilityAddCapabilityErrors = {
    /**
     * Not found
     */
    404: unknown;
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type OrgMeterCapabilityAddCapabilityError = OrgMeterCapabilityAddCapabilityErrors[keyof OrgMeterCapabilityAddCapabilityErrors];

export type OrgMeterCapabilityAddCapabilityResponses = {
    /**
     * Successful Response
     */
    200: MeterCapability;
};

export type OrgMeterCapabilityAddCapabilityResponse = OrgMeterCapabilityAddCapabilityResponses[keyof OrgMeterCapabilityAddCapabilityResponses];

export type OrgMeterCapabilityRemoveCapabilityData = {
    body?: never;
    path: {
        /**
         * Meter Id
         */
        meter_id: string;
        /**
         * Capability Id
         */
        capability_id: string;
        /**
         * Org Id
         */
        org_id: string;
    };
    query?: never;
    url: '/org/{org_id}/meter/{meter_id}/capability/{capability_id}';
};

export type OrgMeterCapabilityRemoveCapabilityErrors = {
    /**
     * Not found
     */
    404: unknown;
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type OrgMeterCapabilityRemoveCapabilityError = OrgMeterCapabilityRemoveCapabilityErrors[keyof OrgMeterCapabilityRemoveCapabilityErrors];

export type OrgMeterCapabilityRemoveCapabilityResponses = {
    /**
     * Successful Response
     */
    200: unknown;
};

export type OrgMeterCapabilityGetCapabilityData = {
    body?: never;
    path: {
        /**
         * Meter Id
         */
        meter_id: string;
        /**
         * Capability Id
         */
        capability_id: string;
        /**
         * Org Id
         */
        org_id: string;
    };
    query?: never;
    url: '/org/{org_id}/meter/{meter_id}/capability/{capability_id}';
};

export type OrgMeterCapabilityGetCapabilityErrors = {
    /**
     * Not found
     */
    404: unknown;
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type OrgMeterCapabilityGetCapabilityError = OrgMeterCapabilityGetCapabilityErrors[keyof OrgMeterCapabilityGetCapabilityErrors];

export type OrgMeterCapabilityGetCapabilityResponses = {
    /**
     * Successful Response
     */
    200: MeterCapability;
};

export type OrgMeterCapabilityGetCapabilityResponse = OrgMeterCapabilityGetCapabilityResponses[keyof OrgMeterCapabilityGetCapabilityResponses];

export type OrgMeterCapabilityUpdateCapabilityData = {
    body: PublicMeterCapabilityUpdate;
    path: {
        /**
         * Meter Id
         */
        meter_id: string;
        /**
         * Capability Id
         */
        capability_id: string;
        /**
         * Org Id
         */
        org_id: string;
    };
    query?: never;
    url: '/org/{org_id}/meter/{meter_id}/capability/{capability_id}';
};

export type OrgMeterCapabilityUpdateCapabilityErrors = {
    /**
     * Not found
     */
    404: unknown;
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type OrgMeterCapabilityUpdateCapabilityError = OrgMeterCapabilityUpdateCapabilityErrors[keyof OrgMeterCapabilityUpdateCapabilityErrors];

export type OrgMeterCapabilityUpdateCapabilityResponses = {
    /**
     * Successful Response
     */
    200: MeterCapability;
};

export type OrgMeterCapabilityUpdateCapabilityResponse = OrgMeterCapabilityUpdateCapabilityResponses[keyof OrgMeterCapabilityUpdateCapabilityResponses];

export type OrgMeterReadingListReadingsData = {
    body?: never;
    path: {
        /**
         * Meter Id
         */
        meter_id: string;
        /**
         * Org Id
         */
        org_id: string;
    };
    query?: {
        /**
         * Capability Id
         */
        capability_id?: string | null;
        /**
         * Date Start
         */
        date_start?: string | null;
        /**
         * Date End
         */
        date_end?: string | null;
    };
    url: '/org/{org_id}/meter/{meter_id}/reading/';
};

export type OrgMeterReadingListReadingsErrors = {
    /**
     * Not found
     */
    404: unknown;
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type OrgMeterReadingListReadingsError = OrgMeterReadingListReadingsErrors[keyof OrgMeterReadingListReadingsErrors];

export type OrgMeterReadingListReadingsResponses = {
    /**
     * Response Org-Meter-Reading--List Readings
     *
     * Successful Response
     */
    200: Array<MeterReading>;
};

export type OrgMeterReadingListReadingsResponse = OrgMeterReadingListReadingsResponses[keyof OrgMeterReadingListReadingsResponses];

export type OrgMeterReadingCreateReadingData = {
    body: MeterReadingCreate;
    path: {
        /**
         * Meter Id
         */
        meter_id: string;
        /**
         * Org Id
         */
        org_id: string;
    };
    query?: never;
    url: '/org/{org_id}/meter/{meter_id}/reading/';
};

export type OrgMeterReadingCreateReadingErrors = {
    /**
     * Not found
     */
    404: unknown;
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type OrgMeterReadingCreateReadingError = OrgMeterReadingCreateReadingErrors[keyof OrgMeterReadingCreateReadingErrors];

export type OrgMeterReadingCreateReadingResponses = {
    /**
     * Successful Response
     */
    200: MeterReading;
};

export type OrgMeterReadingCreateReadingResponse = OrgMeterReadingCreateReadingResponses[keyof OrgMeterReadingCreateReadingResponses];

export type OrgMeterReadingDeleteReadingData = {
    body?: never;
    path: {
        /**
         * Meter Id
         */
        meter_id: string;
        /**
         * Reading Id
         */
        reading_id: string;
        /**
         * Org Id
         */
        org_id: string;
    };
    query?: never;
    url: '/org/{org_id}/meter/{meter_id}/reading/{reading_id}';
};

export type OrgMeterReadingDeleteReadingErrors = {
    /**
     * Not found
     */
    404: unknown;
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type OrgMeterReadingDeleteReadingError = OrgMeterReadingDeleteReadingErrors[keyof OrgMeterReadingDeleteReadingErrors];

export type OrgMeterReadingDeleteReadingResponses = {
    /**
     * Successful Response
     */
    200: unknown;
};

export type OrgMeterReadingGetReadingData = {
    body?: never;
    path: {
        /**
         * Meter Id
         */
        meter_id: string;
        /**
         * Reading Id
         */
        reading_id: string;
        /**
         * Org Id
         */
        org_id: string;
    };
    query?: never;
    url: '/org/{org_id}/meter/{meter_id}/reading/{reading_id}';
};

export type OrgMeterReadingGetReadingErrors = {
    /**
     * Not found
     */
    404: unknown;
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type OrgMeterReadingGetReadingError = OrgMeterReadingGetReadingErrors[keyof OrgMeterReadingGetReadingErrors];

export type OrgMeterReadingGetReadingResponses = {
    /**
     * Successful Response
     */
    200: MeterReading;
};

export type OrgMeterReadingGetReadingResponse = OrgMeterReadingGetReadingResponses[keyof OrgMeterReadingGetReadingResponses];

export type OrgMeterReadingUpdateReadingData = {
    body: MeterReadingUpdate;
    path: {
        /**
         * Meter Id
         */
        meter_id: string;
        /**
         * Reading Id
         */
        reading_id: string;
        /**
         * Org Id
         */
        org_id: string;
    };
    query?: never;
    url: '/org/{org_id}/meter/{meter_id}/reading/{reading_id}';
};

export type OrgMeterReadingUpdateReadingErrors = {
    /**
     * Not found
     */
    404: unknown;
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type OrgMeterReadingUpdateReadingError = OrgMeterReadingUpdateReadingErrors[keyof OrgMeterReadingUpdateReadingErrors];

export type OrgMeterReadingUpdateReadingResponses = {
    /**
     * Successful Response
     */
    200: MeterReading;
};

export type OrgMeterReadingUpdateReadingResponse = OrgMeterReadingUpdateReadingResponses[keyof OrgMeterReadingUpdateReadingResponses];

export type OrgMeterIntervalChannelsListChannelsData = {
    body?: never;
    path: {
        /**
         * Meter Id
         */
        meter_id: string;
        /**
         * Org Id
         */
        org_id: string;
    };
    query?: never;
    url: '/org/{org_id}/meter/{meter_id}/interval/channels';
};

export type OrgMeterIntervalChannelsListChannelsErrors = {
    /**
     * Not found
     */
    404: unknown;
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type OrgMeterIntervalChannelsListChannelsError = OrgMeterIntervalChannelsListChannelsErrors[keyof OrgMeterIntervalChannelsListChannelsErrors];

export type OrgMeterIntervalChannelsListChannelsResponses = {
    /**
     * Response Org-Meter-Interval-Channels-List Channels
     *
     * Successful Response
     */
    200: Array<IntervalChannel>;
};

export type OrgMeterIntervalChannelsListChannelsResponse = OrgMeterIntervalChannelsListChannelsResponses[keyof OrgMeterIntervalChannelsListChannelsResponses];

export type OrgMeterIntervalGetIntervalSeriesData = {
    body?: never;
    path: {
        /**
         * Meter Id
         */
        meter_id: string;
        /**
         * Org Id
         */
        org_id: string;
    };
    query: {
        /**
         * Capability Id
         */
        capability_id: string;
        /**
         * Start
         */
        start: string;
        /**
         * End
         */
        end: string;
        /**
         * Grain
         */
        grain?: 'auto' | 'raw' | 'hour' | 'day';
        /**
         * Max Points
         */
        max_points?: number;
    };
    url: '/org/{org_id}/meter/{meter_id}/interval/';
};

export type OrgMeterIntervalGetIntervalSeriesErrors = {
    /**
     * Not found
     */
    404: unknown;
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type OrgMeterIntervalGetIntervalSeriesError = OrgMeterIntervalGetIntervalSeriesErrors[keyof OrgMeterIntervalGetIntervalSeriesErrors];

export type OrgMeterIntervalGetIntervalSeriesResponses = {
    /**
     * Successful Response
     */
    200: IntervalSeries;
};

export type OrgMeterIntervalGetIntervalSeriesResponse = OrgMeterIntervalGetIntervalSeriesResponses[keyof OrgMeterIntervalGetIntervalSeriesResponses];

export type OrgMeterIntervalSummaryGetIntervalSummaryData = {
    body?: never;
    path: {
        /**
         * Meter Id
         */
        meter_id: string;
        /**
         * Org Id
         */
        org_id: string;
    };
    query: {
        /**
         * Capability Id
         */
        capability_id: string;
        /**
         * Start
         */
        start: string;
        /**
         * End
         */
        end: string;
    };
    url: '/org/{org_id}/meter/{meter_id}/interval/summary';
};

export type OrgMeterIntervalSummaryGetIntervalSummaryErrors = {
    /**
     * Not found
     */
    404: unknown;
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type OrgMeterIntervalSummaryGetIntervalSummaryError = OrgMeterIntervalSummaryGetIntervalSummaryErrors[keyof OrgMeterIntervalSummaryGetIntervalSummaryErrors];

export type OrgMeterIntervalSummaryGetIntervalSummaryResponses = {
    /**
     * Successful Response
     */
    200: IntervalSummary;
};

export type OrgMeterIntervalSummaryGetIntervalSummaryResponse = OrgMeterIntervalSummaryGetIntervalSummaryResponses[keyof OrgMeterIntervalSummaryGetIntervalSummaryResponses];

export type OrgMeterIntervalBatchPushIntervalBatchData = {
    body: IntervalBatchIn;
    path: {
        /**
         * Meter Id
         */
        meter_id: string;
        /**
         * Org Id
         */
        org_id: string;
    };
    query?: never;
    url: '/org/{org_id}/meter/{meter_id}/interval/batch';
};

export type OrgMeterIntervalBatchPushIntervalBatchErrors = {
    /**
     * Not found
     */
    404: unknown;
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type OrgMeterIntervalBatchPushIntervalBatchError = OrgMeterIntervalBatchPushIntervalBatchErrors[keyof OrgMeterIntervalBatchPushIntervalBatchErrors];

export type OrgMeterIntervalBatchPushIntervalBatchResponses = {
    /**
     * Successful Response
     */
    200: IntervalBatchResult;
};

export type OrgMeterIntervalBatchPushIntervalBatchResponse = OrgMeterIntervalBatchPushIntervalBatchResponses[keyof OrgMeterIntervalBatchPushIntervalBatchResponses];

export type OrgMeterMeasureTypeListMeterMeasureTypesData = {
    body?: never;
    path: {
        /**
         * Org Id
         */
        org_id: string;
    };
    query?: never;
    url: '/org/{org_id}/meter-measure-type/';
};

export type OrgMeterMeasureTypeListMeterMeasureTypesErrors = {
    /**
     * Not found
     */
    404: unknown;
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type OrgMeterMeasureTypeListMeterMeasureTypesError = OrgMeterMeasureTypeListMeterMeasureTypesErrors[keyof OrgMeterMeasureTypeListMeterMeasureTypesErrors];

export type OrgMeterMeasureTypeListMeterMeasureTypesResponses = {
    /**
     * Response Org-Meter-Measure-Type--List Meter Measure Types
     *
     * Successful Response
     */
    200: Array<MeterMeasureType>;
};

export type OrgMeterMeasureTypeListMeterMeasureTypesResponse = OrgMeterMeasureTypeListMeterMeasureTypesResponses[keyof OrgMeterMeasureTypeListMeterMeasureTypesResponses];

export type OrgMeterTypeListMeterTypesData = {
    body?: never;
    path: {
        /**
         * Org Id
         */
        org_id: string;
    };
    query?: never;
    url: '/org/{org_id}/meter-type/';
};

export type OrgMeterTypeListMeterTypesErrors = {
    /**
     * Not found
     */
    404: unknown;
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type OrgMeterTypeListMeterTypesError = OrgMeterTypeListMeterTypesErrors[keyof OrgMeterTypeListMeterTypesErrors];

export type OrgMeterTypeListMeterTypesResponses = {
    /**
     * Response Org-Meter-Type--List Meter Types
     *
     * Successful Response
     */
    200: Array<MeterType>;
};

export type OrgMeterTypeListMeterTypesResponse = OrgMeterTypeListMeterTypesResponses[keyof OrgMeterTypeListMeterTypesResponses];

export type OrgUserMeGetData = {
    body?: never;
    path: {
        /**
         * Org Id
         */
        org_id: string;
    };
    query?: never;
    url: '/org/{org_id}/user/me';
};

export type OrgUserMeGetErrors = {
    /**
     * Not found
     */
    404: unknown;
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type OrgUserMeGetError = OrgUserMeGetErrors[keyof OrgUserMeGetErrors];

export type OrgUserMeGetResponses = {
    /**
     * Successful Response
     */
    200: OrgUserPrivate;
};

export type OrgUserMeGetResponse = OrgUserMeGetResponses[keyof OrgUserMeGetResponses];

export type OrgUserListUsersData = {
    body?: never;
    path: {
        /**
         * Org Id
         */
        org_id: string;
    };
    query?: {
        /**
         * Detailed
         */
        detailed?: boolean;
    };
    url: '/org/{org_id}/user/';
};

export type OrgUserListUsersErrors = {
    /**
     * Not found
     */
    404: unknown;
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type OrgUserListUsersError = OrgUserListUsersErrors[keyof OrgUserListUsersErrors];

export type OrgUserListUsersResponses = {
    /**
     * Response Org-User--List Users
     *
     * Successful Response
     */
    200: Array<OrgUserRef> | Array<OrgUserDetails>;
};

export type OrgUserListUsersResponse = OrgUserListUsersResponses[keyof OrgUserListUsersResponses];

export type OrgUserCreateData = {
    body: OrgUserCreate;
    path: {
        /**
         * Org Id
         */
        org_id: string;
    };
    query?: never;
    url: '/org/{org_id}/user/';
};

export type OrgUserCreateErrors = {
    /**
     * Not found
     */
    404: unknown;
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type OrgUserCreateError = OrgUserCreateErrors[keyof OrgUserCreateErrors];

export type OrgUserCreateResponses = {
    /**
     * Successful Response
     */
    200: OrgUserRef;
};

export type OrgUserCreateResponse = OrgUserCreateResponses[keyof OrgUserCreateResponses];

export type OrgUserDeleteUserData = {
    body?: never;
    path: {
        /**
         * User Id
         */
        user_id: string;
        /**
         * Org Id
         */
        org_id: string;
    };
    query?: never;
    url: '/org/{org_id}/user/{user_id}';
};

export type OrgUserDeleteUserErrors = {
    /**
     * Not found
     */
    404: unknown;
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type OrgUserDeleteUserError = OrgUserDeleteUserErrors[keyof OrgUserDeleteUserErrors];

export type OrgUserDeleteUserResponses = {
    /**
     * Successful Response
     */
    200: unknown;
};

export type OrgUserUpdateUserData = {
    body: OrgUserUpdate;
    path: {
        /**
         * User Id
         */
        user_id: string;
        /**
         * Org Id
         */
        org_id: string;
    };
    query?: never;
    url: '/org/{org_id}/user/{user_id}';
};

export type OrgUserUpdateUserErrors = {
    /**
     * Not found
     */
    404: unknown;
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type OrgUserUpdateUserError = OrgUserUpdateUserErrors[keyof OrgUserUpdateUserErrors];

export type OrgUserUpdateUserResponses = {
    /**
     * Successful Response
     */
    200: OrgUserRef;
};

export type OrgUserUpdateUserResponse = OrgUserUpdateUserResponses[keyof OrgUserUpdateUserResponses];

export type OrgUserImageUpdateImageData = {
    body: BodyOrgUserImageUpdateImage;
    path: {
        /**
         * User Id
         */
        user_id: string;
        /**
         * Org Id
         */
        org_id: string;
    };
    query?: never;
    url: '/org/{org_id}/user/{user_id}/image';
};

export type OrgUserImageUpdateImageErrors = {
    /**
     * Not found
     */
    404: unknown;
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type OrgUserImageUpdateImageError = OrgUserImageUpdateImageErrors[keyof OrgUserImageUpdateImageErrors];

export type OrgUserImageUpdateImageResponses = {
    /**
     * Successful Response
     */
    200: unknown;
};

export type OrgVendorListOrgVendorsData = {
    body?: never;
    path: {
        /**
         * Org Id
         */
        org_id: string;
    };
    query?: never;
    url: '/org/{org_id}/vendor/';
};

export type OrgVendorListOrgVendorsErrors = {
    /**
     * Not found
     */
    404: unknown;
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type OrgVendorListOrgVendorsError = OrgVendorListOrgVendorsErrors[keyof OrgVendorListOrgVendorsErrors];

export type OrgVendorListOrgVendorsResponses = {
    /**
     * Response Org-Vendor--List Org Vendors
     *
     * Successful Response
     */
    200: Array<OrgVendor>;
};

export type OrgVendorListOrgVendorsResponse = OrgVendorListOrgVendorsResponses[keyof OrgVendorListOrgVendorsResponses];

export type OrgVendorGetData = {
    body?: never;
    path: {
        /**
         * Vendor Id
         */
        vendor_id: string;
        /**
         * Org Id
         */
        org_id: string;
    };
    query?: never;
    url: '/org/{org_id}/vendor/{vendor_id}';
};

export type OrgVendorGetErrors = {
    /**
     * Not found
     */
    404: unknown;
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type OrgVendorGetError = OrgVendorGetErrors[keyof OrgVendorGetErrors];

export type OrgVendorGetResponses = {
    /**
     * Successful Response
     */
    200: OrgVendor;
};

export type OrgVendorGetResponse = OrgVendorGetResponses[keyof OrgVendorGetResponses];

export type OrgVendorCreateUpdateData = {
    body: OrgVendorCreateUpdate;
    path: {
        /**
         * Vendor Id
         */
        vendor_id: string;
        /**
         * Org Id
         */
        org_id: string;
    };
    query?: never;
    url: '/org/{org_id}/vendor/{vendor_id}';
};

export type OrgVendorCreateUpdateErrors = {
    /**
     * Not found
     */
    404: unknown;
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type OrgVendorCreateUpdateError = OrgVendorCreateUpdateErrors[keyof OrgVendorCreateUpdateErrors];

export type OrgVendorCreateUpdateResponses = {
    /**
     * Response Org-Vendor-Create Update
     *
     * Successful Response
     */
    200: OrgVendor | null;
};

export type OrgVendorCreateUpdateResponse = OrgVendorCreateUpdateResponses[keyof OrgVendorCreateUpdateResponses];

export type OrgVendorBalanceGetBalanceData = {
    body?: never;
    path: {
        /**
         * Vendor Id
         */
        vendor_id: string;
        /**
         * Org Id
         */
        org_id: string;
    };
    query?: never;
    url: '/org/{org_id}/vendor/{vendor_id}/balance';
};

export type OrgVendorBalanceGetBalanceErrors = {
    /**
     * Not found
     */
    404: unknown;
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type OrgVendorBalanceGetBalanceError = OrgVendorBalanceGetBalanceErrors[keyof OrgVendorBalanceGetBalanceErrors];

export type OrgVendorBalanceGetBalanceResponses = {
    /**
     * Successful Response
     */
    200: VendorBalance;
};

export type OrgVendorBalanceGetBalanceResponse = OrgVendorBalanceGetBalanceResponses[keyof OrgVendorBalanceGetBalanceResponses];

export type OrgVendorPropertiesGetPropertiesData = {
    body?: never;
    path: {
        /**
         * Vendor Id
         */
        vendor_id: string;
        /**
         * Org Id
         */
        org_id: string;
    };
    query?: never;
    url: '/org/{org_id}/vendor/{vendor_id}/properties';
};

export type OrgVendorPropertiesGetPropertiesErrors = {
    /**
     * Not found
     */
    404: unknown;
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type OrgVendorPropertiesGetPropertiesError = OrgVendorPropertiesGetPropertiesErrors[keyof OrgVendorPropertiesGetPropertiesErrors];

export type OrgVendorPropertiesGetPropertiesResponses = {
    /**
     * Response Org-Vendor-Properties-Get Properties
     *
     * Successful Response
     */
    200: Array<Property>;
};

export type OrgVendorPropertiesGetPropertiesResponse = OrgVendorPropertiesGetPropertiesResponses[keyof OrgVendorPropertiesGetPropertiesResponses];

export type OrgVendorBillingAccountBillingAccountListData = {
    body?: never;
    path: {
        /**
         * Vendor Id
         */
        vendor_id: string;
        /**
         * Org Id
         */
        org_id: string;
    };
    query?: never;
    url: '/org/{org_id}/vendor/{vendor_id}/billing_account';
};

export type OrgVendorBillingAccountBillingAccountListErrors = {
    /**
     * Not found
     */
    404: unknown;
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type OrgVendorBillingAccountBillingAccountListError = OrgVendorBillingAccountBillingAccountListErrors[keyof OrgVendorBillingAccountBillingAccountListErrors];

export type OrgVendorBillingAccountBillingAccountListResponses = {
    /**
     * Response Org-Vendor-Billing Account-Billing Account List
     *
     * Successful Response
     */
    200: Array<VendorBillingAccountRef>;
};

export type OrgVendorBillingAccountBillingAccountListResponse = OrgVendorBillingAccountBillingAccountListResponses[keyof OrgVendorBillingAccountBillingAccountListResponses];

export type OrgVendorBillingAccountUpdateBillingAccountData = {
    body: BillingAccountPatch;
    path: {
        /**
         * Vendor Id
         */
        vendor_id: string;
        /**
         * Billing Account Id
         */
        billing_account_id: string;
        /**
         * Org Id
         */
        org_id: string;
    };
    query?: never;
    url: '/org/{org_id}/vendor/{vendor_id}/billing_account/{billing_account_id}';
};

export type OrgVendorBillingAccountUpdateBillingAccountErrors = {
    /**
     * Not found
     */
    404: unknown;
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type OrgVendorBillingAccountUpdateBillingAccountError = OrgVendorBillingAccountUpdateBillingAccountErrors[keyof OrgVendorBillingAccountUpdateBillingAccountErrors];

export type OrgVendorBillingAccountUpdateBillingAccountResponses = {
    /**
     * Successful Response
     */
    200: VendorBillingAccount;
};

export type OrgVendorBillingAccountUpdateBillingAccountResponse = OrgVendorBillingAccountUpdateBillingAccountResponses[keyof OrgVendorBillingAccountUpdateBillingAccountResponses];

export type OrgVendorServiceAccountServiceAccountListData = {
    body?: never;
    path: {
        /**
         * Vendor Id
         */
        vendor_id: string;
        /**
         * Org Id
         */
        org_id: string;
    };
    query?: never;
    url: '/org/{org_id}/vendor/{vendor_id}/service_account';
};

export type OrgVendorServiceAccountServiceAccountListErrors = {
    /**
     * Not found
     */
    404: unknown;
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type OrgVendorServiceAccountServiceAccountListError = OrgVendorServiceAccountServiceAccountListErrors[keyof OrgVendorServiceAccountServiceAccountListErrors];

export type OrgVendorServiceAccountServiceAccountListResponses = {
    /**
     * Response Org-Vendor-Service Account-Service Account List
     *
     * Successful Response
     */
    200: Array<VendorServiceAccountRef>;
};

export type OrgVendorServiceAccountServiceAccountListResponse = OrgVendorServiceAccountServiceAccountListResponses[keyof OrgVendorServiceAccountServiceAccountListResponses];

export type OrgVendorBillingAccountPropertiesGetBillingAccountPropertiesData = {
    body?: never;
    path: {
        /**
         * Vendor Id
         */
        vendor_id: string;
        /**
         * Billing Account Id
         */
        billing_account_id: string;
        /**
         * Org Id
         */
        org_id: string;
    };
    query?: never;
    url: '/org/{org_id}/vendor/{vendor_id}/billing_account/{billing_account_id}/properties';
};

export type OrgVendorBillingAccountPropertiesGetBillingAccountPropertiesErrors = {
    /**
     * Not found
     */
    404: unknown;
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type OrgVendorBillingAccountPropertiesGetBillingAccountPropertiesError = OrgVendorBillingAccountPropertiesGetBillingAccountPropertiesErrors[keyof OrgVendorBillingAccountPropertiesGetBillingAccountPropertiesErrors];

export type OrgVendorBillingAccountPropertiesGetBillingAccountPropertiesResponses = {
    /**
     * Response Org-Vendor-Billing Account-Properties-Get Billing Account Properties
     *
     * Successful Response
     */
    200: Array<Property>;
};

export type OrgVendorBillingAccountPropertiesGetBillingAccountPropertiesResponse = OrgVendorBillingAccountPropertiesGetBillingAccountPropertiesResponses[keyof OrgVendorBillingAccountPropertiesGetBillingAccountPropertiesResponses];

export type OrgVendorServiceAccountGetServiceAccountData = {
    body?: never;
    path: {
        /**
         * Vendor Id
         */
        vendor_id: string;
        /**
         * Service Account Id
         */
        service_account_id: string;
        /**
         * Org Id
         */
        org_id: string;
    };
    query?: never;
    url: '/org/{org_id}/vendor/{vendor_id}/service_account/{service_account_id}';
};

export type OrgVendorServiceAccountGetServiceAccountErrors = {
    /**
     * Not found
     */
    404: unknown;
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type OrgVendorServiceAccountGetServiceAccountError = OrgVendorServiceAccountGetServiceAccountErrors[keyof OrgVendorServiceAccountGetServiceAccountErrors];

export type OrgVendorServiceAccountGetServiceAccountResponses = {
    /**
     * Successful Response
     */
    200: VendorServiceAccount;
};

export type OrgVendorServiceAccountGetServiceAccountResponse = OrgVendorServiceAccountGetServiceAccountResponses[keyof OrgVendorServiceAccountGetServiceAccountResponses];

export type OrgVendorServiceAccountUpdateServiceAccountData = {
    body: ServiceAccountPatch;
    path: {
        /**
         * Vendor Id
         */
        vendor_id: string;
        /**
         * Service Account Id
         */
        service_account_id: string;
        /**
         * Org Id
         */
        org_id: string;
    };
    query?: never;
    url: '/org/{org_id}/vendor/{vendor_id}/service_account/{service_account_id}';
};

export type OrgVendorServiceAccountUpdateServiceAccountErrors = {
    /**
     * Not found
     */
    404: unknown;
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type OrgVendorServiceAccountUpdateServiceAccountError = OrgVendorServiceAccountUpdateServiceAccountErrors[keyof OrgVendorServiceAccountUpdateServiceAccountErrors];

export type OrgVendorServiceAccountUpdateServiceAccountResponses = {
    /**
     * Successful Response
     */
    200: VendorServiceAccount;
};

export type OrgVendorServiceAccountUpdateServiceAccountResponse = OrgVendorServiceAccountUpdateServiceAccountResponses[keyof OrgVendorServiceAccountUpdateServiceAccountResponses];

export type OrgVendorServiceAccountPropertiesGetServiceAccountPropertiesData = {
    body?: never;
    path: {
        /**
         * Vendor Id
         */
        vendor_id: string;
        /**
         * Service Account Id
         */
        service_account_id: string;
        /**
         * Org Id
         */
        org_id: string;
    };
    query?: never;
    url: '/org/{org_id}/vendor/{vendor_id}/service_account/{service_account_id}/properties';
};

export type OrgVendorServiceAccountPropertiesGetServiceAccountPropertiesErrors = {
    /**
     * Not found
     */
    404: unknown;
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type OrgVendorServiceAccountPropertiesGetServiceAccountPropertiesError = OrgVendorServiceAccountPropertiesGetServiceAccountPropertiesErrors[keyof OrgVendorServiceAccountPropertiesGetServiceAccountPropertiesErrors];

export type OrgVendorServiceAccountPropertiesGetServiceAccountPropertiesResponses = {
    /**
     * Response Org-Vendor-Service Account-Properties-Get Service Account Properties
     *
     * Successful Response
     */
    200: Array<Property>;
};

export type OrgVendorServiceAccountPropertiesGetServiceAccountPropertiesResponse = OrgVendorServiceAccountPropertiesGetServiceAccountPropertiesResponses[keyof OrgVendorServiceAccountPropertiesGetServiceAccountPropertiesResponses];

export type OrgListListOrgsData = {
    body?: never;
    path: {
        /**
         * Org Id
         */
        org_id: string;
    };
    query?: never;
    url: '/org/{org_id}/list';
};

export type OrgListListOrgsErrors = {
    /**
     * Not found
     */
    404: unknown;
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type OrgListListOrgsError = OrgListListOrgsErrors[keyof OrgListListOrgsErrors];

export type OrgListListOrgsResponses = {
    /**
     * Response Org-List-List Orgs
     *
     * Successful Response
     */
    200: Array<OrgRef>;
};

export type OrgListListOrgsResponse = OrgListListOrgsResponses[keyof OrgListListOrgsResponses];

export type OrgUpdateData = {
    body: OrgUpdate;
    path: {
        /**
         * Org Id
         */
        org_id: string;
    };
    query?: never;
    url: '/org/{org_id}/';
};

export type OrgUpdateErrors = {
    /**
     * Not found
     */
    404: unknown;
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type OrgUpdateError = OrgUpdateErrors[keyof OrgUpdateErrors];

export type OrgUpdateResponses = {
    /**
     * Successful Response
     */
    200: OrgDetails;
};

export type OrgUpdateResponse = OrgUpdateResponses[keyof OrgUpdateResponses];

export type OrgImageGetOrgImageData = {
    body?: never;
    path: {
        /**
         * Org Id
         */
        org_id: string;
    };
    query?: never;
    url: '/org/{org_id}/image';
};

export type OrgImageGetOrgImageErrors = {
    /**
     * Not found
     */
    404: unknown;
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type OrgImageGetOrgImageError = OrgImageGetOrgImageErrors[keyof OrgImageGetOrgImageErrors];

export type OrgImageGetOrgImageResponses = {
    /**
     * Successful Response
     */
    200: unknown;
};

export type OrgImageUpdateImageData = {
    body: BodyOrgImageUpdateImage;
    path: {
        /**
         * Org Id
         */
        org_id: string;
    };
    query?: never;
    url: '/org/{org_id}/image';
};

export type OrgImageUpdateImageErrors = {
    /**
     * Not found
     */
    404: unknown;
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type OrgImageUpdateImageError = OrgImageUpdateImageErrors[keyof OrgImageUpdateImageErrors];

export type OrgImageUpdateImageResponses = {
    /**
     * Successful Response
     */
    200: unknown;
};

export type OrgDigestGetDigestData = {
    body?: never;
    path: {
        /**
         * Org Id
         */
        org_id: string;
    };
    query?: never;
    url: '/org/{org_id}/digest';
};

export type OrgDigestGetDigestErrors = {
    /**
     * Not found
     */
    404: unknown;
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type OrgDigestGetDigestError = OrgDigestGetDigestErrors[keyof OrgDigestGetDigestErrors];

export type OrgDigestGetDigestResponses = {
    /**
     * Successful Response
     */
    200: OrgDigest;
};

export type OrgDigestGetDigestResponse = OrgDigestGetDigestResponses[keyof OrgDigestGetDigestResponses];

export type OrgPaymentListPaymentsData = {
    body?: never;
    path: {
        /**
         * Org Id
         */
        org_id: string;
    };
    query?: {
        /**
         * Billing Account Id
         */
        billing_account_id?: string | null;
        /**
         * Service Account Id
         */
        service_account_id?: string | null;
        /**
         * Statement Id
         */
        statement_id?: string | null;
        /**
         * Statement Service Details Id
         */
        statement_service_details_id?: string | null;
        /**
         * Payment Date From
         */
        payment_date_from?: string | null;
        /**
         * Payment Date To
         */
        payment_date_to?: string | null;
    };
    url: '/org/{org_id}/payment/';
};

export type OrgPaymentListPaymentsErrors = {
    /**
     * Not found
     */
    404: unknown;
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type OrgPaymentListPaymentsError = OrgPaymentListPaymentsErrors[keyof OrgPaymentListPaymentsErrors];

export type OrgPaymentListPaymentsResponses = {
    /**
     * Response Org-Payment--List Payments
     *
     * Successful Response
     */
    200: Array<Payment>;
};

export type OrgPaymentListPaymentsResponse = OrgPaymentListPaymentsResponses[keyof OrgPaymentListPaymentsResponses];

export type OrgPaymentCreateData = {
    body: PaymentCreate;
    path: {
        /**
         * Org Id
         */
        org_id: string;
    };
    query?: never;
    url: '/org/{org_id}/payment/';
};

export type OrgPaymentCreateErrors = {
    /**
     * Not found
     */
    404: unknown;
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type OrgPaymentCreateError = OrgPaymentCreateErrors[keyof OrgPaymentCreateErrors];

export type OrgPaymentCreateResponses = {
    /**
     * Successful Response
     */
    201: Payment;
};

export type OrgPaymentCreateResponse = OrgPaymentCreateResponses[keyof OrgPaymentCreateResponses];

export type OrgPaymentBalanceGetOrgBalanceData = {
    body?: never;
    path: {
        /**
         * Org Id
         */
        org_id: string;
    };
    query?: never;
    url: '/org/{org_id}/payment/balance';
};

export type OrgPaymentBalanceGetOrgBalanceErrors = {
    /**
     * Not found
     */
    404: unknown;
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type OrgPaymentBalanceGetOrgBalanceError = OrgPaymentBalanceGetOrgBalanceErrors[keyof OrgPaymentBalanceGetOrgBalanceErrors];

export type OrgPaymentBalanceGetOrgBalanceResponses = {
    /**
     * Successful Response
     */
    200: OrgBalance;
};

export type OrgPaymentBalanceGetOrgBalanceResponse = OrgPaymentBalanceGetOrgBalanceResponses[keyof OrgPaymentBalanceGetOrgBalanceResponses];

export type OrgPaymentUpcomingListUpcomingData = {
    body?: never;
    path: {
        /**
         * Org Id
         */
        org_id: string;
    };
    query?: {
        /**
         * Days Window
         */
        days_window?: number;
        /**
         * Include Past Due
         */
        include_past_due?: boolean;
        /**
         * Billing Account Id
         */
        billing_account_id?: string | null;
        /**
         * Org Vendor Id
         */
        org_vendor_id?: string | null;
        /**
         * Limit
         */
        limit?: number;
    };
    url: '/org/{org_id}/payment/upcoming';
};

export type OrgPaymentUpcomingListUpcomingErrors = {
    /**
     * Not found
     */
    404: unknown;
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type OrgPaymentUpcomingListUpcomingError = OrgPaymentUpcomingListUpcomingErrors[keyof OrgPaymentUpcomingListUpcomingErrors];

export type OrgPaymentUpcomingListUpcomingResponses = {
    /**
     * Response Org-Payment-Upcoming-List Upcoming
     *
     * Successful Response
     */
    200: Array<UpcomingPayment>;
};

export type OrgPaymentUpcomingListUpcomingResponse = OrgPaymentUpcomingListUpcomingResponses[keyof OrgPaymentUpcomingListUpcomingResponses];

export type OrgPaymentDeleteData = {
    body?: never;
    path: {
        /**
         * Payment Id
         */
        payment_id: string;
        /**
         * Org Id
         */
        org_id: string;
    };
    query?: never;
    url: '/org/{org_id}/payment/{payment_id}';
};

export type OrgPaymentDeleteErrors = {
    /**
     * Not found
     */
    404: unknown;
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type OrgPaymentDeleteError = OrgPaymentDeleteErrors[keyof OrgPaymentDeleteErrors];

export type OrgPaymentDeleteResponses = {
    /**
     * Successful Response
     */
    204: void;
};

export type OrgPaymentDeleteResponse = OrgPaymentDeleteResponses[keyof OrgPaymentDeleteResponses];

export type OrgPaymentUpdateData = {
    body: PaymentUpdate;
    path: {
        /**
         * Payment Id
         */
        payment_id: string;
        /**
         * Org Id
         */
        org_id: string;
    };
    query?: never;
    url: '/org/{org_id}/payment/{payment_id}';
};

export type OrgPaymentUpdateErrors = {
    /**
     * Not found
     */
    404: unknown;
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type OrgPaymentUpdateError = OrgPaymentUpdateErrors[keyof OrgPaymentUpdateErrors];

export type OrgPaymentUpdateResponses = {
    /**
     * Successful Response
     */
    200: Payment;
};

export type OrgPaymentUpdateResponse = OrgPaymentUpdateResponses[keyof OrgPaymentUpdateResponses];

export type OrgProgramListAllProgramsData = {
    body?: never;
    path: {
        /**
         * Org Id
         */
        org_id: string;
    };
    query?: {
        /**
         * Include Deleted
         */
        include_deleted?: boolean;
    };
    url: '/org/{org_id}/program/';
};

export type OrgProgramListAllProgramsErrors = {
    /**
     * Not found
     */
    404: unknown;
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type OrgProgramListAllProgramsError = OrgProgramListAllProgramsErrors[keyof OrgProgramListAllProgramsErrors];

export type OrgProgramListAllProgramsResponses = {
    /**
     * Response Org-Program--List All Programs
     *
     * Successful Response
     */
    200: Array<ProgramResponse>;
};

export type OrgProgramListAllProgramsResponse = OrgProgramListAllProgramsResponses[keyof OrgProgramListAllProgramsResponses];

export type OrgProgramCreateNewProgramData = {
    body: ProgramCreatePublic;
    path: {
        /**
         * Org Id
         */
        org_id: string;
    };
    query?: never;
    url: '/org/{org_id}/program/';
};

export type OrgProgramCreateNewProgramErrors = {
    /**
     * Not found
     */
    404: unknown;
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type OrgProgramCreateNewProgramError = OrgProgramCreateNewProgramErrors[keyof OrgProgramCreateNewProgramErrors];

export type OrgProgramCreateNewProgramResponses = {
    /**
     * Successful Response
     */
    200: ProgramResponse;
};

export type OrgProgramCreateNewProgramResponse = OrgProgramCreateNewProgramResponses[keyof OrgProgramCreateNewProgramResponses];

export type OrgProgramDeleteProgramData = {
    body?: never;
    path: {
        /**
         * Program Id
         */
        program_id: string;
        /**
         * Org Id
         */
        org_id: string;
    };
    query?: never;
    url: '/org/{org_id}/program/{program_id}';
};

export type OrgProgramDeleteProgramErrors = {
    /**
     * Not found
     */
    404: unknown;
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type OrgProgramDeleteProgramError = OrgProgramDeleteProgramErrors[keyof OrgProgramDeleteProgramErrors];

export type OrgProgramDeleteProgramResponses = {
    /**
     * Response Org-Program-Delete Program
     *
     * Successful Response
     */
    200: {
        [key: string]: string;
    };
};

export type OrgProgramDeleteProgramResponse = OrgProgramDeleteProgramResponses[keyof OrgProgramDeleteProgramResponses];

export type OrgProgramGetProgramDetailsData = {
    body?: never;
    path: {
        /**
         * Program Id
         */
        program_id: string;
        /**
         * Org Id
         */
        org_id: string;
    };
    query?: never;
    url: '/org/{org_id}/program/{program_id}';
};

export type OrgProgramGetProgramDetailsErrors = {
    /**
     * Not found
     */
    404: unknown;
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type OrgProgramGetProgramDetailsError = OrgProgramGetProgramDetailsErrors[keyof OrgProgramGetProgramDetailsErrors];

export type OrgProgramGetProgramDetailsResponses = {
    /**
     * Successful Response
     */
    200: ProgramResponse;
};

export type OrgProgramGetProgramDetailsResponse = OrgProgramGetProgramDetailsResponses[keyof OrgProgramGetProgramDetailsResponses];

export type OrgProgramUpdateProgramDetailsData = {
    body: ProgramUpdatePublic;
    path: {
        /**
         * Program Id
         */
        program_id: string;
        /**
         * Org Id
         */
        org_id: string;
    };
    query?: never;
    url: '/org/{org_id}/program/{program_id}';
};

export type OrgProgramUpdateProgramDetailsErrors = {
    /**
     * Not found
     */
    404: unknown;
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type OrgProgramUpdateProgramDetailsError = OrgProgramUpdateProgramDetailsErrors[keyof OrgProgramUpdateProgramDetailsErrors];

export type OrgProgramUpdateProgramDetailsResponses = {
    /**
     * Successful Response
     */
    200: ProgramResponse;
};

export type OrgProgramUpdateProgramDetailsResponse = OrgProgramUpdateProgramDetailsResponses[keyof OrgProgramUpdateProgramDetailsResponses];

export type OrgProgramStatusSetProgramStatusData = {
    body: ProgramStatusUpdate;
    path: {
        /**
         * Program Id
         */
        program_id: string;
        /**
         * Org Id
         */
        org_id: string;
    };
    query?: never;
    url: '/org/{org_id}/program/{program_id}/status';
};

export type OrgProgramStatusSetProgramStatusErrors = {
    /**
     * Not found
     */
    404: unknown;
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type OrgProgramStatusSetProgramStatusError = OrgProgramStatusSetProgramStatusErrors[keyof OrgProgramStatusSetProgramStatusErrors];

export type OrgProgramStatusSetProgramStatusResponses = {
    /**
     * Successful Response
     */
    200: ProgramResponse;
};

export type OrgProgramStatusSetProgramStatusResponse = OrgProgramStatusSetProgramStatusResponses[keyof OrgProgramStatusSetProgramStatusResponses];

export type OrgProgramCyclesListProgramCyclesData = {
    body?: never;
    path: {
        /**
         * Program Id
         */
        program_id: string;
        /**
         * Org Id
         */
        org_id: string;
    };
    query?: never;
    url: '/org/{org_id}/program/{program_id}/cycles';
};

export type OrgProgramCyclesListProgramCyclesErrors = {
    /**
     * Not found
     */
    404: unknown;
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type OrgProgramCyclesListProgramCyclesError = OrgProgramCyclesListProgramCyclesErrors[keyof OrgProgramCyclesListProgramCyclesErrors];

export type OrgProgramCyclesListProgramCyclesResponses = {
    /**
     * Response Org-Program-Cycles-List Program Cycles
     *
     * Successful Response
     */
    200: Array<CycleResponse>;
};

export type OrgProgramCyclesListProgramCyclesResponse = OrgProgramCyclesListProgramCyclesResponses[keyof OrgProgramCyclesListProgramCyclesResponses];

export type OrgProgramCyclesCreateProgramCycleData = {
    body: ProgramCycleCreatePublic;
    path: {
        /**
         * Program Id
         */
        program_id: string;
        /**
         * Org Id
         */
        org_id: string;
    };
    query?: never;
    url: '/org/{org_id}/program/{program_id}/cycles';
};

export type OrgProgramCyclesCreateProgramCycleErrors = {
    /**
     * Not found
     */
    404: unknown;
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type OrgProgramCyclesCreateProgramCycleError = OrgProgramCyclesCreateProgramCycleErrors[keyof OrgProgramCyclesCreateProgramCycleErrors];

export type OrgProgramCyclesCreateProgramCycleResponses = {
    /**
     * Successful Response
     */
    200: CycleResponse;
};

export type OrgProgramCyclesCreateProgramCycleResponse = OrgProgramCyclesCreateProgramCycleResponses[keyof OrgProgramCyclesCreateProgramCycleResponses];

export type OrgProgramCyclesLatestGetLatestCycleData = {
    body?: never;
    path: {
        /**
         * Program Id
         */
        program_id: string;
        /**
         * Org Id
         */
        org_id: string;
    };
    query?: never;
    url: '/org/{org_id}/program/{program_id}/cycles/latest';
};

export type OrgProgramCyclesLatestGetLatestCycleErrors = {
    /**
     * Not found
     */
    404: unknown;
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type OrgProgramCyclesLatestGetLatestCycleError = OrgProgramCyclesLatestGetLatestCycleErrors[keyof OrgProgramCyclesLatestGetLatestCycleErrors];

export type OrgProgramCyclesLatestGetLatestCycleResponses = {
    /**
     * Successful Response
     */
    200: CycleResponse;
};

export type OrgProgramCyclesLatestGetLatestCycleResponse = OrgProgramCyclesLatestGetLatestCycleResponses[keyof OrgProgramCyclesLatestGetLatestCycleResponses];

export type OrgProgramCyclesGetCycleData = {
    body?: never;
    path: {
        /**
         * Program Id
         */
        program_id: string;
        /**
         * Cycle Id
         */
        cycle_id: string;
        /**
         * Org Id
         */
        org_id: string;
    };
    query?: never;
    url: '/org/{org_id}/program/{program_id}/cycles/{cycle_id}';
};

export type OrgProgramCyclesGetCycleErrors = {
    /**
     * Not found
     */
    404: unknown;
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type OrgProgramCyclesGetCycleError = OrgProgramCyclesGetCycleErrors[keyof OrgProgramCyclesGetCycleErrors];

export type OrgProgramCyclesGetCycleResponses = {
    /**
     * Successful Response
     */
    200: CycleResponse;
};

export type OrgProgramCyclesGetCycleResponse = OrgProgramCyclesGetCycleResponses[keyof OrgProgramCyclesGetCycleResponses];

export type OrgProgramCyclesUpdateProgramCycleData = {
    body: ProgramCycleUpdate;
    path: {
        /**
         * Program Id
         */
        program_id: string;
        /**
         * Cycle Id
         */
        cycle_id: string;
        /**
         * Org Id
         */
        org_id: string;
    };
    query?: never;
    url: '/org/{org_id}/program/{program_id}/cycles/{cycle_id}';
};

export type OrgProgramCyclesUpdateProgramCycleErrors = {
    /**
     * Not found
     */
    404: unknown;
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type OrgProgramCyclesUpdateProgramCycleError = OrgProgramCyclesUpdateProgramCycleErrors[keyof OrgProgramCyclesUpdateProgramCycleErrors];

export type OrgProgramCyclesUpdateProgramCycleResponses = {
    /**
     * Successful Response
     */
    200: CycleResponse;
};

export type OrgProgramCyclesUpdateProgramCycleResponse = OrgProgramCyclesUpdateProgramCycleResponses[keyof OrgProgramCyclesUpdateProgramCycleResponses];

export type OrgProgramCyclesActivateActivateCycleData = {
    body?: never;
    path: {
        /**
         * Program Id
         */
        program_id: string;
        /**
         * Cycle Id
         */
        cycle_id: string;
        /**
         * Org Id
         */
        org_id: string;
    };
    query?: never;
    url: '/org/{org_id}/program/{program_id}/cycles/{cycle_id}/activate';
};

export type OrgProgramCyclesActivateActivateCycleErrors = {
    /**
     * Not found
     */
    404: unknown;
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type OrgProgramCyclesActivateActivateCycleError = OrgProgramCyclesActivateActivateCycleErrors[keyof OrgProgramCyclesActivateActivateCycleErrors];

export type OrgProgramCyclesActivateActivateCycleResponses = {
    /**
     * Successful Response
     */
    200: CycleResponse;
};

export type OrgProgramCyclesActivateActivateCycleResponse = OrgProgramCyclesActivateActivateCycleResponses[keyof OrgProgramCyclesActivateActivateCycleResponses];

export type OrgProgramCyclesCriteriaListCycleCriteriaData = {
    body?: never;
    path: {
        /**
         * Program Id
         */
        program_id: string;
        /**
         * Cycle Id
         */
        cycle_id: string;
        /**
         * Org Id
         */
        org_id: string;
    };
    query?: {
        /**
         * Include Inactive
         */
        include_inactive?: boolean;
    };
    url: '/org/{org_id}/program/{program_id}/cycles/{cycle_id}/criteria';
};

export type OrgProgramCyclesCriteriaListCycleCriteriaErrors = {
    /**
     * Not found
     */
    404: unknown;
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type OrgProgramCyclesCriteriaListCycleCriteriaError = OrgProgramCyclesCriteriaListCycleCriteriaErrors[keyof OrgProgramCyclesCriteriaListCycleCriteriaErrors];

export type OrgProgramCyclesCriteriaListCycleCriteriaResponses = {
    /**
     * Response Org-Program-Cycles-Criteria-List Cycle Criteria
     *
     * Successful Response
     */
    200: Array<CriteriaResponse>;
};

export type OrgProgramCyclesCriteriaListCycleCriteriaResponse = OrgProgramCyclesCriteriaListCycleCriteriaResponses[keyof OrgProgramCyclesCriteriaListCycleCriteriaResponses];

export type OrgProgramCyclesCriteriaCreateCycleCriteriaData = {
    body: ProgramCriteriaCreate;
    path: {
        /**
         * Program Id
         */
        program_id: string;
        /**
         * Cycle Id
         */
        cycle_id: string;
        /**
         * Org Id
         */
        org_id: string;
    };
    query?: never;
    url: '/org/{org_id}/program/{program_id}/cycles/{cycle_id}/criteria';
};

export type OrgProgramCyclesCriteriaCreateCycleCriteriaErrors = {
    /**
     * Not found
     */
    404: unknown;
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type OrgProgramCyclesCriteriaCreateCycleCriteriaError = OrgProgramCyclesCriteriaCreateCycleCriteriaErrors[keyof OrgProgramCyclesCriteriaCreateCycleCriteriaErrors];

export type OrgProgramCyclesCriteriaCreateCycleCriteriaResponses = {
    /**
     * Successful Response
     */
    200: CriteriaResponse;
};

export type OrgProgramCyclesCriteriaCreateCycleCriteriaResponse = OrgProgramCyclesCriteriaCreateCycleCriteriaResponses[keyof OrgProgramCyclesCriteriaCreateCycleCriteriaResponses];

export type OrgProgramCyclesCriteriaDeleteCycleCriteriaData = {
    body?: never;
    path: {
        /**
         * Program Id
         */
        program_id: string;
        /**
         * Cycle Id
         */
        cycle_id: string;
        /**
         * Criteria Id
         */
        criteria_id: string;
        /**
         * Org Id
         */
        org_id: string;
    };
    query?: never;
    url: '/org/{org_id}/program/{program_id}/cycles/{cycle_id}/criteria/{criteria_id}';
};

export type OrgProgramCyclesCriteriaDeleteCycleCriteriaErrors = {
    /**
     * Not found
     */
    404: unknown;
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type OrgProgramCyclesCriteriaDeleteCycleCriteriaError = OrgProgramCyclesCriteriaDeleteCycleCriteriaErrors[keyof OrgProgramCyclesCriteriaDeleteCycleCriteriaErrors];

export type OrgProgramCyclesCriteriaDeleteCycleCriteriaResponses = {
    /**
     * Response Org-Program-Cycles-Criteria-Delete Cycle Criteria
     *
     * Successful Response
     */
    200: {
        [key: string]: string;
    };
};

export type OrgProgramCyclesCriteriaDeleteCycleCriteriaResponse = OrgProgramCyclesCriteriaDeleteCycleCriteriaResponses[keyof OrgProgramCyclesCriteriaDeleteCycleCriteriaResponses];

export type OrgProgramCyclesCriteriaUpdateCycleCriteriaData = {
    body: ProgramCriteriaUpdate;
    path: {
        /**
         * Program Id
         */
        program_id: string;
        /**
         * Cycle Id
         */
        cycle_id: string;
        /**
         * Criteria Id
         */
        criteria_id: string;
        /**
         * Org Id
         */
        org_id: string;
    };
    query?: never;
    url: '/org/{org_id}/program/{program_id}/cycles/{cycle_id}/criteria/{criteria_id}';
};

export type OrgProgramCyclesCriteriaUpdateCycleCriteriaErrors = {
    /**
     * Not found
     */
    404: unknown;
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type OrgProgramCyclesCriteriaUpdateCycleCriteriaError = OrgProgramCyclesCriteriaUpdateCycleCriteriaErrors[keyof OrgProgramCyclesCriteriaUpdateCycleCriteriaErrors];

export type OrgProgramCyclesCriteriaUpdateCycleCriteriaResponses = {
    /**
     * Successful Response
     */
    200: CriteriaResponse;
};

export type OrgProgramCyclesCriteriaUpdateCycleCriteriaResponse = OrgProgramCyclesCriteriaUpdateCycleCriteriaResponses[keyof OrgProgramCyclesCriteriaUpdateCycleCriteriaResponses];

export type OrgProgramCyclesRequirementsListCycleRequirementsData = {
    body?: never;
    path: {
        /**
         * Program Id
         */
        program_id: string;
        /**
         * Cycle Id
         */
        cycle_id: string;
        /**
         * Org Id
         */
        org_id: string;
    };
    query?: {
        /**
         * Include Inactive
         */
        include_inactive?: boolean;
    };
    url: '/org/{org_id}/program/{program_id}/cycles/{cycle_id}/requirements';
};

export type OrgProgramCyclesRequirementsListCycleRequirementsErrors = {
    /**
     * Not found
     */
    404: unknown;
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type OrgProgramCyclesRequirementsListCycleRequirementsError = OrgProgramCyclesRequirementsListCycleRequirementsErrors[keyof OrgProgramCyclesRequirementsListCycleRequirementsErrors];

export type OrgProgramCyclesRequirementsListCycleRequirementsResponses = {
    /**
     * Response Org-Program-Cycles-Requirements-List Cycle Requirements
     *
     * Successful Response
     */
    200: Array<RequirementResponse>;
};

export type OrgProgramCyclesRequirementsListCycleRequirementsResponse = OrgProgramCyclesRequirementsListCycleRequirementsResponses[keyof OrgProgramCyclesRequirementsListCycleRequirementsResponses];

export type OrgProgramCyclesRequirementsCreateCycleRequirementData = {
    body: ProgramRequirementCreate;
    path: {
        /**
         * Program Id
         */
        program_id: string;
        /**
         * Cycle Id
         */
        cycle_id: string;
        /**
         * Org Id
         */
        org_id: string;
    };
    query?: never;
    url: '/org/{org_id}/program/{program_id}/cycles/{cycle_id}/requirements';
};

export type OrgProgramCyclesRequirementsCreateCycleRequirementErrors = {
    /**
     * Not found
     */
    404: unknown;
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type OrgProgramCyclesRequirementsCreateCycleRequirementError = OrgProgramCyclesRequirementsCreateCycleRequirementErrors[keyof OrgProgramCyclesRequirementsCreateCycleRequirementErrors];

export type OrgProgramCyclesRequirementsCreateCycleRequirementResponses = {
    /**
     * Successful Response
     */
    200: RequirementResponse;
};

export type OrgProgramCyclesRequirementsCreateCycleRequirementResponse = OrgProgramCyclesRequirementsCreateCycleRequirementResponses[keyof OrgProgramCyclesRequirementsCreateCycleRequirementResponses];

export type OrgProgramCyclesRequirementsDeleteCycleRequirementData = {
    body?: never;
    path: {
        /**
         * Program Id
         */
        program_id: string;
        /**
         * Cycle Id
         */
        cycle_id: string;
        /**
         * Requirement Id
         */
        requirement_id: string;
        /**
         * Org Id
         */
        org_id: string;
    };
    query?: never;
    url: '/org/{org_id}/program/{program_id}/cycles/{cycle_id}/requirements/{requirement_id}';
};

export type OrgProgramCyclesRequirementsDeleteCycleRequirementErrors = {
    /**
     * Not found
     */
    404: unknown;
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type OrgProgramCyclesRequirementsDeleteCycleRequirementError = OrgProgramCyclesRequirementsDeleteCycleRequirementErrors[keyof OrgProgramCyclesRequirementsDeleteCycleRequirementErrors];

export type OrgProgramCyclesRequirementsDeleteCycleRequirementResponses = {
    /**
     * Response Org-Program-Cycles-Requirements-Delete Cycle Requirement
     *
     * Successful Response
     */
    200: {
        [key: string]: string;
    };
};

export type OrgProgramCyclesRequirementsDeleteCycleRequirementResponse = OrgProgramCyclesRequirementsDeleteCycleRequirementResponses[keyof OrgProgramCyclesRequirementsDeleteCycleRequirementResponses];

export type OrgProgramCyclesRequirementsUpdateCycleRequirementData = {
    body: ProgramRequirementUpdate;
    path: {
        /**
         * Program Id
         */
        program_id: string;
        /**
         * Cycle Id
         */
        cycle_id: string;
        /**
         * Requirement Id
         */
        requirement_id: string;
        /**
         * Org Id
         */
        org_id: string;
    };
    query?: never;
    url: '/org/{org_id}/program/{program_id}/cycles/{cycle_id}/requirements/{requirement_id}';
};

export type OrgProgramCyclesRequirementsUpdateCycleRequirementErrors = {
    /**
     * Not found
     */
    404: unknown;
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type OrgProgramCyclesRequirementsUpdateCycleRequirementError = OrgProgramCyclesRequirementsUpdateCycleRequirementErrors[keyof OrgProgramCyclesRequirementsUpdateCycleRequirementErrors];

export type OrgProgramCyclesRequirementsUpdateCycleRequirementResponses = {
    /**
     * Successful Response
     */
    200: RequirementResponse;
};

export type OrgProgramCyclesRequirementsUpdateCycleRequirementResponse = OrgProgramCyclesRequirementsUpdateCycleRequirementResponses[keyof OrgProgramCyclesRequirementsUpdateCycleRequirementResponses];

export type OrgProgramCyclesDeadlinesListCycleDeadlinesData = {
    body?: never;
    path: {
        /**
         * Program Id
         */
        program_id: string;
        /**
         * Cycle Id
         */
        cycle_id: string;
        /**
         * Org Id
         */
        org_id: string;
    };
    query?: {
        /**
         * Include Inactive
         */
        include_inactive?: boolean;
    };
    url: '/org/{org_id}/program/{program_id}/cycles/{cycle_id}/deadlines';
};

export type OrgProgramCyclesDeadlinesListCycleDeadlinesErrors = {
    /**
     * Not found
     */
    404: unknown;
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type OrgProgramCyclesDeadlinesListCycleDeadlinesError = OrgProgramCyclesDeadlinesListCycleDeadlinesErrors[keyof OrgProgramCyclesDeadlinesListCycleDeadlinesErrors];

export type OrgProgramCyclesDeadlinesListCycleDeadlinesResponses = {
    /**
     * Response Org-Program-Cycles-Deadlines-List Cycle Deadlines
     *
     * Successful Response
     */
    200: Array<DeadlineResponse>;
};

export type OrgProgramCyclesDeadlinesListCycleDeadlinesResponse = OrgProgramCyclesDeadlinesListCycleDeadlinesResponses[keyof OrgProgramCyclesDeadlinesListCycleDeadlinesResponses];

export type OrgProgramCyclesDeadlinesCreateCycleDeadlineData = {
    body: ProgramDeadlineCreate;
    path: {
        /**
         * Program Id
         */
        program_id: string;
        /**
         * Cycle Id
         */
        cycle_id: string;
        /**
         * Org Id
         */
        org_id: string;
    };
    query?: never;
    url: '/org/{org_id}/program/{program_id}/cycles/{cycle_id}/deadlines';
};

export type OrgProgramCyclesDeadlinesCreateCycleDeadlineErrors = {
    /**
     * Not found
     */
    404: unknown;
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type OrgProgramCyclesDeadlinesCreateCycleDeadlineError = OrgProgramCyclesDeadlinesCreateCycleDeadlineErrors[keyof OrgProgramCyclesDeadlinesCreateCycleDeadlineErrors];

export type OrgProgramCyclesDeadlinesCreateCycleDeadlineResponses = {
    /**
     * Successful Response
     */
    200: DeadlineResponse;
};

export type OrgProgramCyclesDeadlinesCreateCycleDeadlineResponse = OrgProgramCyclesDeadlinesCreateCycleDeadlineResponses[keyof OrgProgramCyclesDeadlinesCreateCycleDeadlineResponses];

export type OrgProgramCyclesDeadlinesDeleteCycleDeadlineData = {
    body?: never;
    path: {
        /**
         * Program Id
         */
        program_id: string;
        /**
         * Cycle Id
         */
        cycle_id: string;
        /**
         * Deadline Id
         */
        deadline_id: string;
        /**
         * Org Id
         */
        org_id: string;
    };
    query?: never;
    url: '/org/{org_id}/program/{program_id}/cycles/{cycle_id}/deadlines/{deadline_id}';
};

export type OrgProgramCyclesDeadlinesDeleteCycleDeadlineErrors = {
    /**
     * Not found
     */
    404: unknown;
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type OrgProgramCyclesDeadlinesDeleteCycleDeadlineError = OrgProgramCyclesDeadlinesDeleteCycleDeadlineErrors[keyof OrgProgramCyclesDeadlinesDeleteCycleDeadlineErrors];

export type OrgProgramCyclesDeadlinesDeleteCycleDeadlineResponses = {
    /**
     * Response Org-Program-Cycles-Deadlines-Delete Cycle Deadline
     *
     * Successful Response
     */
    200: {
        [key: string]: string;
    };
};

export type OrgProgramCyclesDeadlinesDeleteCycleDeadlineResponse = OrgProgramCyclesDeadlinesDeleteCycleDeadlineResponses[keyof OrgProgramCyclesDeadlinesDeleteCycleDeadlineResponses];

export type OrgProgramCyclesDeadlinesUpdateCycleDeadlineData = {
    body: ProgramDeadlineUpdate;
    path: {
        /**
         * Program Id
         */
        program_id: string;
        /**
         * Cycle Id
         */
        cycle_id: string;
        /**
         * Deadline Id
         */
        deadline_id: string;
        /**
         * Org Id
         */
        org_id: string;
    };
    query?: never;
    url: '/org/{org_id}/program/{program_id}/cycles/{cycle_id}/deadlines/{deadline_id}';
};

export type OrgProgramCyclesDeadlinesUpdateCycleDeadlineErrors = {
    /**
     * Not found
     */
    404: unknown;
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type OrgProgramCyclesDeadlinesUpdateCycleDeadlineError = OrgProgramCyclesDeadlinesUpdateCycleDeadlineErrors[keyof OrgProgramCyclesDeadlinesUpdateCycleDeadlineErrors];

export type OrgProgramCyclesDeadlinesUpdateCycleDeadlineResponses = {
    /**
     * Successful Response
     */
    200: DeadlineResponse;
};

export type OrgProgramCyclesDeadlinesUpdateCycleDeadlineResponse = OrgProgramCyclesDeadlinesUpdateCycleDeadlineResponses[keyof OrgProgramCyclesDeadlinesUpdateCycleDeadlineResponses];

export type OrgProgramTemplateCriteriaListProgramTemplateCriteriaData = {
    body?: never;
    path: {
        /**
         * Program Id
         */
        program_id: string;
        /**
         * Org Id
         */
        org_id: string;
    };
    query?: {
        /**
         * Include Inactive
         */
        include_inactive?: boolean;
    };
    url: '/org/{org_id}/program/{program_id}/template/criteria';
};

export type OrgProgramTemplateCriteriaListProgramTemplateCriteriaErrors = {
    /**
     * Not found
     */
    404: unknown;
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type OrgProgramTemplateCriteriaListProgramTemplateCriteriaError = OrgProgramTemplateCriteriaListProgramTemplateCriteriaErrors[keyof OrgProgramTemplateCriteriaListProgramTemplateCriteriaErrors];

export type OrgProgramTemplateCriteriaListProgramTemplateCriteriaResponses = {
    /**
     * Response Org-Program-Template-Criteria-List Program Template Criteria
     *
     * Successful Response
     */
    200: Array<CriteriaResponse>;
};

export type OrgProgramTemplateCriteriaListProgramTemplateCriteriaResponse = OrgProgramTemplateCriteriaListProgramTemplateCriteriaResponses[keyof OrgProgramTemplateCriteriaListProgramTemplateCriteriaResponses];

export type OrgProgramTemplateCriteriaCreateProgramTemplateCriteriaData = {
    body: ProgramCriteriaCreate;
    path: {
        /**
         * Program Id
         */
        program_id: string;
        /**
         * Org Id
         */
        org_id: string;
    };
    query?: never;
    url: '/org/{org_id}/program/{program_id}/template/criteria';
};

export type OrgProgramTemplateCriteriaCreateProgramTemplateCriteriaErrors = {
    /**
     * Not found
     */
    404: unknown;
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type OrgProgramTemplateCriteriaCreateProgramTemplateCriteriaError = OrgProgramTemplateCriteriaCreateProgramTemplateCriteriaErrors[keyof OrgProgramTemplateCriteriaCreateProgramTemplateCriteriaErrors];

export type OrgProgramTemplateCriteriaCreateProgramTemplateCriteriaResponses = {
    /**
     * Successful Response
     */
    200: CriteriaResponse;
};

export type OrgProgramTemplateCriteriaCreateProgramTemplateCriteriaResponse = OrgProgramTemplateCriteriaCreateProgramTemplateCriteriaResponses[keyof OrgProgramTemplateCriteriaCreateProgramTemplateCriteriaResponses];

export type OrgProgramTemplateCriteriaDeleteProgramTemplateCriteriaData = {
    body?: never;
    path: {
        /**
         * Program Id
         */
        program_id: string;
        /**
         * Criteria Id
         */
        criteria_id: string;
        /**
         * Org Id
         */
        org_id: string;
    };
    query?: never;
    url: '/org/{org_id}/program/{program_id}/template/criteria/{criteria_id}';
};

export type OrgProgramTemplateCriteriaDeleteProgramTemplateCriteriaErrors = {
    /**
     * Not found
     */
    404: unknown;
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type OrgProgramTemplateCriteriaDeleteProgramTemplateCriteriaError = OrgProgramTemplateCriteriaDeleteProgramTemplateCriteriaErrors[keyof OrgProgramTemplateCriteriaDeleteProgramTemplateCriteriaErrors];

export type OrgProgramTemplateCriteriaDeleteProgramTemplateCriteriaResponses = {
    /**
     * Response Org-Program-Template-Criteria-Delete Program Template Criteria
     *
     * Successful Response
     */
    200: {
        [key: string]: string;
    };
};

export type OrgProgramTemplateCriteriaDeleteProgramTemplateCriteriaResponse = OrgProgramTemplateCriteriaDeleteProgramTemplateCriteriaResponses[keyof OrgProgramTemplateCriteriaDeleteProgramTemplateCriteriaResponses];

export type OrgProgramTemplateCriteriaUpdateProgramTemplateCriteriaData = {
    body: ProgramCriteriaUpdate;
    path: {
        /**
         * Program Id
         */
        program_id: string;
        /**
         * Criteria Id
         */
        criteria_id: string;
        /**
         * Org Id
         */
        org_id: string;
    };
    query?: never;
    url: '/org/{org_id}/program/{program_id}/template/criteria/{criteria_id}';
};

export type OrgProgramTemplateCriteriaUpdateProgramTemplateCriteriaErrors = {
    /**
     * Not found
     */
    404: unknown;
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type OrgProgramTemplateCriteriaUpdateProgramTemplateCriteriaError = OrgProgramTemplateCriteriaUpdateProgramTemplateCriteriaErrors[keyof OrgProgramTemplateCriteriaUpdateProgramTemplateCriteriaErrors];

export type OrgProgramTemplateCriteriaUpdateProgramTemplateCriteriaResponses = {
    /**
     * Successful Response
     */
    200: CriteriaResponse;
};

export type OrgProgramTemplateCriteriaUpdateProgramTemplateCriteriaResponse = OrgProgramTemplateCriteriaUpdateProgramTemplateCriteriaResponses[keyof OrgProgramTemplateCriteriaUpdateProgramTemplateCriteriaResponses];

export type OrgProgramTemplateRequirementsListProgramTemplateRequirementsData = {
    body?: never;
    path: {
        /**
         * Program Id
         */
        program_id: string;
        /**
         * Org Id
         */
        org_id: string;
    };
    query?: {
        /**
         * Include Inactive
         */
        include_inactive?: boolean;
    };
    url: '/org/{org_id}/program/{program_id}/template/requirements';
};

export type OrgProgramTemplateRequirementsListProgramTemplateRequirementsErrors = {
    /**
     * Not found
     */
    404: unknown;
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type OrgProgramTemplateRequirementsListProgramTemplateRequirementsError = OrgProgramTemplateRequirementsListProgramTemplateRequirementsErrors[keyof OrgProgramTemplateRequirementsListProgramTemplateRequirementsErrors];

export type OrgProgramTemplateRequirementsListProgramTemplateRequirementsResponses = {
    /**
     * Response Org-Program-Template-Requirements-List Program Template Requirements
     *
     * Successful Response
     */
    200: Array<RequirementResponse>;
};

export type OrgProgramTemplateRequirementsListProgramTemplateRequirementsResponse = OrgProgramTemplateRequirementsListProgramTemplateRequirementsResponses[keyof OrgProgramTemplateRequirementsListProgramTemplateRequirementsResponses];

export type OrgProgramTemplateRequirementsCreateProgramTemplateRequirementData = {
    body: ProgramRequirementCreate;
    path: {
        /**
         * Program Id
         */
        program_id: string;
        /**
         * Org Id
         */
        org_id: string;
    };
    query?: never;
    url: '/org/{org_id}/program/{program_id}/template/requirements';
};

export type OrgProgramTemplateRequirementsCreateProgramTemplateRequirementErrors = {
    /**
     * Not found
     */
    404: unknown;
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type OrgProgramTemplateRequirementsCreateProgramTemplateRequirementError = OrgProgramTemplateRequirementsCreateProgramTemplateRequirementErrors[keyof OrgProgramTemplateRequirementsCreateProgramTemplateRequirementErrors];

export type OrgProgramTemplateRequirementsCreateProgramTemplateRequirementResponses = {
    /**
     * Successful Response
     */
    200: RequirementResponse;
};

export type OrgProgramTemplateRequirementsCreateProgramTemplateRequirementResponse = OrgProgramTemplateRequirementsCreateProgramTemplateRequirementResponses[keyof OrgProgramTemplateRequirementsCreateProgramTemplateRequirementResponses];

export type OrgProgramTemplateRequirementsDeleteProgramTemplateRequirementData = {
    body?: never;
    path: {
        /**
         * Program Id
         */
        program_id: string;
        /**
         * Requirement Id
         */
        requirement_id: string;
        /**
         * Org Id
         */
        org_id: string;
    };
    query?: never;
    url: '/org/{org_id}/program/{program_id}/template/requirements/{requirement_id}';
};

export type OrgProgramTemplateRequirementsDeleteProgramTemplateRequirementErrors = {
    /**
     * Not found
     */
    404: unknown;
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type OrgProgramTemplateRequirementsDeleteProgramTemplateRequirementError = OrgProgramTemplateRequirementsDeleteProgramTemplateRequirementErrors[keyof OrgProgramTemplateRequirementsDeleteProgramTemplateRequirementErrors];

export type OrgProgramTemplateRequirementsDeleteProgramTemplateRequirementResponses = {
    /**
     * Response Org-Program-Template-Requirements-Delete Program Template Requirement
     *
     * Successful Response
     */
    200: {
        [key: string]: string;
    };
};

export type OrgProgramTemplateRequirementsDeleteProgramTemplateRequirementResponse = OrgProgramTemplateRequirementsDeleteProgramTemplateRequirementResponses[keyof OrgProgramTemplateRequirementsDeleteProgramTemplateRequirementResponses];

export type OrgProgramTemplateRequirementsUpdateProgramTemplateRequirementData = {
    body: ProgramRequirementUpdate;
    path: {
        /**
         * Program Id
         */
        program_id: string;
        /**
         * Requirement Id
         */
        requirement_id: string;
        /**
         * Org Id
         */
        org_id: string;
    };
    query?: never;
    url: '/org/{org_id}/program/{program_id}/template/requirements/{requirement_id}';
};

export type OrgProgramTemplateRequirementsUpdateProgramTemplateRequirementErrors = {
    /**
     * Not found
     */
    404: unknown;
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type OrgProgramTemplateRequirementsUpdateProgramTemplateRequirementError = OrgProgramTemplateRequirementsUpdateProgramTemplateRequirementErrors[keyof OrgProgramTemplateRequirementsUpdateProgramTemplateRequirementErrors];

export type OrgProgramTemplateRequirementsUpdateProgramTemplateRequirementResponses = {
    /**
     * Successful Response
     */
    200: RequirementResponse;
};

export type OrgProgramTemplateRequirementsUpdateProgramTemplateRequirementResponse = OrgProgramTemplateRequirementsUpdateProgramTemplateRequirementResponses[keyof OrgProgramTemplateRequirementsUpdateProgramTemplateRequirementResponses];

export type OrgProgramTemplateDeadlinesListProgramTemplateDeadlinesData = {
    body?: never;
    path: {
        /**
         * Program Id
         */
        program_id: string;
        /**
         * Org Id
         */
        org_id: string;
    };
    query?: {
        /**
         * Include Inactive
         */
        include_inactive?: boolean;
    };
    url: '/org/{org_id}/program/{program_id}/template/deadlines';
};

export type OrgProgramTemplateDeadlinesListProgramTemplateDeadlinesErrors = {
    /**
     * Not found
     */
    404: unknown;
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type OrgProgramTemplateDeadlinesListProgramTemplateDeadlinesError = OrgProgramTemplateDeadlinesListProgramTemplateDeadlinesErrors[keyof OrgProgramTemplateDeadlinesListProgramTemplateDeadlinesErrors];

export type OrgProgramTemplateDeadlinesListProgramTemplateDeadlinesResponses = {
    /**
     * Response Org-Program-Template-Deadlines-List Program Template Deadlines
     *
     * Successful Response
     */
    200: Array<DeadlineResponse>;
};

export type OrgProgramTemplateDeadlinesListProgramTemplateDeadlinesResponse = OrgProgramTemplateDeadlinesListProgramTemplateDeadlinesResponses[keyof OrgProgramTemplateDeadlinesListProgramTemplateDeadlinesResponses];

export type OrgProgramTemplateDeadlinesCreateProgramTemplateDeadlineData = {
    body: ProgramDeadlineCreate;
    path: {
        /**
         * Program Id
         */
        program_id: string;
        /**
         * Org Id
         */
        org_id: string;
    };
    query?: never;
    url: '/org/{org_id}/program/{program_id}/template/deadlines';
};

export type OrgProgramTemplateDeadlinesCreateProgramTemplateDeadlineErrors = {
    /**
     * Not found
     */
    404: unknown;
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type OrgProgramTemplateDeadlinesCreateProgramTemplateDeadlineError = OrgProgramTemplateDeadlinesCreateProgramTemplateDeadlineErrors[keyof OrgProgramTemplateDeadlinesCreateProgramTemplateDeadlineErrors];

export type OrgProgramTemplateDeadlinesCreateProgramTemplateDeadlineResponses = {
    /**
     * Successful Response
     */
    200: DeadlineResponse;
};

export type OrgProgramTemplateDeadlinesCreateProgramTemplateDeadlineResponse = OrgProgramTemplateDeadlinesCreateProgramTemplateDeadlineResponses[keyof OrgProgramTemplateDeadlinesCreateProgramTemplateDeadlineResponses];

export type OrgProgramTemplateDeadlinesDeleteProgramTemplateDeadlineData = {
    body?: never;
    path: {
        /**
         * Program Id
         */
        program_id: string;
        /**
         * Deadline Id
         */
        deadline_id: string;
        /**
         * Org Id
         */
        org_id: string;
    };
    query?: never;
    url: '/org/{org_id}/program/{program_id}/template/deadlines/{deadline_id}';
};

export type OrgProgramTemplateDeadlinesDeleteProgramTemplateDeadlineErrors = {
    /**
     * Not found
     */
    404: unknown;
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type OrgProgramTemplateDeadlinesDeleteProgramTemplateDeadlineError = OrgProgramTemplateDeadlinesDeleteProgramTemplateDeadlineErrors[keyof OrgProgramTemplateDeadlinesDeleteProgramTemplateDeadlineErrors];

export type OrgProgramTemplateDeadlinesDeleteProgramTemplateDeadlineResponses = {
    /**
     * Response Org-Program-Template-Deadlines-Delete Program Template Deadline
     *
     * Successful Response
     */
    200: {
        [key: string]: string;
    };
};

export type OrgProgramTemplateDeadlinesDeleteProgramTemplateDeadlineResponse = OrgProgramTemplateDeadlinesDeleteProgramTemplateDeadlineResponses[keyof OrgProgramTemplateDeadlinesDeleteProgramTemplateDeadlineResponses];

export type OrgProgramTemplateDeadlinesUpdateProgramTemplateDeadlineData = {
    body: ProgramDeadlineUpdate;
    path: {
        /**
         * Program Id
         */
        program_id: string;
        /**
         * Deadline Id
         */
        deadline_id: string;
        /**
         * Org Id
         */
        org_id: string;
    };
    query?: never;
    url: '/org/{org_id}/program/{program_id}/template/deadlines/{deadline_id}';
};

export type OrgProgramTemplateDeadlinesUpdateProgramTemplateDeadlineErrors = {
    /**
     * Not found
     */
    404: unknown;
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type OrgProgramTemplateDeadlinesUpdateProgramTemplateDeadlineError = OrgProgramTemplateDeadlinesUpdateProgramTemplateDeadlineErrors[keyof OrgProgramTemplateDeadlinesUpdateProgramTemplateDeadlineErrors];

export type OrgProgramTemplateDeadlinesUpdateProgramTemplateDeadlineResponses = {
    /**
     * Successful Response
     */
    200: DeadlineResponse;
};

export type OrgProgramTemplateDeadlinesUpdateProgramTemplateDeadlineResponse = OrgProgramTemplateDeadlinesUpdateProgramTemplateDeadlineResponses[keyof OrgProgramTemplateDeadlinesUpdateProgramTemplateDeadlineResponses];

export type OrgProgramPropertiesListProgramPropertiesData = {
    body?: never;
    path: {
        /**
         * Program Id
         */
        program_id: string;
        /**
         * Org Id
         */
        org_id: string;
    };
    query?: never;
    url: '/org/{org_id}/program/{program_id}/properties/';
};

export type OrgProgramPropertiesListProgramPropertiesErrors = {
    /**
     * Not found
     */
    404: unknown;
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type OrgProgramPropertiesListProgramPropertiesError = OrgProgramPropertiesListProgramPropertiesErrors[keyof OrgProgramPropertiesListProgramPropertiesErrors];

export type OrgProgramPropertiesListProgramPropertiesResponses = {
    /**
     * Response Org-Program-Properties--List Program Properties
     *
     * Successful Response
     */
    200: Array<ProgramPropertyResponse>;
};

export type OrgProgramPropertiesListProgramPropertiesResponse = OrgProgramPropertiesListProgramPropertiesResponses[keyof OrgProgramPropertiesListProgramPropertiesResponses];

export type OrgProgramPropertiesCreateProgramPropertyData = {
    body: ProgramPropertyCreate;
    path: {
        /**
         * Program Id
         */
        program_id: string;
        /**
         * Org Id
         */
        org_id: string;
    };
    query?: never;
    url: '/org/{org_id}/program/{program_id}/properties/';
};

export type OrgProgramPropertiesCreateProgramPropertyErrors = {
    /**
     * Not found
     */
    404: unknown;
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type OrgProgramPropertiesCreateProgramPropertyError = OrgProgramPropertiesCreateProgramPropertyErrors[keyof OrgProgramPropertiesCreateProgramPropertyErrors];

export type OrgProgramPropertiesCreateProgramPropertyResponses = {
    /**
     * Successful Response
     */
    200: ProgramPropertyResponse;
};

export type OrgProgramPropertiesCreateProgramPropertyResponse = OrgProgramPropertiesCreateProgramPropertyResponses[keyof OrgProgramPropertiesCreateProgramPropertyResponses];

export type OrgProgramPropertiesDeleteProgramPropertyData = {
    body?: never;
    path: {
        /**
         * Program Id
         */
        program_id: string;
        /**
         * Property Id
         */
        property_id: string;
        /**
         * Org Id
         */
        org_id: string;
    };
    query?: never;
    url: '/org/{org_id}/program/{program_id}/properties/{property_id}';
};

export type OrgProgramPropertiesDeleteProgramPropertyErrors = {
    /**
     * Not found
     */
    404: unknown;
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type OrgProgramPropertiesDeleteProgramPropertyError = OrgProgramPropertiesDeleteProgramPropertyErrors[keyof OrgProgramPropertiesDeleteProgramPropertyErrors];

export type OrgProgramPropertiesDeleteProgramPropertyResponses = {
    /**
     * Response Org-Program-Properties-Delete Program Property
     *
     * Successful Response
     */
    200: {
        [key: string]: string;
    };
};

export type OrgProgramPropertiesDeleteProgramPropertyResponse = OrgProgramPropertiesDeleteProgramPropertyResponses[keyof OrgProgramPropertiesDeleteProgramPropertyResponses];

export type OrgProgramPropertiesUpdateProgramPropertyData = {
    body: ProgramPropertyUpdate;
    path: {
        /**
         * Program Id
         */
        program_id: string;
        /**
         * Property Id
         */
        property_id: string;
        /**
         * Org Id
         */
        org_id: string;
    };
    query?: never;
    url: '/org/{org_id}/program/{program_id}/properties/{property_id}';
};

export type OrgProgramPropertiesUpdateProgramPropertyErrors = {
    /**
     * Not found
     */
    404: unknown;
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type OrgProgramPropertiesUpdateProgramPropertyError = OrgProgramPropertiesUpdateProgramPropertyErrors[keyof OrgProgramPropertiesUpdateProgramPropertyErrors];

export type OrgProgramPropertiesUpdateProgramPropertyResponses = {
    /**
     * Successful Response
     */
    200: ProgramPropertyResponse;
};

export type OrgProgramPropertiesUpdateProgramPropertyResponse = OrgProgramPropertiesUpdateProgramPropertyResponses[keyof OrgProgramPropertiesUpdateProgramPropertyResponses];

export type OrgProgramPropertiesAutoMatchCandidatesListAutoMatchCandidatesData = {
    body?: never;
    path: {
        /**
         * Program Id
         */
        program_id: string;
        /**
         * Org Id
         */
        org_id: string;
    };
    query?: never;
    url: '/org/{org_id}/program/{program_id}/properties/auto-match-candidates';
};

export type OrgProgramPropertiesAutoMatchCandidatesListAutoMatchCandidatesErrors = {
    /**
     * Not found
     */
    404: unknown;
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type OrgProgramPropertiesAutoMatchCandidatesListAutoMatchCandidatesError = OrgProgramPropertiesAutoMatchCandidatesListAutoMatchCandidatesErrors[keyof OrgProgramPropertiesAutoMatchCandidatesListAutoMatchCandidatesErrors];

export type OrgProgramPropertiesAutoMatchCandidatesListAutoMatchCandidatesResponses = {
    /**
     * Response Org-Program-Properties-Auto-Match-Candidates-List Auto Match Candidates
     *
     * Successful Response
     */
    200: Array<AutoMatchCandidate>;
};

export type OrgProgramPropertiesAutoMatchCandidatesListAutoMatchCandidatesResponse = OrgProgramPropertiesAutoMatchCandidatesListAutoMatchCandidatesResponses[keyof OrgProgramPropertiesAutoMatchCandidatesListAutoMatchCandidatesResponses];

export type OrgProgramPropertiesLinkUnlinkProgramPropertyData = {
    body?: never;
    path: {
        /**
         * Program Id
         */
        program_id: string;
        /**
         * Property Id
         */
        property_id: string;
        /**
         * Em Property Id
         */
        em_property_id: string;
        /**
         * Org Id
         */
        org_id: string;
    };
    query?: never;
    url: '/org/{org_id}/program/{program_id}/properties/{property_id}/link/{em_property_id}';
};

export type OrgProgramPropertiesLinkUnlinkProgramPropertyErrors = {
    /**
     * Not found
     */
    404: unknown;
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type OrgProgramPropertiesLinkUnlinkProgramPropertyError = OrgProgramPropertiesLinkUnlinkProgramPropertyErrors[keyof OrgProgramPropertiesLinkUnlinkProgramPropertyErrors];

export type OrgProgramPropertiesLinkUnlinkProgramPropertyResponses = {
    /**
     * Response Org-Program-Properties-Link-Unlink Program Property
     *
     * Successful Response
     */
    200: {
        [key: string]: string;
    };
};

export type OrgProgramPropertiesLinkUnlinkProgramPropertyResponse = OrgProgramPropertiesLinkUnlinkProgramPropertyResponses[keyof OrgProgramPropertiesLinkUnlinkProgramPropertyResponses];

export type OrgProgramPropertiesLinkLinkProgramPropertyData = {
    body?: never;
    path: {
        /**
         * Program Id
         */
        program_id: string;
        /**
         * Property Id
         */
        property_id: string;
        /**
         * Em Property Id
         */
        em_property_id: string;
        /**
         * Org Id
         */
        org_id: string;
    };
    query?: never;
    url: '/org/{org_id}/program/{program_id}/properties/{property_id}/link/{em_property_id}';
};

export type OrgProgramPropertiesLinkLinkProgramPropertyErrors = {
    /**
     * Not found
     */
    404: unknown;
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type OrgProgramPropertiesLinkLinkProgramPropertyError = OrgProgramPropertiesLinkLinkProgramPropertyErrors[keyof OrgProgramPropertiesLinkLinkProgramPropertyErrors];

export type OrgProgramPropertiesLinkLinkProgramPropertyResponses = {
    /**
     * Response Org-Program-Properties-Link-Link Program Property
     *
     * Successful Response
     */
    200: {
        [key: string]: string;
    };
};

export type OrgProgramPropertiesLinkLinkProgramPropertyResponse = OrgProgramPropertiesLinkLinkProgramPropertyResponses[keyof OrgProgramPropertiesLinkLinkProgramPropertyResponses];

export type OrgProgramCyclesEnrollmentsListCycleEnrollmentsData = {
    body?: never;
    path: {
        /**
         * Program Id
         */
        program_id: string;
        /**
         * Cycle Id
         */
        cycle_id: string;
        /**
         * Org Id
         */
        org_id: string;
    };
    query?: never;
    url: '/org/{org_id}/program/{program_id}/cycles/{cycle_id}/enrollments';
};

export type OrgProgramCyclesEnrollmentsListCycleEnrollmentsErrors = {
    /**
     * Not found
     */
    404: unknown;
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type OrgProgramCyclesEnrollmentsListCycleEnrollmentsError = OrgProgramCyclesEnrollmentsListCycleEnrollmentsErrors[keyof OrgProgramCyclesEnrollmentsListCycleEnrollmentsErrors];

export type OrgProgramCyclesEnrollmentsListCycleEnrollmentsResponses = {
    /**
     * Response Org-Program-Cycles-Enrollments-List Cycle Enrollments
     *
     * Successful Response
     */
    200: Array<EnrollmentResponse>;
};

export type OrgProgramCyclesEnrollmentsListCycleEnrollmentsResponse = OrgProgramCyclesEnrollmentsListCycleEnrollmentsResponses[keyof OrgProgramCyclesEnrollmentsListCycleEnrollmentsResponses];

export type OrgProgramCyclesEnrollmentsCreateCycleEnrollmentData = {
    body: EnrollmentCreate;
    path: {
        /**
         * Program Id
         */
        program_id: string;
        /**
         * Cycle Id
         */
        cycle_id: string;
        /**
         * Org Id
         */
        org_id: string;
    };
    query?: never;
    url: '/org/{org_id}/program/{program_id}/cycles/{cycle_id}/enrollments';
};

export type OrgProgramCyclesEnrollmentsCreateCycleEnrollmentErrors = {
    /**
     * Not found
     */
    404: unknown;
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type OrgProgramCyclesEnrollmentsCreateCycleEnrollmentError = OrgProgramCyclesEnrollmentsCreateCycleEnrollmentErrors[keyof OrgProgramCyclesEnrollmentsCreateCycleEnrollmentErrors];

export type OrgProgramCyclesEnrollmentsCreateCycleEnrollmentResponses = {
    /**
     * Successful Response
     */
    200: EnrollmentResponse;
};

export type OrgProgramCyclesEnrollmentsCreateCycleEnrollmentResponse = OrgProgramCyclesEnrollmentsCreateCycleEnrollmentResponses[keyof OrgProgramCyclesEnrollmentsCreateCycleEnrollmentResponses];

export type OrgProgramCyclesEnrollmentsUpdateCycleEnrollmentData = {
    body: ProgramEnrollmentUpdate;
    path: {
        /**
         * Program Id
         */
        program_id: string;
        /**
         * Cycle Id
         */
        cycle_id: string;
        /**
         * Enrollment Id
         */
        enrollment_id: string;
        /**
         * Org Id
         */
        org_id: string;
    };
    query?: never;
    url: '/org/{org_id}/program/{program_id}/cycles/{cycle_id}/enrollments/{enrollment_id}';
};

export type OrgProgramCyclesEnrollmentsUpdateCycleEnrollmentErrors = {
    /**
     * Not found
     */
    404: unknown;
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type OrgProgramCyclesEnrollmentsUpdateCycleEnrollmentError = OrgProgramCyclesEnrollmentsUpdateCycleEnrollmentErrors[keyof OrgProgramCyclesEnrollmentsUpdateCycleEnrollmentErrors];

export type OrgProgramCyclesEnrollmentsUpdateCycleEnrollmentResponses = {
    /**
     * Successful Response
     */
    200: EnrollmentResponse;
};

export type OrgProgramCyclesEnrollmentsUpdateCycleEnrollmentResponse = OrgProgramCyclesEnrollmentsUpdateCycleEnrollmentResponses[keyof OrgProgramCyclesEnrollmentsUpdateCycleEnrollmentResponses];

export type OrgProgramCyclesComplianceListCycleComplianceData = {
    body?: never;
    path: {
        /**
         * Program Id
         */
        program_id: string;
        /**
         * Cycle Id
         */
        cycle_id: string;
        /**
         * Org Id
         */
        org_id: string;
    };
    query?: never;
    url: '/org/{org_id}/program/{program_id}/cycles/{cycle_id}/compliance';
};

export type OrgProgramCyclesComplianceListCycleComplianceErrors = {
    /**
     * Not found
     */
    404: unknown;
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type OrgProgramCyclesComplianceListCycleComplianceError = OrgProgramCyclesComplianceListCycleComplianceErrors[keyof OrgProgramCyclesComplianceListCycleComplianceErrors];

export type OrgProgramCyclesComplianceListCycleComplianceResponses = {
    /**
     * Response Org-Program-Cycles-Compliance-List Cycle Compliance
     *
     * Successful Response
     */
    200: Array<ComplianceRecordResponse>;
};

export type OrgProgramCyclesComplianceListCycleComplianceResponse = OrgProgramCyclesComplianceListCycleComplianceResponses[keyof OrgProgramCyclesComplianceListCycleComplianceResponses];

export type OrgProgramCyclesComplianceCreateCycleComplianceRecordData = {
    body: ComplianceRecordCreatePublic;
    path: {
        /**
         * Program Id
         */
        program_id: string;
        /**
         * Cycle Id
         */
        cycle_id: string;
        /**
         * Org Id
         */
        org_id: string;
    };
    query?: never;
    url: '/org/{org_id}/program/{program_id}/cycles/{cycle_id}/compliance';
};

export type OrgProgramCyclesComplianceCreateCycleComplianceRecordErrors = {
    /**
     * Not found
     */
    404: unknown;
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type OrgProgramCyclesComplianceCreateCycleComplianceRecordError = OrgProgramCyclesComplianceCreateCycleComplianceRecordErrors[keyof OrgProgramCyclesComplianceCreateCycleComplianceRecordErrors];

export type OrgProgramCyclesComplianceCreateCycleComplianceRecordResponses = {
    /**
     * Successful Response
     */
    200: ComplianceRecordResponse;
};

export type OrgProgramCyclesComplianceCreateCycleComplianceRecordResponse = OrgProgramCyclesComplianceCreateCycleComplianceRecordResponses[keyof OrgProgramCyclesComplianceCreateCycleComplianceRecordResponses];

export type OrgProgramCyclesComplianceUpdateCycleComplianceRecordData = {
    body: ComplianceRecordUpdate;
    path: {
        /**
         * Program Id
         */
        program_id: string;
        /**
         * Cycle Id
         */
        cycle_id: string;
        /**
         * Record Id
         */
        record_id: string;
        /**
         * Org Id
         */
        org_id: string;
    };
    query?: never;
    url: '/org/{org_id}/program/{program_id}/cycles/{cycle_id}/compliance/{record_id}';
};

export type OrgProgramCyclesComplianceUpdateCycleComplianceRecordErrors = {
    /**
     * Not found
     */
    404: unknown;
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type OrgProgramCyclesComplianceUpdateCycleComplianceRecordError = OrgProgramCyclesComplianceUpdateCycleComplianceRecordErrors[keyof OrgProgramCyclesComplianceUpdateCycleComplianceRecordErrors];

export type OrgProgramCyclesComplianceUpdateCycleComplianceRecordResponses = {
    /**
     * Successful Response
     */
    200: ComplianceRecordResponse;
};

export type OrgProgramCyclesComplianceUpdateCycleComplianceRecordResponse = OrgProgramCyclesComplianceUpdateCycleComplianceRecordResponses[keyof OrgProgramCyclesComplianceUpdateCycleComplianceRecordResponses];

export type OrgProgramCyclesComplianceStatsGetCycleComplianceStatsData = {
    body?: never;
    path: {
        /**
         * Program Id
         */
        program_id: string;
        /**
         * Cycle Id
         */
        cycle_id: string;
        /**
         * Org Id
         */
        org_id: string;
    };
    query?: never;
    url: '/org/{org_id}/program/{program_id}/cycles/{cycle_id}/compliance/stats';
};

export type OrgProgramCyclesComplianceStatsGetCycleComplianceStatsErrors = {
    /**
     * Not found
     */
    404: unknown;
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type OrgProgramCyclesComplianceStatsGetCycleComplianceStatsError = OrgProgramCyclesComplianceStatsGetCycleComplianceStatsErrors[keyof OrgProgramCyclesComplianceStatsGetCycleComplianceStatsErrors];

export type OrgProgramCyclesComplianceStatsGetCycleComplianceStatsResponses = {
    /**
     * Successful Response
     */
    200: CycleComplianceStats;
};

export type OrgProgramCyclesComplianceStatsGetCycleComplianceStatsResponse = OrgProgramCyclesComplianceStatsGetCycleComplianceStatsResponses[keyof OrgProgramCyclesComplianceStatsGetCycleComplianceStatsResponses];

export type OrgProgramCyclesComplianceEvaluateEvaluateCycleComplianceData = {
    body?: never;
    path: {
        /**
         * Program Id
         */
        program_id: string;
        /**
         * Cycle Id
         */
        cycle_id: string;
        /**
         * Org Id
         */
        org_id: string;
    };
    query?: never;
    url: '/org/{org_id}/program/{program_id}/cycles/{cycle_id}/compliance/evaluate';
};

export type OrgProgramCyclesComplianceEvaluateEvaluateCycleComplianceErrors = {
    /**
     * Not found
     */
    404: unknown;
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type OrgProgramCyclesComplianceEvaluateEvaluateCycleComplianceError = OrgProgramCyclesComplianceEvaluateEvaluateCycleComplianceErrors[keyof OrgProgramCyclesComplianceEvaluateEvaluateCycleComplianceErrors];

export type OrgProgramCyclesComplianceEvaluateEvaluateCycleComplianceResponses = {
    /**
     * Response Org-Program-Cycles-Compliance-Evaluate-Evaluate Cycle Compliance
     *
     * Successful Response
     */
    202: {
        [key: string]: boolean;
    };
};

export type OrgProgramCyclesComplianceEvaluateEvaluateCycleComplianceResponse = OrgProgramCyclesComplianceEvaluateEvaluateCycleComplianceResponses[keyof OrgProgramCyclesComplianceEvaluateEvaluateCycleComplianceResponses];

export type OrgProgramCyclesFormsListCycleFormsData = {
    body?: never;
    path: {
        /**
         * Program Id
         */
        program_id: string;
        /**
         * Cycle Id
         */
        cycle_id: string;
        /**
         * Org Id
         */
        org_id: string;
    };
    query?: never;
    url: '/org/{org_id}/program/{program_id}/cycles/{cycle_id}/forms';
};

export type OrgProgramCyclesFormsListCycleFormsErrors = {
    /**
     * Not found
     */
    404: unknown;
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type OrgProgramCyclesFormsListCycleFormsError = OrgProgramCyclesFormsListCycleFormsErrors[keyof OrgProgramCyclesFormsListCycleFormsErrors];

export type OrgProgramCyclesFormsListCycleFormsResponses = {
    /**
     * Response Org-Program-Cycles-Forms-List Cycle Forms
     *
     * Successful Response
     */
    200: Array<FormResponse>;
};

export type OrgProgramCyclesFormsListCycleFormsResponse = OrgProgramCyclesFormsListCycleFormsResponses[keyof OrgProgramCyclesFormsListCycleFormsResponses];

export type OrgProgramCyclesFormsCreateCycleFormData = {
    body: ProgramFormCreate;
    path: {
        /**
         * Program Id
         */
        program_id: string;
        /**
         * Cycle Id
         */
        cycle_id: string;
        /**
         * Org Id
         */
        org_id: string;
    };
    query?: never;
    url: '/org/{org_id}/program/{program_id}/cycles/{cycle_id}/forms';
};

export type OrgProgramCyclesFormsCreateCycleFormErrors = {
    /**
     * Not found
     */
    404: unknown;
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type OrgProgramCyclesFormsCreateCycleFormError = OrgProgramCyclesFormsCreateCycleFormErrors[keyof OrgProgramCyclesFormsCreateCycleFormErrors];

export type OrgProgramCyclesFormsCreateCycleFormResponses = {
    /**
     * Successful Response
     */
    200: FormResponse;
};

export type OrgProgramCyclesFormsCreateCycleFormResponse = OrgProgramCyclesFormsCreateCycleFormResponses[keyof OrgProgramCyclesFormsCreateCycleFormResponses];

export type OrgProgramCyclesFormsDeleteCycleFormData = {
    body?: never;
    path: {
        /**
         * Program Id
         */
        program_id: string;
        /**
         * Cycle Id
         */
        cycle_id: string;
        /**
         * Form Id
         */
        form_id: string;
        /**
         * Org Id
         */
        org_id: string;
    };
    query?: never;
    url: '/org/{org_id}/program/{program_id}/cycles/{cycle_id}/forms/{form_id}';
};

export type OrgProgramCyclesFormsDeleteCycleFormErrors = {
    /**
     * Not found
     */
    404: unknown;
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type OrgProgramCyclesFormsDeleteCycleFormError = OrgProgramCyclesFormsDeleteCycleFormErrors[keyof OrgProgramCyclesFormsDeleteCycleFormErrors];

export type OrgProgramCyclesFormsDeleteCycleFormResponses = {
    /**
     * Response Org-Program-Cycles-Forms-Delete Cycle Form
     *
     * Successful Response
     */
    200: {
        [key: string]: string;
    };
};

export type OrgProgramCyclesFormsDeleteCycleFormResponse = OrgProgramCyclesFormsDeleteCycleFormResponses[keyof OrgProgramCyclesFormsDeleteCycleFormResponses];

export type OrgProgramCyclesFormsUpdateCycleFormData = {
    body: ProgramFormUpdate;
    path: {
        /**
         * Program Id
         */
        program_id: string;
        /**
         * Cycle Id
         */
        cycle_id: string;
        /**
         * Form Id
         */
        form_id: string;
        /**
         * Org Id
         */
        org_id: string;
    };
    query?: never;
    url: '/org/{org_id}/program/{program_id}/cycles/{cycle_id}/forms/{form_id}';
};

export type OrgProgramCyclesFormsUpdateCycleFormErrors = {
    /**
     * Not found
     */
    404: unknown;
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type OrgProgramCyclesFormsUpdateCycleFormError = OrgProgramCyclesFormsUpdateCycleFormErrors[keyof OrgProgramCyclesFormsUpdateCycleFormErrors];

export type OrgProgramCyclesFormsUpdateCycleFormResponses = {
    /**
     * Successful Response
     */
    200: FormResponse;
};

export type OrgProgramCyclesFormsUpdateCycleFormResponse = OrgProgramCyclesFormsUpdateCycleFormResponses[keyof OrgProgramCyclesFormsUpdateCycleFormResponses];

export type OrgProgramCyclesFormsSubmissionsListFormSubmissionsData = {
    body?: never;
    path: {
        /**
         * Program Id
         */
        program_id: string;
        /**
         * Cycle Id
         */
        cycle_id: string;
        /**
         * Form Id
         */
        form_id: string;
        /**
         * Org Id
         */
        org_id: string;
    };
    query?: never;
    url: '/org/{org_id}/program/{program_id}/cycles/{cycle_id}/forms/{form_id}/submissions';
};

export type OrgProgramCyclesFormsSubmissionsListFormSubmissionsErrors = {
    /**
     * Not found
     */
    404: unknown;
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type OrgProgramCyclesFormsSubmissionsListFormSubmissionsError = OrgProgramCyclesFormsSubmissionsListFormSubmissionsErrors[keyof OrgProgramCyclesFormsSubmissionsListFormSubmissionsErrors];

export type OrgProgramCyclesFormsSubmissionsListFormSubmissionsResponses = {
    /**
     * Response Org-Program-Cycles-Forms-Submissions-List Form Submissions
     *
     * Successful Response
     */
    200: Array<ViaductApiRoutersProgramFormAdminFormSubmissionResponse>;
};

export type OrgProgramCyclesFormsSubmissionsListFormSubmissionsResponse = OrgProgramCyclesFormsSubmissionsListFormSubmissionsResponses[keyof OrgProgramCyclesFormsSubmissionsListFormSubmissionsResponses];

export type OrgProgramCyclesFormsSubmissionsUpsertOwnerFormSubmissionData = {
    body: OwnerSubmissionDraft;
    path: {
        /**
         * Program Id
         */
        program_id: string;
        /**
         * Cycle Id
         */
        cycle_id: string;
        /**
         * Form Id
         */
        form_id: string;
        /**
         * Org Id
         */
        org_id: string;
    };
    query?: never;
    url: '/org/{org_id}/program/{program_id}/cycles/{cycle_id}/forms/{form_id}/submissions';
};

export type OrgProgramCyclesFormsSubmissionsUpsertOwnerFormSubmissionErrors = {
    /**
     * Not found
     */
    404: unknown;
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type OrgProgramCyclesFormsSubmissionsUpsertOwnerFormSubmissionError = OrgProgramCyclesFormsSubmissionsUpsertOwnerFormSubmissionErrors[keyof OrgProgramCyclesFormsSubmissionsUpsertOwnerFormSubmissionErrors];

export type OrgProgramCyclesFormsSubmissionsUpsertOwnerFormSubmissionResponses = {
    /**
     * Successful Response
     */
    200: OwnerFormSubmissionResponse;
};

export type OrgProgramCyclesFormsSubmissionsUpsertOwnerFormSubmissionResponse = OrgProgramCyclesFormsSubmissionsUpsertOwnerFormSubmissionResponses[keyof OrgProgramCyclesFormsSubmissionsUpsertOwnerFormSubmissionResponses];

export type OrgProgramCyclesFormsSubmissionsReviewFormSubmissionData = {
    body: SubmissionReviewDecision;
    path: {
        /**
         * Program Id
         */
        program_id: string;
        /**
         * Cycle Id
         */
        cycle_id: string;
        /**
         * Submission Id
         */
        submission_id: string;
        /**
         * Org Id
         */
        org_id: string;
    };
    query?: never;
    url: '/org/{org_id}/program/{program_id}/cycles/{cycle_id}/forms/submissions/{submission_id}';
};

export type OrgProgramCyclesFormsSubmissionsReviewFormSubmissionErrors = {
    /**
     * Not found
     */
    404: unknown;
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type OrgProgramCyclesFormsSubmissionsReviewFormSubmissionError = OrgProgramCyclesFormsSubmissionsReviewFormSubmissionErrors[keyof OrgProgramCyclesFormsSubmissionsReviewFormSubmissionErrors];

export type OrgProgramCyclesFormsSubmissionsReviewFormSubmissionResponses = {
    /**
     * Successful Response
     */
    200: ViaductApiRoutersProgramFormAdminFormSubmissionResponse;
};

export type OrgProgramCyclesFormsSubmissionsReviewFormSubmissionResponse = OrgProgramCyclesFormsSubmissionsReviewFormSubmissionResponses[keyof OrgProgramCyclesFormsSubmissionsReviewFormSubmissionResponses];

export type OrgProgramCyclesPortalsListCyclePortalsData = {
    body?: never;
    path: {
        /**
         * Program Id
         */
        program_id: string;
        /**
         * Cycle Id
         */
        cycle_id: string;
        /**
         * Org Id
         */
        org_id: string;
    };
    query?: never;
    url: '/org/{org_id}/program/{program_id}/cycles/{cycle_id}/portals';
};

export type OrgProgramCyclesPortalsListCyclePortalsErrors = {
    /**
     * Not found
     */
    404: unknown;
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type OrgProgramCyclesPortalsListCyclePortalsError = OrgProgramCyclesPortalsListCyclePortalsErrors[keyof OrgProgramCyclesPortalsListCyclePortalsErrors];

export type OrgProgramCyclesPortalsListCyclePortalsResponses = {
    /**
     * Response Org-Program-Cycles-Portals-List Cycle Portals
     *
     * Successful Response
     */
    200: Array<PortalResponse>;
};

export type OrgProgramCyclesPortalsListCyclePortalsResponse = OrgProgramCyclesPortalsListCyclePortalsResponses[keyof OrgProgramCyclesPortalsListCyclePortalsResponses];

export type OrgProgramCyclesPortalsCreateCyclePortalData = {
    body: UploadPortalCreate;
    path: {
        /**
         * Program Id
         */
        program_id: string;
        /**
         * Cycle Id
         */
        cycle_id: string;
        /**
         * Org Id
         */
        org_id: string;
    };
    query?: never;
    url: '/org/{org_id}/program/{program_id}/cycles/{cycle_id}/portals';
};

export type OrgProgramCyclesPortalsCreateCyclePortalErrors = {
    /**
     * Not found
     */
    404: unknown;
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type OrgProgramCyclesPortalsCreateCyclePortalError = OrgProgramCyclesPortalsCreateCyclePortalErrors[keyof OrgProgramCyclesPortalsCreateCyclePortalErrors];

export type OrgProgramCyclesPortalsCreateCyclePortalResponses = {
    /**
     * Successful Response
     */
    200: PortalResponse;
};

export type OrgProgramCyclesPortalsCreateCyclePortalResponse = OrgProgramCyclesPortalsCreateCyclePortalResponses[keyof OrgProgramCyclesPortalsCreateCyclePortalResponses];

export type OrgProgramCyclesPortalsDeleteCyclePortalData = {
    body?: never;
    path: {
        /**
         * Program Id
         */
        program_id: string;
        /**
         * Cycle Id
         */
        cycle_id: string;
        /**
         * Portal Id
         */
        portal_id: string;
        /**
         * Org Id
         */
        org_id: string;
    };
    query?: never;
    url: '/org/{org_id}/program/{program_id}/cycles/{cycle_id}/portals/{portal_id}';
};

export type OrgProgramCyclesPortalsDeleteCyclePortalErrors = {
    /**
     * Not found
     */
    404: unknown;
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type OrgProgramCyclesPortalsDeleteCyclePortalError = OrgProgramCyclesPortalsDeleteCyclePortalErrors[keyof OrgProgramCyclesPortalsDeleteCyclePortalErrors];

export type OrgProgramCyclesPortalsDeleteCyclePortalResponses = {
    /**
     * Response Org-Program-Cycles-Portals-Delete Cycle Portal
     *
     * Successful Response
     */
    200: {
        [key: string]: string;
    };
};

export type OrgProgramCyclesPortalsDeleteCyclePortalResponse = OrgProgramCyclesPortalsDeleteCyclePortalResponses[keyof OrgProgramCyclesPortalsDeleteCyclePortalResponses];

export type OrgProgramCyclesPortalsUpdateCyclePortalData = {
    body: UploadPortalUpdate;
    path: {
        /**
         * Program Id
         */
        program_id: string;
        /**
         * Cycle Id
         */
        cycle_id: string;
        /**
         * Portal Id
         */
        portal_id: string;
        /**
         * Org Id
         */
        org_id: string;
    };
    query?: never;
    url: '/org/{org_id}/program/{program_id}/cycles/{cycle_id}/portals/{portal_id}';
};

export type OrgProgramCyclesPortalsUpdateCyclePortalErrors = {
    /**
     * Not found
     */
    404: unknown;
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type OrgProgramCyclesPortalsUpdateCyclePortalError = OrgProgramCyclesPortalsUpdateCyclePortalErrors[keyof OrgProgramCyclesPortalsUpdateCyclePortalErrors];

export type OrgProgramCyclesPortalsUpdateCyclePortalResponses = {
    /**
     * Successful Response
     */
    200: PortalResponse;
};

export type OrgProgramCyclesPortalsUpdateCyclePortalResponse = OrgProgramCyclesPortalsUpdateCyclePortalResponses[keyof OrgProgramCyclesPortalsUpdateCyclePortalResponses];

export type OrgProgramCyclesPortalsSubmissionsListPortalSubmissionsData = {
    body?: never;
    path: {
        /**
         * Program Id
         */
        program_id: string;
        /**
         * Cycle Id
         */
        cycle_id: string;
        /**
         * Portal Id
         */
        portal_id: string;
        /**
         * Org Id
         */
        org_id: string;
    };
    query?: never;
    url: '/org/{org_id}/program/{program_id}/cycles/{cycle_id}/portals/{portal_id}/submissions';
};

export type OrgProgramCyclesPortalsSubmissionsListPortalSubmissionsErrors = {
    /**
     * Not found
     */
    404: unknown;
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type OrgProgramCyclesPortalsSubmissionsListPortalSubmissionsError = OrgProgramCyclesPortalsSubmissionsListPortalSubmissionsErrors[keyof OrgProgramCyclesPortalsSubmissionsListPortalSubmissionsErrors];

export type OrgProgramCyclesPortalsSubmissionsListPortalSubmissionsResponses = {
    /**
     * Response Org-Program-Cycles-Portals-Submissions-List Portal Submissions
     *
     * Successful Response
     */
    200: Array<PortalSubmissionResponse>;
};

export type OrgProgramCyclesPortalsSubmissionsListPortalSubmissionsResponse = OrgProgramCyclesPortalsSubmissionsListPortalSubmissionsResponses[keyof OrgProgramCyclesPortalsSubmissionsListPortalSubmissionsResponses];

export type OrgProgramCyclesPortalsSubmissionsUploadOwnerPortalSubmissionData = {
    body: BodyOrgProgramCyclesPortalsSubmissionsUploadOwnerPortalSubmission;
    path: {
        /**
         * Program Id
         */
        program_id: string;
        /**
         * Cycle Id
         */
        cycle_id: string;
        /**
         * Portal Id
         */
        portal_id: string;
        /**
         * Org Id
         */
        org_id: string;
    };
    query?: never;
    url: '/org/{org_id}/program/{program_id}/cycles/{cycle_id}/portals/{portal_id}/submissions';
};

export type OrgProgramCyclesPortalsSubmissionsUploadOwnerPortalSubmissionErrors = {
    /**
     * Not found
     */
    404: unknown;
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type OrgProgramCyclesPortalsSubmissionsUploadOwnerPortalSubmissionError = OrgProgramCyclesPortalsSubmissionsUploadOwnerPortalSubmissionErrors[keyof OrgProgramCyclesPortalsSubmissionsUploadOwnerPortalSubmissionErrors];

export type OrgProgramCyclesPortalsSubmissionsUploadOwnerPortalSubmissionResponses = {
    /**
     * Successful Response
     */
    200: OwnerPortalSubmissionResponse;
};

export type OrgProgramCyclesPortalsSubmissionsUploadOwnerPortalSubmissionResponse = OrgProgramCyclesPortalsSubmissionsUploadOwnerPortalSubmissionResponses[keyof OrgProgramCyclesPortalsSubmissionsUploadOwnerPortalSubmissionResponses];

export type OrgProgramCyclesPortalsSubmissionsReviewPortalSubmissionData = {
    body: SubmissionReviewDecision;
    path: {
        /**
         * Program Id
         */
        program_id: string;
        /**
         * Cycle Id
         */
        cycle_id: string;
        /**
         * Submission Id
         */
        submission_id: string;
        /**
         * Org Id
         */
        org_id: string;
    };
    query?: never;
    url: '/org/{org_id}/program/{program_id}/cycles/{cycle_id}/portals/submissions/{submission_id}';
};

export type OrgProgramCyclesPortalsSubmissionsReviewPortalSubmissionErrors = {
    /**
     * Not found
     */
    404: unknown;
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type OrgProgramCyclesPortalsSubmissionsReviewPortalSubmissionError = OrgProgramCyclesPortalsSubmissionsReviewPortalSubmissionErrors[keyof OrgProgramCyclesPortalsSubmissionsReviewPortalSubmissionErrors];

export type OrgProgramCyclesPortalsSubmissionsReviewPortalSubmissionResponses = {
    /**
     * Successful Response
     */
    200: PortalSubmissionResponse;
};

export type OrgProgramCyclesPortalsSubmissionsReviewPortalSubmissionResponse = OrgProgramCyclesPortalsSubmissionsReviewPortalSubmissionResponses[keyof OrgProgramCyclesPortalsSubmissionsReviewPortalSubmissionResponses];

export type OrgProgramCyclesFormsDefinitionGetFormDefinitionData = {
    body?: never;
    path: {
        /**
         * Program Id
         */
        program_id: string;
        /**
         * Cycle Id
         */
        cycle_id: string;
        /**
         * Form Id
         */
        form_id: string;
        /**
         * Org Id
         */
        org_id: string;
    };
    query?: never;
    url: '/org/{org_id}/program/{program_id}/cycles/{cycle_id}/forms/{form_id}/definition';
};

export type OrgProgramCyclesFormsDefinitionGetFormDefinitionErrors = {
    /**
     * Not found
     */
    404: unknown;
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type OrgProgramCyclesFormsDefinitionGetFormDefinitionError = OrgProgramCyclesFormsDefinitionGetFormDefinitionErrors[keyof OrgProgramCyclesFormsDefinitionGetFormDefinitionErrors];

export type OrgProgramCyclesFormsDefinitionGetFormDefinitionResponses = {
    /**
     * Successful Response
     */
    200: OwnerFormDefinition;
};

export type OrgProgramCyclesFormsDefinitionGetFormDefinitionResponse = OrgProgramCyclesFormsDefinitionGetFormDefinitionResponses[keyof OrgProgramCyclesFormsDefinitionGetFormDefinitionResponses];

export type OrgProgramCyclesFormsSubmissionsSubmitSubmitOwnerFormSubmissionData = {
    body?: never;
    path: {
        /**
         * Program Id
         */
        program_id: string;
        /**
         * Cycle Id
         */
        cycle_id: string;
        /**
         * Form Id
         */
        form_id: string;
        /**
         * Submission Id
         */
        submission_id: string;
        /**
         * Org Id
         */
        org_id: string;
    };
    query?: never;
    url: '/org/{org_id}/program/{program_id}/cycles/{cycle_id}/forms/{form_id}/submissions/{submission_id}/submit';
};

export type OrgProgramCyclesFormsSubmissionsSubmitSubmitOwnerFormSubmissionErrors = {
    /**
     * Not found
     */
    404: unknown;
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type OrgProgramCyclesFormsSubmissionsSubmitSubmitOwnerFormSubmissionError = OrgProgramCyclesFormsSubmissionsSubmitSubmitOwnerFormSubmissionErrors[keyof OrgProgramCyclesFormsSubmissionsSubmitSubmitOwnerFormSubmissionErrors];

export type OrgProgramCyclesFormsSubmissionsSubmitSubmitOwnerFormSubmissionResponses = {
    /**
     * Successful Response
     */
    200: OwnerFormSubmissionResponse;
};

export type OrgProgramCyclesFormsSubmissionsSubmitSubmitOwnerFormSubmissionResponse = OrgProgramCyclesFormsSubmissionsSubmitSubmitOwnerFormSubmissionResponses[keyof OrgProgramCyclesFormsSubmissionsSubmitSubmitOwnerFormSubmissionResponses];

export type OrgProgramCyclesFormsMySubmissionGetMyFormSubmissionData = {
    body?: never;
    path: {
        /**
         * Program Id
         */
        program_id: string;
        /**
         * Cycle Id
         */
        cycle_id: string;
        /**
         * Form Id
         */
        form_id: string;
        /**
         * Org Id
         */
        org_id: string;
    };
    query: {
        /**
         * Property Id
         */
        property_id: string;
    };
    url: '/org/{org_id}/program/{program_id}/cycles/{cycle_id}/forms/{form_id}/my-submission';
};

export type OrgProgramCyclesFormsMySubmissionGetMyFormSubmissionErrors = {
    /**
     * Not found
     */
    404: unknown;
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type OrgProgramCyclesFormsMySubmissionGetMyFormSubmissionError = OrgProgramCyclesFormsMySubmissionGetMyFormSubmissionErrors[keyof OrgProgramCyclesFormsMySubmissionGetMyFormSubmissionErrors];

export type OrgProgramCyclesFormsMySubmissionGetMyFormSubmissionResponses = {
    /**
     * Response Org-Program-Cycles-Forms-My-Submission-Get My Form Submission
     *
     * Successful Response
     */
    200: OwnerFormSubmissionResponse | null;
};

export type OrgProgramCyclesFormsMySubmissionGetMyFormSubmissionResponse = OrgProgramCyclesFormsMySubmissionGetMyFormSubmissionResponses[keyof OrgProgramCyclesFormsMySubmissionGetMyFormSubmissionResponses];

export type OrgProgramCyclesPortalsMySubmissionsListMyPortalSubmissionsData = {
    body?: never;
    path: {
        /**
         * Program Id
         */
        program_id: string;
        /**
         * Cycle Id
         */
        cycle_id: string;
        /**
         * Portal Id
         */
        portal_id: string;
        /**
         * Org Id
         */
        org_id: string;
    };
    query: {
        /**
         * Property Id
         */
        property_id: string;
    };
    url: '/org/{org_id}/program/{program_id}/cycles/{cycle_id}/portals/{portal_id}/my-submissions';
};

export type OrgProgramCyclesPortalsMySubmissionsListMyPortalSubmissionsErrors = {
    /**
     * Not found
     */
    404: unknown;
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type OrgProgramCyclesPortalsMySubmissionsListMyPortalSubmissionsError = OrgProgramCyclesPortalsMySubmissionsListMyPortalSubmissionsErrors[keyof OrgProgramCyclesPortalsMySubmissionsListMyPortalSubmissionsErrors];

export type OrgProgramCyclesPortalsMySubmissionsListMyPortalSubmissionsResponses = {
    /**
     * Response Org-Program-Cycles-Portals-My-Submissions-List My Portal Submissions
     *
     * Successful Response
     */
    200: Array<OwnerPortalSubmissionResponse>;
};

export type OrgProgramCyclesPortalsMySubmissionsListMyPortalSubmissionsResponse = OrgProgramCyclesPortalsMySubmissionsListMyPortalSubmissionsResponses[keyof OrgProgramCyclesPortalsMySubmissionsListMyPortalSubmissionsResponses];

export type OrgProgramCyclesPortalsSubmissionsGetMyPortalSubmissionData = {
    body?: never;
    path: {
        /**
         * Program Id
         */
        program_id: string;
        /**
         * Cycle Id
         */
        cycle_id: string;
        /**
         * Portal Id
         */
        portal_id: string;
        /**
         * Submission Id
         */
        submission_id: string;
        /**
         * Org Id
         */
        org_id: string;
    };
    query?: never;
    url: '/org/{org_id}/program/{program_id}/cycles/{cycle_id}/portals/{portal_id}/submissions/{submission_id}';
};

export type OrgProgramCyclesPortalsSubmissionsGetMyPortalSubmissionErrors = {
    /**
     * Not found
     */
    404: unknown;
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type OrgProgramCyclesPortalsSubmissionsGetMyPortalSubmissionError = OrgProgramCyclesPortalsSubmissionsGetMyPortalSubmissionErrors[keyof OrgProgramCyclesPortalsSubmissionsGetMyPortalSubmissionErrors];

export type OrgProgramCyclesPortalsSubmissionsGetMyPortalSubmissionResponses = {
    /**
     * Successful Response
     */
    200: OwnerPortalSubmissionResponse;
};

export type OrgProgramCyclesPortalsSubmissionsGetMyPortalSubmissionResponse = OrgProgramCyclesPortalsSubmissionsGetMyPortalSubmissionResponses[keyof OrgProgramCyclesPortalsSubmissionsGetMyPortalSubmissionResponses];

export type OrgProgramCommunicationsTemplatesListCommunicationTemplatesData = {
    body?: never;
    path: {
        /**
         * Program Id
         */
        program_id: string;
        /**
         * Org Id
         */
        org_id: string;
    };
    query?: never;
    url: '/org/{org_id}/program/{program_id}/communications/templates';
};

export type OrgProgramCommunicationsTemplatesListCommunicationTemplatesErrors = {
    /**
     * Not found
     */
    404: unknown;
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type OrgProgramCommunicationsTemplatesListCommunicationTemplatesError = OrgProgramCommunicationsTemplatesListCommunicationTemplatesErrors[keyof OrgProgramCommunicationsTemplatesListCommunicationTemplatesErrors];

export type OrgProgramCommunicationsTemplatesListCommunicationTemplatesResponses = {
    /**
     * Response Org-Program-Communications-Templates-List Communication Templates
     *
     * Successful Response
     */
    200: Array<CommunicationTemplateResponse>;
};

export type OrgProgramCommunicationsTemplatesListCommunicationTemplatesResponse = OrgProgramCommunicationsTemplatesListCommunicationTemplatesResponses[keyof OrgProgramCommunicationsTemplatesListCommunicationTemplatesResponses];

export type OrgProgramCommunicationsTemplatesCreateCommunicationTemplateData = {
    body: CommunicationTemplateCreate;
    path: {
        /**
         * Program Id
         */
        program_id: string;
        /**
         * Org Id
         */
        org_id: string;
    };
    query?: never;
    url: '/org/{org_id}/program/{program_id}/communications/templates';
};

export type OrgProgramCommunicationsTemplatesCreateCommunicationTemplateErrors = {
    /**
     * Not found
     */
    404: unknown;
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type OrgProgramCommunicationsTemplatesCreateCommunicationTemplateError = OrgProgramCommunicationsTemplatesCreateCommunicationTemplateErrors[keyof OrgProgramCommunicationsTemplatesCreateCommunicationTemplateErrors];

export type OrgProgramCommunicationsTemplatesCreateCommunicationTemplateResponses = {
    /**
     * Successful Response
     */
    200: CommunicationTemplateResponse;
};

export type OrgProgramCommunicationsTemplatesCreateCommunicationTemplateResponse = OrgProgramCommunicationsTemplatesCreateCommunicationTemplateResponses[keyof OrgProgramCommunicationsTemplatesCreateCommunicationTemplateResponses];

export type OrgProgramCommunicationsTemplatesDeleteCommunicationTemplateData = {
    body?: never;
    path: {
        /**
         * Program Id
         */
        program_id: string;
        /**
         * Template Id
         */
        template_id: string;
        /**
         * Org Id
         */
        org_id: string;
    };
    query?: never;
    url: '/org/{org_id}/program/{program_id}/communications/templates/{template_id}';
};

export type OrgProgramCommunicationsTemplatesDeleteCommunicationTemplateErrors = {
    /**
     * Not found
     */
    404: unknown;
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type OrgProgramCommunicationsTemplatesDeleteCommunicationTemplateError = OrgProgramCommunicationsTemplatesDeleteCommunicationTemplateErrors[keyof OrgProgramCommunicationsTemplatesDeleteCommunicationTemplateErrors];

export type OrgProgramCommunicationsTemplatesDeleteCommunicationTemplateResponses = {
    /**
     * Response Org-Program-Communications-Templates-Delete Communication Template
     *
     * Successful Response
     */
    200: {
        [key: string]: string;
    };
};

export type OrgProgramCommunicationsTemplatesDeleteCommunicationTemplateResponse = OrgProgramCommunicationsTemplatesDeleteCommunicationTemplateResponses[keyof OrgProgramCommunicationsTemplatesDeleteCommunicationTemplateResponses];

export type OrgProgramCommunicationsTemplatesUpdateCommunicationTemplateData = {
    body: CommunicationTemplateUpdate;
    path: {
        /**
         * Program Id
         */
        program_id: string;
        /**
         * Template Id
         */
        template_id: string;
        /**
         * Org Id
         */
        org_id: string;
    };
    query?: never;
    url: '/org/{org_id}/program/{program_id}/communications/templates/{template_id}';
};

export type OrgProgramCommunicationsTemplatesUpdateCommunicationTemplateErrors = {
    /**
     * Not found
     */
    404: unknown;
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type OrgProgramCommunicationsTemplatesUpdateCommunicationTemplateError = OrgProgramCommunicationsTemplatesUpdateCommunicationTemplateErrors[keyof OrgProgramCommunicationsTemplatesUpdateCommunicationTemplateErrors];

export type OrgProgramCommunicationsTemplatesUpdateCommunicationTemplateResponses = {
    /**
     * Successful Response
     */
    200: CommunicationTemplateResponse;
};

export type OrgProgramCommunicationsTemplatesUpdateCommunicationTemplateResponse = OrgProgramCommunicationsTemplatesUpdateCommunicationTemplateResponses[keyof OrgProgramCommunicationsTemplatesUpdateCommunicationTemplateResponses];

export type OrgProgramPropertyShareRequestsCreateShareRequestData = {
    body: ShareRequestCreate;
    path: {
        /**
         * Org Id
         */
        org_id: string;
    };
    query?: never;
    url: '/org/{org_id}/program/property-share-requests/';
};

export type OrgProgramPropertyShareRequestsCreateShareRequestErrors = {
    /**
     * Not found
     */
    404: unknown;
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type OrgProgramPropertyShareRequestsCreateShareRequestError = OrgProgramPropertyShareRequestsCreateShareRequestErrors[keyof OrgProgramPropertyShareRequestsCreateShareRequestErrors];

export type OrgProgramPropertyShareRequestsCreateShareRequestResponses = {
    /**
     * Successful Response
     */
    200: ShareRequestResponse;
};

export type OrgProgramPropertyShareRequestsCreateShareRequestResponse = OrgProgramPropertyShareRequestsCreateShareRequestResponses[keyof OrgProgramPropertyShareRequestsCreateShareRequestResponses];

export type OrgProgramPropertyShareRequestsOutgoingListOutgoingShareRequestsData = {
    body?: never;
    path: {
        /**
         * Org Id
         */
        org_id: string;
    };
    query?: {
        /**
         * Program Id
         */
        program_id?: string | null;
    };
    url: '/org/{org_id}/program/property-share-requests/outgoing';
};

export type OrgProgramPropertyShareRequestsOutgoingListOutgoingShareRequestsErrors = {
    /**
     * Not found
     */
    404: unknown;
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type OrgProgramPropertyShareRequestsOutgoingListOutgoingShareRequestsError = OrgProgramPropertyShareRequestsOutgoingListOutgoingShareRequestsErrors[keyof OrgProgramPropertyShareRequestsOutgoingListOutgoingShareRequestsErrors];

export type OrgProgramPropertyShareRequestsOutgoingListOutgoingShareRequestsResponses = {
    /**
     * Response Org-Program-Property-Share-Requests-Outgoing-List Outgoing Share Requests
     *
     * Successful Response
     */
    200: Array<ShareRequestResponse>;
};

export type OrgProgramPropertyShareRequestsOutgoingListOutgoingShareRequestsResponse = OrgProgramPropertyShareRequestsOutgoingListOutgoingShareRequestsResponses[keyof OrgProgramPropertyShareRequestsOutgoingListOutgoingShareRequestsResponses];

export type OrgProgramPropertyShareRequestsIncomingListIncomingShareRequestsData = {
    body?: never;
    path: {
        /**
         * Org Id
         */
        org_id: string;
    };
    query?: {
        /**
         * Program Id
         */
        program_id?: string | null;
    };
    url: '/org/{org_id}/program/property-share-requests/incoming';
};

export type OrgProgramPropertyShareRequestsIncomingListIncomingShareRequestsErrors = {
    /**
     * Not found
     */
    404: unknown;
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type OrgProgramPropertyShareRequestsIncomingListIncomingShareRequestsError = OrgProgramPropertyShareRequestsIncomingListIncomingShareRequestsErrors[keyof OrgProgramPropertyShareRequestsIncomingListIncomingShareRequestsErrors];

export type OrgProgramPropertyShareRequestsIncomingListIncomingShareRequestsResponses = {
    /**
     * Response Org-Program-Property-Share-Requests-Incoming-List Incoming Share Requests
     *
     * Successful Response
     */
    200: Array<ShareRequestResponse>;
};

export type OrgProgramPropertyShareRequestsIncomingListIncomingShareRequestsResponse = OrgProgramPropertyShareRequestsIncomingListIncomingShareRequestsResponses[keyof OrgProgramPropertyShareRequestsIncomingListIncomingShareRequestsResponses];

export type OrgProgramPropertyShareRequestsApproveApproveShareRequestData = {
    body: ShareRequestDecision;
    path: {
        /**
         * Request Id
         */
        request_id: string;
        /**
         * Org Id
         */
        org_id: string;
    };
    query?: never;
    url: '/org/{org_id}/program/property-share-requests/{request_id}/approve';
};

export type OrgProgramPropertyShareRequestsApproveApproveShareRequestErrors = {
    /**
     * Not found
     */
    404: unknown;
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type OrgProgramPropertyShareRequestsApproveApproveShareRequestError = OrgProgramPropertyShareRequestsApproveApproveShareRequestErrors[keyof OrgProgramPropertyShareRequestsApproveApproveShareRequestErrors];

export type OrgProgramPropertyShareRequestsApproveApproveShareRequestResponses = {
    /**
     * Successful Response
     */
    200: ShareRequestResponse;
};

export type OrgProgramPropertyShareRequestsApproveApproveShareRequestResponse = OrgProgramPropertyShareRequestsApproveApproveShareRequestResponses[keyof OrgProgramPropertyShareRequestsApproveApproveShareRequestResponses];

export type OrgProgramPropertyShareRequestsDenyDenyShareRequestData = {
    body: ShareRequestDecision;
    path: {
        /**
         * Request Id
         */
        request_id: string;
        /**
         * Org Id
         */
        org_id: string;
    };
    query?: never;
    url: '/org/{org_id}/program/property-share-requests/{request_id}/deny';
};

export type OrgProgramPropertyShareRequestsDenyDenyShareRequestErrors = {
    /**
     * Not found
     */
    404: unknown;
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type OrgProgramPropertyShareRequestsDenyDenyShareRequestError = OrgProgramPropertyShareRequestsDenyDenyShareRequestErrors[keyof OrgProgramPropertyShareRequestsDenyDenyShareRequestErrors];

export type OrgProgramPropertyShareRequestsDenyDenyShareRequestResponses = {
    /**
     * Successful Response
     */
    200: ShareRequestResponse;
};

export type OrgProgramPropertyShareRequestsDenyDenyShareRequestResponse = OrgProgramPropertyShareRequestsDenyDenyShareRequestResponses[keyof OrgProgramPropertyShareRequestsDenyDenyShareRequestResponses];

export type OrgProgramPropertyShareRequestsRevokeRevokeShareRequestData = {
    body: ShareRequestDecision;
    path: {
        /**
         * Request Id
         */
        request_id: string;
        /**
         * Org Id
         */
        org_id: string;
    };
    query?: never;
    url: '/org/{org_id}/program/property-share-requests/{request_id}/revoke';
};

export type OrgProgramPropertyShareRequestsRevokeRevokeShareRequestErrors = {
    /**
     * Not found
     */
    404: unknown;
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type OrgProgramPropertyShareRequestsRevokeRevokeShareRequestError = OrgProgramPropertyShareRequestsRevokeRevokeShareRequestErrors[keyof OrgProgramPropertyShareRequestsRevokeRevokeShareRequestErrors];

export type OrgProgramPropertyShareRequestsRevokeRevokeShareRequestResponses = {
    /**
     * Successful Response
     */
    200: ShareRequestResponse;
};

export type OrgProgramPropertyShareRequestsRevokeRevokeShareRequestResponse = OrgProgramPropertyShareRequestsRevokeRevokeShareRequestResponses[keyof OrgProgramPropertyShareRequestsRevokeRevokeShareRequestResponses];

export type OrgProgramCyclesReportsCitywideCitywideReportData = {
    body?: never;
    path: {
        /**
         * Program Id
         */
        program_id: string;
        /**
         * Cycle Id
         */
        cycle_id: string;
        /**
         * Org Id
         */
        org_id: string;
    };
    query?: never;
    url: '/org/{org_id}/program/{program_id}/cycles/{cycle_id}/reports/citywide';
};

export type OrgProgramCyclesReportsCitywideCitywideReportErrors = {
    /**
     * Not found
     */
    404: unknown;
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type OrgProgramCyclesReportsCitywideCitywideReportError = OrgProgramCyclesReportsCitywideCitywideReportErrors[keyof OrgProgramCyclesReportsCitywideCitywideReportErrors];

export type OrgProgramCyclesReportsCitywideCitywideReportResponses = {
    /**
     * Successful Response
     */
    200: CitywideReport;
};

export type OrgProgramCyclesReportsCitywideCitywideReportResponse = OrgProgramCyclesReportsCitywideCitywideReportResponses[keyof OrgProgramCyclesReportsCitywideCitywideReportResponses];

export type OrgProgramCyclesReportsDashboardProgramDashboardData = {
    body?: never;
    path: {
        /**
         * Program Id
         */
        program_id: string;
        /**
         * Cycle Id
         */
        cycle_id: string;
        /**
         * Org Id
         */
        org_id: string;
    };
    query?: never;
    url: '/org/{org_id}/program/{program_id}/cycles/{cycle_id}/reports/dashboard';
};

export type OrgProgramCyclesReportsDashboardProgramDashboardErrors = {
    /**
     * Not found
     */
    404: unknown;
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type OrgProgramCyclesReportsDashboardProgramDashboardError = OrgProgramCyclesReportsDashboardProgramDashboardErrors[keyof OrgProgramCyclesReportsDashboardProgramDashboardErrors];

export type OrgProgramCyclesReportsDashboardProgramDashboardResponses = {
    /**
     * Successful Response
     */
    200: DashboardReport;
};

export type OrgProgramCyclesReportsDashboardProgramDashboardResponse = OrgProgramCyclesReportsDashboardProgramDashboardResponses[keyof OrgProgramCyclesReportsDashboardProgramDashboardResponses];

export type OrgProgramCyclesReportsDisclosureCsvDisclosureExportData = {
    body?: never;
    path: {
        /**
         * Program Id
         */
        program_id: string;
        /**
         * Cycle Id
         */
        cycle_id: string;
        /**
         * Org Id
         */
        org_id: string;
    };
    query?: never;
    url: '/org/{org_id}/program/{program_id}/cycles/{cycle_id}/reports/disclosure.csv';
};

export type OrgProgramCyclesReportsDisclosureCsvDisclosureExportErrors = {
    /**
     * Not found
     */
    404: unknown;
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type OrgProgramCyclesReportsDisclosureCsvDisclosureExportError = OrgProgramCyclesReportsDisclosureCsvDisclosureExportErrors[keyof OrgProgramCyclesReportsDisclosureCsvDisclosureExportErrors];

export type OrgProgramCyclesReportsDisclosureCsvDisclosureExportResponses = {
    /**
     * Successful Response
     */
    200: unknown;
};

export type OrgProgramTracksListProgramTracksData = {
    body?: never;
    path: {
        /**
         * Program Id
         */
        program_id: string;
        /**
         * Org Id
         */
        org_id: string;
    };
    query?: never;
    url: '/org/{org_id}/program/{program_id}/tracks';
};

export type OrgProgramTracksListProgramTracksErrors = {
    /**
     * Not found
     */
    404: unknown;
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type OrgProgramTracksListProgramTracksError = OrgProgramTracksListProgramTracksErrors[keyof OrgProgramTracksListProgramTracksErrors];

export type OrgProgramTracksListProgramTracksResponses = {
    /**
     * Response Org-Program-Tracks-List Program Tracks
     *
     * Successful Response
     */
    200: Array<TrackResponse>;
};

export type OrgProgramTracksListProgramTracksResponse = OrgProgramTracksListProgramTracksResponses[keyof OrgProgramTracksListProgramTracksResponses];

export type OrgProgramSourcesListProgramSourcesData = {
    body?: never;
    path: {
        /**
         * Program Id
         */
        program_id: string;
        /**
         * Org Id
         */
        org_id: string;
    };
    query?: never;
    url: '/org/{org_id}/program/{program_id}/sources';
};

export type OrgProgramSourcesListProgramSourcesErrors = {
    /**
     * Not found
     */
    404: unknown;
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type OrgProgramSourcesListProgramSourcesError = OrgProgramSourcesListProgramSourcesErrors[keyof OrgProgramSourcesListProgramSourcesErrors];

export type OrgProgramSourcesListProgramSourcesResponses = {
    /**
     * Response Org-Program-Sources-List Program Sources
     *
     * Successful Response
     */
    200: Array<SourceResponse>;
};

export type OrgProgramSourcesListProgramSourcesResponse = OrgProgramSourcesListProgramSourcesResponses[keyof OrgProgramSourcesListProgramSourcesResponses];

export type OrgProgramReferenceGetProgramReferenceData = {
    body?: never;
    path: {
        /**
         * Program Id
         */
        program_id: string;
        /**
         * Org Id
         */
        org_id: string;
    };
    query?: {
        /**
         * On
         *
         * Read the versions in effect on this date (default: current).
         */
        on?: string | null;
    };
    url: '/org/{org_id}/program/{program_id}/reference';
};

export type OrgProgramReferenceGetProgramReferenceErrors = {
    /**
     * Not found
     */
    404: unknown;
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type OrgProgramReferenceGetProgramReferenceError = OrgProgramReferenceGetProgramReferenceErrors[keyof OrgProgramReferenceGetProgramReferenceErrors];

export type OrgProgramReferenceGetProgramReferenceResponses = {
    /**
     * Successful Response
     */
    200: ProgramReferenceResponse;
};

export type OrgProgramReferenceGetProgramReferenceResponse = OrgProgramReferenceGetProgramReferenceResponses[keyof OrgProgramReferenceGetProgramReferenceResponses];

export type OrgProgramDefinitionHistoryListProgramDefinitionHistoryData = {
    body?: never;
    path: {
        /**
         * Program Id
         */
        program_id: string;
        /**
         * Org Id
         */
        org_id: string;
    };
    query?: {
        /**
         * Kind
         */
        kind?: string | null;
        /**
         * Key
         */
        key?: string | null;
    };
    url: '/org/{org_id}/program/{program_id}/definition-history';
};

export type OrgProgramDefinitionHistoryListProgramDefinitionHistoryErrors = {
    /**
     * Not found
     */
    404: unknown;
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type OrgProgramDefinitionHistoryListProgramDefinitionHistoryError = OrgProgramDefinitionHistoryListProgramDefinitionHistoryErrors[keyof OrgProgramDefinitionHistoryListProgramDefinitionHistoryErrors];

export type OrgProgramDefinitionHistoryListProgramDefinitionHistoryResponses = {
    /**
     * Response Org-Program-Definition-History-List Program Definition History
     *
     * Successful Response
     */
    200: Array<DefinitionRecordResponse>;
};

export type OrgProgramDefinitionHistoryListProgramDefinitionHistoryResponse = OrgProgramDefinitionHistoryListProgramDefinitionHistoryResponses[keyof OrgProgramDefinitionHistoryListProgramDefinitionHistoryResponses];

export type OrgProgramImportRunsListProgramImportRunsData = {
    body?: never;
    path: {
        /**
         * Program Id
         */
        program_id: string;
        /**
         * Org Id
         */
        org_id: string;
    };
    query?: never;
    url: '/org/{org_id}/program/{program_id}/import-runs';
};

export type OrgProgramImportRunsListProgramImportRunsErrors = {
    /**
     * Not found
     */
    404: unknown;
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type OrgProgramImportRunsListProgramImportRunsError = OrgProgramImportRunsListProgramImportRunsErrors[keyof OrgProgramImportRunsListProgramImportRunsErrors];

export type OrgProgramImportRunsListProgramImportRunsResponses = {
    /**
     * Response Org-Program-Import-Runs-List Program Import Runs
     *
     * Successful Response
     */
    200: Array<ImportRunResponse>;
};

export type OrgProgramImportRunsListProgramImportRunsResponse = OrgProgramImportRunsListProgramImportRunsResponses[keyof OrgProgramImportRunsListProgramImportRunsResponses];

export type OrgProgramCatalogListCatalogProgramsData = {
    body?: never;
    path: {
        /**
         * Org Id
         */
        org_id: string;
    };
    query?: never;
    url: '/org/{org_id}/program-catalog';
};

export type OrgProgramCatalogListCatalogProgramsErrors = {
    /**
     * Not found
     */
    404: unknown;
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type OrgProgramCatalogListCatalogProgramsError = OrgProgramCatalogListCatalogProgramsErrors[keyof OrgProgramCatalogListCatalogProgramsErrors];

export type OrgProgramCatalogListCatalogProgramsResponses = {
    /**
     * Response Org-Program-Catalog-List Catalog Programs
     *
     * Successful Response
     */
    200: Array<ProgramResponse>;
};

export type OrgProgramCatalogListCatalogProgramsResponse = OrgProgramCatalogListCatalogProgramsResponses[keyof OrgProgramCatalogListCatalogProgramsResponses];

export type OrgProgramCatalogGetCatalogProgramData = {
    body?: never;
    path: {
        /**
         * Program Id
         */
        program_id: string;
        /**
         * Org Id
         */
        org_id: string;
    };
    query?: never;
    url: '/org/{org_id}/program-catalog/{program_id}';
};

export type OrgProgramCatalogGetCatalogProgramErrors = {
    /**
     * Not found
     */
    404: unknown;
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type OrgProgramCatalogGetCatalogProgramError = OrgProgramCatalogGetCatalogProgramErrors[keyof OrgProgramCatalogGetCatalogProgramErrors];

export type OrgProgramCatalogGetCatalogProgramResponses = {
    /**
     * Successful Response
     */
    200: ProgramDetailResponse;
};

export type OrgProgramCatalogGetCatalogProgramResponse = OrgProgramCatalogGetCatalogProgramResponses[keyof OrgProgramCatalogGetCatalogProgramResponses];

export type OrgProgramMatchListProgramMatchesData = {
    body?: never;
    path: {
        /**
         * Org Id
         */
        org_id: string;
    };
    query?: {
        /**
         * Status
         *
         * Defaults to the open matches (Proposed and Possible).
         */
        status?: Array<ProgramMatchStatus> | null;
        /**
         * Property Id
         */
        property_id?: string | null;
    };
    url: '/org/{org_id}/program-match';
};

export type OrgProgramMatchListProgramMatchesErrors = {
    /**
     * Not found
     */
    404: unknown;
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type OrgProgramMatchListProgramMatchesError = OrgProgramMatchListProgramMatchesErrors[keyof OrgProgramMatchListProgramMatchesErrors];

export type OrgProgramMatchListProgramMatchesResponses = {
    /**
     * Response Org-Program-Match-List Program Matches
     *
     * Successful Response
     */
    200: Array<ProgramMatchResponse>;
};

export type OrgProgramMatchListProgramMatchesResponse = OrgProgramMatchListProgramMatchesResponses[keyof OrgProgramMatchListProgramMatchesResponses];

export type OrgProgramMatchGetProgramMatchData = {
    body?: never;
    path: {
        /**
         * Match Id
         */
        match_id: string;
        /**
         * Org Id
         */
        org_id: string;
    };
    query?: never;
    url: '/org/{org_id}/program-match/{match_id}';
};

export type OrgProgramMatchGetProgramMatchErrors = {
    /**
     * Not found
     */
    404: unknown;
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type OrgProgramMatchGetProgramMatchError = OrgProgramMatchGetProgramMatchErrors[keyof OrgProgramMatchGetProgramMatchErrors];

export type OrgProgramMatchGetProgramMatchResponses = {
    /**
     * Successful Response
     */
    200: ProgramMatchResponse;
};

export type OrgProgramMatchGetProgramMatchResponse = OrgProgramMatchGetProgramMatchResponses[keyof OrgProgramMatchGetProgramMatchResponses];

export type OrgProgramMatchConfirmConfirmProgramMatchData = {
    body?: never;
    path: {
        /**
         * Match Id
         */
        match_id: string;
        /**
         * Org Id
         */
        org_id: string;
    };
    query?: never;
    url: '/org/{org_id}/program-match/{match_id}/confirm';
};

export type OrgProgramMatchConfirmConfirmProgramMatchErrors = {
    /**
     * Not found
     */
    404: unknown;
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type OrgProgramMatchConfirmConfirmProgramMatchError = OrgProgramMatchConfirmConfirmProgramMatchErrors[keyof OrgProgramMatchConfirmConfirmProgramMatchErrors];

export type OrgProgramMatchConfirmConfirmProgramMatchResponses = {
    /**
     * Successful Response
     */
    200: ProgramMatchResponse;
};

export type OrgProgramMatchConfirmConfirmProgramMatchResponse = OrgProgramMatchConfirmConfirmProgramMatchResponses[keyof OrgProgramMatchConfirmConfirmProgramMatchResponses];

export type OrgProgramMatchDeclineDeclineProgramMatchData = {
    body: DeclineRequest;
    path: {
        /**
         * Match Id
         */
        match_id: string;
        /**
         * Org Id
         */
        org_id: string;
    };
    query?: never;
    url: '/org/{org_id}/program-match/{match_id}/decline';
};

export type OrgProgramMatchDeclineDeclineProgramMatchErrors = {
    /**
     * Not found
     */
    404: unknown;
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type OrgProgramMatchDeclineDeclineProgramMatchError = OrgProgramMatchDeclineDeclineProgramMatchErrors[keyof OrgProgramMatchDeclineDeclineProgramMatchErrors];

export type OrgProgramMatchDeclineDeclineProgramMatchResponses = {
    /**
     * Successful Response
     */
    200: ProgramMatchResponse;
};

export type OrgProgramMatchDeclineDeclineProgramMatchResponse = OrgProgramMatchDeclineDeclineProgramMatchResponses[keyof OrgProgramMatchDeclineDeclineProgramMatchResponses];

export type OrgPreferencesGetPreferencesData = {
    body?: never;
    path: {
        /**
         * Org Id
         */
        org_id: string;
    };
    query?: never;
    url: '/org/{org_id}/preferences/';
};

export type OrgPreferencesGetPreferencesErrors = {
    /**
     * Not found
     */
    404: unknown;
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type OrgPreferencesGetPreferencesError = OrgPreferencesGetPreferencesErrors[keyof OrgPreferencesGetPreferencesErrors];

export type OrgPreferencesGetPreferencesResponses = {
    /**
     * Response Org-Preferences--Get Preferences
     *
     * Successful Response
     */
    200: Array<Preference>;
};

export type OrgPreferencesGetPreferencesResponse = OrgPreferencesGetPreferencesResponses[keyof OrgPreferencesGetPreferencesResponses];

export type OrgPreferencesSetPreferencesData = {
    body: PreferenceCollection;
    path: {
        /**
         * Org Id
         */
        org_id: string;
    };
    query?: never;
    url: '/org/{org_id}/preferences/';
};

export type OrgPreferencesSetPreferencesErrors = {
    /**
     * Not found
     */
    404: unknown;
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type OrgPreferencesSetPreferencesError = OrgPreferencesSetPreferencesErrors[keyof OrgPreferencesSetPreferencesErrors];

export type OrgPreferencesSetPreferencesResponses = {
    /**
     * Response Org-Preferences--Set Preferences
     *
     * Successful Response
     */
    200: Array<Preference>;
};

export type OrgPreferencesSetPreferencesResponse = OrgPreferencesSetPreferencesResponses[keyof OrgPreferencesSetPreferencesResponses];

export type OrgPropertyListData = {
    body?: never;
    path: {
        /**
         * Org Id
         */
        org_id: string;
    };
    query?: never;
    url: '/org/{org_id}/property/';
};

export type OrgPropertyListErrors = {
    /**
     * Not found
     */
    404: unknown;
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type OrgPropertyListError = OrgPropertyListErrors[keyof OrgPropertyListErrors];

export type OrgPropertyListResponses = {
    /**
     * Response Org-Property--List
     *
     * Successful Response
     */
    200: Array<Property>;
};

export type OrgPropertyListResponse = OrgPropertyListResponses[keyof OrgPropertyListResponses];

export type OrgPropertyCreateData = {
    body: PublicPropertyCreateUpdate;
    path: {
        /**
         * Org Id
         */
        org_id: string;
    };
    query?: never;
    url: '/org/{org_id}/property/';
};

export type OrgPropertyCreateErrors = {
    /**
     * Not found
     */
    404: unknown;
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type OrgPropertyCreateError = OrgPropertyCreateErrors[keyof OrgPropertyCreateErrors];

export type OrgPropertyCreateResponses = {
    /**
     * Successful Response
     */
    200: Property;
};

export type OrgPropertyCreateResponse = OrgPropertyCreateResponses[keyof OrgPropertyCreateResponses];

export type OrgPropertyUpdateData = {
    body: PublicPropertyCreateUpdate;
    path: {
        /**
         * Property Id
         */
        property_id: string;
        /**
         * Org Id
         */
        org_id: string;
    };
    query?: never;
    url: '/org/{org_id}/property/{property_id}';
};

export type OrgPropertyUpdateErrors = {
    /**
     * Not found
     */
    404: unknown;
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type OrgPropertyUpdateError = OrgPropertyUpdateErrors[keyof OrgPropertyUpdateErrors];

export type OrgPropertyUpdateResponses = {
    /**
     * Successful Response
     */
    200: Property;
};

export type OrgPropertyUpdateResponse = OrgPropertyUpdateResponses[keyof OrgPropertyUpdateResponses];

export type OrgPropertyServiceHistoryGetServiceHistoryData = {
    body?: never;
    path: {
        /**
         * Property Id
         */
        property_id: string;
        /**
         * Org Id
         */
        org_id: string;
    };
    query?: never;
    url: '/org/{org_id}/property/{property_id}/service_history';
};

export type OrgPropertyServiceHistoryGetServiceHistoryErrors = {
    /**
     * Not found
     */
    404: unknown;
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type OrgPropertyServiceHistoryGetServiceHistoryError = OrgPropertyServiceHistoryGetServiceHistoryErrors[keyof OrgPropertyServiceHistoryGetServiceHistoryErrors];

export type OrgPropertyServiceHistoryGetServiceHistoryResponses = {
    /**
     * Response Org-Property-Service History-Get Service History
     *
     * Successful Response
     */
    200: Array<ServiceDetailSummary>;
};

export type OrgPropertyServiceHistoryGetServiceHistoryResponse = OrgPropertyServiceHistoryGetServiceHistoryResponses[keyof OrgPropertyServiceHistoryGetServiceHistoryResponses];

export type OrgPropertyProgramFactsGetPropertyProgramFactsData = {
    body?: never;
    path: {
        /**
         * Property Id
         */
        property_id: string;
        /**
         * Org Id
         */
        org_id: string;
    };
    query?: never;
    url: '/org/{org_id}/property/{property_id}/program-facts';
};

export type OrgPropertyProgramFactsGetPropertyProgramFactsErrors = {
    /**
     * Not found
     */
    404: unknown;
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type OrgPropertyProgramFactsGetPropertyProgramFactsError = OrgPropertyProgramFactsGetPropertyProgramFactsErrors[keyof OrgPropertyProgramFactsGetPropertyProgramFactsErrors];

export type OrgPropertyProgramFactsGetPropertyProgramFactsResponses = {
    /**
     * Successful Response
     */
    200: ProgramFactsResponse;
};

export type OrgPropertyProgramFactsGetPropertyProgramFactsResponse = OrgPropertyProgramFactsGetPropertyProgramFactsResponses[keyof OrgPropertyProgramFactsGetPropertyProgramFactsResponses];

export type OrgPropertyProgramFactsSetPropertyProgramFactsData = {
    /**
     * Data
     */
    body: {
        [key: string]: unknown;
    };
    path: {
        /**
         * Property Id
         */
        property_id: string;
        /**
         * Org Id
         */
        org_id: string;
    };
    query?: never;
    url: '/org/{org_id}/property/{property_id}/program-facts';
};

export type OrgPropertyProgramFactsSetPropertyProgramFactsErrors = {
    /**
     * Not found
     */
    404: unknown;
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type OrgPropertyProgramFactsSetPropertyProgramFactsError = OrgPropertyProgramFactsSetPropertyProgramFactsErrors[keyof OrgPropertyProgramFactsSetPropertyProgramFactsErrors];

export type OrgPropertyProgramFactsSetPropertyProgramFactsResponses = {
    /**
     * Successful Response
     */
    200: ProgramFactsResponse;
};

export type OrgPropertyProgramFactsSetPropertyProgramFactsResponse = OrgPropertyProgramFactsSetPropertyProgramFactsResponses[keyof OrgPropertyProgramFactsSetPropertyProgramFactsResponses];

export type OrgPropertyUsesListPropertyUsesData = {
    body?: never;
    path: {
        /**
         * Property Id
         */
        property_id: string;
        /**
         * Org Id
         */
        org_id: string;
    };
    query?: {
        /**
         * Include Ended
         */
        include_ended?: boolean;
    };
    url: '/org/{org_id}/property/{property_id}/uses';
};

export type OrgPropertyUsesListPropertyUsesErrors = {
    /**
     * Not found
     */
    404: unknown;
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type OrgPropertyUsesListPropertyUsesError = OrgPropertyUsesListPropertyUsesErrors[keyof OrgPropertyUsesListPropertyUsesErrors];

export type OrgPropertyUsesListPropertyUsesResponses = {
    /**
     * Response Org-Property-Uses-List Property Uses
     *
     * Successful Response
     */
    200: Array<PropertyUseResponse>;
};

export type OrgPropertyUsesListPropertyUsesResponse = OrgPropertyUsesListPropertyUsesResponses[keyof OrgPropertyUsesListPropertyUsesResponses];

export type OrgPropertyUsesReplacePropertyUsesData = {
    /**
     * Data
     */
    body: Array<PropertyUseModel>;
    path: {
        /**
         * Property Id
         */
        property_id: string;
        /**
         * Org Id
         */
        org_id: string;
    };
    query?: {
        /**
         * Effective On
         *
         * Date the new uses take effect (default today).
         */
        effective_on?: string | null;
    };
    url: '/org/{org_id}/property/{property_id}/uses';
};

export type OrgPropertyUsesReplacePropertyUsesErrors = {
    /**
     * Not found
     */
    404: unknown;
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type OrgPropertyUsesReplacePropertyUsesError = OrgPropertyUsesReplacePropertyUsesErrors[keyof OrgPropertyUsesReplacePropertyUsesErrors];

export type OrgPropertyUsesReplacePropertyUsesResponses = {
    /**
     * Response Org-Property-Uses-Replace Property Uses
     *
     * Successful Response
     */
    200: Array<PropertyUseResponse>;
};

export type OrgPropertyUsesReplacePropertyUsesResponse = OrgPropertyUsesReplacePropertyUsesResponses[keyof OrgPropertyUsesReplacePropertyUsesResponses];

export type OrgPropertyMetricsListPropertyMetricsData = {
    body?: never;
    path: {
        /**
         * Property Id
         */
        property_id: string;
        /**
         * Org Id
         */
        org_id: string;
    };
    query?: never;
    url: '/org/{org_id}/property/{property_id}/metrics';
};

export type OrgPropertyMetricsListPropertyMetricsErrors = {
    /**
     * Not found
     */
    404: unknown;
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type OrgPropertyMetricsListPropertyMetricsError = OrgPropertyMetricsListPropertyMetricsErrors[keyof OrgPropertyMetricsListPropertyMetricsErrors];

export type OrgPropertyMetricsListPropertyMetricsResponses = {
    /**
     * Response Org-Property-Metrics-List Property Metrics
     *
     * Successful Response
     */
    200: Array<MetricResponse>;
};

export type OrgPropertyMetricsListPropertyMetricsResponse = OrgPropertyMetricsListPropertyMetricsResponses[keyof OrgPropertyMetricsListPropertyMetricsResponses];

export type OrgPropertyMetricsSetPropertyMetricData = {
    body: MetricValue;
    path: {
        /**
         * Property Id
         */
        property_id: string;
        /**
         * Org Id
         */
        org_id: string;
    };
    query?: never;
    url: '/org/{org_id}/property/{property_id}/metrics';
};

export type OrgPropertyMetricsSetPropertyMetricErrors = {
    /**
     * Not found
     */
    404: unknown;
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type OrgPropertyMetricsSetPropertyMetricError = OrgPropertyMetricsSetPropertyMetricErrors[keyof OrgPropertyMetricsSetPropertyMetricErrors];

export type OrgPropertyMetricsSetPropertyMetricResponses = {
    /**
     * Successful Response
     */
    200: MetricResponse;
};

export type OrgPropertyMetricsSetPropertyMetricResponse = OrgPropertyMetricsSetPropertyMetricResponses[keyof OrgPropertyMetricsSetPropertyMetricResponses];

export type OrgPropertyMetricsImportImportPropertyMetricsData = {
    body: MetricsImportRequest;
    path: {
        /**
         * Org Id
         */
        org_id: string;
    };
    query?: never;
    url: '/org/{org_id}/property/metrics/import';
};

export type OrgPropertyMetricsImportImportPropertyMetricsErrors = {
    /**
     * Not found
     */
    404: unknown;
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type OrgPropertyMetricsImportImportPropertyMetricsError = OrgPropertyMetricsImportImportPropertyMetricsErrors[keyof OrgPropertyMetricsImportImportPropertyMetricsErrors];

export type OrgPropertyMetricsImportImportPropertyMetricsResponses = {
    /**
     * Successful Response
     */
    200: MetricsImportResponse;
};

export type OrgPropertyMetricsImportImportPropertyMetricsResponse = OrgPropertyMetricsImportImportPropertyMetricsResponses[keyof OrgPropertyMetricsImportImportPropertyMetricsResponses];

export type OrgPropertyTenantSpacesListPropertyTenantSpacesData = {
    body?: never;
    path: {
        /**
         * Property Id
         */
        property_id: string;
        /**
         * Org Id
         */
        org_id: string;
    };
    query?: {
        /**
         * Program Key
         *
         * Program whose tenant-space threshold applies.
         */
        program_key?: string | null;
    };
    url: '/org/{org_id}/property/{property_id}/tenant-spaces';
};

export type OrgPropertyTenantSpacesListPropertyTenantSpacesErrors = {
    /**
     * Not found
     */
    404: unknown;
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type OrgPropertyTenantSpacesListPropertyTenantSpacesError = OrgPropertyTenantSpacesListPropertyTenantSpacesErrors[keyof OrgPropertyTenantSpacesListPropertyTenantSpacesErrors];

export type OrgPropertyTenantSpacesListPropertyTenantSpacesResponses = {
    /**
     * Successful Response
     */
    200: TenantSpacesResponse;
};

export type OrgPropertyTenantSpacesListPropertyTenantSpacesResponse = OrgPropertyTenantSpacesListPropertyTenantSpacesResponses[keyof OrgPropertyTenantSpacesListPropertyTenantSpacesResponses];

export type OrgPropertyTenantSpacesCreatePropertyTenantSpaceData = {
    body: TenantSpaceModel;
    path: {
        /**
         * Property Id
         */
        property_id: string;
        /**
         * Org Id
         */
        org_id: string;
    };
    query?: never;
    url: '/org/{org_id}/property/{property_id}/tenant-spaces';
};

export type OrgPropertyTenantSpacesCreatePropertyTenantSpaceErrors = {
    /**
     * Not found
     */
    404: unknown;
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type OrgPropertyTenantSpacesCreatePropertyTenantSpaceError = OrgPropertyTenantSpacesCreatePropertyTenantSpaceErrors[keyof OrgPropertyTenantSpacesCreatePropertyTenantSpaceErrors];

export type OrgPropertyTenantSpacesCreatePropertyTenantSpaceResponses = {
    /**
     * Successful Response
     */
    200: TenantSpaceResponse;
};

export type OrgPropertyTenantSpacesCreatePropertyTenantSpaceResponse = OrgPropertyTenantSpacesCreatePropertyTenantSpaceResponses[keyof OrgPropertyTenantSpacesCreatePropertyTenantSpaceResponses];

export type OrgPropertyTenantSpacesUpdatePropertyTenantSpaceData = {
    body: TenantSpaceModel;
    path: {
        /**
         * Property Id
         */
        property_id: string;
        /**
         * Space Id
         */
        space_id: string;
        /**
         * Org Id
         */
        org_id: string;
    };
    query?: never;
    url: '/org/{org_id}/property/{property_id}/tenant-spaces/{space_id}';
};

export type OrgPropertyTenantSpacesUpdatePropertyTenantSpaceErrors = {
    /**
     * Not found
     */
    404: unknown;
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type OrgPropertyTenantSpacesUpdatePropertyTenantSpaceError = OrgPropertyTenantSpacesUpdatePropertyTenantSpaceErrors[keyof OrgPropertyTenantSpacesUpdatePropertyTenantSpaceErrors];

export type OrgPropertyTenantSpacesUpdatePropertyTenantSpaceResponses = {
    /**
     * Successful Response
     */
    200: TenantSpaceResponse;
};

export type OrgPropertyTenantSpacesUpdatePropertyTenantSpaceResponse = OrgPropertyTenantSpacesUpdatePropertyTenantSpaceResponses[keyof OrgPropertyTenantSpacesUpdatePropertyTenantSpaceResponses];

export type OrgPropertyTenantSpacesExportCsvExportPropertyTenantSpacesData = {
    body?: never;
    path: {
        /**
         * Property Id
         */
        property_id: string;
        /**
         * Org Id
         */
        org_id: string;
    };
    query?: {
        /**
         * Program Key
         */
        program_key?: string | null;
    };
    url: '/org/{org_id}/property/{property_id}/tenant-spaces/export.csv';
};

export type OrgPropertyTenantSpacesExportCsvExportPropertyTenantSpacesErrors = {
    /**
     * Not found
     */
    404: unknown;
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type OrgPropertyTenantSpacesExportCsvExportPropertyTenantSpacesError = OrgPropertyTenantSpacesExportCsvExportPropertyTenantSpacesErrors[keyof OrgPropertyTenantSpacesExportCsvExportPropertyTenantSpacesErrors];

export type OrgPropertyTenantSpacesExportCsvExportPropertyTenantSpacesResponses = {
    /**
     * Successful Response
     */
    200: unknown;
};

export type OrgPropertyTenantSpacesImportImportPropertyTenantSpacesData = {
    body: TenantSpacesImportRequest;
    path: {
        /**
         * Property Id
         */
        property_id: string;
        /**
         * Org Id
         */
        org_id: string;
    };
    query?: never;
    url: '/org/{org_id}/property/{property_id}/tenant-spaces/import';
};

export type OrgPropertyTenantSpacesImportImportPropertyTenantSpacesErrors = {
    /**
     * Not found
     */
    404: unknown;
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type OrgPropertyTenantSpacesImportImportPropertyTenantSpacesError = OrgPropertyTenantSpacesImportImportPropertyTenantSpacesErrors[keyof OrgPropertyTenantSpacesImportImportPropertyTenantSpacesErrors];

export type OrgPropertyTenantSpacesImportImportPropertyTenantSpacesResponses = {
    /**
     * Successful Response
     */
    200: TenantSpacesImportResponse;
};

export type OrgPropertyTenantSpacesImportImportPropertyTenantSpacesResponse = OrgPropertyTenantSpacesImportImportPropertyTenantSpacesResponses[keyof OrgPropertyTenantSpacesImportImportPropertyTenantSpacesResponses];

export type OrgPropertyAttestationsListPropertyAttestationsData = {
    body?: never;
    path: {
        /**
         * Property Id
         */
        property_id: string;
        /**
         * Org Id
         */
        org_id: string;
    };
    query?: never;
    url: '/org/{org_id}/property/{property_id}/attestations';
};

export type OrgPropertyAttestationsListPropertyAttestationsErrors = {
    /**
     * Not found
     */
    404: unknown;
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type OrgPropertyAttestationsListPropertyAttestationsError = OrgPropertyAttestationsListPropertyAttestationsErrors[keyof OrgPropertyAttestationsListPropertyAttestationsErrors];

export type OrgPropertyAttestationsListPropertyAttestationsResponses = {
    /**
     * Response Org-Property-Attestations-List Property Attestations
     *
     * Successful Response
     */
    200: Array<AttestationResponse>;
};

export type OrgPropertyAttestationsListPropertyAttestationsResponse = OrgPropertyAttestationsListPropertyAttestationsResponses[keyof OrgPropertyAttestationsListPropertyAttestationsResponses];

export type OrgPropertyAttestationsCreatePropertyAttestationData = {
    body: AttestationModel;
    path: {
        /**
         * Property Id
         */
        property_id: string;
        /**
         * Org Id
         */
        org_id: string;
    };
    query?: never;
    url: '/org/{org_id}/property/{property_id}/attestations';
};

export type OrgPropertyAttestationsCreatePropertyAttestationErrors = {
    /**
     * Not found
     */
    404: unknown;
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type OrgPropertyAttestationsCreatePropertyAttestationError = OrgPropertyAttestationsCreatePropertyAttestationErrors[keyof OrgPropertyAttestationsCreatePropertyAttestationErrors];

export type OrgPropertyAttestationsCreatePropertyAttestationResponses = {
    /**
     * Successful Response
     */
    200: AttestationResponse;
};

export type OrgPropertyAttestationsCreatePropertyAttestationResponse = OrgPropertyAttestationsCreatePropertyAttestationResponses[keyof OrgPropertyAttestationsCreatePropertyAttestationResponses];

export type OrgPropertyAttestationsUpdatePropertyAttestationData = {
    body: AttestationModel;
    path: {
        /**
         * Property Id
         */
        property_id: string;
        /**
         * Attestation Id
         */
        attestation_id: string;
        /**
         * Org Id
         */
        org_id: string;
    };
    query?: never;
    url: '/org/{org_id}/property/{property_id}/attestations/{attestation_id}';
};

export type OrgPropertyAttestationsUpdatePropertyAttestationErrors = {
    /**
     * Not found
     */
    404: unknown;
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type OrgPropertyAttestationsUpdatePropertyAttestationError = OrgPropertyAttestationsUpdatePropertyAttestationErrors[keyof OrgPropertyAttestationsUpdatePropertyAttestationErrors];

export type OrgPropertyAttestationsUpdatePropertyAttestationResponses = {
    /**
     * Successful Response
     */
    200: AttestationResponse;
};

export type OrgPropertyAttestationsUpdatePropertyAttestationResponse = OrgPropertyAttestationsUpdatePropertyAttestationResponses[keyof OrgPropertyAttestationsUpdatePropertyAttestationResponses];

export type OrgPropertyReadinessGetPropertyReadinessData = {
    body?: never;
    path: {
        /**
         * Property Id
         */
        property_id: string;
        /**
         * Org Id
         */
        org_id: string;
    };
    query: {
        /**
         * Year
         *
         * Calendar year of data
         */
        year: number;
    };
    url: '/org/{org_id}/property/{property_id}/readiness';
};

export type OrgPropertyReadinessGetPropertyReadinessErrors = {
    /**
     * Not found
     */
    404: unknown;
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type OrgPropertyReadinessGetPropertyReadinessError = OrgPropertyReadinessGetPropertyReadinessErrors[keyof OrgPropertyReadinessGetPropertyReadinessErrors];

export type OrgPropertyReadinessGetPropertyReadinessResponses = {
    /**
     * Response Org-Property-Readiness-Get Property Readiness
     *
     * Successful Response
     */
    200: {
        [key: string]: unknown;
    };
};

export type OrgPropertyReadinessGetPropertyReadinessResponse = OrgPropertyReadinessGetPropertyReadinessResponses[keyof OrgPropertyReadinessGetPropertyReadinessResponses];

export type OrgQueryDataGetDataData = {
    body: QuerySpec;
    path: {
        /**
         * Org Id
         */
        org_id: string;
    };
    query?: never;
    url: '/org/{org_id}/query/data';
};

export type OrgQueryDataGetDataErrors = {
    /**
     * Not found
     */
    404: unknown;
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type OrgQueryDataGetDataError = OrgQueryDataGetDataErrors[keyof OrgQueryDataGetDataErrors];

export type OrgQueryDataGetDataResponses = {
    /**
     * Successful Response
     */
    200: QueryResult;
};

export type OrgQueryDataGetDataResponse = OrgQueryDataGetDataResponses[keyof OrgQueryDataGetDataResponses];

export type OrgQueryBatchExecuteQueryBatchData = {
    body: BatchQueryRequest;
    path: {
        /**
         * Org Id
         */
        org_id: string;
    };
    query?: never;
    url: '/org/{org_id}/query/batch';
};

export type OrgQueryBatchExecuteQueryBatchErrors = {
    /**
     * Not found
     */
    404: unknown;
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type OrgQueryBatchExecuteQueryBatchError = OrgQueryBatchExecuteQueryBatchErrors[keyof OrgQueryBatchExecuteQueryBatchErrors];

export type OrgQueryBatchExecuteQueryBatchResponses = {
    /**
     * Successful Response
     */
    200: BatchQueryResponse;
};

export type OrgQueryBatchExecuteQueryBatchResponse = OrgQueryBatchExecuteQueryBatchResponses[keyof OrgQueryBatchExecuteQueryBatchResponses];

export type OrgQueryExportCreateExportJobData = {
    body: ExportRequest;
    path: {
        /**
         * Org Id
         */
        org_id: string;
    };
    query?: never;
    url: '/org/{org_id}/query/export';
};

export type OrgQueryExportCreateExportJobErrors = {
    /**
     * Not found
     */
    404: unknown;
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type OrgQueryExportCreateExportJobError = OrgQueryExportCreateExportJobErrors[keyof OrgQueryExportCreateExportJobErrors];

export type OrgQueryExportCreateExportJobResponses = {
    /**
     * Successful Response
     */
    200: ExportJobSummary;
};

export type OrgQueryExportCreateExportJobResponse = OrgQueryExportCreateExportJobResponses[keyof OrgQueryExportCreateExportJobResponses];

export type OrgQueryExportGetExportJobData = {
    body?: never;
    path: {
        /**
         * Job Id
         */
        job_id: string;
        /**
         * Org Id
         */
        org_id: string;
    };
    query?: never;
    url: '/org/{org_id}/query/export/{job_id}';
};

export type OrgQueryExportGetExportJobErrors = {
    /**
     * Not found
     */
    404: unknown;
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type OrgQueryExportGetExportJobError = OrgQueryExportGetExportJobErrors[keyof OrgQueryExportGetExportJobErrors];

export type OrgQueryExportGetExportJobResponses = {
    /**
     * Successful Response
     */
    200: ExportJobSummary;
};

export type OrgQueryExportGetExportJobResponse = OrgQueryExportGetExportJobResponses[keyof OrgQueryExportGetExportJobResponses];

export type OrgQueryCatalogMetricsGetMetricCatalogData = {
    body?: never;
    path: {
        /**
         * Org Id
         */
        org_id: string;
    };
    query?: never;
    url: '/org/{org_id}/query/catalog/metrics';
};

export type OrgQueryCatalogMetricsGetMetricCatalogErrors = {
    /**
     * Not found
     */
    404: unknown;
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type OrgQueryCatalogMetricsGetMetricCatalogError = OrgQueryCatalogMetricsGetMetricCatalogErrors[keyof OrgQueryCatalogMetricsGetMetricCatalogErrors];

export type OrgQueryCatalogMetricsGetMetricCatalogResponses = {
    /**
     * Response Org-Query-Catalog-Metrics-Get Metric Catalog
     *
     * Successful Response
     */
    200: Array<Metric>;
};

export type OrgQueryCatalogMetricsGetMetricCatalogResponse = OrgQueryCatalogMetricsGetMetricCatalogResponses[keyof OrgQueryCatalogMetricsGetMetricCatalogResponses];

export type OrgQueryCatalogDimensionsGetDimensionCatalogData = {
    body?: never;
    path: {
        /**
         * Org Id
         */
        org_id: string;
    };
    query?: never;
    url: '/org/{org_id}/query/catalog/dimensions';
};

export type OrgQueryCatalogDimensionsGetDimensionCatalogErrors = {
    /**
     * Not found
     */
    404: unknown;
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type OrgQueryCatalogDimensionsGetDimensionCatalogError = OrgQueryCatalogDimensionsGetDimensionCatalogErrors[keyof OrgQueryCatalogDimensionsGetDimensionCatalogErrors];

export type OrgQueryCatalogDimensionsGetDimensionCatalogResponses = {
    /**
     * Response Org-Query-Catalog-Dimensions-Get Dimension Catalog
     *
     * Successful Response
     */
    200: Array<Dimension>;
};

export type OrgQueryCatalogDimensionsGetDimensionCatalogResponse = OrgQueryCatalogDimensionsGetDimensionCatalogResponses[keyof OrgQueryCatalogDimensionsGetDimensionCatalogResponses];

export type OrgSavedFilterListSavedFiltersData = {
    body?: never;
    path: {
        /**
         * Org Id
         */
        org_id: string;
    };
    query?: never;
    url: '/org/{org_id}/saved-filter/';
};

export type OrgSavedFilterListSavedFiltersErrors = {
    /**
     * Not found
     */
    404: unknown;
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type OrgSavedFilterListSavedFiltersError = OrgSavedFilterListSavedFiltersErrors[keyof OrgSavedFilterListSavedFiltersErrors];

export type OrgSavedFilterListSavedFiltersResponses = {
    /**
     * Response Org-Saved-Filter--List Saved Filters
     *
     * Successful Response
     */
    200: Array<SavedFilter>;
};

export type OrgSavedFilterListSavedFiltersResponse = OrgSavedFilterListSavedFiltersResponses[keyof OrgSavedFilterListSavedFiltersResponses];

export type OrgSavedFilterCreateData = {
    body: SavedFilterBody;
    path: {
        /**
         * Org Id
         */
        org_id: string;
    };
    query?: never;
    url: '/org/{org_id}/saved-filter/';
};

export type OrgSavedFilterCreateErrors = {
    /**
     * Not found
     */
    404: unknown;
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type OrgSavedFilterCreateError = OrgSavedFilterCreateErrors[keyof OrgSavedFilterCreateErrors];

export type OrgSavedFilterCreateResponses = {
    /**
     * Successful Response
     */
    200: SavedFilter;
};

export type OrgSavedFilterCreateResponse = OrgSavedFilterCreateResponses[keyof OrgSavedFilterCreateResponses];

export type OrgSavedFilterDeleteData = {
    body?: never;
    path: {
        /**
         * Saved Filter Id
         */
        saved_filter_id: string;
        /**
         * Org Id
         */
        org_id: string;
    };
    query?: never;
    url: '/org/{org_id}/saved-filter/{saved_filter_id}';
};

export type OrgSavedFilterDeleteErrors = {
    /**
     * Not found
     */
    404: unknown;
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type OrgSavedFilterDeleteError = OrgSavedFilterDeleteErrors[keyof OrgSavedFilterDeleteErrors];

export type OrgSavedFilterDeleteResponses = {
    /**
     * Successful Response
     */
    200: unknown;
};

export type OrgSavedFilterUpdateData = {
    body: SavedFilterBody;
    path: {
        /**
         * Saved Filter Id
         */
        saved_filter_id: string;
        /**
         * Org Id
         */
        org_id: string;
    };
    query?: never;
    url: '/org/{org_id}/saved-filter/{saved_filter_id}';
};

export type OrgSavedFilterUpdateErrors = {
    /**
     * Not found
     */
    404: unknown;
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type OrgSavedFilterUpdateError = OrgSavedFilterUpdateErrors[keyof OrgSavedFilterUpdateErrors];

export type OrgSavedFilterUpdateResponses = {
    /**
     * Successful Response
     */
    200: SavedFilter;
};

export type OrgSavedFilterUpdateResponse = OrgSavedFilterUpdateResponses[keyof OrgSavedFilterUpdateResponses];

export type OrgViewListViewsData = {
    body?: never;
    path: {
        /**
         * Org Id
         */
        org_id: string;
    };
    query?: {
        /**
         * Shared Only
         */
        shared_only?: boolean;
        /**
         * Presentation
         */
        presentation?: string | null;
    };
    url: '/org/{org_id}/view/';
};

export type OrgViewListViewsErrors = {
    /**
     * Not found
     */
    404: unknown;
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type OrgViewListViewsError = OrgViewListViewsErrors[keyof OrgViewListViewsErrors];

export type OrgViewListViewsResponses = {
    /**
     * Response Org-View--List Views
     *
     * Successful Response
     */
    200: Array<ViewSummary>;
};

export type OrgViewListViewsResponse = OrgViewListViewsResponses[keyof OrgViewListViewsResponses];

export type OrgViewCreateViewData = {
    body: ViewCreateRequest;
    path: {
        /**
         * Org Id
         */
        org_id: string;
    };
    query?: never;
    url: '/org/{org_id}/view/';
};

export type OrgViewCreateViewErrors = {
    /**
     * Not found
     */
    404: unknown;
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type OrgViewCreateViewError = OrgViewCreateViewErrors[keyof OrgViewCreateViewErrors];

export type OrgViewCreateViewResponses = {
    /**
     * Successful Response
     */
    200: ViewDetail;
};

export type OrgViewCreateViewResponse = OrgViewCreateViewResponses[keyof OrgViewCreateViewResponses];

export type OrgViewTemplateListTemplatesData = {
    body?: never;
    path: {
        /**
         * Org Id
         */
        org_id: string;
    };
    query?: never;
    url: '/org/{org_id}/view/template';
};

export type OrgViewTemplateListTemplatesErrors = {
    /**
     * Not found
     */
    404: unknown;
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type OrgViewTemplateListTemplatesError = OrgViewTemplateListTemplatesErrors[keyof OrgViewTemplateListTemplatesErrors];

export type OrgViewTemplateListTemplatesResponses = {
    /**
     * Successful Response
     */
    200: TemplateLibraryResponse;
};

export type OrgViewTemplateListTemplatesResponse = OrgViewTemplateListTemplatesResponses[keyof OrgViewTemplateListTemplatesResponses];

export type OrgViewFromTemplateCreateFromTemplateData = {
    body: ViewCreateFromTemplateRequest;
    path: {
        /**
         * Org Id
         */
        org_id: string;
    };
    query?: never;
    url: '/org/{org_id}/view/from-template';
};

export type OrgViewFromTemplateCreateFromTemplateErrors = {
    /**
     * Not found
     */
    404: unknown;
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type OrgViewFromTemplateCreateFromTemplateError = OrgViewFromTemplateCreateFromTemplateErrors[keyof OrgViewFromTemplateCreateFromTemplateErrors];

export type OrgViewFromTemplateCreateFromTemplateResponses = {
    /**
     * Successful Response
     */
    200: ViewDetail;
};

export type OrgViewFromTemplateCreateFromTemplateResponse = OrgViewFromTemplateCreateFromTemplateResponses[keyof OrgViewFromTemplateCreateFromTemplateResponses];

export type OrgViewDashboardTemplateListDashboardTemplateLibraryData = {
    body?: never;
    path: {
        /**
         * Org Id
         */
        org_id: string;
    };
    query?: never;
    url: '/org/{org_id}/view/dashboard-template';
};

export type OrgViewDashboardTemplateListDashboardTemplateLibraryErrors = {
    /**
     * Not found
     */
    404: unknown;
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type OrgViewDashboardTemplateListDashboardTemplateLibraryError = OrgViewDashboardTemplateListDashboardTemplateLibraryErrors[keyof OrgViewDashboardTemplateListDashboardTemplateLibraryErrors];

export type OrgViewDashboardTemplateListDashboardTemplateLibraryResponses = {
    /**
     * Successful Response
     */
    200: DashboardTemplateLibraryResponse;
};

export type OrgViewDashboardTemplateListDashboardTemplateLibraryResponse = OrgViewDashboardTemplateListDashboardTemplateLibraryResponses[keyof OrgViewDashboardTemplateListDashboardTemplateLibraryResponses];

export type OrgViewDashboardTemplateInstantiateCreateDashboardFromTemplateData = {
    body: DashboardCreateFromTemplateRequest;
    path: {
        /**
         * Org Id
         */
        org_id: string;
    };
    query?: never;
    url: '/org/{org_id}/view/dashboard-template/instantiate';
};

export type OrgViewDashboardTemplateInstantiateCreateDashboardFromTemplateErrors = {
    /**
     * Not found
     */
    404: unknown;
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type OrgViewDashboardTemplateInstantiateCreateDashboardFromTemplateError = OrgViewDashboardTemplateInstantiateCreateDashboardFromTemplateErrors[keyof OrgViewDashboardTemplateInstantiateCreateDashboardFromTemplateErrors];

export type OrgViewDashboardTemplateInstantiateCreateDashboardFromTemplateResponses = {
    /**
     * Successful Response
     */
    200: DashboardSummaryResponse;
};

export type OrgViewDashboardTemplateInstantiateCreateDashboardFromTemplateResponse = OrgViewDashboardTemplateInstantiateCreateDashboardFromTemplateResponses[keyof OrgViewDashboardTemplateInstantiateCreateDashboardFromTemplateResponses];

export type OrgViewDeleteViewData = {
    body?: never;
    path: {
        /**
         * View Id
         */
        view_id: string;
        /**
         * Org Id
         */
        org_id: string;
    };
    query?: never;
    url: '/org/{org_id}/view/{view_id}';
};

export type OrgViewDeleteViewErrors = {
    /**
     * Not found
     */
    404: unknown;
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type OrgViewDeleteViewError = OrgViewDeleteViewErrors[keyof OrgViewDeleteViewErrors];

export type OrgViewDeleteViewResponses = {
    /**
     * Response Org-View-Delete View
     *
     * Successful Response
     */
    200: {
        [key: string]: string;
    };
};

export type OrgViewDeleteViewResponse = OrgViewDeleteViewResponses[keyof OrgViewDeleteViewResponses];

export type OrgViewGetViewData = {
    body?: never;
    path: {
        /**
         * View Id
         */
        view_id: string;
        /**
         * Org Id
         */
        org_id: string;
    };
    query?: never;
    url: '/org/{org_id}/view/{view_id}';
};

export type OrgViewGetViewErrors = {
    /**
     * Not found
     */
    404: unknown;
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type OrgViewGetViewError = OrgViewGetViewErrors[keyof OrgViewGetViewErrors];

export type OrgViewGetViewResponses = {
    /**
     * Successful Response
     */
    200: ViewDetail;
};

export type OrgViewGetViewResponse = OrgViewGetViewResponses[keyof OrgViewGetViewResponses];

export type OrgViewUpdateViewData = {
    body: ViewUpdateRequest;
    path: {
        /**
         * View Id
         */
        view_id: string;
        /**
         * Org Id
         */
        org_id: string;
    };
    query?: never;
    url: '/org/{org_id}/view/{view_id}';
};

export type OrgViewUpdateViewErrors = {
    /**
     * Not found
     */
    404: unknown;
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type OrgViewUpdateViewError = OrgViewUpdateViewErrors[keyof OrgViewUpdateViewErrors];

export type OrgViewUpdateViewResponses = {
    /**
     * Successful Response
     */
    200: ViewDetail;
};

export type OrgViewUpdateViewResponse = OrgViewUpdateViewResponses[keyof OrgViewUpdateViewResponses];

export type OrgViewDuplicateDuplicateViewData = {
    body?: never;
    path: {
        /**
         * View Id
         */
        view_id: string;
        /**
         * Org Id
         */
        org_id: string;
    };
    query?: never;
    url: '/org/{org_id}/view/{view_id}/duplicate';
};

export type OrgViewDuplicateDuplicateViewErrors = {
    /**
     * Not found
     */
    404: unknown;
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type OrgViewDuplicateDuplicateViewError = OrgViewDuplicateDuplicateViewErrors[keyof OrgViewDuplicateDuplicateViewErrors];

export type OrgViewDuplicateDuplicateViewResponses = {
    /**
     * Successful Response
     */
    200: ViewDetail;
};

export type OrgViewDuplicateDuplicateViewResponse = OrgViewDuplicateDuplicateViewResponses[keyof OrgViewDuplicateDuplicateViewResponses];

export type OrgViewDataGetDataData = {
    /**
     * Body
     */
    body?: ViewDataRequest | null;
    path: {
        /**
         * View Id
         */
        view_id: string;
        /**
         * Org Id
         */
        org_id: string;
    };
    query?: never;
    url: '/org/{org_id}/view/{view_id}/data';
};

export type OrgViewDataGetDataErrors = {
    /**
     * Not found
     */
    404: unknown;
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type OrgViewDataGetDataError = OrgViewDataGetDataErrors[keyof OrgViewDataGetDataErrors];

export type OrgViewDataGetDataResponses = {
    /**
     * Successful Response
     */
    200: QueryResult;
};

export type OrgViewDataGetDataResponse = OrgViewDataGetDataResponses[keyof OrgViewDataGetDataResponses];

export type OrgTargetListTargetsData = {
    body?: never;
    path: {
        /**
         * Org Id
         */
        org_id: string;
    };
    query?: never;
    url: '/org/{org_id}/target/';
};

export type OrgTargetListTargetsErrors = {
    /**
     * Not found
     */
    404: unknown;
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type OrgTargetListTargetsError = OrgTargetListTargetsErrors[keyof OrgTargetListTargetsErrors];

export type OrgTargetListTargetsResponses = {
    /**
     * Response Org-Target--List Targets
     *
     * Successful Response
     */
    200: Array<Target>;
};

export type OrgTargetListTargetsResponse = OrgTargetListTargetsResponses[keyof OrgTargetListTargetsResponses];

export type OrgTargetCreateData = {
    body: TargetBody;
    path: {
        /**
         * Org Id
         */
        org_id: string;
    };
    query?: never;
    url: '/org/{org_id}/target/';
};

export type OrgTargetCreateErrors = {
    /**
     * Not found
     */
    404: unknown;
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type OrgTargetCreateError = OrgTargetCreateErrors[keyof OrgTargetCreateErrors];

export type OrgTargetCreateResponses = {
    /**
     * Successful Response
     */
    200: Target;
};

export type OrgTargetCreateResponse = OrgTargetCreateResponses[keyof OrgTargetCreateResponses];

export type OrgTargetProgressListProgressData = {
    body?: never;
    path: {
        /**
         * Org Id
         */
        org_id: string;
    };
    query?: never;
    url: '/org/{org_id}/target/progress';
};

export type OrgTargetProgressListProgressErrors = {
    /**
     * Not found
     */
    404: unknown;
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type OrgTargetProgressListProgressError = OrgTargetProgressListProgressErrors[keyof OrgTargetProgressListProgressErrors];

export type OrgTargetProgressListProgressResponses = {
    /**
     * Response Org-Target-Progress-List Progress
     *
     * Successful Response
     */
    200: Array<TargetProgressSummary>;
};

export type OrgTargetProgressListProgressResponse = OrgTargetProgressListProgressResponses[keyof OrgTargetProgressListProgressResponses];

export type OrgTargetSeriesGetSeriesData = {
    body?: never;
    path: {
        /**
         * Target Id
         */
        target_id: string;
        /**
         * Org Id
         */
        org_id: string;
    };
    query?: never;
    url: '/org/{org_id}/target/{target_id}/series';
};

export type OrgTargetSeriesGetSeriesErrors = {
    /**
     * Not found
     */
    404: unknown;
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type OrgTargetSeriesGetSeriesError = OrgTargetSeriesGetSeriesErrors[keyof OrgTargetSeriesGetSeriesErrors];

export type OrgTargetSeriesGetSeriesResponses = {
    /**
     * Response Org-Target-Series-Get Series
     *
     * Successful Response
     */
    200: {
        [key: string]: unknown;
    };
};

export type OrgTargetSeriesGetSeriesResponse = OrgTargetSeriesGetSeriesResponses[keyof OrgTargetSeriesGetSeriesResponses];

export type OrgTargetDeleteData = {
    body?: never;
    path: {
        /**
         * Target Id
         */
        target_id: string;
        /**
         * Org Id
         */
        org_id: string;
    };
    query?: never;
    url: '/org/{org_id}/target/{target_id}';
};

export type OrgTargetDeleteErrors = {
    /**
     * Not found
     */
    404: unknown;
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type OrgTargetDeleteError = OrgTargetDeleteErrors[keyof OrgTargetDeleteErrors];

export type OrgTargetDeleteResponses = {
    /**
     * Response Org-Target-Delete
     *
     * Successful Response
     */
    200: {
        [key: string]: string;
    };
};

export type OrgTargetDeleteResponse = OrgTargetDeleteResponses[keyof OrgTargetDeleteResponses];

export type OrgTargetUpdateData = {
    body: TargetBody;
    path: {
        /**
         * Target Id
         */
        target_id: string;
        /**
         * Org Id
         */
        org_id: string;
    };
    query?: never;
    url: '/org/{org_id}/target/{target_id}';
};

export type OrgTargetUpdateErrors = {
    /**
     * Not found
     */
    404: unknown;
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type OrgTargetUpdateError = OrgTargetUpdateErrors[keyof OrgTargetUpdateErrors];

export type OrgTargetUpdateResponses = {
    /**
     * Successful Response
     */
    200: Target;
};

export type OrgTargetUpdateResponse = OrgTargetUpdateResponses[keyof OrgTargetUpdateResponses];

export type OrgSearchSearchData = {
    body?: never;
    path: {
        /**
         * Org Id
         */
        org_id: string;
    };
    query: {
        /**
         * Q
         *
         * Search query
         */
        q: string;
        /**
         * Types
         *
         * List of types to search
         */
        types?: Array<SearchType> | null;
    };
    url: '/org/{org_id}/search/';
};

export type OrgSearchSearchErrors = {
    /**
     * Not found
     */
    404: unknown;
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type OrgSearchSearchError = OrgSearchSearchErrors[keyof OrgSearchSearchErrors];

export type OrgSearchSearchResponses = {
    /**
     * Successful Response
     */
    200: SearchResponse;
};

export type OrgSearchSearchResponse = OrgSearchSearchResponses[keyof OrgSearchSearchResponses];

export type OrgServiceAccountServiceAccountListData = {
    body?: never;
    path: {
        /**
         * Org Id
         */
        org_id: string;
    };
    query?: never;
    url: '/org/{org_id}/service_account/';
};

export type OrgServiceAccountServiceAccountListErrors = {
    /**
     * Not found
     */
    404: unknown;
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type OrgServiceAccountServiceAccountListError = OrgServiceAccountServiceAccountListErrors[keyof OrgServiceAccountServiceAccountListErrors];

export type OrgServiceAccountServiceAccountListResponses = {
    /**
     * Response Org-Service Account--Service Account List
     *
     * Successful Response
     */
    200: Array<VendorServiceAccountRef>;
};

export type OrgServiceAccountServiceAccountListResponse = OrgServiceAccountServiceAccountListResponses[keyof OrgServiceAccountServiceAccountListResponses];

export type OrgServiceAccountBalanceGetBalanceData = {
    body?: never;
    path: {
        /**
         * Service Account Id
         */
        service_account_id: string;
        /**
         * Org Id
         */
        org_id: string;
    };
    query?: never;
    url: '/org/{org_id}/service_account/{service_account_id}/balance';
};

export type OrgServiceAccountBalanceGetBalanceErrors = {
    /**
     * Not found
     */
    404: unknown;
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type OrgServiceAccountBalanceGetBalanceError = OrgServiceAccountBalanceGetBalanceErrors[keyof OrgServiceAccountBalanceGetBalanceErrors];

export type OrgServiceAccountBalanceGetBalanceResponses = {
    /**
     * Successful Response
     */
    200: AccountBalance;
};

export type OrgServiceAccountBalanceGetBalanceResponse = OrgServiceAccountBalanceGetBalanceResponses[keyof OrgServiceAccountBalanceGetBalanceResponses];

export type OrgStatementListData = {
    body?: never;
    path: {
        /**
         * Org Id
         */
        org_id: string;
    };
    query?: {
        /**
         * Sort By
         */
        sort_by?: StatementSortFields | null;
        /**
         * Sort Direction
         */
        sort_direction?: SortDirection | null;
        /**
         * Search Text
         */
        search_text?: string | null;
        /**
         * Weather Normalize
         */
        weather_normalize?: boolean | null;
        /**
         * Bucket Grain
         */
        bucket_grain?: BucketGrain | null;
        /**
         * Date Range Spec
         */
        date_range_spec?: 'Calendar Year To Date' | 'Last Calendar Year' | 'Fiscal Year To Date' | 'Last Fiscal Year' | 'Quarter To Date' | 'Last Quarter' | 'Month To Date' | 'Last Month' | 'Last Three Months' | 'Last Six Months' | 'Last Twelve Months' | 'Custom' | null;
        /**
         * Date Range Start
         */
        date_range_start?: string | null;
        /**
         * Date Range End
         */
        date_range_end?: string | null;
        /**
         * Funds
         */
        funds?: Array<string> | null;
        /**
         * Departments
         */
        departments?: Array<string> | null;
        /**
         * Properties
         */
        properties?: Array<string> | null;
        /**
         * Billing Accounts
         */
        billing_accounts?: Array<string> | null;
        /**
         * Commodities
         */
        commodities?: Array<string> | null;
        /**
         * Utility Tariffs
         */
        utility_tariffs?: Array<string> | null;
        /**
         * Utility Companies
         */
        utility_companies?: Array<string> | null;
        /**
         * Utility Suppliers
         */
        utility_suppliers?: Array<string> | null;
        /**
         * Meters
         */
        meters?: Array<string> | null;
        /**
         * Limit
         */
        limit?: number | null;
        /**
         * Page
         */
        page?: number | null;
        /**
         * After
         */
        after?: [
            unknown,
            string
        ] | null;
    };
    url: '/org/{org_id}/statement/';
};

export type OrgStatementListErrors = {
    /**
     * Not found
     */
    404: unknown;
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type OrgStatementListError = OrgStatementListErrors[keyof OrgStatementListErrors];

export type OrgStatementListResponses = {
    /**
     * Successful Response
     */
    200: PaginatedResultVendorStatementOverview;
};

export type OrgStatementListResponse = OrgStatementListResponses[keyof OrgStatementListResponses];

export type OrgStatementDeleteData = {
    body?: never;
    path: {
        /**
         * Statement Id
         */
        statement_id: string;
        /**
         * Org Id
         */
        org_id: string;
    };
    query?: {
        /**
         * Cascade Payments
         *
         * If true, attached payments are hard-deleted along with the statement. If false (default), payments are detached (statement_id and statement_service_details_id nulled) and remain on the billing account.
         */
        cascade_payments?: boolean;
    };
    url: '/org/{org_id}/statement/{statement_id}';
};

export type OrgStatementDeleteErrors = {
    /**
     * Not found
     */
    404: unknown;
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type OrgStatementDeleteError = OrgStatementDeleteErrors[keyof OrgStatementDeleteErrors];

export type OrgStatementDeleteResponses = {
    /**
     * Successful Response
     */
    204: void;
};

export type OrgStatementDeleteResponse = OrgStatementDeleteResponses[keyof OrgStatementDeleteResponses];

export type OrgStatementGetData = {
    body?: never;
    path: {
        /**
         * Statement Id
         */
        statement_id: string;
        /**
         * Org Id
         */
        org_id: string;
    };
    query?: never;
    url: '/org/{org_id}/statement/{statement_id}';
};

export type OrgStatementGetErrors = {
    /**
     * Not found
     */
    404: unknown;
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type OrgStatementGetError = OrgStatementGetErrors[keyof OrgStatementGetErrors];

export type OrgStatementGetResponses = {
    /**
     * Successful Response
     */
    200: VendorStatement;
};

export type OrgStatementGetResponse = OrgStatementGetResponses[keyof OrgStatementGetResponses];

export type OrgStatementUpdateData = {
    body: StatementUpdate;
    path: {
        /**
         * Statement Id
         */
        statement_id: string;
        /**
         * Org Id
         */
        org_id: string;
    };
    query?: never;
    url: '/org/{org_id}/statement/{statement_id}';
};

export type OrgStatementUpdateErrors = {
    /**
     * Not found
     */
    404: unknown;
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type OrgStatementUpdateError = OrgStatementUpdateErrors[keyof OrgStatementUpdateErrors];

export type OrgStatementUpdateResponses = {
    /**
     * Successful Response
     */
    200: VendorStatement;
};

export type OrgStatementUpdateResponse = OrgStatementUpdateResponses[keyof OrgStatementUpdateResponses];

export type OrgSupportListSupportRequestsData = {
    body?: never;
    path: {
        /**
         * Org Id
         */
        org_id: string;
    };
    query?: {
        /**
         * Scope
         */
        scope?: 'own' | 'assigned' | 'org' | 'all';
        /**
         * Status
         *
         * Filter by status
         */
        status?: SupportRequestStatus | null;
        /**
         * Priority
         *
         * Filter by priority
         */
        priority?: SupportRequestPriority | null;
        /**
         * Limit
         *
         * Maximum number of results
         */
        limit?: number;
        /**
         * Offset
         *
         * Offset for pagination
         */
        offset?: number;
    };
    url: '/org/{org_id}/support/';
};

export type OrgSupportListSupportRequestsErrors = {
    /**
     * Not found
     */
    404: unknown;
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type OrgSupportListSupportRequestsError = OrgSupportListSupportRequestsErrors[keyof OrgSupportListSupportRequestsErrors];

export type OrgSupportListSupportRequestsResponses = {
    /**
     * Response Org-Support--List Support Requests
     *
     * Successful Response
     */
    200: Array<SupportRequestSummary>;
};

export type OrgSupportListSupportRequestsResponse = OrgSupportListSupportRequestsResponses[keyof OrgSupportListSupportRequestsResponses];

export type OrgSupportCreateSupportRequestData = {
    body: SupportRequestCreate;
    path: {
        /**
         * Org Id
         */
        org_id: string;
    };
    query?: never;
    url: '/org/{org_id}/support/';
};

export type OrgSupportCreateSupportRequestErrors = {
    /**
     * Not found
     */
    404: unknown;
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type OrgSupportCreateSupportRequestError = OrgSupportCreateSupportRequestErrors[keyof OrgSupportCreateSupportRequestErrors];

export type OrgSupportCreateSupportRequestResponses = {
    /**
     * Successful Response
     */
    200: SupportRequest;
};

export type OrgSupportCreateSupportRequestResponse = OrgSupportCreateSupportRequestResponses[keyof OrgSupportCreateSupportRequestResponses];

export type OrgSupportGetSupportRequestData = {
    body?: never;
    path: {
        /**
         * Request Id
         */
        request_id: string;
        /**
         * Org Id
         */
        org_id: string;
    };
    query?: never;
    url: '/org/{org_id}/support/{request_id}';
};

export type OrgSupportGetSupportRequestErrors = {
    /**
     * Not found
     */
    404: unknown;
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type OrgSupportGetSupportRequestError = OrgSupportGetSupportRequestErrors[keyof OrgSupportGetSupportRequestErrors];

export type OrgSupportGetSupportRequestResponses = {
    /**
     * Successful Response
     */
    200: SupportRequest;
};

export type OrgSupportGetSupportRequestResponse = OrgSupportGetSupportRequestResponses[keyof OrgSupportGetSupportRequestResponses];

export type OrgSupportUpdateSupportRequestData = {
    body: SupportRequestUpdate;
    path: {
        /**
         * Request Id
         */
        request_id: string;
        /**
         * Org Id
         */
        org_id: string;
    };
    query?: never;
    url: '/org/{org_id}/support/{request_id}';
};

export type OrgSupportUpdateSupportRequestErrors = {
    /**
     * Not found
     */
    404: unknown;
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type OrgSupportUpdateSupportRequestError = OrgSupportUpdateSupportRequestErrors[keyof OrgSupportUpdateSupportRequestErrors];

export type OrgSupportUpdateSupportRequestResponses = {
    /**
     * Successful Response
     */
    200: SupportRequest;
};

export type OrgSupportUpdateSupportRequestResponse = OrgSupportUpdateSupportRequestResponses[keyof OrgSupportUpdateSupportRequestResponses];

export type OrgSupportMessageCreateMessageData = {
    body: SupportRequestMessageCreate;
    path: {
        /**
         * Request Id
         */
        request_id: string;
        /**
         * Org Id
         */
        org_id: string;
    };
    query?: never;
    url: '/org/{org_id}/support/{request_id}/message';
};

export type OrgSupportMessageCreateMessageErrors = {
    /**
     * Not found
     */
    404: unknown;
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type OrgSupportMessageCreateMessageError = OrgSupportMessageCreateMessageErrors[keyof OrgSupportMessageCreateMessageErrors];

export type OrgSupportMessageCreateMessageResponses = {
    /**
     * Successful Response
     */
    200: SupportRequestMessage;
};

export type OrgSupportMessageCreateMessageResponse = OrgSupportMessageCreateMessageResponses[keyof OrgSupportMessageCreateMessageResponses];

export type PublicDashboardGetPublishedDashboardData = {
    body?: never;
    path: {
        /**
         * Dashboard Id
         */
        dashboard_id: string;
    };
    query?: never;
    url: '/public/dashboard/{dashboard_id}';
};

export type PublicDashboardGetPublishedDashboardErrors = {
    /**
     * Not found
     */
    404: unknown;
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type PublicDashboardGetPublishedDashboardError = PublicDashboardGetPublishedDashboardErrors[keyof PublicDashboardGetPublishedDashboardErrors];

export type PublicDashboardGetPublishedDashboardResponses = {
    /**
     * Successful Response
     */
    200: PublicDashboardResponse;
};

export type PublicDashboardGetPublishedDashboardResponse = PublicDashboardGetPublishedDashboardResponses[keyof PublicDashboardGetPublishedDashboardResponses];

export type PublicDashboardDataGetPublishedDashboardDataData = {
    /**
     * Body
     */
    body?: PublicDashboardDataRequest | null;
    path: {
        /**
         * Dashboard Id
         */
        dashboard_id: string;
    };
    query?: never;
    url: '/public/dashboard/{dashboard_id}/data';
};

export type PublicDashboardDataGetPublishedDashboardDataErrors = {
    /**
     * Not found
     */
    404: unknown;
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type PublicDashboardDataGetPublishedDashboardDataError = PublicDashboardDataGetPublishedDashboardDataErrors[keyof PublicDashboardDataGetPublishedDashboardDataErrors];

export type PublicDashboardDataGetPublishedDashboardDataResponses = {
    /**
     * Response Public-Dashboard-Data-Get Published Dashboard Data
     *
     * Successful Response
     */
    200: {
        [key: string]: QueryResult;
    };
};

export type PublicDashboardDataGetPublishedDashboardDataResponse = PublicDashboardDataGetPublishedDashboardDataResponses[keyof PublicDashboardDataGetPublishedDashboardDataResponses];

export type PublicDashboardTargetsGetPublishedDashboardTargetsData = {
    body?: never;
    path: {
        /**
         * Dashboard Id
         */
        dashboard_id: string;
    };
    query?: never;
    url: '/public/dashboard/{dashboard_id}/targets';
};

export type PublicDashboardTargetsGetPublishedDashboardTargetsErrors = {
    /**
     * Not found
     */
    404: unknown;
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type PublicDashboardTargetsGetPublishedDashboardTargetsError = PublicDashboardTargetsGetPublishedDashboardTargetsErrors[keyof PublicDashboardTargetsGetPublishedDashboardTargetsErrors];

export type PublicDashboardTargetsGetPublishedDashboardTargetsResponses = {
    /**
     * Response Public-Dashboard-Targets-Get Published Dashboard Targets
     *
     * Successful Response
     */
    200: Array<TargetProgressSummary>;
};

export type PublicDashboardTargetsGetPublishedDashboardTargetsResponse = PublicDashboardTargetsGetPublishedDashboardTargetsResponses[keyof PublicDashboardTargetsGetPublishedDashboardTargetsResponses];

export type PublicProgramFormGetPublicFormData = {
    body?: never;
    path: {
        /**
         * Form Id
         */
        form_id: string;
    };
    query?: never;
    url: '/public/program/form/{form_id}';
};

export type PublicProgramFormGetPublicFormErrors = {
    /**
     * Not found
     */
    404: unknown;
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type PublicProgramFormGetPublicFormError = PublicProgramFormGetPublicFormErrors[keyof PublicProgramFormGetPublicFormErrors];

export type PublicProgramFormGetPublicFormResponses = {
    /**
     * Successful Response
     */
    200: PublicFormResponse;
};

export type PublicProgramFormGetPublicFormResponse = PublicProgramFormGetPublicFormResponses[keyof PublicProgramFormGetPublicFormResponses];

export type PublicProgramFormValidateAccessValidateFormAccessData = {
    body: AccessValidationRequest;
    path: {
        /**
         * Form Id
         */
        form_id: string;
    };
    query?: {
        /**
         * Token
         */
        token?: string | null;
    };
    url: '/public/program/form/{form_id}/validate-access';
};

export type PublicProgramFormValidateAccessValidateFormAccessErrors = {
    /**
     * Not found
     */
    404: unknown;
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type PublicProgramFormValidateAccessValidateFormAccessError = PublicProgramFormValidateAccessValidateFormAccessErrors[keyof PublicProgramFormValidateAccessValidateFormAccessErrors];

export type PublicProgramFormValidateAccessValidateFormAccessResponses = {
    /**
     * Successful Response
     */
    200: AccessValidationResponse;
};

export type PublicProgramFormValidateAccessValidateFormAccessResponse = PublicProgramFormValidateAccessValidateFormAccessResponses[keyof PublicProgramFormValidateAccessValidateFormAccessResponses];

export type PublicProgramFormSubmissionGetFormSubmissionByCredentialsData = {
    body?: never;
    path: {
        /**
         * Form Id
         */
        form_id: string;
    };
    query?: {
        /**
         * Token
         */
        token?: string | null;
        /**
         * Code
         */
        code?: string | null;
    };
    url: '/public/program/form/{form_id}/submission';
};

export type PublicProgramFormSubmissionGetFormSubmissionByCredentialsErrors = {
    /**
     * Not found
     */
    404: unknown;
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type PublicProgramFormSubmissionGetFormSubmissionByCredentialsError = PublicProgramFormSubmissionGetFormSubmissionByCredentialsErrors[keyof PublicProgramFormSubmissionGetFormSubmissionByCredentialsErrors];

export type PublicProgramFormSubmissionGetFormSubmissionByCredentialsResponses = {
    /**
     * Successful Response
     */
    200: ViaductApiRoutersPublicProgramPortalFormSubmissionResponse;
};

export type PublicProgramFormSubmissionGetFormSubmissionByCredentialsResponse = PublicProgramFormSubmissionGetFormSubmissionByCredentialsResponses[keyof PublicProgramFormSubmissionGetFormSubmissionByCredentialsResponses];

export type PublicProgramFormSubmissionCreateOrUpdateSubmissionData = {
    body: FormSubmissionCreate;
    path: {
        /**
         * Form Id
         */
        form_id: string;
    };
    query?: {
        /**
         * Token
         */
        token?: string | null;
        /**
         * Code
         */
        code?: string | null;
    };
    url: '/public/program/form/{form_id}/submission';
};

export type PublicProgramFormSubmissionCreateOrUpdateSubmissionErrors = {
    /**
     * Not found
     */
    404: unknown;
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type PublicProgramFormSubmissionCreateOrUpdateSubmissionError = PublicProgramFormSubmissionCreateOrUpdateSubmissionErrors[keyof PublicProgramFormSubmissionCreateOrUpdateSubmissionErrors];

export type PublicProgramFormSubmissionCreateOrUpdateSubmissionResponses = {
    /**
     * Successful Response
     */
    200: ViaductApiRoutersPublicProgramPortalFormSubmissionResponse;
};

export type PublicProgramFormSubmissionCreateOrUpdateSubmissionResponse = PublicProgramFormSubmissionCreateOrUpdateSubmissionResponses[keyof PublicProgramFormSubmissionCreateOrUpdateSubmissionResponses];

export type PublicProgramPortalGetPublicPortalData = {
    body?: never;
    path: {
        /**
         * Portal Id
         */
        portal_id: string;
    };
    query?: never;
    url: '/public/program/portal/{portal_id}';
};

export type PublicProgramPortalGetPublicPortalErrors = {
    /**
     * Not found
     */
    404: unknown;
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type PublicProgramPortalGetPublicPortalError = PublicProgramPortalGetPublicPortalErrors[keyof PublicProgramPortalGetPublicPortalErrors];

export type PublicProgramPortalGetPublicPortalResponses = {
    /**
     * Successful Response
     */
    200: PublicPortalResponse;
};

export type PublicProgramPortalGetPublicPortalResponse = PublicProgramPortalGetPublicPortalResponses[keyof PublicProgramPortalGetPublicPortalResponses];

export type PublicProgramPortalValidateAccessValidatePortalAccessData = {
    body: AccessValidationRequest;
    path: {
        /**
         * Portal Id
         */
        portal_id: string;
    };
    query?: {
        /**
         * Token
         */
        token?: string | null;
    };
    url: '/public/program/portal/{portal_id}/validate-access';
};

export type PublicProgramPortalValidateAccessValidatePortalAccessErrors = {
    /**
     * Not found
     */
    404: unknown;
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type PublicProgramPortalValidateAccessValidatePortalAccessError = PublicProgramPortalValidateAccessValidatePortalAccessErrors[keyof PublicProgramPortalValidateAccessValidatePortalAccessErrors];

export type PublicProgramPortalValidateAccessValidatePortalAccessResponses = {
    /**
     * Successful Response
     */
    200: AccessValidationResponse;
};

export type PublicProgramPortalValidateAccessValidatePortalAccessResponse = PublicProgramPortalValidateAccessValidatePortalAccessResponses[keyof PublicProgramPortalValidateAccessValidatePortalAccessResponses];

export type PublicTargetSeriesGetSeriesData = {
    body?: never;
    path: {
        /**
         * Target Id
         */
        target_id: string;
    };
    query?: never;
    url: '/public/target/{target_id}/series';
};

export type PublicTargetSeriesGetSeriesErrors = {
    /**
     * Not found
     */
    404: unknown;
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type PublicTargetSeriesGetSeriesError = PublicTargetSeriesGetSeriesErrors[keyof PublicTargetSeriesGetSeriesErrors];

export type PublicTargetSeriesGetSeriesResponses = {
    /**
     * Response Public-Target-Series-Get Series
     *
     * Successful Response
     */
    200: {
        [key: string]: unknown;
    };
};

export type PublicTargetSeriesGetSeriesResponse = PublicTargetSeriesGetSeriesResponses[keyof PublicTargetSeriesGetSeriesResponses];

export type PublicViewGetViewData = {
    body?: never;
    path: {
        /**
         * View Id
         */
        view_id: string;
    };
    query?: never;
    url: '/public/view/{view_id}';
};

export type PublicViewGetViewErrors = {
    /**
     * Not found
     */
    404: unknown;
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type PublicViewGetViewError = PublicViewGetViewErrors[keyof PublicViewGetViewErrors];

export type PublicViewGetViewResponses = {
    /**
     * Successful Response
     */
    200: PublicViewResponse;
};

export type PublicViewGetViewResponse = PublicViewGetViewResponses[keyof PublicViewGetViewResponses];

export type PublicViewDataGetDataData = {
    /**
     * Body
     */
    body?: PublicViewDataRequest | null;
    path: {
        /**
         * View Id
         */
        view_id: string;
    };
    query?: never;
    url: '/public/view/{view_id}/data';
};

export type PublicViewDataGetDataErrors = {
    /**
     * Not found
     */
    404: unknown;
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type PublicViewDataGetDataError = PublicViewDataGetDataErrors[keyof PublicViewDataGetDataErrors];

export type PublicViewDataGetDataResponses = {
    /**
     * Successful Response
     */
    200: QueryResult;
};

export type PublicViewDataGetDataResponse = PublicViewDataGetDataResponses[keyof PublicViewDataGetDataResponses];
